// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Outfit:wght@400;500;600;700;800&family=Barlow+Condensed:wght@600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html.cm-immersive,
html.cm-immersive body {
  position: fixed;
  inset: 0;
  width: 100%;
  height: 100%;
  height: var(--lt-vvh, 100dvh);
  overflow: hidden;
  overscroll-behavior: none;
}

html.cm-immersive .cm-page,
html:fullscreen .cm-page,
html:-webkit-full-screen .cm-page {
  height: var(--lt-vvh, 100dvh);
  max-height: var(--lt-vvh, 100dvh);
}

.cm-fs-gate {
  position: fixed;
  top: calc(0.55rem + env(safe-area-inset-top, 0px));
  left: 50%;
  z-index: 120;
  transform: translateX(-50%);
  border: 0;
  border-radius: 999px;
  padding: 0.55rem 1rem;
  background: rgba(8, 119, 188, 0.92);
  color: #fff;
  font-size: 0.78rem;
  font-weight: 750;
  box-shadow: 0 10px 28px rgba(0, 0, 0, 0.35);
  cursor: pointer;
}

.cm-fs-gate__label {
  white-space: nowrap;
}

.cm-sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

.cm-page {
  --cm-bg: #0b0f19;
  --cm-slate: #121826;
  --cm-text: #f8fafc;
  --cm-muted: #94a3b8;
  --cm-border: rgba(255, 255, 255, 0.08);
  --cm-glass: rgba(15, 23, 42, 0.72);
  --cm-primary: var(--brand-primary, #0877bc);
  --cm-home: #34d399;
  --cm-away: #fbbf24;
  --cm-rec: #fb7185;
  --cm-ease: cubic-bezier(0.16, 1, 0.3, 1);
  box-sizing: border-box;
  position: relative;
  width: 100%;
  height: 100dvh;
  height: 100svh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding: env(safe-area-inset-top, 0px) 0.7rem
    calc(0.45rem + env(safe-area-inset-bottom, 0px));
  background:
    radial-gradient(1100px 520px at 8% -18%, color-mix(in srgb, var(--cm-primary) 32%, transparent), transparent 58%),
    radial-gradient(720px 380px at 108% 4%, rgba(251, 191, 36, 0.1), transparent 52%),
    var(--cm-bg);
  color: var(--cm-text);
  font-family: Outfit, Inter, var(--brand-font, sans-serif);
}

.cm-page--light {
  --cm-bg: #f3f5f8;
  --cm-slate: #ffffff;
  --cm-text: #0f172a;
  --cm-muted: #475569;
  --cm-border: rgba(15, 23, 42, 0.08);
  --cm-glass: rgba(255, 255, 255, 0.86);
  --cm-home: #047857;
  --cm-away: #b45309;
  --cm-rec: #e11d48;
}

.cm-page * {
  box-sizing: border-box;
}

.cm-page [hidden] {
  display: none !important;
}

.cm-page button,
.cm-page input,
.cm-page textarea {
  font: inherit;
}

.cm-status {
  flex: 1 1;
  display: grid;
  place-items: center;
  text-align: center;
  color: var(--cm-muted);
  padding: 1.5rem;
}

.cm-status a,
.cm-status button {
  color: var(--cm-primary);
}

.cm-head {
  flex: 0 0 auto;
  display: grid;
  grid-template-columns: 36px 1fr auto;
  gap: 0.45rem;
  align-items: center;
  min-height: 44px;
}

.cm-head__back,
.cm-icon-btn {
  width: 36px;
  height: 36px;
  border: 1px solid var(--cm-border);
  border-radius: 12px;
  background: var(--cm-glass);
  color: var(--cm-text);
  display: grid;
  place-items: center;
  cursor: pointer;
  padding: 0;
}

.cm-head__vs {
  min-width: 0;
}

.cm-head__prep {
  display: inline-block;
  margin-top: 4px;
  font-size: 0.72rem;
  font-weight: 700;
  color: #7dd3fc;
  text-decoration: none;
}

.cm-head__kicker {
  margin: 0;
  color: var(--cm-muted);
  font-size: 0.62rem;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
}

.cm-head h1 {
  margin: 0;
  font-size: 0.92rem;
  font-weight: 800;
  letter-spacing: -0.03em;
  line-height: 1.15;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.cm-head__score {
  text-align: right;
  font-weight: 800;
  font-size: 1.55rem;
  letter-spacing: -0.04em;
  line-height: 0.9;
  font-variant-numeric: tabular-nums;
  color: var(--cm-text);
}

.cm-head__score span {
  display: block;
  margin-top: 0.12rem;
  color: var(--cm-muted);
  font-size: 0.62rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.cm-banner {
  flex: 0 0 auto;
  margin: 0.3rem 0 0;
  color: var(--cm-rec);
  font-size: 0.75rem;
  font-weight: 650;
}

.cm-tables {
  flex: 0 0 auto;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.3rem;
  margin-top: 0.32rem;
}

.cm-table {
  min-height: 44px;
  padding: 0.28rem 0.55rem;
  border-radius: 14px;
  border: 1px solid var(--cm-border);
  background: var(--cm-glass);
  display: grid;
  grid-template-columns: auto 1fr;
  grid-template-rows: auto auto;
  gap: 0.1rem 0.4rem;
  align-items: center;
}

.cm-table strong {
  font-size: 0.72rem;
  font-weight: 800;
  grid-column: 1;
}

.cm-table__meta {
  grid-column: 2;
  justify-self: end;
  color: var(--cm-muted);
  font-size: 0.66rem;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
}

.cm-table__scorewatch {
  grid-column: 1 / -1;
  color: #7dd3fc;
  font-size: 0.62rem;
  font-weight: 700;
}

.cm-table__cams {
  grid-column: 1 / -1;
  display: inline-flex;
  align-items: center;
  gap: 0.28rem;
  margin-top: 0.08rem;
  color: var(--cm-muted);
  font-size: 0.62rem;
  font-weight: 700;
}

.cm-table__cams.is-on {
  color: #7dd3fc;
}

.cm-table.has-cam {
  border-color: color-mix(in srgb, #7dd3fc 45%, var(--cm-border));
}

.cm-table.is-live {
  border-color: color-mix(in srgb, var(--cm-primary) 55%, var(--cm-border));
  box-shadow: 0 0 0 1px color-mix(in srgb, var(--cm-primary) 35%, transparent);
}

.cm-table.is-selected {
  border-color: color-mix(in srgb, var(--cm-primary) 70%, var(--cm-border));
  box-shadow: 0 0 0 2px color-mix(in srgb, var(--cm-primary) 40%, transparent);
  background: color-mix(in srgb, var(--cm-primary) 14%, var(--cm-glass));
}

button.cm-table {
  width: 100%;
  text-align: left;
  color: inherit;
  font: inherit;
  cursor: pointer;
}

button.cm-table:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.cm-tables--pick .cm-table.is-selected strong {
  color: var(--cm-primary);
}

.cm-cam-strip {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  gap: 0.4rem;
  margin: 0.35rem 0 0;
  padding: 0.35rem 0.55rem;
  border-radius: 999px;
  border: 1px solid color-mix(in srgb, #7dd3fc 35%, var(--cm-border));
  background: color-mix(in srgb, #7dd3fc 12%, var(--cm-glass));
  color: #7dd3fc;
  font-size: 0.72rem;
  font-weight: 700;
}

.cm-cam-strip .cm-rec {
  margin-left: auto;
}

.cm-status-chip {
  flex: 1 1 100%;
  margin: 0;
  min-height: 34px;
  display: grid;
  place-items: center;
  padding: 0 0.7rem;
  border-radius: 12px;
  border: 1px dashed var(--cm-border);
  background: var(--cm-glass);
  color: var(--cm-muted);
  font-size: 0.74rem;
  font-weight: 650;
  text-align: center;
}

.cm-status-chip--ok {
  border-style: solid;
  border-color: color-mix(in srgb, #7dd3fc 40%, var(--cm-border));
  color: #7dd3fc;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.35rem;
}

.cm-btn--block {
  width: 100%;
  flex: none;
  min-height: 44px;
}

.cm-score-cta {
  display: flex;
  flex-direction: column;
  gap: 0.45rem;
  margin-top: 0.35rem;
}

.cm-status-chip--block {
  width: 100%;
  justify-content: center;
  margin: 0;
  box-sizing: border-box;
}

.cm-reset-discrete {
  display: block;
  width: 100%;
  margin: 0.85rem 0 0;
  padding: 0.35rem;
  border: 0;
  background: transparent;
  color: var(--cm-muted);
  font: inherit;
  font-size: 0.72rem;
  font-weight: 650;
  text-decoration: underline;
  text-underline-offset: 0.15em;
  cursor: pointer;
  opacity: 0.75;
}

.cm-reset-discrete:hover:not(:disabled) {
  opacity: 1;
  color: #fb7185;
}

.cm-reset-discrete:disabled {
  opacity: 0.4;
  cursor: default;
}

.cm-sheet-label {
  margin: 0 0 0.35rem;
  color: var(--cm-muted);
  font-size: 0.72rem;
  font-weight: 650;
  flex: 0 0 auto;
}

.cm-focus-bar {
  display: grid;
  grid-template-columns: auto 1fr auto;
  gap: 0.35rem;
  align-items: center;
  flex: 0 0 auto;
}

.cm-focus-bar__back {
  display: inline-flex;
  align-items: center;
  gap: 0.1rem;
  min-height: 36px;
  padding: 0 0.5rem 0 0.2rem;
  border: 0;
  border-radius: 10px;
  background: transparent;
  color: var(--cm-primary);
  font-size: 0.72rem;
  font-weight: 750;
  cursor: pointer;
}

.cm-focus-bar__meta {
  min-width: 0;
  text-align: center;
}

.cm-focus-bar__meta em {
  display: block;
  font-style: normal;
  font-size: 0.9rem;
  font-weight: 800;
  letter-spacing: -0.02em;
}

.cm-focus-bar__meta span {
  display: block;
  color: var(--cm-muted);
  font-size: 0.68rem;
  font-weight: 650;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.cm-icon-btn--ghost {
  border-color: transparent;
  background: transparent;
  pointer-events: none;
}

/* Live score console: players + big score + equal −/+ below (no overlap) */
.cm-scoredeck {
  flex: 0 1 auto;
  min-height: 0;
  max-height: min(52dvh, 24rem);
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto minmax(0, 1fr);
  gap: 0.4rem 0.35rem;
  align-items: stretch;
  padding: 0.65rem 0.45rem 0.7rem;
  border-radius: 22px;
  border: 1px solid var(--cm-border);
  background:
    radial-gradient(
      120% 80% at 50% -20%,
      color-mix(in srgb, var(--cm-primary) 22%, transparent),
      transparent 55%
    ),
    var(--cm-glass);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.04);
}

.cm-scoredeck__lane {
  min-width: 0;
  min-height: 0;
  display: grid;
  grid-template-rows: minmax(0, 1fr) auto auto;
  align-content: start;
  gap: 0.35rem;
  overflow: hidden;
}

.cm-scoredeck__players {
  display: flex;
  flex-direction: column;
  gap: 0.28rem;
  min-height: 0;
  max-height: 8.5rem;
  overflow-x: hidden;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  overscroll-behavior: contain;
  padding-right: 0.1rem;
}

.cm-scoredeck__players--right {
  align-items: flex-end;
  text-align: right;
}

.cm-scoredeck__player {
  min-width: 0;
  max-width: 100%;
}

.cm-scoredeck__fullname {
  display: block;
  margin: 0;
  color: var(--cm-text);
  font-size: clamp(0.78rem, 3.6vw, 0.95rem);
  font-weight: 800;
  line-height: 1.2;
  letter-spacing: -0.02em;
  overflow-wrap: anywhere;
  word-break: break-word;
}

.cm-scoredeck__meta {
  display: block;
  margin-top: 0.12rem;
  color: var(--cm-muted);
  font-size: clamp(0.62rem, 2.8vw, 0.72rem);
  font-weight: 700;
  line-height: 1.2;
}

.cm-scoredeck__pts {
  margin: 0;
  padding: 0.15rem 0;
  text-align: center;
  font-size: clamp(2.6rem, 14vw, 4.25rem);
  font-weight: 800;
  letter-spacing: -0.07em;
  line-height: 1;
  font-variant-numeric: tabular-nums;
}

.cm-scoredeck__btns {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.4rem;
  position: relative;
  z-index: 2;
  --cm-score-btn: clamp(3rem, 14vw, 3.55rem);
}

.cm-scoredeck--score-edit .cm-scoredeck__pts {
  display: none;
}

.cm-scoredeck--score-edit .cm-scoredeck__lane {
  grid-template-rows: minmax(0, 1fr);
}

.cm-scoredeck__btn {
  width: 100%;
  height: var(--cm-score-btn);
  min-height: var(--cm-score-btn);
  border: 2px solid #f8fafc;
  border-radius: 16px;
  background: #0f172a;
  color: #fff;
  font-size: 1.65rem;
  font-weight: 700;
  line-height: 1;
  display: grid;
  place-items: center;
  cursor: pointer;
  padding: 0;
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.35);
  transition: transform 0.12s var(--cm-ease), opacity 0.12s var(--cm-ease);
  -webkit-tap-highlight-color: transparent;
  touch-action: manipulation;
  -webkit-user-select: none;
          user-select: none;
}

.cm-scoredeck__btn:active:not(:disabled) {
  transform: scale(0.94);
}

.cm-scoredeck__btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
  pointer-events: none;
  filter: grayscale(0.2);
}

.cm-scoredeck__btn--plus {
  color: #fff;
}

.cm-scoredeck__btn--home {
  background: var(--cm-primary, #0877bc);
  border-color: #f8fafc;
  box-shadow: 0 8px 18px color-mix(in srgb, var(--cm-primary) 42%, transparent);
}

.cm-scoredeck__btn--away {
  background: #d97706;
  border-color: #f8fafc;
  box-shadow: 0 8px 18px rgba(217, 119, 6, 0.42);
}

.cm-page--light .cm-scoredeck__btn {
  background: #0f172a;
  color: #fff;
  border-color: #0f172a;
}

.cm-page--light .cm-scoredeck__btn--home {
  background: var(--cm-primary, #0877bc);
  border-color: #0f172a;
  color: #fff;
}

.cm-page--light .cm-scoredeck__btn--away {
  background: #b45309;
  border-color: #0f172a;
  color: #fff;
}

.cm-scoredeck__sets {
  align-self: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.15rem;
  min-width: 3rem;
  padding: 0.55rem 0.3rem;
  border-radius: 14px;
  border: 1px solid var(--cm-border);
  background: rgba(0, 0, 0, 0.22);
}

.cm-page--light .cm-scoredeck__sets {
  background: rgba(15, 23, 42, 0.04);
}

.cm-scoredeck__sets strong {
  font-size: 1.15rem;
  font-weight: 800;
  letter-spacing: -0.03em;
  font-variant-numeric: tabular-nums;
  line-height: 1;
}

.cm-scoredeck__lane.is-winner .cm-scoredeck__pts {
  color: #f5d76e;
  text-shadow: 0 0 18px color-mix(in srgb, #f5d76e 45%, transparent);
}

.cm-scoredeck__lane.is-winner .cm-scoredeck__fullname {
  color: #f5d76e;
}

.cm-page--light .cm-scoredeck__lane.is-winner .cm-scoredeck__pts,
.cm-page--light .cm-scoredeck__lane.is-winner .cm-scoredeck__fullname {
  color: #b45309;
}

.cm-scoredeck.is-set-over {
  box-shadow:
    inset 0 1px 0 rgba(255, 255, 255, 0.06),
    0 0 0 1px color-mix(in srgb, #f5d76e 35%, transparent);
}

.cm-set-banner {
  margin: 0.15rem 0 0;
  padding: 0.45rem 0.7rem;
  border-radius: 14px;
  text-align: center;
  font-size: 0.92rem;
  font-weight: 800;
  letter-spacing: -0.02em;
  background: color-mix(in srgb, #f5d76e 18%, var(--cm-glass));
  border: 1px solid color-mix(in srgb, #f5d76e 40%, var(--cm-border));
}

.cm-set-banner.is-home {
  background: color-mix(in srgb, var(--cm-primary) 22%, var(--cm-glass));
  border-color: color-mix(in srgb, var(--cm-primary) 45%, var(--cm-border));
}

.cm-set-banner.is-away {
  background: color-mix(in srgb, var(--cm-away) 22%, var(--cm-glass));
  border-color: color-mix(in srgb, var(--cm-away) 45%, var(--cm-border));
}

.cm-btn--start-set {
  margin-top: 0.15rem;
  min-height: 48px;
  font-weight: 800;
}

.cm-scoredeck__sets span {
  color: var(--cm-muted);
  font-size: 0.58rem;
  font-weight: 750;
  text-transform: uppercase;
  letter-spacing: 0.06em;
}

.cm-score-modes {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.28rem;
  flex: 0 0 auto;
}

.cm-score-modes button {
  min-height: 34px;
  border: 1px solid var(--cm-border);
  border-radius: 999px;
  background: var(--cm-glass);
  color: var(--cm-muted);
  font-size: 0.68rem;
  font-weight: 700;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.28rem;
  cursor: pointer;
}

.cm-score-modes button.is-on {
  background: var(--cm-primary);
  border-color: var(--cm-primary);
  color: #fff;
}

.cm-follow--compact {
  flex: 0 0 auto;
  min-height: 0;
  padding: 0.55rem;
  font-size: 0.78rem;
}

.cm-rec {
  display: inline-flex;
  align-items: center;
  gap: 0.28rem;
  color: var(--cm-rec);
  font-size: 0.62rem;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.cm-rec i {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: var(--cm-rec);
  animation: cm-pulse 1.1s var(--cm-ease) infinite;
}

.cm-head__rec {
  display: inline-flex;
  margin-top: 0.28rem;
  justify-content: flex-end;
}

.cm-table__rec {
  margin-left: 0.28rem;
  vertical-align: middle;
}

.cm-preview-badge {
  color: #e2e8f0;
  font-size: 0.62rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
}

.cm-tabs__icon {
  position: relative;
  display: inline-flex;
}

.cm-tabs__rec {
  position: absolute;
  top: -2px;
  right: -6px;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: var(--cm-rec);
  animation: cm-pulse 1.1s var(--cm-ease) infinite;
}

@keyframes cm-pulse {
  50% {
    opacity: 0.35;
  }
}

.cm-cam-perm {
  flex: 0 0 auto;
  margin-top: 0.45rem;
  padding: 0.65rem 0.75rem;
  border-radius: 14px;
  border: 1px solid color-mix(in srgb, var(--cm-rec) 42%, var(--cm-border));
  background: color-mix(in srgb, var(--cm-rec) 14%, var(--cm-glass));
  color: var(--cm-text);
  font-size: 0.78rem;
  line-height: 1.4;
  font-weight: 600;
}

.cm-actions {
  flex: 0 0 auto;
  display: flex;
  flex-wrap: wrap;
  gap: 0.35rem;
  margin-top: 0.4rem;
}

.cm-btn {
  flex: 1 1 auto;
  min-width: calc(50% - 0.2rem);
  min-height: 34px;
  border: 0;
  border-radius: 12px;
  background: var(--cm-primary);
  color: #fff;
  font-size: 0.78rem;
  font-weight: 700;
  cursor: pointer;
  padding: 0 0.6rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.3rem;
}

.cm-btn:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.cm-btn--ghost {
  background: transparent;
  color: var(--cm-text);
  border: 1px solid var(--cm-border);
}

.cm-btn--danger {
  background: var(--cm-rec);
}

.cm-btn--rec {
  background: var(--cm-rec);
  color: #fff;
}

.cm-body {
  flex: 1 1 auto;
  min-height: 0;
  margin-top: 0.45rem;
  display: flex;
  flex-direction: column;
  position: relative;
}

.cm-panel {
  flex: 1 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.cm-scroll {
  flex: 1 1;
  min-height: 0;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
}

.cm-scroll--sheet {
  display: flex;
  flex-direction: column;
  overscroll-behavior: contain;
  touch-action: pan-y;
  padding-bottom: 0.25rem;
}

.cm-scroll--sheet .cm-rubbers--sheet {
  flex: 0 0 auto;
  min-height: auto;
  overflow: visible;
  padding-bottom: calc(0.75rem + env(safe-area-inset-bottom, 0px));
}

.cm-rubbers {
  flex: 1 1 auto;
  min-height: 0;
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 0.28rem;
  overflow: auto;
}

.cm-rubbers--sheet {
  /* Scroll the list; size rows to content so names are never clipped. */
  flex: 1 1 auto;
  min-height: 0;
  grid-template-columns: 1fr;
  grid-auto-rows: min-content;
  align-content: start;
  gap: 0.45rem;
  padding-bottom: calc(0.75rem + env(safe-area-inset-bottom, 0px));
  overflow-x: hidden;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  overscroll-behavior: contain;
  touch-action: pan-y;
}

.cm-rubber {
  min-height: 38px;
  border: 1px solid var(--cm-border);
  border-radius: 12px;
  background: var(--cm-glass);
  color: var(--cm-text);
  padding: 0.2rem 0.15rem;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.05rem;
}

.cm-rubber em {
  font-style: normal;
  font-size: 0.62rem;
  font-weight: 800;
}

.cm-rubber span {
  font-size: 0.58rem;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
  color: var(--cm-muted);
}

.cm-rubber__names {
  max-width: 100%;
  padding: 0 0.1rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 0.52rem !important;
  font-weight: 650 !important;
  line-height: 1.1;
}

.cm-rubber.is-live {
  border-color: color-mix(in srgb, var(--cm-primary) 60%, transparent);
  background: color-mix(in srgb, var(--cm-primary) 18%, var(--cm-glass));
}

.cm-rubber.is-on {
  box-shadow: inset 0 0 0 1.5px var(--cm-primary);
}

.cm-rubber.is-done span {
  color: var(--cm-text);
}

.cm-rubber-card {
  width: 100%;
  border: 1px solid var(--cm-border);
  border-radius: 18px;
  background: var(--cm-glass);
  color: var(--cm-text);
  padding: 0.75rem 0.8rem;
  cursor: pointer;
  text-align: left;
  display: flex;
  flex-direction: column;
  gap: 0.55rem;
  -webkit-tap-highlight-color: transparent;
  position: relative;
  /* overflow:hidden + grid compression was clipping player names */
  overflow: visible;
  min-height: min-content;
  flex-shrink: 0;
}

.cm-rubber-card.is-readonly {
  cursor: default;
  gap: 0.55rem;
  padding: 0.75rem 0.8rem 0.85rem;
  background:
    linear-gradient(
      180deg,
      color-mix(in srgb, var(--cm-primary) 10%, transparent),
      transparent 38%
    ),
    var(--cm-glass);
}

.cm-rubber-card.is-readonly .cm-rubber-card__top {
  order: -1;
  padding-bottom: 0.15rem;
  border-bottom: 1px solid color-mix(in srgb, var(--cm-border) 70%, transparent);
  margin-bottom: 0.05rem;
}

.cm-rubber-card.is-readonly .cm-rubber-card__scoreline {
  margin-left: auto;
}

.cm-rubber-card.is-readonly .cm-rubber-card__setn {
  font-size: 1.35rem;
}

.cm-rubber-card.is-readonly .cm-rubber-card__setn.is-win {
  font-size: 1.48rem;
}

.cm-rubber-card.is-readonly .cm-rubber-card__review {
  order: 3;
}

.cm-rubber-card__top {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  flex-wrap: wrap;
}

.cm-rubber-card__top em {
  font-style: normal;
  font-size: 0.85rem;
  font-weight: 800;
  letter-spacing: -0.02em;
}

.cm-rubber-card__table {
  display: inline-flex;
  align-items: center;
  gap: 0.22rem;
  color: var(--cm-muted);
  font-size: 0.7rem;
  font-weight: 700;
}

.cm-rubber-card__table.has-cam {
  color: var(--cm-text);
}

.cm-rubber-card__scoreline {
  margin-left: auto;
  display: inline-flex;
  align-items: baseline;
  gap: 0.18rem;
  font-variant-numeric: tabular-nums;
}

.cm-rubber-card__points {
  flex-basis: 100%;
  margin: 0.05rem 0 0;
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.01em;
  font-variant-numeric: tabular-nums;
  color: var(--cm-muted);
}

.cm-rubber-card__setn {
  font-size: 1.15rem;
  font-weight: 800;
  letter-spacing: -0.03em;
  color: var(--cm-muted);
  min-width: 0.9em;
  text-align: center;
}

.cm-rubber-card__setn.is-win {
  color: var(--cm-home);
  font-size: 1.28rem;
}

.cm-rubber-card__setn.is-lose {
  color: var(--cm-muted);
  opacity: 0.72;
}

.cm-rubber-card__score-sep {
  color: var(--cm-muted);
  font-size: 0.95rem;
  font-weight: 700;
}

.cm-rubber-card__badge {
  display: inline-flex;
  align-items: center;
  gap: 0.22rem;
  padding: 0.14rem 0.45rem;
  border-radius: 999px;
  background: color-mix(in srgb, var(--cm-primary) 28%, transparent);
  color: var(--cm-text);
  font-size: 0.58rem;
  font-weight: 800;
  letter-spacing: 0.06em;
  text-transform: uppercase;
}

.cm-rubber-card__badge--live i {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #fb7185;
  animation: cm-pulse 1.1s var(--cm-ease) infinite;
}

.cm-rubber-card__badge--live {
  background: color-mix(in srgb, #fb7185 28%, transparent);
  color: #fecdd3;
}

.cm-rubber-card__badge--final {
  background: color-mix(in srgb, var(--cm-home) 22%, transparent);
  color: color-mix(in srgb, var(--cm-home) 70%, #fff);
}

.cm-rubber-card__badge--done {
  background: rgba(148, 163, 184, 0.22);
}

.cm-rubber-card__vs,
.cm-rubber-card__matchup {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto minmax(0, 1fr);
  gap: 0.45rem;
  align-items: start;
  width: 100%;
  flex: 0 0 auto;
}

.cm-rubber-card__side,
.cm-rubber-card__fighter {
  position: relative;
  z-index: 1;
  min-width: 0;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  padding: 0.45rem 0.5rem;
  border-radius: 12px;
  border: 1px solid transparent;
  background: rgba(255, 255, 255, 0.06);
  isolation: isolate;
}

.cm-page--light .cm-rubber-card__fighter {
  background: rgba(15, 23, 42, 0.05);
}

.cm-rubber-card__side--away,
.cm-rubber-card__fighter--away {
  text-align: right;
  align-items: flex-end;
}

.cm-rubber-card__fighter.is-winner {
  background: color-mix(in srgb, var(--cm-home) 16%, transparent);
  border-color: color-mix(in srgb, var(--cm-home) 42%, transparent);
}

.cm-rubber-card__fighter.is-winner .cm-rubber-card__names-line {
  color: var(--cm-home) !important;
}

.cm-rubber-card__fighter.is-loser {
  opacity: 1;
  background: color-mix(in srgb, var(--cm-rec) 16%, transparent);
  border-color: color-mix(in srgb, var(--cm-rec) 42%, transparent);
}

.cm-rubber-card__fighter.is-loser .cm-rubber-card__names-line {
  opacity: 1;
  color: var(--cm-rec) !important;
}

.cm-page--light .cm-rubber-card__fighter.is-winner .cm-rubber-card__names-line {
  color: var(--cm-home) !important;
}

.cm-page--light .cm-rubber-card__fighter.is-loser .cm-rubber-card__names-line {
  color: var(--cm-rec) !important;
}

.cm-rubber-card__result {
  display: inline-flex;
  align-items: center;
  gap: 0.22rem;
  font-size: 0.62rem;
  font-weight: 800;
  letter-spacing: 0.06em;
  text-transform: uppercase;
}

.cm-rubber-card__result--win {
  color: var(--cm-home);
}

.cm-rubber-card__result--lose {
  color: var(--cm-rec);
}

.cm-rubber-card__fighter--away .cm-rubber-card__result {
  flex-direction: row-reverse;
}

.cm-rubber-card__names-line {
  display: block;
  margin: 0;
  color: #f8fafc !important;
  font-size: clamp(1rem, 4.4vw, 1.18rem) !important;
  font-weight: 800 !important;
  line-height: 1.3 !important;
  letter-spacing: -0.02em;
  overflow-wrap: anywhere;
  word-break: break-word;
  white-space: normal;
  opacity: 1 !important;
  visibility: visible !important;
  min-height: 1.3em;
}

.cm-page--light .cm-rubber-card__names-line {
  color: #0f172a !important;
}

.cm-rubber-card__meta-line {
  display: block;
  margin: 0;
  color: var(--cm-muted);
  font-size: 0.68rem;
  font-weight: 700;
  line-height: 1.2;
}

.cm-rubber-card__names {
  display: flex;
  flex-direction: column;
  gap: 0.28rem;
  width: 100%;
  min-width: 0;
}

.cm-rubber-card__player {
  min-width: 0;
}

.cm-rubber-card__player strong {
  display: block;
  font-size: clamp(0.88rem, 3.8vw, 1.02rem);
  font-weight: 800;
  line-height: 1.25;
  letter-spacing: -0.02em;
  color: var(--cm-text);
  overflow-wrap: anywhere;
  word-break: break-word;
}

.cm-rubber-card__side.is-winner .cm-rubber-card__player strong {
  font-weight: 800;
}

.cm-rubber-card__player span {
  display: block;
  margin-top: 0.08rem;
  color: var(--cm-muted);
  font-size: 0.68rem;
  font-weight: 700;
}

.cm-rubber-card__sep {
  align-self: center;
  color: var(--cm-muted);
  font-size: 0.78rem;
  font-weight: 800;
  letter-spacing: 0.04em;
  text-transform: none;
  padding-top: 0.15rem;
}

.cm-rubber-card.is-live {
  border-color: color-mix(in srgb, var(--cm-primary) 55%, transparent);
  background: color-mix(in srgb, var(--cm-primary) 14%, var(--cm-glass));
}

.cm-rubber-card.is-on {
  box-shadow: inset 0 0 0 1.5px var(--cm-primary);
}

.cm-rubber-card.is-done {
  border-color: color-mix(in srgb, var(--cm-home) 28%, var(--cm-border));
  background:
    linear-gradient(
      90deg,
      color-mix(in srgb, var(--cm-home) 18%, transparent),
      transparent 42%
    ),
    var(--cm-glass);
  box-shadow: inset 3px 0 0 var(--cm-home);
}

.cm-rubber-card.is-readonly:active {
  transform: none;
}

.cm-rubber-card.is-done.is-winner-away {
  background:
    linear-gradient(
      270deg,
      color-mix(in srgb, var(--cm-home) 18%, transparent),
      transparent 42%
    ),
    var(--cm-glass);
  box-shadow: inset -3px 0 0 var(--cm-home);
}

.cm-live {
  flex: 1 1;
  min-height: 0;
  margin-top: 0.4rem;
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  overflow-x: hidden;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  overscroll-behavior: contain;
  padding-bottom: 0.35rem;
}

.cm-live__meta {
  display: flex;
  justify-content: space-between;
  gap: 0.4rem;
  align-items: baseline;
  min-height: 1.1rem;
}

.cm-live__meta strong {
  font-size: 0.82rem;
  font-weight: 750;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.cm-live__meta span {
  color: var(--cm-muted);
  font-size: 0.68rem;
  font-weight: 650;
  flex-shrink: 0;
}

.cm-edit-score {
  flex: 0 0 auto;
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  gap: 0.45rem;
  align-items: end;
  padding: 0.2rem 0 0.35rem;
  position: relative;
  z-index: 3;
}

.cm-edit-score label {
  display: flex;
  flex-direction: column;
  gap: 0.28rem;
  min-width: 0;
  font-size: 0.72rem;
  font-weight: 700;
  color: var(--cm-muted);
  line-height: 1.2;
  overflow: hidden;
  text-overflow: ellipsis;
}

.cm-edit-score label input {
  width: 100%;
  box-sizing: border-box;
}

.cm-edit-score input {
  min-height: 64px;
  border: 2px solid color-mix(in srgb, var(--cm-primary) 45%, var(--cm-border));
  border-radius: 14px;
  background: #0b1220;
  color: #f8fafc;
  -webkit-text-fill-color: #f8fafc;
  caret-color: #38bdf8;
  color-scheme: dark;
  font-size: 1.85rem;
  font-weight: 800;
  text-align: center;
  font-variant-numeric: tabular-nums;
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.06);
}

.cm-edit-score input:focus {
  outline: none;
  border-color: #38bdf8;
  box-shadow: 0 0 0 3px color-mix(in srgb, #38bdf8 28%, transparent);
}

.cm-edit-score input::placeholder {
  color: #64748b;
  -webkit-text-fill-color: #64748b;
}

.cm-page--light .cm-edit-score input {
  background: #ffffff;
  color: #0f172a;
  -webkit-text-fill-color: #0f172a;
  caret-color: var(--cm-primary);
  color-scheme: light;
  border-color: color-mix(in srgb, var(--cm-primary) 35%, #cbd5e1);
  box-shadow: inset 0 0 0 1px rgba(15, 23, 42, 0.04);
}

.cm-edit-score > span {
  font-size: 1.4rem;
  font-weight: 800;
  padding-bottom: 0.85rem;
  color: var(--cm-text);
}

.cm-edit-score .cm-btn {
  grid-column: 1 / -1;
}

.cm-head__live-score {
  display: block;
  font-size: 1.85rem;
  font-weight: 800;
  letter-spacing: -0.05em;
  font-variant-numeric: tabular-nums;
  line-height: 0.95;
}

.cm-head__match-hint {
  margin: 0.18rem 0 0;
  color: var(--cm-muted);
  font-size: 0.66rem;
  font-weight: 650;
}

.cm-match-status {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  gap: 0.55rem;
  margin-top: 0.35rem;
  padding: 0.4rem 0.6rem;
  border-radius: 14px;
  border: 1px solid var(--cm-border);
  background: var(--cm-glass);
  font-size: 0.72rem;
  font-weight: 700;
}

.cm-match-status .cm-rec {
  margin-left: auto;
}

.cm-cam__context {
  margin: 0;
  padding: 0.35rem 0.55rem;
  border-radius: 999px;
  border: 1px solid color-mix(in srgb, var(--cm-primary) 40%, var(--cm-border));
  background: color-mix(in srgb, var(--cm-primary) 14%, var(--cm-glass));
  color: var(--cm-text);
  font-size: 0.72rem;
  font-weight: 700;
  text-align: center;
}

.cm-page--in-match .cm-head h1 {
  font-size: 0.98rem;
}

.cm-chip:disabled {
  opacity: 0.35;
  cursor: not-allowed;
}

.cm-follow {
  flex: 1 1;
  display: grid;
  place-items: center;
  text-align: center;
  color: var(--cm-muted);
  font-size: 0.86rem;
  padding: 0.6rem;
  border-radius: 16px;
  border: 1px solid var(--cm-border);
  background: var(--cm-glass);
}

.cm-stamps {
  flex: 0 0 auto;
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  gap: 0.35rem;
  margin-top: 0.35rem;
  padding: 0.15rem 0 0.1rem;
  max-height: none;
  overflow: visible;
}

.cm-stamps-wrap {
  flex: 0 0 auto;
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  margin-top: 0.35rem;
}

.cm-timeout-toggle {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.45rem;
  width: 100%;
  min-height: 2.6rem;
  border-radius: 12px;
  border: 1px solid color-mix(in srgb, #c45c26 45%, var(--cm-border));
  background: color-mix(in srgb, #c45c26 16%, var(--cm-glass));
  color: var(--cm-text);
  font-weight: 750;
  font-size: 0.9rem;
  cursor: pointer;
}

.cm-timeout-toggle.is-on {
  border-color: color-mix(in srgb, #0a7a3e 50%, var(--cm-border));
  background: color-mix(in srgb, #0a7a3e 18%, var(--cm-glass));
}

.cm-timeout-toggle:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.cm-timeout-toggle__mark {
  display: inline-flex;
}

.cm-timeout-banner {
  margin: 0;
  padding: 0.45rem 0.65rem;
  border-radius: 10px;
  font-size: 0.78rem;
  line-height: 1.35;
  color: var(--cm-text);
  background: color-mix(in srgb, #c45c26 12%, var(--cm-glass));
  border: 1px solid color-mix(in srgb, #c45c26 28%, var(--cm-border));
}

.cm-tagchip:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.cm-tagchip {
  --tag-accent: var(--cm-primary);
  --tag-fill: color-mix(in srgb, var(--tag-accent) 14%, var(--cm-glass));
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  min-width: 0;
  min-height: 2.35rem;
  max-width: 100%;
  border: 1px solid color-mix(in srgb, var(--tag-accent) 35%, var(--cm-border));
  border-radius: 12px;
  background: var(--tag-fill);
  color: var(--cm-text);
  padding: 0.28rem 0.55rem 0.28rem 0.35rem;
  cursor: pointer;
  box-sizing: border-box;
  flex-grow: 1;
  flex-shrink: 1;
  flex-basis: calc(33.333% - 0.35rem);
  transition: transform 0.12s var(--cm-ease), border-color 0.15s ease,
    background 0.15s ease, box-shadow 0.15s ease;
}

.cm-tagchip__mark {
  flex: 0 0 auto;
  width: 1.55rem;
  height: 1.55rem;
  border-radius: 8px;
  display: grid;
  place-items: center;
  background: color-mix(in srgb, var(--tag-accent) 22%, transparent);
  color: var(--tag-accent);
}

.cm-tagchip__text {
  flex: 1 1 auto;
  min-width: 0;
  font-size: clamp(0.62rem, 2.6vw, 0.74rem);
  font-weight: 750;
  line-height: 1.15;
  letter-spacing: -0.01em;
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.cm-tagchip--serve {
  --tag-accent: #38bdf8;
}

.cm-tagchip--error {
  --tag-accent: #fb7185;
}

.cm-tagchip--winner {
  --tag-accent: #34d399;
}

.cm-tagchip--moment {
  --tag-accent: #a78bfa;
}

.cm-tagchip--schema {
  --tag-accent: #fbbf24;
}

.cm-tagchip--more {
  --tag-accent: var(--cm-primary);
  flex-grow: 1;
  flex-shrink: 1;
  flex-basis: calc(33.333% - 0.35rem);
  border-style: dashed;
}

.cm-tagchip.is-on {
  background: color-mix(in srgb, var(--tag-accent) 28%, var(--cm-glass));
  border-color: color-mix(in srgb, var(--tag-accent) 72%, transparent);
  box-shadow: inset 0 0 0 1px color-mix(in srgb, var(--tag-accent) 35%, transparent);
}

.cm-tagchip.is-on .cm-tagchip__mark {
  background: var(--tag-accent);
  color: #0b0f19;
}

.cm-page--light .cm-tagchip.is-on .cm-tagchip__mark {
  color: #fff;
}

.cm-tagchip:active {
  transform: scale(0.97);
}

.cm-tagdock {
  flex: 0 1 auto;
  min-height: 0;
  max-height: min(48dvh, 22rem);
  display: flex;
  flex-direction: column;
  gap: 0.45rem;
  margin-top: 0.35rem;
  padding: 0.55rem 0.55rem 0.45rem;
  border-radius: 16px;
  border: 1px solid var(--cm-border);
  background: var(--cm-slate);
  overflow: hidden;
  position: relative;
  z-index: 2;
}

.cm-tagdock__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  flex: 0 0 auto;
}

.cm-tagdock__head strong {
  font-size: 0.82rem;
  font-weight: 800;
  letter-spacing: -0.01em;
}

.cm-tagdock__close {
  width: 2rem;
  height: 2rem;
  border: 1px solid var(--cm-border);
  border-radius: 999px;
  background: transparent;
  color: var(--cm-text);
  display: grid;
  place-items: center;
  cursor: pointer;
  flex: 0 0 auto;
}

.cm-tagdock__scroll {
  flex: 1 1 auto;
  min-height: 0;
  overflow-x: hidden;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  display: flex;
  flex-direction: column;
  gap: 0.65rem;
  padding-bottom: 0.15rem;
}

.cm-tagdock__group {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  min-width: 0;
}

.cm-tagdock__label {
  margin: 0;
  font-size: 0.66rem;
  font-weight: 750;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--cm-muted);
}

.cm-tagdock__chips {
  display: flex;
  flex-wrap: wrap;
  gap: 0.35rem;
}

.cm-tagdock__chips .cm-tagchip {
  flex-grow: 1;
  flex-shrink: 1;
  flex-basis: calc(50% - 0.35rem);
  max-width: calc(50% - 0.18rem);
}

/* Legacy stamp used only if referenced elsewhere */
.cm-stamp {
  min-width: 0;
  min-height: 2.35rem;
  border: 1px solid var(--cm-border);
  border-radius: 12px;
  background: var(--cm-glass);
  color: var(--cm-text);
  font-size: 0.7rem;
  font-weight: 700;
  padding: 0.28rem 0.45rem;
  cursor: pointer;
}

.cm-stamp.is-on {
  background: color-mix(in srgb, var(--cm-primary) 22%, var(--cm-glass));
  border-color: color-mix(in srgb, var(--cm-primary) 55%, transparent);
}

.cm-btn--dock {
  background: color-mix(in srgb, #0f172a 70%, var(--cm-primary));
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.35rem;
}

.cm-calib {
  position: fixed;
  inset: 0;
  z-index: 90;
  display: flex;
  flex-direction: column;
  background: #000;
  padding: env(safe-area-inset-top, 0) 0 env(safe-area-inset-bottom, 0);
}

.cm-calib__stage {
  position: relative;
  flex: 1 1;
  min-height: 0;
  background: #000;
}

.cm-calib__video {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: contain;
  background: #000;
}

.cm-calib__hint {
  flex: 0 0 auto;
  margin: 0;
  padding: 0.55rem 0.85rem;
  color: #cbd5e1;
  font-size: 0.75rem;
  font-weight: 650;
  text-align: center;
  background: #0b1220;
}

.cm-cam-settings {
  position: fixed;
  inset: 0;
  z-index: 92;
  display: grid;
  place-items: end center;
  padding: 0.85rem;
  padding-bottom: calc(0.85rem + env(safe-area-inset-bottom, 0px));
  background: rgba(2, 6, 23, 0.55);
}

.cm-cam-settings__card {
  width: min(420px, 100%);
  border-radius: 18px;
  border: 1px solid var(--cm-border);
  background: var(--cm-slate);
  padding: 0.85rem;
  box-shadow: 0 18px 40px rgba(0, 0, 0, 0.35);
  display: flex;
  flex-direction: column;
  gap: 0.55rem;
  max-height: min(92dvh, 720px);
}

.cm-cam-settings__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
}

.cm-cam-settings__head strong {
  font-size: 0.95rem;
  font-weight: 800;
}

.cm-cam-settings__stage {
  position: relative;
  width: 100%;
  aspect-ratio: 3 / 4;
  max-height: 48dvh;
  border-radius: 14px;
  overflow: hidden;
  background: #0b1220;
  touch-action: none;
  user-select: none;
  -webkit-user-select: none;
}

.cm-cam-settings__preview {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  transform-origin: center center;
  pointer-events: none;
}

.cm-cam-settings__zoom-pill {
  position: absolute;
  top: 0.55rem;
  right: 0.55rem;
  z-index: 2;
  padding: 0.22rem 0.5rem;
  border-radius: 999px;
  background: rgba(2, 6, 23, 0.72);
  color: #f8fafc;
  font-size: 0.72rem;
  font-weight: 800;
  letter-spacing: 0.02em;
  pointer-events: none;
}

.cm-cam-settings__hint {
  margin: 0;
  color: var(--cm-muted);
  font-size: 0.74rem;
  font-weight: 650;
}

.cm-cam-settings__cams {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.4rem;
}

.cm-cam-settings__cam {
  min-height: 44px;
  border: 1px solid var(--cm-border);
  border-radius: 12px;
  background: var(--cm-glass);
  color: var(--cm-text);
  font-size: 0.82rem;
  font-weight: 750;
  cursor: pointer;
}

.cm-cam-settings__cam.is-on {
  background: var(--cm-primary);
  border-color: var(--cm-primary);
  color: #fff;
}

.cm-cam-settings__cam:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.cm-cam-settings__reset {
  width: 100%;
}

.cm-cam-settings__encode {
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  margin-top: 0.85rem;
}

.cm-cam-settings__encode-label {
  font-size: 0.72rem;
  letter-spacing: 0.02em;
  opacity: 0.72;
}

.cm-cam-settings__encode-row {
  display: flex;
  flex-wrap: wrap;
  gap: 0.35rem;
}

.cm-cam-settings--landscape {
  place-items: stretch;
  padding: 0;
  background: #000;
  pointer-events: none;
}

.cm-cam-settings--landscape .cm-cam-settings__close,
.cm-cam-settings--landscape .cm-cam-settings__cams,
.cm-cam-settings--landscape .cm-cam-settings__zoom-pill {
  pointer-events: auto;
}

.cm-cam-settings--landscape .cm-cam-settings__close {
  position: absolute;
  top: calc(0.55rem + env(safe-area-inset-top, 0px));
  right: calc(0.55rem + env(safe-area-inset-right, 0px));
  z-index: 3;
  min-height: 40px;
  padding: 0.4rem 0.85rem;
  border-radius: 999px;
  border: 1px solid rgba(255, 255, 255, 0.35);
  background: rgba(0, 0, 0, 0.28);
  color: #fff;
  font-size: 0.78rem;
  font-weight: 750;
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
}

.cm-cam-settings--landscape .cm-cam-settings__zoom-pill {
  position: absolute;
  top: calc(0.55rem + env(safe-area-inset-top, 0px));
  left: calc(0.55rem + env(safe-area-inset-left, 0px));
  z-index: 3;
  right: auto;
}

.cm-cam-settings__cams--overlay {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 3;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 0.4rem;
  padding: 0.55rem
    calc(0.55rem + env(safe-area-inset-right, 0px))
    calc(0.7rem + env(safe-area-inset-bottom, 0px))
    calc(0.55rem + env(safe-area-inset-left, 0px));
  background: transparent;
}

.cm-cam-settings--landscape .cm-cam-settings__cam {
  min-height: 42px;
  padding: 0.4rem 0.85rem;
  border-radius: 999px;
  border: 1px solid rgba(255, 255, 255, 0.38);
  background: rgba(0, 0, 0, 0.28);
  color: #fff;
  font-size: 0.78rem;
  font-weight: 750;
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.25);
}

.cm-cam-settings--landscape .cm-cam-settings__cam.is-on {
  background: rgba(8, 119, 188, 0.72);
  border-color: rgba(255, 255, 255, 0.55);
  color: #fff;
}

.cm-cam-record-canvas {
  position: absolute;
  width: 1px;
  height: 1px;
  opacity: 0;
  pointer-events: none;
  overflow: hidden;
}

.cm-score-jump {
  position: fixed;
  inset: 0;
  z-index: 160;
  display: grid;
  place-items: center;
  padding: 1.25rem;
  background: rgba(2, 6, 23, 0.72);
}

.cm-score-jump__card {
  width: min(22rem, 100%);
  border-radius: 18px;
  padding: 1.1rem 1.15rem 1rem;
  background: #0f172a;
  border: 1px solid rgba(255, 255, 255, 0.14);
  color: #f8fafc;
  text-align: center;
}

.cm-score-jump__card p {
  margin: 0;
}

.cm-score-jump__card strong {
  display: block;
  margin: 0.45rem 0 0.7rem;
  font-size: 1.7rem;
  font-variant-numeric: tabular-nums;
  letter-spacing: 0.02em;
}

.cm-score-jump__acts {
  display: flex;
  gap: 0.5rem;
  justify-content: center;
  margin-top: 0.9rem;
}

.cm-dock-dim {
  position: fixed;
  inset: 0;
  z-index: 95;
  border: 0;
  padding: 0 1rem;
  margin: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.55rem;
  background: rgba(0, 0, 0, 0.94);
  color: #94a3b8;
  -webkit-tap-highlight-color: transparent;
}

.cm-dock-dim__rec {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  color: #fb7185;
  font-size: 0.72rem;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.cm-dock-dim__rec i {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #fb7185;
  animation: cm-pulse 1.1s var(--cm-ease) infinite;
}

.cm-dock-dim__wait {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  color: #94a3b8;
  font-size: 0.72rem;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.cm-dock-dim__hint {
  margin: 0;
  max-width: 18rem;
  text-align: center;
  font-size: 0.72rem;
  font-weight: 650;
  opacity: 0.75;
  line-height: 1.35;
}

.cm-dock-dim strong {
  color: #e2e8f0;
  font-size: 1rem;
  font-weight: 750;
}

.cm-dock-dim__score {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.2rem;
  margin: 0.15rem 0;
}

.cm-dock-dim__score-kicker {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  color: #64748b;
  font-size: 0.68rem;
  font-weight: 800;
  letter-spacing: 0.12em;
  text-transform: uppercase;
}

.cm-dock-dim__score strong {
  font-size: clamp(3.4rem, 18vw, 5.6rem);
  font-weight: 800;
  line-height: 0.9;
  letter-spacing: -0.05em;
  font-variant-numeric: tabular-nums;
  color: #cbd5e1;
}

.cm-dock-dim__score-sets {
  color: #64748b;
  font-size: 0.78rem;
  font-weight: 750;
  letter-spacing: 0.06em;
  text-transform: uppercase;
}

.cm-dock-dim__pulse {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #475569;
  flex: 0 0 auto;
}

.cm-dock-dim__score.is-reading .cm-dock-dim__score-kicker,
.cm-dock-dim__score.is-reading strong {
  color: #7dd3fc;
}

.cm-dock-dim__score.is-reading strong {
  animation: cm-dock-score-read 0.85s ease-in-out infinite;
}

.cm-dock-dim__score.is-read strong {
  animation: cm-dock-score-hit 0.55s ease-out;
}

.cm-dock-dim__pulse--reading {
  background: #38bdf8;
  box-shadow: 0 0 10px rgba(56, 189, 248, 0.85);
  animation: cm-pulse 0.7s var(--cm-ease) infinite;
}

.cm-dock-dim__pulse--read {
  background: #34d399;
  box-shadow: 0 0 10px rgba(52, 211, 153, 0.75);
  animation: cm-dock-score-hit 0.55s ease-out;
}

.cm-dock-dim__score-icon {
  flex: 0 0 auto;
  color: #94a3b8;
}

.cm-dock-dim__score.is-reading .cm-dock-dim__score-icon {
  color: #38bdf8;
}

.cm-dock-dim__score.is-motion .cm-dock-dim__score-icon,
.cm-dock-dim__score.is-occlusion .cm-dock-dim__score-icon {
  color: #fb7185;
}

.cm-dock-dim__score.is-hit .cm-dock-dim__score-icon {
  color: #34d399;
}

.cm-dock-dim__score-log {
  list-style: none;
  margin: 0.35rem 0 0;
  padding: 0;
  width: min(18rem, 100%);
  display: flex;
  flex-direction: column;
  gap: 0.15rem;
  text-align: center;
}

.cm-dock-dim__score-log li {
  font-size: 0.62rem;
  font-weight: 650;
  color: #64748b;
  line-height: 1.25;
}

.cm-dock-dim__score-log .is-ok {
  color: #86efac;
}

.cm-dock-dim__score-log .is-warn {
  color: #fde68a;
}

.cm-dock-dim__score-log .is-err {
  color: #fda4af;
}

@keyframes cm-dock-score-read {
  0%,
  100% {
    opacity: 0.45;
  }
  50% {
    opacity: 1;
  }
}

@keyframes cm-dock-score-hit {
  0% {
    transform: scale(1.06);
    filter: brightness(1.6);
  }
  100% {
    transform: scale(1);
    filter: brightness(1);
  }
}

.cm-dock-dim__actions {
  display: flex;
  flex-wrap: wrap;
  gap: 0.45rem;
  justify-content: center;
  margin-top: 0.55rem;
  width: min(360px, 100%);
}

.cm-dock-dim__actions .cm-btn {
  min-width: 8.5rem;
}

.cm-page--cam-docked .cm-tabs,
.cm-page--cam-docked .cm-head,
.cm-page--cam-docked .cm-body {
  visibility: hidden;
}

.cm-comment {
  flex: 0 0 auto;
  display: flex;
  gap: 0.35rem;
  margin-top: 0.35rem;
}

.cm-comment input {
  flex: 1 1;
  min-width: 0;
  min-height: 38px;
  border: 1px solid var(--cm-border);
  border-radius: 12px;
  background: var(--cm-glass);
  color: var(--cm-text);
  padding: 0 0.7rem;
}

.cm-comment button {
  flex: 0 0 auto;
}

.cm-sheet {
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  gap: 0.45rem;
  padding: 0.7rem;
  border-radius: 18px;
  border: 1px solid var(--cm-border);
  background: var(--cm-slate);
  overflow: hidden;
}

.cm-sheet__head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: 800;
}

.cm-sheet__grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 0.32rem;
  overflow: auto;
  margin-top: 0.45rem;
}

.cm-sheet__grid .cm-stamp {
  width: 100%;
}

.cm-lineup {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: minmax(0, 1fr) auto auto;
  gap: 0.45rem;
  flex: 1 1 auto;
  min-height: 0;
  height: 100%;
  align-content: stretch;
  overflow: hidden;
}

.cm-lineup.has-sheet-photo {
  grid-template-rows: auto minmax(0, 1fr) auto auto;
}

.cm-lineup.has-sheet-photo section {
  grid-row: 2;
}

.cm-sheet-photo {
  grid-column: 1 / -1;
  grid-row: 1;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.35rem 0.5rem;
}

.cm-sheet-photo .cm-btn {
  flex: 0 1 auto;
  min-width: 0;
}

.cm-sheet-photo__note {
  flex: 1 1 12rem;
  margin: 0;
  color: var(--cm-muted);
  font-size: 0.68rem;
  line-height: 1.35;
}

.cm-lineup section {
  grid-row: 1;
  min-height: 0;
  min-width: 0;
  display: flex;
  flex-direction: column;
  border: 1px solid var(--cm-border);
  border-radius: 16px;
  background: var(--cm-glass);
  padding: 0.45rem;
  overflow-x: hidden;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  overscroll-behavior: contain;
}

.cm-lineup h2 {
  margin: 0 0 0.35rem;
  flex: 0 0 auto;
  position: sticky;
  top: 0;
  z-index: 1;
  padding-bottom: 0.15rem;
  background: var(--cm-glass);
  font-size: 0.72rem;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--cm-muted);
}

.cm-lineup__section-label {
  margin: 0 0 0.3rem;
  flex: 0 0 auto;
  font-size: 0.66rem;
  font-weight: 750;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: var(--cm-primary);
}

.cm-lineup__locked {
  margin: 0 0 0.85rem;
  padding: 0.55rem 0.75rem;
  border-radius: 12px;
  border: 1px solid color-mix(in srgb, var(--cm-primary, #0877bc) 35%, transparent);
  background: color-mix(in srgb, var(--cm-primary, #0877bc) 12%, transparent);
  font-size: 0.84rem;
  font-weight: 600;
}

.cm-lineup.is-locked input {
  opacity: 0.92;
  cursor: default;
}

.cm-lineup ol {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 0.28rem;
  flex: 0 0 auto;
}

.cm-lineup li {
  display: grid;
  grid-template-columns: 1.1rem minmax(0, 1fr) auto;
  gap: 0.28rem;
  align-items: center;
  min-height: 42px;
  min-width: 0;
}

.cm-lineup li.is-swap-target {
  cursor: pointer;
  border-radius: 10px;
  padding: 0.12rem 0.2rem;
  background: color-mix(in srgb, var(--cm-primary) 14%, transparent);
  outline: 1px dashed color-mix(in srgb, var(--cm-primary) 72%, transparent);
  outline-offset: 1px;
}

.cm-lineup li.is-swap-target input {
  pointer-events: none;
}

.cm-lineup__swap-hint {
  margin: 0 0 0.35rem;
  flex: 0 0 auto;
  font-size: 0.66rem;
  font-weight: 700;
  line-height: 1.3;
  color: var(--cm-primary);
}

.cm-lineup li > div {
  min-width: 0;
  overflow: hidden;
}

.cm-lineup__acts {
  display: inline-flex;
  align-items: center;
  gap: 0.12rem;
  flex-shrink: 0;
}

.cm-lineup .pos {
  font-weight: 800;
  color: var(--cm-primary);
}

.cm-lineup input {
  width: 100%;
  min-width: 0;
  border: 0;
  background: transparent;
  color: var(--cm-text);
  font-size: 0.78rem;
  font-weight: 650;
  outline: none;
  padding: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.cm-lineup small {
  display: block;
  color: var(--cm-muted);
  font-size: 0.58rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.cm-opp-pool {
  margin-top: 0.65rem;
  padding-top: 0.55rem;
  border-top: 1px dashed var(--cm-border);
  flex: 0 0 auto;
  display: flex;
  flex-direction: column;
  gap: 0.55rem;
}

.cm-opp-pool__group {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  min-width: 0;
}

.cm-opp-pool__label {
  margin: 0;
  flex: 0 0 auto;
  font-size: 0.72rem;
  font-weight: 750;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: var(--cm-muted);
}

.cm-opp-pool__hint {
  margin: 0;
  font-size: 0.66rem;
  font-weight: 650;
  line-height: 1.35;
  color: var(--cm-primary);
}

.cm-opp-pool__list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
}

.cm-opp-pool__list li {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 0.28rem;
  min-height: 40px;
  min-width: 0;
  padding: 0.35rem 0.45rem;
  border-radius: 12px;
  border: 1px solid var(--cm-border);
  background: var(--cm-glass);
}

.cm-opp-pool__list li.is-swap-source {
  border-color: var(--cm-primary);
  box-shadow: inset 0 0 0 1px var(--cm-primary);
  background: color-mix(in srgb, var(--cm-primary) 12%, var(--cm-glass));
}

.cm-opp-pool__list li.is-expected {
  border-color: color-mix(in srgb, var(--cm-primary) 42%, var(--cm-border));
  background: color-mix(in srgb, var(--cm-primary) 10%, var(--cm-glass));
}

.cm-opp-pool__list strong {
  display: block;
  font-size: 0.82rem;
  line-height: 1.25;
  overflow-wrap: anywhere;
}

.cm-opp-pool__list small {
  display: block;
  color: var(--cm-muted);
  font-size: 0.66rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.cm-opp-pool__list > li > div:first-child {
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
}

.cm-opp-pool__seats {
  display: inline-flex;
  gap: 0.2rem;
  flex: 0 0 auto;
  position: relative;
  z-index: 1;
}

.cm-opp-pool__acts {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex: 0 0 auto;
  min-width: 0;
}

.cm-opp-pool__swap {
  display: inline-flex;
  align-items: center;
  gap: 0.28rem;
  min-height: 1.7rem;
  border-radius: 999px;
  border: 1px solid var(--cm-border);
  padding: 0.16rem 0.55rem;
  background: color-mix(in srgb, var(--cm-primary) 16%, transparent);
  color: var(--cm-text);
  font-size: 0.68rem;
  font-weight: 750;
  cursor: pointer;
  white-space: nowrap;
}

.cm-opp-pool__swap.is-on {
  background: var(--cm-primary);
  border-color: var(--cm-primary);
  color: #fff;
}

.cm-opp-pool__seat {
  width: 1.7rem;
  height: 1.7rem;
  flex: 0 0 auto;
  border-radius: 8px;
  border: 1px solid var(--cm-border);
  background: color-mix(in srgb, var(--cm-primary) 16%, transparent);
  color: var(--cm-text);
  font-size: 0.72rem;
  font-weight: 750;
  cursor: pointer;
}

.cm-opp-pool__in {
  flex: 0 0 auto;
  font-size: 0.66rem;
  font-weight: 750;
  color: var(--cm-home, #34d399);
  white-space: nowrap;
}

.cm-opp-avail {
  min-height: 1.7rem;
  border-radius: 999px;
  border: 1px solid var(--cm-border);
  padding: 0.18rem 0.55rem;
  font-size: 0.68rem;
  font-weight: 750;
  cursor: pointer;
  white-space: nowrap;
}

.cm-opp-avail--play {
  background: color-mix(in srgb, var(--cm-home, #34d399) 18%, transparent);
  color: var(--cm-home, #34d399);
}

.cm-opp-avail--bench {
  background: color-mix(in srgb, var(--cm-rec, #fb7185) 16%, transparent);
  color: var(--cm-rec, #fb7185);
}

.cm-opp-avail--icon {
  width: 1.7rem;
  height: 1.7rem;
  min-width: 1.7rem;
  min-height: 1.7rem;
  padding: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.cm-page--light .cm-opp-pool__seat,
.cm-page--light .cm-opp-pool__swap {
  background: color-mix(in srgb, var(--cm-primary) 12%, #fff);
  color: var(--cm-primary);
}

.cm-page--light .cm-opp-pool__swap.is-on {
  background: var(--cm-primary);
  color: #fff;
}

.cm-page--light .cm-opp-pool__list li.is-expected {
  background: color-mix(in srgb, var(--cm-primary) 8%, #fff);
}

.cm-swap {
  border: 0;
  background: transparent;
  color: var(--cm-primary);
  font-weight: 800;
  cursor: pointer;
  padding: 0 0.15rem;
  flex-shrink: 0;
}

.cm-hint {
  grid-column: 1 / -1;
  margin: 0;
  color: var(--cm-muted);
  font-size: 0.68rem;
}

@media (max-width: 719px) {
  .cm-lineup {
    grid-template-columns: 1fr 1fr;
    gap: 0.35rem;
  }

  .cm-lineup section {
    padding: 0.35rem;
  }

  .cm-lineup input {
    font-size: 0.7rem;
  }

  .cm-lineup li {
    min-height: 36px;
  }

  .cm-opp-pool__seat {
    width: 1.45rem;
    height: 1.45rem;
    font-size: 0.66rem;
  }

  .cm-opp-pool__list strong {
    font-size: 0.72rem;
  }
}

.cm-cam {
  flex: 1 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
}

.cm-cam__preview {
  flex: 1 1;
  min-height: 0;
  position: relative;
  border-radius: 18px;
  overflow: hidden;
  background: #000;
  border: 1px solid var(--cm-border);
  touch-action: none;
}

.cm-cam__preview video {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transform-origin: center center;
  pointer-events: none;
}

.cm-cam__score-roi {
  position: absolute;
  border: 2px solid rgba(56, 189, 248, 0.95);
  box-shadow: 0 0 0 1px rgba(15, 23, 42, 0.45);
  pointer-events: none;
  z-index: 3;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.cm-cam__score-roi.is-reading {
  border-color: #38bdf8;
  box-shadow: 0 0 0 2px rgba(56, 189, 248, 0.55), 0 0 18px rgba(56, 189, 248, 0.55);
  animation: cm-score-roi-pulse 0.85s ease-in-out infinite;
}

.cm-cam__score-roi.is-motion,
.cm-cam__score-roi.is-occlusion {
  border-color: #fb7185;
  box-shadow: 0 0 0 2px rgba(251, 113, 133, 0.5), 0 0 16px rgba(251, 113, 133, 0.45);
}

.cm-cam__score-roi.is-hit {
  border-color: #34d399;
  box-shadow: 0 0 0 2px rgba(52, 211, 153, 0.55), 0 0 16px rgba(52, 211, 153, 0.4);
}

.cm-cam__score-roi.is-confirm {
  border-color: #fbbf24;
  box-shadow: 0 0 0 2px rgba(251, 191, 36, 0.5);
}

.cm-cam__score-roi-icon {
  position: absolute;
  top: -10px;
  right: -10px;
  width: 22px;
  height: 22px;
  border-radius: 999px;
  display: grid;
  place-items: center;
  background: rgba(15, 23, 42, 0.92);
  color: #e2e8f0;
  border: 1px solid rgba(255, 255, 255, 0.18);
}

.cm-cam__score-roi.is-reading .cm-cam__score-roi-icon {
  color: #7dd3fc;
}

.cm-cam__score-roi.is-motion .cm-cam__score-roi-icon,
.cm-cam__score-roi.is-occlusion .cm-cam__score-roi-icon {
  color: #fda4af;
}

.cm-cam__score-roi.is-hit .cm-cam__score-roi-icon {
  color: #6ee7b7;
}

.cm-cam__score-roi-icon .is-spin,
.cm-score-ai-hud .is-spin,
.cm-dock-dim__score-icon.is-spin {
  animation: cm-score-spin 0.8s linear infinite;
}

@keyframes cm-score-spin {
  to {
    transform: rotate(360deg);
  }
}

@keyframes cm-score-roi-pulse {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.72;
  }
}

.cm-score-ai-hud {
  position: absolute;
  left: 0.55rem;
  bottom: 0.55rem;
  z-index: 6;
  width: min(22rem, calc(100% - 1.1rem));
  pointer-events: none;
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
}

.cm-score-ai-hud__status {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  max-width: 100%;
  padding: 0.35rem 0.55rem;
  border-radius: 999px;
  background: rgba(2, 6, 23, 0.78);
  border: 1px solid rgba(148, 163, 184, 0.28);
  color: #e2e8f0;
  font-size: 0.68rem;
  font-weight: 750;
  letter-spacing: 0.02em;
}

.cm-score-ai-hud__status span {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.cm-score-ai-hud__status strong {
  margin-left: auto;
  font-variant-numeric: tabular-nums;
  color: #7dd3fc;
}

.cm-score-ai-hud.is-reading .cm-score-ai-hud__status {
  border-color: rgba(56, 189, 248, 0.55);
  color: #bae6fd;
}

.cm-score-ai-hud.is-motion .cm-score-ai-hud__status,
.cm-score-ai-hud.is-occlusion .cm-score-ai-hud__status {
  border-color: rgba(251, 113, 133, 0.55);
  color: #fecdd3;
}

.cm-score-ai-hud.is-hit .cm-score-ai-hud__status {
  border-color: rgba(52, 211, 153, 0.55);
  color: #a7f3d0;
}

.cm-score-ai-hud.is-confirm .cm-score-ai-hud__status,
.cm-score-ai-hud.is-error .cm-score-ai-hud__status {
  border-color: rgba(251, 191, 36, 0.55);
  color: #fde68a;
}

.cm-score-ai-hud__gate {
  display: flex;
  flex-direction: column;
  gap: 0.1rem;
  padding: 0.3rem 0.5rem;
  border-radius: 10px;
  background: rgba(2, 6, 23, 0.66);
  border: 1px solid rgba(148, 163, 184, 0.18);
  color: #94a3b8;
  font-size: 0.58rem;
  font-weight: 650;
  font-variant-numeric: tabular-nums;
  line-height: 1.3;
}

.cm-score-ai-hud__gate span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.cm-score-ai-hud__log {
  list-style: none;
  margin: 0;
  padding: 0.4rem 0.5rem;
  border-radius: 12px;
  background: rgba(2, 6, 23, 0.72);
  border: 1px solid rgba(148, 163, 184, 0.2);
  max-height: 9.5rem;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  gap: 0.18rem;
}

.cm-score-ai-hud__log li {
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 0.4rem;
  font-size: 0.62rem;
  font-weight: 650;
  color: #cbd5e1;
  line-height: 1.25;
}

.cm-score-ai-hud__log time {
  color: #64748b;
  font-variant-numeric: tabular-nums;
}

.cm-score-ai-hud__log .is-ok {
  color: #86efac;
}

.cm-score-ai-hud__log .is-warn {
  color: #fde68a;
}

.cm-score-ai-hud__log .is-err {
  color: #fda4af;
}

.cm-cam__score-roi-draw {
  z-index: 4;
}

.cm-cam__idle {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.65rem;
  padding: 1.25rem;
  text-align: center;
  color: var(--cm-muted);
  background:
    radial-gradient(circle at 50% 35%, rgba(8, 119, 188, 0.18), transparent 55%),
    #0a0f18;
}

.cm-cam__idle--guide {
  z-index: 5;
  justify-content: flex-start;
  padding-top: calc(4.15rem + env(safe-area-inset-top, 0px));
  background: transparent;
  pointer-events: none;
}

.cm-cam__idle--guide > :first-child {
  display: none;
}

.cm-cam__idle p {
  margin: 0;
  max-width: 16rem;
  font-size: 0.82rem;
  font-weight: 600;
  line-height: 1.35;
  color: #cbd5e1;
}

.cm-cam__roster {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 0.28rem;
}

.cm-cam__roster li {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  min-height: 28px;
  padding: 0.2rem 0.55rem;
  border-radius: 999px;
  background: rgba(52, 211, 153, 0.12);
  border: 1px solid rgba(52, 211, 153, 0.35);
  color: #6ee7b7;
  font-size: 0.72rem;
  font-weight: 700;
}

.cm-page--light .cm-cam__roster li {
  background: color-mix(in srgb, #047857 10%, #fff);
  border-color: color-mix(in srgb, #047857 28%, transparent);
  color: #047857;
}

.cm-cam-status {
  list-style: none;
  flex: 0 1 auto;
  min-height: 0;
  max-height: 7.25rem;
  margin: 0.35rem 0 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 0.28rem;
  overflow-x: hidden;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  overscroll-behavior: contain;
}

.cm-cam-status__item {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  min-height: 34px;
  padding: 0.35rem 0.55rem;
  border-radius: 12px;
  border: 1px solid color-mix(in srgb, var(--cm-primary) 35%, var(--cm-border));
  background: color-mix(in srgb, var(--cm-primary) 12%, transparent);
  color: var(--cm-text);
  font-size: 0.74rem;
  font-weight: 650;
}

.cm-cam-status__item.is-this {
  border-color: color-mix(in srgb, var(--cm-home) 45%, var(--cm-border));
  background: color-mix(in srgb, var(--cm-home) 14%, transparent);
}

.cm-cam-status__item.is-offline {
  opacity: 0.72;
  border-style: dashed;
}

.cm-cam__roster li.is-offline {
  background: rgba(148, 163, 184, 0.12);
  border-color: rgba(148, 163, 184, 0.35);
  border-style: dashed;
  color: #94a3b8;
}

.cm-cam__roster li.is-this {
  box-shadow: inset 0 0 0 1px rgba(52, 211, 153, 0.45);
}

.cm-cam__idle-phones {
  margin: 0 0 0.35rem;
  color: var(--cm-muted);
  font-size: 0.78rem;
  font-weight: 600;
}

.cm-cam-status__item span {
  flex: 1 1;
  min-width: 0;
  overflow: visible;
  line-height: 1.35;
  overflow-wrap: anywhere;
}

.cm-cam-status__remove {
  flex: 0 0 auto;
  min-height: 28px;
  padding: 0.2rem 0.55rem;
  border-radius: 999px;
  border: 1px solid var(--cm-border);
  background: transparent;
  color: var(--cm-text);
  font-size: 0.7rem;
  font-weight: 750;
  cursor: pointer;
}

.cm-page--light .cm-cam-status__item {
  background: color-mix(in srgb, var(--cm-primary) 10%, #fff);
  border-color: color-mix(in srgb, var(--cm-primary) 28%, var(--cm-border));
}

.cm-page--cam-armed .cm-cam__roster,
.cm-page--cam-armed .cm-picks,
.cm-page--cam-armed .cm-cam__idle-phones,
.cm-page--cam-armed .cm-hint,
.cm-page--cam-landscape .cm-cam-status,
.cm-page--cam-landscape .cm-cam__roster,
.cm-page--cam-landscape .cm-cam__idle-phones {
  display: none;
}

.cm-cam__badge {
  position: absolute;
  top: 0.55rem;
  left: 0.55rem;
  padding: 0.22rem 0.5rem;
  border-radius: 999px;
  background: rgba(0, 0, 0, 0.55);
}

.cm-cam__badge--roster {
  left: auto;
  right: 0.55rem;
  top: 0.55rem;
  background: rgba(8, 119, 188, 0.72);
}

.cm-cam__badge--zoom {
  left: auto;
  right: 0.55rem;
  top: 0.55rem;
  background: rgba(2, 6, 23, 0.72);
  font-variant-numeric: tabular-nums;
}

.cm-picks {
  display: flex;
  flex-wrap: wrap;
  gap: 0.3rem;
}

.cm-scorecam-mode {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.cm-scorecam-mode__note {
  margin: 0;
  color: var(--cm-muted);
  font-size: 0.75rem;
  line-height: 1.35;
}

.cm-chip {
  min-height: 34px;
  padding: 0 0.7rem;
  border-radius: 999px;
  border: 1px solid var(--cm-border);
  background: var(--cm-glass);
  color: var(--cm-text);
  font-size: 0.72rem;
  font-weight: 700;
  cursor: pointer;
}

.cm-chip.is-on {
  background: var(--cm-primary);
  border-color: var(--cm-primary);
  color: #fff;
}

.cm-replay__filters {
  flex: 0 0 auto;
  display: flex;
  gap: 0.28rem;
  overflow: auto;
  padding-bottom: 0.2rem;
}

.cm-replay__filters .cm-tagchip {
  flex: 0 0 auto;
  max-width: none;
  min-width: 5.2rem;
}

.cm-replay__filters .cm-outcome__btn {
  flex: 0 0 auto;
  flex-direction: row;
  gap: 0.28rem;
  min-height: 2.15rem;
  min-width: 4.6rem;
  padding: 0.2rem 0.55rem;
}

.cm-outcome--score {
  flex: 0 0 auto;
  margin: 0.25rem 0 0.1rem;
  min-width: 0;
}

.cm-live > .cm-outcome--score {
  position: relative;
  z-index: 2;
  padding: 0.2rem 0 0.15rem;
  background: linear-gradient(
    180deg,
    transparent,
    color-mix(in srgb, var(--cm-glass, #0b1220) 92%, transparent) 35%
  );
}

.cm-live > .cm-scoredeck {
  flex: 1 1 auto;
  min-height: 0;
}

@media (max-height: 720px) {
  .cm-live > .cm-scoredeck {
    max-height: min(38dvh, 16rem);
  }

  .cm-live > .cm-outcome--score .cm-outcome__text {
    font-size: 0.58rem;
  }

  .cm-live > .cm-outcome--score .cm-outcome__btn {
    min-height: 2.25rem;
    padding: 0.18rem 0.1rem;
  }
}

@media (max-height: 580px) {
  .cm-live > .cm-outcome--score .cm-outcome__text {
    display: none;
  }

  .cm-live > .cm-scoredeck {
    max-height: min(32dvh, 12.5rem);
  }

  .cm-scoredeck__pts {
    font-size: clamp(1.9rem, 10vw, 3rem);
  }
}

.cm-film__outcome {
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  font-size: 0.75rem;
  font-weight: 750;
}

.cm-film__outcome--winner {
  color: #22c55e;
}

.cm-film__outcome--unforced_error {
  color: #ef4444;
}

.cm-film__outcome--forced_error {
  color: #eab308;
}

.cm-film__outcome--lucky {
  color: #94a3b8;
}

.cm-film__outcome--rally {
  color: #0ea5e9;
}

/* ── Match video replay (cinema desk + mobile label dock) ── */
.cm-chrono-shell {
  list-style: none;
  margin: 0.25rem 0 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  min-height: 0;
  flex: 1 1 auto;
  overflow: hidden;
}

.cm-chrono__rubber-tabs {
  display: flex;
  gap: 0.4rem;
  overflow-x: auto;
  padding: 0.1rem 0.1rem 0.15rem;
  -webkit-overflow-scrolling: touch;
}

.cm-chrono__rubber-tab {
  flex: 0 0 auto;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.12rem;
  border: 1px solid var(--cm-border);
  background: color-mix(in srgb, var(--cm-slate) 80%, transparent);
  color: var(--cm-text);
  border-radius: 12px;
  padding: 0.45rem 0.75rem;
  font: inherit;
  cursor: pointer;
  min-width: 5.5rem;
}

.cm-chrono__rubber-tab strong {
  font-size: 0.78rem;
  font-weight: 800;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.cm-chrono__rubber-tab span {
  font-size: 0.66rem;
  font-weight: 650;
  color: var(--cm-muted);
}

.cm-chrono__rubber-tab.is-on {
  border-color: color-mix(in srgb, var(--cm-primary) 55%, var(--cm-border));
  background: color-mix(in srgb, var(--cm-primary) 14%, var(--cm-slate));
  box-shadow: inset 0 0 0 1px color-mix(in srgb, var(--cm-primary) 25%, transparent);
}

.cm-chrono {
  --cm-chrono-chrome: 1;
  --cm-rail: #0a0f18;
  --cm-deck: #0f1520;
  --cm-chip: #121a27;
  --cm-chip-on: #1d2636;
  --cm-hair: rgba(255, 255, 255, 0.07);
  --cm-fill: rgba(255, 255, 255, 0.05);
  --cm-fill-strong: rgba(255, 255, 255, 0.12);
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  height: auto;
  min-height: 0;
  max-height: 100%;
  border: 1px solid var(--cm-border);
  border-radius: 16px;
  background: var(--cm-glass);
  overflow: hidden;
}

.cm-page--light .cm-chrono:not(.is-stage-fs) {
  --cm-rail: #eef1f6;
  --cm-deck: #ffffff;
  --cm-chip: #f4f6fa;
  --cm-chip-on: #ffffff;
  --cm-hair: rgba(15, 23, 42, 0.09);
  --cm-fill: rgba(15, 23, 42, 0.05);
  --cm-fill-strong: rgba(15, 23, 42, 0.1);
}

/* Full-screen stage is always a dark cinema, whatever the page theme. */
.cm-chrono.is-stage-fs {
  --cm-text: #f8fafc;
  --cm-muted: #94a3b8;
  --cm-border: rgba(255, 255, 255, 0.08);
}

.cm-chrono__rubber {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 0.5rem;
  padding: 0.5rem 0.75rem 0.3rem;
  flex: 0 0 auto;
}

.cm-chrono__rubber strong {
  font-size: 0.8rem;
  font-weight: 800;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.cm-chrono__rubber span {
  color: var(--cm-muted);
  font-size: 0.72rem;
  font-weight: 650;
  text-align: right;
}

.cm-chrono__layout,
.cm-chrono__stage {
  display: contents;
}

.cm-chrono__player-shell,
.cm-chrono__player,
.cm-chrono__empty-stage {
  order: 1;
}

.cm-chrono__tape-scrub {
  order: 2;
}

.cm-film {
  order: 3;
}

.cm-chrono__tagger-slot--dock {
  order: 4;
}

.cm-chrono__side {
  order: 5;
}

.cm-chrono__player-spacer {
  width: 100%;
  pointer-events: none;
}

.cm-chrono__player-shell {
  position: relative;
  flex: 1 1;
  min-height: 0;
  width: 100%;
  border-radius: 0;
  overflow: hidden;
  background: #05070c;
  isolation: isolate;
  /* Width + height so chrome can scale with the video frame, not the page. */
  container-type: size;
  container-name: cm-player;
}

.cm-chrono__player-shell > .review-video-player {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
}

.cm-chrono__player-shell.is-expanding,
.cm-chrono__player-shell.is-expanded {
  position: fixed;
  z-index: 11000;
  margin: 0;
  overflow: hidden;
  background: #000;
  box-shadow: none;
  border-radius: 0;
}

.cm-chrono__player-shell.is-expanded:not(.is-expanding) {
  inset: 0;
  width: 100vw;
  width: 100dvw;
  height: 100%;
  height: 100dvh;
  max-width: 100vw;
  left: 0;
  right: 0;
  display: flex;
  flex-direction: column;
}

.cm-chrono__player-shell.is-expanded .cm-chrono__eval-player,
.cm-chrono__player-shell.is-expanding .cm-chrono__eval-player,
.cm-chrono__player-shell.is-expanded .review-video-player,
.cm-chrono__player-shell.is-expanding .review-video-player {
  flex: 1 1 auto;
  width: 100%;
  height: 100%;
  min-height: 0;
  border-radius: 0;
}

.cm-chrono__player-shell.is-expanded .review-video-player__viewport,
.cm-chrono__player-shell.is-expanding .review-video-player__viewport,
.cm-chrono__player-shell.is-expanded .review-video-player--embedded .review-video-player__viewport,
.cm-chrono__player-shell.is-expanding .review-video-player--embedded .review-video-player__viewport {
  aspect-ratio: auto;
  max-height: none;
  height: 100%;
  width: 100%;
  flex: 1 1 auto;
}

.cm-chrono__player-shell.is-expanded .review-video-player__transform,
.cm-chrono__player-shell.is-expanding .review-video-player__transform,
.cm-chrono__player-shell.is-expanded .review-video-player__video,
.cm-chrono__player-shell.is-expanding .review-video-player__video {
  width: 100%;
  height: 100%;
  max-width: none;
  max-height: none;
  object-fit: contain;
}

.cm-chrono__player {
  position: relative;
  border-radius: 12px;
  overflow: hidden;
  background: #05070c;
  aspect-ratio: 16 / 9;
  max-height: min(46vh, 26rem);
}

.cm-chrono__player--photo {
  display: grid;
  place-items: center;
  flex: 1 1 auto;
  max-height: none;
}

.cm-chrono__player--photo img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.cm-chrono__eval-player {
  width: 100%;
  height: 100%;
  min-height: 0;
  border-radius: 0;
}

.cm-chrono__player-shell .cm-chrono__eval-player.review-video-player--embedded,
.cm-chrono__player-shell .review-video-player--embedded {
  height: 100%;
  min-height: 0;
  border-radius: 0;
}

.cm-chrono__player-shell .review-video-player--embedded .review-video-player__viewport {
  aspect-ratio: auto;
  max-height: none;
  height: 100%;
}

.cm-chrono__eval-player video,
.cm-chrono__player video {
  width: 100%;
  height: 100%;
  object-fit: contain;
  background: #000;
}

/* HUD overlays: hide with player chrome after inactivity */
.cm-chrono__hud {
  position: absolute;
  inset: 0;
  z-index: 22;
  pointer-events: none;
  opacity: 0;
  transition: opacity 0.2s ease;
}

.cm-chrono__player-shell:has(.review-video-player--controls-visible) .cm-chrono__hud,
.cm-chrono__player-shell:not(:has(.review-video-player)) .cm-chrono__hud {
  opacity: 1;
}

/* View-mode pill: portrait / landscape full screen, exit. Stays tappable but
   recedes while the player chrome is hidden. */
.cm-stagectl {
  --cm-stagectl-btn: clamp(1.75rem, 7cqmin, 2.3rem);
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
  z-index: 30;
  display: flex;
  align-items: center;
  gap: 1px;
  padding: 2px;
  border-radius: 999px;
  background: rgba(6, 9, 15, 0.5);
  border: 1px solid rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px) saturate(140%);
  -webkit-backdrop-filter: blur(10px) saturate(140%);
  opacity: 0.62;
  transition: opacity 0.2s ease;
}

.cm-chrono__player-shell:has(.review-video-player--controls-visible) .cm-stagectl,
.cm-chrono__player-shell:not(:has(.review-video-player)) .cm-stagectl,
.cm-stagectl:hover,
.cm-stagectl:focus-within {
  opacity: 1;
}

.cm-stagectl__btn {
  width: var(--cm-stagectl-btn);
  height: var(--cm-stagectl-btn);
  border: 0;
  border-radius: 999px;
  display: grid;
  place-items: center;
  padding: 0;
  cursor: pointer;
  color: rgba(248, 250, 252, 0.92);
  background: transparent;
  -webkit-tap-highlight-color: transparent;
  transition: background 0.15s ease, transform 0.12s ease;
}

.cm-stagectl__btn:hover {
  background: rgba(255, 255, 255, 0.12);
}

.cm-stagectl__btn:active {
  transform: scale(0.92);
}

.cm-stagectl__btn:focus-visible {
  outline: 2px solid var(--cm-primary);
  outline-offset: 1px;
}

.cm-stagectl__btn--exit {
  color: #fff;
  background: rgba(255, 255, 255, 0.14);
}

.cm-chrono.is-stage-fs .cm-stagectl {
  --cm-stagectl-btn: 2.5rem;
  top: max(0.6rem, env(safe-area-inset-top, 0px));
  right: max(0.6rem, env(safe-area-inset-right, 0px));
}

.cm-chrono__board {
  position: absolute;
  left: 0.5rem;
  top: 0.5rem;
  z-index: 1;
  padding: 0.22rem clamp(0.4rem, 2.2cqi, 0.6rem);
  border-radius: 999px;
  background: rgba(8, 12, 20, 0.55);
  color: #f8fafc;
  border: 1px solid rgba(255, 255, 255, 0.12);
  font-size: clamp(0.66rem, 3.2cqi, 0.8rem);
  font-weight: 750;
  letter-spacing: 0.02em;
  backdrop-filter: blur(8px);
}

.cm-chrono__player-shell.is-expanded .cm-chrono__board {
  top: max(0.7rem, env(safe-area-inset-top, 0px));
  left: max(0.7rem, env(safe-area-inset-left, 0px));
}

.cm-chrono__parts {
  position: absolute;
  left: 0.5rem;
  bottom: 0.5rem;
  z-index: 1;
  margin: 0;
  padding: 0.18rem 0.45rem;
  border-radius: 999px;
  background: rgba(8, 12, 20, 0.5);
  color: #f8fafc;
  font-size: clamp(0.58rem, 2.8cqi, 0.7rem);
  font-weight: 700;
  letter-spacing: 0.04em;
}

.cm-chrono__tape-id {
  position: absolute;
  left: 0.5rem;
  top: calc(0.5rem + clamp(1.5rem, 6cqmin, 1.95rem));
  z-index: 1;
  margin: 0;
  max-width: min(70%, 22rem);
  padding: 0.18rem 0.45rem;
  border-radius: 999px;
  background: rgba(8, 12, 20, 0.55);
  color: #f8fafc;
  font-size: clamp(0.55rem, 2.5cqi, 0.68rem);
  font-weight: 600;
  letter-spacing: 0.02em;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.cm-chrono__error {
  position: absolute;
  inset: auto 0.55rem 0.55rem;
  margin: 0;
  padding: 0.4rem 0.55rem;
  border-radius: 10px;
  background: rgba(127, 29, 29, 0.88);
  color: #fff;
  font-size: 0.75rem;
  z-index: 24;
}

.cm-chrono__empty-stage {
  display: grid;
  place-items: center;
  gap: 0.35rem;
  flex: 1 1 auto;
  min-height: 0;
  width: 100%;
  border-radius: 0;
  border: 1.5px dashed color-mix(in srgb, var(--cm-primary) 40%, var(--cm-border));
  color: var(--cm-muted);
  text-align: center;
  padding: 1rem;
  background: color-mix(in srgb, var(--cm-slate) 70%, transparent);
}

.cm-chrono__empty-stage p {
  margin: 0;
  font-size: 0.84rem;
  max-width: 16rem;
}

/* Compact ReviewVideoPlayer chrome: scale with the video frame (cqmin). */
.cm-chrono__player-shell .review-video-player__chrome {
  --cm-rv-gap: clamp(2px, 1.1cqmin, 8px);
  --cm-rv-pad-y: clamp(4px, 1.5cqmin, 10px);
  --cm-rv-pad-x: clamp(6px, 2cqmin, 12px);
  --cm-rv-btn: clamp(1.35rem, 5.8cqmin, 2.35rem);
  --cm-rv-play: clamp(1.65rem, 7.2cqmin, 2.85rem);
  --cm-rv-icon: clamp(12px, 3.8cqmin, 18px);
  --cm-rv-label: clamp(0.55rem, 2.2cqmin, 0.78rem);
  --cm-rv-radius: clamp(8px, 1.8cqmin, 14px);
  padding: var(--cm-rv-pad-y) var(--cm-rv-pad-x);
  gap: var(--cm-rv-gap);
}

.cm-chrono__player-shell .review-video-player__chrome--top {
  padding-top: max(var(--cm-rv-pad-y), env(safe-area-inset-top, 0px));
  padding-left: var(--cm-rv-pad-x);
}

.cm-chrono__player-shell .review-video-player--embedded .review-video-player__chrome--top {
  padding-right: clamp(4.4rem, 18cqmin, 6.5rem);
  padding-left: var(--cm-rv-pad-x);
  border-radius: 0;
}

.cm-chrono__player-shell .review-video-player__chrome--bottom {
  padding-bottom: max(var(--cm-rv-pad-y), env(safe-area-inset-bottom, 0px));
}

.cm-chrono__player-shell .review-video-player__orient,
.cm-chrono__player-shell .review-video-player__pose-tools,
.cm-chrono__player-shell .review-video-player__joint-overlay,
.cm-chrono__player-shell .review-video-player__speeds,
.cm-chrono__player-shell .review-video-player__transport,
.cm-chrono__player-shell .review-video-player__transport-main,
.cm-chrono__player-shell .review-video-player__transport-extra,
.cm-chrono__player-shell .review-video-player__game-points {
  gap: var(--cm-rv-gap);
}

.cm-chrono__player-shell .review-video-player__btn,
.cm-chrono__player-shell .review-video-player__transport-main > .review-video-player__btn,
.cm-chrono__player-shell .review-video-player__game-points .review-video-player__btn {
  width: var(--cm-rv-btn);
  height: var(--cm-rv-btn);
  min-width: 0;
  min-height: 0;
  padding: clamp(2px, 0.7cqmin, 6px);
  border-radius: var(--cm-rv-radius);
  flex: 1 1;
}

.cm-chrono__player-shell .review-video-player__btn--play,
.cm-chrono__player-shell .review-video-player__transport-main > .review-video-player__btn--play {
  width: var(--cm-rv-play);
  height: var(--cm-rv-play);
  min-width: 0;
  min-height: 0;
  flex: 1.15 1;
  border-radius: calc(var(--cm-rv-radius) + 2px);
}

.cm-chrono__player-shell .review-video-player__btn svg,
.cm-chrono__player-shell .review-video-player__chrome-toggle svg {
  width: var(--cm-rv-icon);
  height: var(--cm-rv-icon);
}

.cm-chrono__player-shell .review-video-player__btn span,
.cm-chrono__player-shell .review-video-player__speed-btn,
.cm-chrono__player-shell .review-video-player__joint-overlay-btn {
  font-size: var(--cm-rv-label);
}

.cm-chrono__player-shell .review-video-player__speed-btn,
.cm-chrono__player-shell .review-video-player__joint-overlay-btn {
  min-width: 0;
  width: auto;
  height: clamp(1.15rem, 4.6cqmin, 1.85rem);
  padding: 0 clamp(0.35rem, 1.6cqmin, 0.65rem);
  border-radius: 999px;
}

.cm-chrono__player-shell .review-video-player__time {
  font-size: clamp(0.58rem, 2.4cqmin, 0.75rem);
  gap: clamp(2px, 0.8cqmin, 4px);
}

.cm-chrono__player-shell .review-video-player__scrubber-wrap {
  margin: 0;
  padding: 0.45rem 0.1rem;
  pointer-events: auto !important;
  touch-action: none;
}

.cm-chrono__player-shell .review-video-player__scrubber {
  appearance: none;
  width: 100%;
  height: 1.4rem;
  margin: 0;
  background: transparent;
  accent-color: #fff;
  cursor: grab;
  pointer-events: auto !important;
  touch-action: none;
}

.cm-chrono__player-shell .review-video-player__scrubber::-webkit-slider-runnable-track {
  height: 4px;
  background: rgba(255, 255, 255, 0.38);
  border-radius: 999px;
}

.cm-chrono__player-shell .review-video-player__scrubber::-webkit-slider-thumb {
  appearance: none;
  width: 0.95rem;
  height: 0.95rem;
  margin-top: -0.36rem;
  border: 0;
  border-radius: 50%;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.55);
  cursor: grab;
}

.cm-chrono__player-shell .review-video-player__scrubber::-moz-range-track {
  height: 4px;
  background: rgba(255, 255, 255, 0.38);
  border-radius: 999px;
}

.cm-chrono__player-shell .review-video-player__scrubber::-moz-range-thumb {
  width: 0.95rem;
  height: 0.95rem;
  border: 0;
  border-radius: 50%;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.55);
  cursor: grab;
}

/* The frame ball stays on the picture after the rest of the chrome hides. */
.cm-chrono__player-shell .review-video-player:not(.review-video-player--controls-visible) .review-video-player__chrome--bottom {
  opacity: 1 !important;
  background: linear-gradient(to top, rgba(0, 0, 0, 0.55), transparent);
  pointer-events: none !important;
}

.cm-chrono__player-shell .review-video-player:not(.review-video-player--controls-visible) .review-video-player__chrome--bottom > :not(.review-video-player__scrubber-wrap) {
  display: none;
}

.cm-chrono__player-shell .review-video-player__chrome-toggle {
  top: max(clamp(4px, 1.4cqmin, 10px), env(safe-area-inset-top, 0px));
  right: clamp(2.4rem, 11cqmin, 3.5rem);
  min-width: var(--cm-rv-btn);
  min-height: var(--cm-rv-btn);
  width: var(--cm-rv-btn);
  height: var(--cm-rv-btn);
  border-radius: var(--cm-rv-radius);
}

.cm-chrono__player-shell .review-video-player__analysis-hud {
  top: calc(max(0.5rem, env(safe-area-inset-top, 0px)) + clamp(2.2rem, 8cqmin, 2.9rem));
  gap: clamp(4px, 1.2cqmin, 8px);
}

.cm-chrono__player-shell .review-video-player__analysis-info-btn {
  width: clamp(1.55rem, 7cqmin, 2.4rem);
  height: clamp(1.55rem, 7cqmin, 2.4rem);
}

.cm-chrono__player-shell .review-video-player__analysis-info-btn svg {
  width: clamp(12px, 3.6cqmin, 18px);
  height: clamp(12px, 3.6cqmin, 18px);
}

.cm-chrono__player-shell .review-video-player__feedback-panel {
  width: min(86%, clamp(9rem, 42cqmin, 13.5rem));
  max-height: min(38%, clamp(6.5rem, 36cqh, 14rem));
  padding: clamp(4px, 1.4cqmin, 8px) clamp(6px, 1.8cqmin, 10px);
  border-radius: clamp(8px, 2cqmin, 12px);
  font-size: clamp(0.58rem, 2.2cqmin, 0.72rem);
}

.cm-chrono__player-shell .cm-chrono__board {
  font-size: clamp(0.62rem, 2.6cqmin, 0.9rem);
}

/* Short / narrow frames: keep transport, drop secondary chrome. */
@container cm-player (max-width: 480px), (max-height: 320px) {
  .review-video-player__chrome--top .review-video-player__orient,
  .review-video-player__chrome--top .review-video-player__pose-tools,
  .review-video-player__transport-extra,
  .review-video-player__joint-overlay {
    display: none;
  }

  .review-video-player__btn span {
    display: none;
  }

  .review-video-player__btn {
    gap: 0;
  }
}

@container cm-player (max-height: 260px) {
  .review-video-player__speeds,
  .review-video-player__chrome--top .review-video-player__orient-status {
    display: none;
  }

  .review-video-player__chrome--bottom {
    gap: 2px;
    padding-top: 2px;
  }
}

@container cm-player (max-height: 200px) {
  .review-video-player__chrome--top {
    display: none;
  }

  .review-video-player__time {
    display: none;
  }
}

.cm-film {
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  flex: 0 0 auto;
  min-width: 0;
  padding: 0.5rem 0 0.45rem;
  background: var(--cm-rail);
  color: var(--cm-text);
}

.cm-film__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  padding: 0 0.6rem;
  min-width: 0;
}

.cm-film__sets {
  display: inline-flex;
  align-items: center;
  gap: 2px;
  min-width: 0;
  overflow-x: auto;
  padding: 2px;
  border-radius: 999px;
  background: var(--cm-fill);
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
}

.cm-film .cm-film__set {
  flex: 0 0 auto;
  border: 0;
  background: transparent;
  color: var(--cm-muted);
  border-radius: 999px;
  padding: 0.3rem 0.7rem;
  font: inherit;
  font-size: 0.68rem;
  font-weight: 750;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease;
}

.cm-film .cm-film__set.is-on {
  background: var(--cm-chip-on);
  color: var(--cm-text);
  box-shadow: 0 1px 0 rgba(255, 255, 255, 0.06) inset, 0 2px 6px rgba(0, 0, 0, 0.35);
}

.cm-film__progress {
  flex: 0 0 auto;
  font-size: 0.66rem;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
  color: var(--cm-muted);
  white-space: nowrap;
}

.cm-film__progress.is-done {
  color: var(--cm-home);
}

.cm-film__points {
  display: flex;
  flex-wrap: nowrap;
  gap: 0.3rem;
  overflow-x: auto;
  scroll-snap-type: x proximity;
  scroll-padding-inline: 0.6rem;
  padding: 0.1rem 0.6rem 0.15rem;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
}

.cm-film__point {
  --oc: var(--cm-fill-strong);
  position: relative;
  flex: 0 0 auto;
  scroll-snap-align: start;
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.05rem;
  min-width: 2.7rem;
  min-height: 2.6rem;
  border: 1px solid var(--cm-hair);
  background: var(--cm-chip);
  color: var(--cm-text);
  border-radius: 10px;
  padding: 0.2rem 0.45rem 0.32rem;
  overflow: hidden;
  font: inherit;
  cursor: pointer;
  transition: border-color 0.15s ease, background 0.15s ease;
}

.cm-film__point::after {
  content: "";
  position: absolute;
  left: 0.4rem;
  right: 0.4rem;
  bottom: 0.18rem;
  height: 3px;
  border-radius: 999px;
  background: var(--oc);
}

.cm-film__point[data-outcome="winner"] { --oc: #22c55e; }
.cm-film__point[data-outcome="unforced_error"] { --oc: #ef4444; }
.cm-film__point[data-outcome="forced_error"] { --oc: #eab308; }
.cm-film__point[data-outcome="lucky"] { --oc: #94a3b8; }
.cm-film__point[data-outcome="rally"] { --oc: #0ea5e9; }

.cm-film__point:disabled {
  opacity: 0.45;
  cursor: default;
}

.cm-film__point:focus-visible {
  outline: 2px solid var(--cm-primary);
  outline-offset: 1px;
}

.cm-film__point-n {
  font-family: "Barlow Condensed", "Outfit", sans-serif;
  font-size: 0.66rem;
  font-weight: 600;
  letter-spacing: 0.04em;
  color: var(--cm-muted);
  line-height: 1;
}

.cm-film__point-score {
  font-size: 0.8rem;
  font-weight: 800;
  font-variant-numeric: tabular-nums;
  letter-spacing: -0.02em;
  line-height: 1.1;
}

.cm-film__point-score.is-empty {
  color: var(--cm-muted);
  font-weight: 650;
}

.cm-film__point.is-selected {
  border-color: color-mix(in srgb, var(--cm-primary) 70%, transparent);
  background: color-mix(in srgb, var(--cm-primary) 24%, var(--cm-chip));
}

.cm-film__point.is-active {
  border-color: var(--cm-primary);
  box-shadow: 0 0 0 2px color-mix(in srgb, var(--cm-primary) 35%, transparent);
}

.cm-film__point.is-active .cm-film__point-n,
.cm-film__point.is-selected .cm-film__point-n {
  color: var(--cm-text);
}

.cm-film__labels {
  display: flex;
  gap: 0.7rem;
  overflow-x: auto;
  padding: 0.05rem 0.55rem 0.35rem;
  -webkit-overflow-scrolling: touch;
}

.cm-film__label-group {
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  gap: 0.28rem;
}

.cm-film__label-kicker {
  font-size: 0.62rem;
  font-weight: 800;
  letter-spacing: 0.07em;
  text-transform: uppercase;
  color: var(--cm-muted);
  margin-right: 0.1rem;
}

.cm-film__label {
  border-radius: 999px;
  padding: 0.16rem 0.45rem;
  background: color-mix(in srgb, var(--cm-muted) 14%, var(--cm-slate));
  color: var(--cm-text);
  font-size: 0.68rem;
  font-weight: 700;
}

.cm-film__labels-empty {
  font-size: 0.72rem;
  color: var(--cm-muted);
}

.cm-chrono:fullscreen,
.cm-chrono.is-review-fs,
.cm-review:fullscreen {
  background: var(--cm-bg);
  color: var(--cm-text);
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.cm-chrono:fullscreen .cm-film,
.cm-chrono.is-review-fs .cm-film,
.cm-review:fullscreen .cm-film {
  display: flex;
}

.cm-chrono:fullscreen .cm-chrono__sets,
.cm-chrono:fullscreen .cm-chrono__set-label,
.cm-chrono:fullscreen .cm-chrono__rail,
.cm-chrono.is-review-fs .cm-chrono__sets,
.cm-chrono.is-review-fs .cm-chrono__set-label,
.cm-chrono.is-review-fs .cm-chrono__rail,
.cm-review:fullscreen .cm-chrono__sets,
.cm-review:fullscreen .cm-chrono__set-label,
.cm-review:fullscreen .cm-chrono__rail {
  display: none;
}

.cm-chrono:fullscreen .cm-chrono__layout,
.cm-chrono.is-review-fs .cm-chrono__layout,
.cm-review:fullscreen .cm-chrono__layout {
  flex: 1 1 auto;
  min-height: 0;
  display: flex;
  flex-direction: column;
  grid-template-columns: 1fr;
}

.cm-chrono:fullscreen .cm-chrono__stage,
.cm-chrono.is-review-fs .cm-chrono__stage,
.cm-review:fullscreen .cm-chrono__stage {
  flex: 1 1 auto;
  min-height: 0;
  padding: 0;
  gap: 0;
}

.cm-chrono:fullscreen .cm-chrono__player-shell,
.cm-chrono.is-review-fs .cm-chrono__player-shell,
.cm-review:fullscreen .cm-chrono__player-shell {
  flex: 1 1 auto;
  aspect-ratio: auto;
  min-height: 0;
  border-radius: 0;
}

.cm-chrono:fullscreen .cm-chrono__side:not(:has(.cm-chrono__mod)),
.cm-chrono.is-review-fs .cm-chrono__side:not(:has(.cm-chrono__mod)),
.cm-review:fullscreen .cm-chrono__side:not(:has(.cm-chrono__mod)) {
  display: none;
}

.cm-review:fullscreen {
  padding: 0;
}

.cm-review:fullscreen .cm-review__body,
.cm-review:fullscreen .cm-chrono {
  flex: 1 1 auto;
  min-height: 0;
  height: auto;
  border: 0;
  border-radius: 0;
  background: transparent;
}

/* Timeline fullscreen: video on top, one set + point strip along the bottom.
   Portrait phones rotate this stage so playback is landscape. */
.cm-chrono.is-stage-fs {
  position: fixed;
  inset: 0;
  z-index: 11000;
  width: 100dvw;
  height: 100dvh;
  max-height: none;
  margin: 0;
  border: 0;
  border-radius: 0;
  background: #05070c;
  display: flex;
  flex-direction: column;
}

.cm-chrono.is-stage-fs.is-portrait-stage {
  inset: auto;
  top: 0;
  left: 0;
  right: auto;
  bottom: auto;
  width: 100dvh;
  height: 100dvw;
  transform: rotate(90deg) translateY(-100%);
  transform-origin: top left;
}

.cm-chrono.is-stage-fs .cm-chrono__layout,
.cm-chrono.is-stage-fs .cm-chrono__stage,
.cm-chrono:fullscreen .cm-chrono__layout,
.cm-chrono:fullscreen .cm-chrono__stage {
  flex: 1 1 auto;
  min-height: 0;
  display: flex;
  flex-direction: column;
  padding: 0;
  gap: 0;
  background: #05070c;
}

.cm-chrono.is-stage-fs .cm-chrono__player-shell,
.cm-chrono:fullscreen .cm-chrono__player-shell {
  flex: 1 1;
  min-height: 0;
  width: 100%;
  height: auto;
  aspect-ratio: auto;
  border-radius: 0;
}

.cm-chrono.is-stage-fs .cm-chrono__rubber,
.cm-chrono.is-stage-fs .cm-chrono__side,
.cm-chrono.is-stage-fs .cm-chrono__tagger-slot,
.cm-chrono.is-stage-fs .cm-chrono__tape-scrub,
.cm-chrono:fullscreen .cm-chrono__rubber,
.cm-chrono:fullscreen .cm-chrono__side,
.cm-chrono:fullscreen .cm-chrono__tagger-slot,
.cm-chrono:fullscreen .cm-chrono__tape-scrub {
  display: none;
}

.cm-chrono.is-stage-fs .cm-film,
.cm-chrono:fullscreen .cm-film {
  display: flex;
  flex: 0 0 auto;
  background: #0b1018;
  padding-bottom: max(0.45rem, env(safe-area-inset-bottom, 0px));
  padding-left: env(safe-area-inset-left, 0px);
  padding-right: env(safe-area-inset-right, 0px);
}

.cm-chrono.is-stage-fs .cm-chrono__player-shell .review-video-player__analysis-hud {
  top: calc(max(0.6rem, env(safe-area-inset-top, 0px)) + 3.2rem);
}

/* Portrait full screen: upright stage, video centred, point strip under the
   thumb. On wide screens the stage keeps a phone-shaped column. */
.cm-chrono.is-stage-portrait {
  background:
    radial-gradient(120% 60% at 50% 0%, color-mix(in srgb, var(--cm-primary) 14%, transparent), transparent 70%),
    #05070c;
}

.cm-chrono.is-stage-portrait .cm-chrono__layout {
  background: transparent;
}

.cm-chrono.is-stage-portrait .cm-chrono__stage {
  align-items: center;
  width: 100%;
  min-width: 0;
  background: transparent;
}

.cm-chrono.is-stage-portrait .cm-chrono__player-shell,
.cm-chrono.is-stage-portrait .cm-film {
  width: min(100%, calc(100dvh * 9 / 16));
  max-width: 100%;
}

.cm-chrono.is-stage-portrait .cm-chrono__player-shell {
  background: transparent;
}

.cm-chrono.is-stage-portrait .cm-film {
  background: transparent;
  border-top: 1px solid rgba(255, 255, 255, 0.06);
  padding-top: 0.65rem;
}

.cm-chrono.is-stage-portrait .cm-film__point {
  min-width: 3rem;
  min-height: 2.9rem;
}

@media (orientation: portrait) {
  .cm-chrono.is-stage-portrait .cm-chrono__player-shell,
  .cm-chrono.is-stage-portrait .cm-film {
    width: 100%;
  }
}

/* Landscape stage: the tape fills the screen. Sets, labels, and the live
   score sit on top of the picture instead of reserving a band under it. */
.cm-chrono.is-stage-landscape .cm-chrono__layout,
.cm-chrono.is-stage-landscape .cm-chrono__stage {
  position: relative;
  flex: 1 1 auto;
  min-height: 0;
}

.cm-chrono.is-stage-landscape .cm-chrono__player-shell {
  position: absolute;
  inset: 0;
  z-index: 1;
  width: 100%;
  height: 100%;
  max-height: none;
  flex: none;
}

.cm-chrono.is-stage-landscape .cm-chrono__player-shell .review-video-player,
.cm-chrono.is-stage-landscape .cm-chrono__player-shell .review-video-player__viewport,
.cm-chrono.is-stage-landscape .cm-chrono__player-shell .review-video-player__transform,
.cm-chrono.is-stage-landscape .cm-chrono__player-shell .review-video-player__video {
  width: 100%;
  height: 100%;
  max-width: none;
  max-height: none;
  aspect-ratio: auto;
  object-fit: contain;
}

.cm-chrono.is-stage-landscape .cm-film {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  z-index: 26;
  flex: none;
  height: auto;
  background: transparent;
  padding: 0;
  pointer-events: none;
}

.cm-chrono.is-stage-landscape .cm-film__points {
  display: none;
}

.cm-chrono.is-stage-landscape .cm-chrono__board,
.cm-chrono.is-stage-landscape .cm-chrono__tape-id,
.cm-chrono.is-stage-landscape .cm-chrono__parts {
  display: none;
}

.cm-chrono.is-stage-landscape .cm-film__head {
  padding:
    max(0.45rem, env(safe-area-inset-top, 0px))
    max(6.4rem, calc(env(safe-area-inset-right, 0px) + 5.6rem))
    0
    max(0.55rem, env(safe-area-inset-left, 0px));
  pointer-events: none;
}

.cm-chrono.is-stage-landscape .cm-film__sets {
  pointer-events: auto;
  background: rgba(5, 8, 14, 0.55);
  border: 1px solid rgba(255, 255, 255, 0.12);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
}

.cm-chrono.is-stage-landscape .cm-film .cm-film__set {
  color: rgba(248, 250, 252, 0.72);
}

.cm-chrono.is-stage-landscape .cm-film .cm-film__set.is-on {
  background: rgba(255, 255, 255, 0.16);
  color: #fff;
  box-shadow: none;
}

.cm-chrono.is-stage-landscape .cm-film__progress {
  padding: 0.28rem 0.55rem;
  border-radius: 999px;
  background: rgba(5, 8, 14, 0.55);
  color: rgba(248, 250, 252, 0.82);
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.cm-chrono.is-stage-landscape .cm-film__labels {
  padding:
    0.35rem
    max(0.55rem, env(safe-area-inset-right, 0px))
    0
    max(0.55rem, env(safe-area-inset-left, 0px));
  pointer-events: none;
}

.cm-chrono.is-stage-landscape .cm-chrono__player-shell .review-video-player__chrome--top {
  padding-top: max(2.75rem, calc(env(safe-area-inset-top, 0px) + 2.35rem));
}

.cm-chrono.is-stage-landscape .cm-chrono__player-shell .review-video-player__chrome--bottom {
  padding-left: max(
    0.75rem,
    calc(min(22rem, 68vw) + env(safe-area-inset-left, 0px))
  );
}

.cm-league {
  --cm-league-brand: var(--cm-primary, #0877bc);
  --cm-league-ink: #f8fafc;
  --cm-league-muted: rgba(248, 250, 252, 0.72);
  --cm-league-board: rgba(8, 12, 20, 0.88);
  --cm-league-edge: color-mix(in srgb, var(--cm-league-brand) 45%, rgba(255, 255, 255, 0.14));
  --cm-league-teams-bg: color-mix(in srgb, var(--cm-league-brand) 16%, rgba(248, 250, 252, 0.96));
  --cm-league-teams-ink: #0f172a;
  --cm-league-set-bg: color-mix(in srgb, var(--cm-league-brand) 78%, #0b1220);
  --cm-league-set-ink: #fff;
  --cm-league-brand-bg: color-mix(in srgb, var(--cm-league-brand) 82%, #0b1220);
  --cm-league-logo-bg: #ffffff;
  --cm-league-logo-ring: color-mix(in srgb, var(--cm-league-brand) 28%, rgba(15, 23, 42, 0.18));
  --cm-league-logo-ink: #0f172a;
  --cm-league-home: color-mix(in srgb, var(--cm-league-brand) 72%, var(--cm-home, #34d399));
  --cm-league-away: color-mix(in srgb, var(--cm-league-brand) 55%, var(--cm-away, #60a5fa));
  --cm-league-shadow: drop-shadow(0 8px 18px rgba(0, 0, 0, 0.45));
  position: absolute;
  z-index: 21;
  left: max(0.4rem, env(safe-area-inset-left, 0px));
  bottom: max(0.4rem, env(safe-area-inset-bottom, 0px));
  display: flex;
  align-items: stretch;
  gap: 0.28rem;
  max-width: min(34rem, calc(100% - 0.8rem));
  pointer-events: none;
  color: var(--cm-league-ink);
  filter: var(--cm-league-shadow);
}

/* Bright page theme — light plate when docked under the tape. */
.cm-page--light .cm-league {
  --cm-league-ink: #0f172a;
  --cm-league-muted: #475569;
  --cm-league-board: rgba(255, 255, 255, 0.94);
  --cm-league-edge: color-mix(in srgb, var(--cm-league-brand) 40%, rgba(15, 23, 42, 0.12));
  --cm-league-teams-bg: color-mix(in srgb, var(--cm-league-brand) 12%, #ffffff);
  --cm-league-teams-ink: #0f172a;
  --cm-league-set-bg: color-mix(in srgb, var(--cm-league-brand) 88%, #0b1220);
  --cm-league-set-ink: #fff;
  --cm-league-brand-bg: color-mix(in srgb, var(--cm-league-brand) 22%, #e8eef5);
  --cm-league-logo-bg: #ffffff;
  --cm-league-logo-ring: color-mix(in srgb, var(--cm-league-brand) 35%, rgba(15, 23, 42, 0.14));
  --cm-league-logo-ink: #0f172a;
  --cm-league-home: color-mix(in srgb, var(--cm-league-brand) 55%, var(--cm-home, #047857));
  --cm-league-away: color-mix(in srgb, var(--cm-league-brand) 45%, #2563eb);
  --cm-league-shadow: drop-shadow(0 6px 14px rgba(15, 23, 42, 0.16));
}

/* Over video (fullscreen / landscape) stay dark for contrast on the picture. */
.cm-page--light .cm-chrono.is-stage-landscape .cm-league,
.cm-page--light .cm-chrono.is-stage-fs .cm-league,
.cm-page--light .cm-chrono__player-shell .cm-league {
  --cm-league-ink: #f8fafc;
  --cm-league-muted: rgba(248, 250, 252, 0.72);
  --cm-league-board: rgba(8, 12, 20, 0.88);
  --cm-league-edge: color-mix(in srgb, var(--cm-league-brand) 45%, rgba(255, 255, 255, 0.14));
  --cm-league-teams-bg: color-mix(in srgb, var(--cm-league-brand) 16%, rgba(248, 250, 252, 0.96));
  --cm-league-teams-ink: #0f172a;
  --cm-league-set-bg: color-mix(in srgb, var(--cm-league-brand) 78%, #0b1220);
  --cm-league-set-ink: #fff;
  --cm-league-brand-bg: color-mix(in srgb, var(--cm-league-brand) 82%, #0b1220);
  --cm-league-logo-bg: #ffffff;
  --cm-league-logo-ring: color-mix(in srgb, var(--cm-league-brand) 28%, rgba(15, 23, 42, 0.18));
  --cm-league-logo-ink: #0f172a;
  --cm-league-home: color-mix(in srgb, var(--cm-league-brand) 72%, #34d399);
  --cm-league-away: color-mix(in srgb, var(--cm-league-brand) 55%, #60a5fa);
  --cm-league-shadow: drop-shadow(0 8px 18px rgba(0, 0, 0, 0.45));
}

.cm-league__brand {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.18rem;
  width: 3.35rem;
  flex: 0 0 auto;
  padding: 0.28rem 0.2rem;
  background: var(--cm-league-brand-bg);
}

.cm-league__logo,
.cm-league__mark {
  width: 2.35rem;
  height: 2.35rem;
  flex: 0 0 auto;
  box-sizing: border-box;
  padding: 0.22rem;
  border-radius: 50%;
  background: var(--cm-league-logo-bg);
  border: 1.5px solid var(--cm-league-logo-ring);
  box-shadow:
    0 1px 2px rgba(15, 23, 42, 0.12),
    inset 0 0 0 1px rgba(255, 255, 255, 0.55);
}

.cm-league__logo {
  object-fit: contain;
}

.cm-league__mark {
  display: grid;
  place-items: center;
  color: var(--cm-league-logo-ink);
  font-size: 0.72rem;
  font-weight: 800;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.cm-league__club {
  max-width: 3.3rem;
  font-size: 0.48rem;
  font-weight: 800;
  letter-spacing: 0.04em;
  line-height: 1.05;
  text-align: center;
  text-transform: uppercase;
  color: var(--cm-league-set-ink);
}

.cm-league__board {
  flex: 1 1 auto;
  min-width: 0;
  display: flex;
  flex-direction: column;
  background: var(--cm-league-board);
  border: 1px solid var(--cm-league-edge);
  box-shadow: inset 3px 0 0 var(--cm-league-brand);
}

.cm-league__teams {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto auto minmax(0, 1fr);
  align-items: center;
  column-gap: 0.35rem;
  padding: 0.12rem 0.4rem;
  background: var(--cm-league-teams-bg);
  color: var(--cm-league-teams-ink);
  font-size: 0.68rem;
  font-weight: 800;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  border-bottom: 2px solid var(--cm-league-brand);
}

.cm-league__set {
  padding: 0.08rem 0.4rem;
  background: var(--cm-league-set-bg);
  color: var(--cm-league-set-ink);
  font-size: 0.58rem;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.cm-league__team {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.cm-league__team--away {
  text-align: right;
}

.cm-league__team-score {
  font-family: "Barlow Condensed", "Arial Narrow", Impact, sans-serif;
  font-size: 1.15rem;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
  line-height: 1;
}

.cm-league__teams.has-division {
  grid-template-columns: minmax(0, 1fr) auto minmax(0, 1.15fr) auto minmax(0, 1fr);
}

.cm-league__division {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: center;
  font-size: 0.58rem;
  font-weight: 800;
  letter-spacing: 0.05em;
  text-transform: uppercase;
}

.cm-league__player {
  display: grid;
  grid-template-columns: 1.2rem minmax(0, 1fr) auto;
  align-items: center;
  column-gap: 0.4rem;
  min-height: 1.45rem;
  padding: 0.08rem 0.4rem 0.08rem 0.22rem;
}

.cm-league__player--home {
  --cm-league-side: var(--cm-league-home);
}

.cm-league__player--away {
  --cm-league-side: var(--cm-league-away);
}

.cm-league__games {
  width: 1.2rem;
  height: 1.2rem;
  display: grid;
  place-items: center;
  background: var(--cm-league-side);
  color: #fff;
  font-size: 0.75rem;
  font-weight: 800;
  font-variant-numeric: tabular-nums;
}

.cm-league__name {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 0.66rem;
  font-weight: 750;
  letter-spacing: 0.02em;
  text-transform: none;
}

.cm-league__pts {
  font-family: "Barlow Condensed", "Arial Narrow", Impact, sans-serif;
  font-size: 1.45rem;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
  line-height: 0.9;
  min-width: 1.2rem;
  text-align: right;
}

.cm-chrono__label-wait {
  top: max(0.55rem, env(safe-area-inset-top, 0px));
  bottom: auto;
}

.cm-broadcast {
  position: absolute;
  z-index: 21;
  left: max(0.55rem, env(safe-area-inset-left, 0px));
  bottom: max(0.55rem, env(safe-area-inset-bottom, 0px));
  width: min(16.4rem, 48vw);
  display: flex;
  flex-direction: column;
  gap: 0.12rem;
  padding: 0.38rem 0.55rem 0.32rem 0.42rem;
  border-radius: 2px;
  background: rgba(5, 8, 14, 0.78);
  border: 1px solid rgba(255, 255, 255, 0.16);
  box-shadow: 0 10px 28px rgba(0, 0, 0, 0.38);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  pointer-events: none;
  color: #f8fafc;
}

.cm-broadcast__row {
  display: grid;
  grid-template-columns: 3px minmax(0, 1fr) auto;
  align-items: center;
  column-gap: 0.45rem;
  min-height: 1.45rem;
}

.cm-broadcast__row--home {
  --cm-side: var(--cm-home, #34d399);
}

.cm-broadcast__row--away {
  --cm-side: var(--cm-away, #fbbf24);
}

.cm-broadcast__bar {
  width: 3px;
  height: 1.05rem;
  background: var(--cm-side);
}

.cm-broadcast__name {
  min-width: 0;
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.07em;
  text-transform: uppercase;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.cm-broadcast__pts {
  font-family: "Barlow Condensed", "Arial Narrow", Impact, sans-serif;
  font-size: 1.7rem;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
  letter-spacing: 0.02em;
  line-height: 0.85;
  min-width: 1.35rem;
  text-align: right;
}

.cm-broadcast__meta {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 0.6rem;
  margin-top: 0.12rem;
  padding-top: 0.16rem;
  border-top: 1px solid rgba(255, 255, 255, 0.14);
  font-size: 0.62rem;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: rgba(248, 250, 252, 0.72);
}

.cm-broadcast__sets {
  font-family: "Barlow Condensed", "Arial Narrow", sans-serif;
  font-size: 0.95rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  color: #fff;
}

.cm-page--timeline .cm-body,
.cm-page--timeline .cm-panel {
  min-height: 0;
}

.cm-page--timeline .cm-cam-status {
  max-height: 2.6rem;
  overflow: auto;
  flex: 0 0 auto;
}

.cm-chrono__point-strip {
  display: none;
  gap: 0.35rem;
  overflow-x: auto;
  padding: 0.05rem 0.05rem 0.15rem;
  -webkit-overflow-scrolling: touch;
  scroll-snap-type: x proximity;
}

.cm-chrono__point-pill {
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  border: 1px solid rgba(255, 255, 255, 0.12);
  background: rgba(255, 255, 255, 0.06);
  color: #f8fafc;
  border-radius: 999px;
  padding: 0.38rem 0.65rem 0.38rem 0.38rem;
  font: inherit;
  cursor: pointer;
  scroll-snap-align: start;
}

.cm-chrono__point-pill:disabled {
  opacity: 0.45;
  cursor: default;
}

.cm-chrono__point-pill-n {
  width: 1.35rem;
  height: 1.35rem;
  border-radius: 999px;
  display: grid;
  place-items: center;
  font-size: 0.65rem;
  font-weight: 800;
  background: rgba(255, 255, 255, 0.12);
}

.cm-chrono__point-pill-score {
  font-size: 0.82rem;
  font-weight: 800;
  font-variant-numeric: tabular-nums;
}

.cm-chrono__point-pill-dot {
  width: 0.4rem;
  height: 0.4rem;
  border-radius: 999px;
  background: var(--cm-primary, #38bdf8);
}

.cm-chrono__point-pill.is-active,
.cm-chrono__point-pill.is-selected {
  border-color: color-mix(in srgb, var(--cm-primary) 65%, transparent);
  background: color-mix(in srgb, var(--cm-primary) 28%, rgba(8, 12, 20, 0.7));
}

.cm-chrono__point-pill.is-active .cm-chrono__point-pill-n {
  background: var(--cm-primary);
  color: #041018;
}

.cm-chrono__tape-scrub {
  display: flex;
  align-items: center;
  gap: 0.55rem;
  padding: 0 0.1rem;
  flex: 0 0 auto;
}

.cm-chrono__tape-scrub-label {
  flex: 0 0 auto;
  font-size: 0.66rem;
  font-weight: 800;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: rgba(248, 250, 252, 0.65);
}

.cm-chrono__tape-scrub input[type="range"] {
  flex: 1 1 auto;
  min-width: 0;
  accent-color: var(--cm-primary);
}

.cm-chrono__side {
  display: flex;
  flex-direction: column;
  min-height: 0;
  min-width: 0;
  flex: 0 0 auto;
  max-height: 28%;
  overflow: auto;
  border-left: 0;
  border-top: 1px solid var(--cm-border);
  background: color-mix(in srgb, var(--cm-muted) 5%, var(--cm-slate));
}

.cm-chrono__side:not(:has(.cm-chrono__mod)):not(:has(.cm-chrono__score-ai)) {
  display: none;
}

.cm-chrono__sets,
.cm-chrono__set-label,
.cm-chrono__rail {
  display: none;
}

.cm-chrono__sets {
  gap: 0.35rem;
  padding: 0.55rem 0.65rem 0.2rem;
  overflow-x: auto;
  flex: 0 0 auto;
}

.cm-chrono__set {
  flex: 0 0 auto;
  border: 1px solid var(--cm-border);
  background: transparent;
  color: var(--cm-text);
  border-radius: 999px;
  padding: 0.3rem 0.68rem;
  font: inherit;
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  cursor: pointer;
}

.cm-chrono__set.is-on {
  background: color-mix(in srgb, var(--cm-primary) 18%, transparent);
  border-color: color-mix(in srgb, var(--cm-primary) 55%, var(--cm-border));
  color: var(--cm-primary);
}

.cm-chrono__set-label {
  margin: 0.45rem 0.75rem 0;
  font-size: 0.68rem;
  font-weight: 800;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--cm-muted);
  flex: 0 0 auto;
}

.cm-chrono__rail {
  flex: 1 1 auto;
  min-height: 0;
  overflow: auto;
  padding: 0.45rem 0.55rem 0.55rem;
  scroll-padding-block: 2.5rem;
}

.cm-chrono__rail-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  margin-bottom: 0.4rem;
  position: sticky;
  top: 0;
  z-index: 1;
  padding: 0.15rem 0 0.35rem;
  background: linear-gradient(
    to bottom,
    color-mix(in srgb, var(--cm-slate) 96%, transparent),
    color-mix(in srgb, var(--cm-slate) 88%, transparent)
  );
}

.cm-chrono__rail-label {
  margin: 0;
  font-size: 0.66rem;
  font-weight: 800;
  letter-spacing: 0.07em;
  text-transform: uppercase;
  color: var(--cm-muted);
}

.cm-chrono__now-pill {
  flex: 0 0 auto;
  padding: 0.16rem 0.48rem;
  border-radius: 999px;
  background: color-mix(in srgb, var(--cm-primary) 22%, transparent);
  color: var(--cm-primary);
  font-size: 0.62rem;
  font-weight: 800;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.cm-chrono__cues {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
}

.cm-chrono__cue {
  border-radius: 12px;
  border: 1px solid transparent;
  background: color-mix(in srgb, var(--cm-primary) 4%, transparent);
  transition:
    border-color 0.18s ease,
    background 0.18s ease,
    box-shadow 0.18s ease;
}

.cm-chrono__cue.is-selected {
  border-color: color-mix(in srgb, var(--cm-primary) 32%, var(--cm-border));
  background: color-mix(in srgb, var(--cm-primary) 8%, var(--cm-slate));
}

.cm-chrono__cue.is-active {
  border-color: color-mix(in srgb, var(--cm-primary) 70%, var(--cm-border));
  background: color-mix(in srgb, var(--cm-primary) 15%, var(--cm-slate));
  box-shadow:
    inset 3px 0 0 var(--cm-primary),
    0 0 0 1px color-mix(in srgb, var(--cm-primary) 22%, transparent);
}

.cm-chrono__cue-hit {
  width: 100%;
  display: grid;
  grid-template-columns: auto auto auto 1fr auto;
  grid-template-areas:
    "index score clock live media"
    "index tags tags tags tags"
    "index note note note note";
  gap: 0.14rem 0.4rem;
  align-items: baseline;
  text-align: left;
  border: 0;
  background: transparent;
  color: inherit;
  font: inherit;
  padding: 0.5rem 0.6rem;
  cursor: pointer;
}

.cm-chrono__cue-hit:disabled {
  opacity: 0.55;
  cursor: default;
}

.cm-chrono__cue-index {
  grid-area: index;
  width: 1.45rem;
  height: 1.45rem;
  border-radius: 8px;
  display: grid;
  place-items: center;
  font-size: 0.66rem;
  font-weight: 800;
  font-variant-numeric: tabular-nums;
  color: var(--cm-muted);
  background: color-mix(in srgb, var(--cm-muted) 14%, transparent);
  align-self: start;
}

.cm-chrono__cue.is-active .cm-chrono__cue-index {
  color: #041018;
  background: var(--cm-primary);
}

.cm-chrono__cue-score {
  grid-area: score;
  font-weight: 800;
  font-variant-numeric: tabular-nums;
  font-size: 0.92rem;
}

.cm-chrono__cue-clock {
  grid-area: clock;
  font-size: 0.7rem;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
  color: var(--cm-muted);
  font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
}

.cm-chrono__cue-live {
  grid-area: live;
  justify-self: start;
  padding: 0.1rem 0.35rem;
  border-radius: 999px;
  background: color-mix(in srgb, var(--cm-primary) 28%, transparent);
  color: var(--cm-primary);
  font-size: 0.6rem;
  font-weight: 800;
  letter-spacing: 0.06em;
  text-transform: uppercase;
}

.cm-chrono__cue-tags {
  grid-area: tags;
  display: flex;
  flex-wrap: wrap;
  gap: 0.25rem;
  min-width: 0;
}

.cm-chrono__cue-tags--empty {
  font-size: 0.68rem;
  font-weight: 600;
  color: color-mix(in srgb, var(--cm-muted) 80%, transparent);
  font-style: italic;
}

.cm-chrono__cue-tag {
  display: inline-flex;
  align-items: center;
  padding: 0.1rem 0.38rem;
  border-radius: 999px;
  border: 1px solid color-mix(in srgb, var(--cm-primary) 28%, var(--cm-border));
  background: color-mix(in srgb, var(--cm-primary) 12%, transparent);
  color: color-mix(in srgb, var(--cm-primary) 75%, var(--cm-text));
  font-size: 0.64rem;
  font-weight: 700;
  letter-spacing: 0.02em;
  white-space: nowrap;
}

.cm-chrono__cue-note {
  grid-area: note;
  font-size: 0.74rem;
  color: var(--cm-muted);
}

.cm-chrono__cue-media {
  grid-area: media;
  display: inline-flex;
  gap: 0.25rem;
  color: var(--cm-muted);
  justify-self: end;
}

.cm-chrono__cue-gallery {
  display: flex;
  gap: 0.35rem;
  padding: 0 0.65rem 0.55rem;
  overflow-x: auto;
}

.cm-chrono__thumb {
  width: 3rem;
  height: 3rem;
  padding: 0;
  border: 1px solid var(--cm-border);
  border-radius: 8px;
  overflow: hidden;
  background: #0b1220;
  cursor: pointer;
}

.cm-chrono__thumb img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.cm-chrono__cue-voices {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  padding: 0 0.65rem 0.55rem;
}

.cm-chrono__cue-voices audio {
  width: 100%;
}

.cm-chrono__tagger-slot--dock {
  display: block;
  flex: 0 1 auto;
  min-height: 0;
  max-height: 52%;
  overflow: auto;
  overscroll-behavior: contain;
}

.cm-chrono__tagger-slot--side,
.cm-chrono__tagger-slot--review {
  display: none;
}

/* ── Tag deck (embedded): point nav, flip score, outcome, reactions ── */
.cm-deck {
  container-type: inline-size;
  container-name: cm-deck;
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
  padding: 0.6rem 0.7rem 0.75rem;
  background: var(--cm-deck);
  border-top: 1px solid var(--cm-hair);
  color: var(--cm-text);
}

.cm-deck__head {
  display: grid;
  grid-template-columns: auto minmax(0, 1fr) auto;
  align-items: center;
  gap: 0.5rem;
}

.cm-deck__nav {
  width: 2.15rem;
  height: 2.15rem;
  display: grid;
  place-items: center;
  padding: 0;
  border: 1px solid var(--cm-hair);
  border-radius: 999px;
  background: var(--cm-fill);
  color: var(--cm-text);
  cursor: pointer;
  transition: background 0.15s ease, transform 0.12s ease;
}

.cm-deck__nav:hover:not(:disabled) {
  background: var(--cm-fill-strong);
}

.cm-deck__nav:active:not(:disabled) {
  transform: scale(0.94);
}

.cm-deck__nav:disabled {
  opacity: 0.3;
  cursor: default;
}

.cm-deck__title {
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 0;
  line-height: 1.15;
}

.cm-deck__title strong {
  font-size: 0.82rem;
  font-weight: 750;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
}

.cm-deck__clock {
  font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
  font-size: 0.66rem;
  font-variant-numeric: tabular-nums;
  color: var(--cm-muted);
}

.cm-deck__score {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto minmax(0, 1fr) auto;
  align-items: end;
  gap: 0.35rem;
}

.cm-deck__sets-edit {
  display: grid;
  grid-template-columns: auto minmax(0, 1fr) auto minmax(0, 1fr);
  align-items: end;
  gap: 0.3rem 0.35rem;
  margin: 0 0 0.35rem;
  padding: 0.35rem 0.4rem;
  border-radius: 10px;
  background: color-mix(in srgb, var(--cm-fill, #1e293b) 70%, transparent);
}

.cm-deck__sets-label {
  grid-column: 1;
  align-self: center;
  font-size: 0.68rem;
  font-weight: 800;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--cm-muted);
}

.cm-deck__colon {
  font-family: "Barlow Condensed", "Outfit", sans-serif;
  font-size: 1.7rem;
  font-weight: 700;
  line-height: 1;
  color: var(--cm-muted);
  opacity: 0.6;
  padding-bottom: 0.6rem;
}

.cm-deck__colon--sets {
  font-size: 1.1rem;
  padding-bottom: 0.35rem;
}

.cm-flip--compact .cm-flip__name {
  font-size: 0.58rem;
}

.cm-flip--compact .cm-flip__card {
  min-width: 2.1rem;
  height: 2.1rem;
  font-size: 1.05rem;
}

.cm-flip--compact .cm-flip__step {
  width: 1.55rem;
  height: 1.55rem;
}

/* Flip score card: the umpire's table counter. */
.cm-flip {
  --side: var(--cm-home);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.25rem;
  min-width: 0;
}

.cm-flip--away {
  --side: var(--cm-away);
}

.cm-flip__name {
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
  max-width: 100%;
  font-size: 0.66rem;
  font-weight: 700;
  color: var(--cm-muted);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.cm-flip__name::before {
  content: "";
  flex: 0 0 auto;
  width: 0.4rem;
  height: 0.4rem;
  border-radius: 999px;
  background: var(--side);
}

.cm-flip__row {
  display: flex;
  align-items: center;
  gap: 0.25rem;
}

.cm-flip__step {
  flex: 0 0 auto;
  width: 1.95rem;
  height: 1.95rem;
  display: grid;
  place-items: center;
  padding: 0;
  border: 0;
  border-radius: 999px;
  background: var(--cm-fill);
  color: var(--cm-text);
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
  transition: background 0.15s ease, transform 0.12s ease;
}

.cm-flip__step:hover:not(:disabled) {
  background: color-mix(in srgb, var(--side) 22%, transparent);
}

.cm-flip__step:active:not(:disabled) {
  transform: scale(0.9);
}

.cm-flip__step:disabled {
  opacity: 0.3;
  cursor: default;
}

.cm-flip .cm-flip__card {
  width: 2.75rem;
  height: 3.15rem;
  padding: 0;
  border: 0;
  border-radius: 8px;
  text-align: center;
  font-family: "Barlow Condensed", "Outfit", sans-serif;
  font-size: 2.05rem;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
  line-height: 1;
  color: #f8fafc;
  caret-color: var(--side);
  background:
    linear-gradient(
      180deg,
      transparent calc(50% - 0.5px),
      rgba(0, 0, 0, 0.6) calc(50% - 0.5px),
      rgba(0, 0, 0, 0.6) calc(50% + 0.5px),
      transparent calc(50% + 0.5px)
    ),
    linear-gradient(180deg, #1f2838 0 50%, #171e2b 50% 100%);
  box-shadow:
    inset 0 -3px 0 var(--side),
    inset 0 1px 0 rgba(255, 255, 255, 0.06),
    0 4px 12px rgba(0, 0, 0, 0.4);
}

.cm-flip__card::placeholder {
  color: rgba(248, 250, 252, 0.25);
}

.cm-flip__card:focus-visible {
  outline: 2px solid var(--side);
  outline-offset: 2px;
}

.cm-deck .cm-deck__save {
  align-self: end;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.35rem;
  height: 2.45rem;
  min-width: 2.45rem;
  margin-bottom: 0.35rem;
  padding: 0 0.85rem;
  border: 1px solid var(--cm-hair);
  border-radius: 999px;
  background: var(--cm-fill);
  color: var(--cm-muted);
  font: inherit;
  font-size: 0.72rem;
  font-weight: 750;
  white-space: nowrap;
  cursor: pointer;
  transition: background 0.18s ease, color 0.18s ease, box-shadow 0.18s ease;
}

.cm-deck__save.is-ready {
  border-color: transparent;
  background: var(--cm-primary);
  color: #fff;
  box-shadow: 0 6px 18px color-mix(in srgb, var(--cm-primary) 40%, transparent);
}

.cm-deck__save:disabled {
  cursor: default;
}

.cm-deck__save:disabled:not(.is-ready) {
  opacity: 0.55;
}

.cm-deck__save:focus-visible,
.cm-deck__emoji:focus-visible,
.cm-deck__nav:focus-visible,
.cm-flip__step:focus-visible {
  outline: 2px solid var(--cm-primary);
  outline-offset: 2px;
}

.cm-deck__spin {
  animation: cm-deck-spin 0.9s linear infinite;
}

@keyframes cm-deck-spin {
  to {
    transform: rotate(360deg);
  }
}

@container cm-deck (max-width: 26rem) {
  .cm-deck .cm-deck__save {
    padding: 0;
    width: 2.45rem;
  }

  .cm-deck .cm-deck__save span {
    position: absolute;
    width: 1px;
    height: 1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
  }
}

@container cm-deck (max-width: 19rem) {
  .cm-flip__step {
    width: 1.6rem;
    height: 1.6rem;
  }

  .cm-flip .cm-flip__card {
    width: 2.35rem;
  }
}

.cm-deck__label {
  margin: 0;
  font-size: 0.62rem;
  font-weight: 750;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--cm-muted);
  margin-bottom: -0.3rem;
}

.cm-outcome--deck {
  gap: 0.3rem;
}

.cm-outcome--deck .cm-outcome__btn {
  min-height: 2.6rem;
  border-radius: 10px;
  border-color: color-mix(in srgb, var(--oc) 28%, transparent);
  background: color-mix(in srgb, var(--oc) 7%, var(--cm-chip));
  transition: background 0.15s ease, border-color 0.15s ease, transform 0.12s ease;
}

.cm-outcome--deck .cm-outcome__btn:hover:not(:disabled) {
  background: color-mix(in srgb, var(--oc) 16%, var(--cm-chip));
}

.cm-outcome--deck .cm-outcome__btn:active:not(:disabled) {
  transform: scale(0.96);
}

.cm-outcome--deck .cm-outcome__btn.is-on {
  border-color: var(--oc);
  background: color-mix(in srgb, var(--oc) 26%, var(--cm-chip));
  box-shadow: 0 0 0 1px var(--oc) inset, 0 4px 14px color-mix(in srgb, var(--oc) 25%, transparent);
}

.cm-outcome--deck .cm-outcome__btn:focus-visible {
  outline: 2px solid var(--oc);
  outline-offset: 2px;
}

.cm-outcome--deck .cm-outcome__mark {
  font-size: 0.82rem;
}

.cm-deck__react {
  display: flex;
  gap: 0.3rem;
  overflow-x: auto;
  scrollbar-width: none;
  -webkit-overflow-scrolling: touch;
  border-top: 1px solid var(--cm-hair);
  padding-top: 0.55rem;
}

.cm-deck .cm-deck__emoji {
  flex: 0 0 auto;
  width: 2.05rem;
  height: 2.05rem;
  display: grid;
  place-items: center;
  padding: 0;
  border: 0;
  border-radius: 999px;
  background: var(--cm-fill);
  font-size: 1.05rem;
  line-height: 1;
  cursor: pointer;
  transition: transform 0.12s ease, background 0.15s ease;
}

.cm-deck__emoji:hover {
  background: var(--cm-fill-strong);
}

.cm-deck__emoji:active {
  transform: scale(1.18);
}

.cm-deck__note {
  margin: -0.2rem 0 0;
  font-size: 0.72rem;
  color: var(--cm-muted);
}

@media (prefers-reduced-motion: reduce) {
  .cm-deck__spin {
    animation: none;
  }

  .cm-deck *,
  .cm-stagectl,
  .cm-stagectl__btn,
  .cm-film__point {
    transition: none !important;
  }
}

.cm-chrono__reassign {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  margin-top: 0.35rem;
  font-size: 0.78rem;
  color: var(--cm-muted, #6b7280);
}

.cm-chrono__reassign-select {
  width: 100%;
  border: 1px solid var(--cm-line, #d1d5db);
  border-radius: 8px;
  padding: 0.45rem 0.55rem;
  background: #fff;
  font: inherit;
  color: inherit;
}

.cm-chrono__mod {
  display: flex;
  flex-wrap: wrap;
  gap: 0.35rem;
  padding: 0.55rem 0.65rem 0;
}

.cm-chrono__mod .cm-btn {
  font-size: 0.72rem;
  min-height: 2rem;
  padding: 0.28rem 0.55rem;
}

.cm-chrono__mod .cm-btn.is-on {
  border-color: var(--cm-primary);
  color: var(--cm-primary);
}

.cm-chrono__scorecam-count {
  display: inline-grid;
  place-items: center;
  min-width: 1.15rem;
  height: 1.15rem;
  padding: 0 0.28rem;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.12);
  font-size: 0.65rem;
  font-weight: 800;
  font-variant-numeric: tabular-nums;
}

.cm-chrono__scorecam-debug {
  display: flex;
  flex-direction: column;
  gap: 0.45rem;
  margin: 0.35rem 0.65rem 0;
  padding: 0.55rem 0.6rem;
  border: 1px dashed color-mix(in srgb, var(--cm-border) 70%, #f59e0b 30%);
  border-radius: 10px;
  background: color-mix(in srgb, var(--cm-slate) 92%, #f59e0b 8%);
}

.cm-chrono__scorecam-hint {
  margin: 0;
  font-size: 0.7rem;
  line-height: 1.35;
  color: var(--cm-muted);
}

.cm-chrono__scorecam-list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 0.55rem;
}

.cm-chrono__scorecam-item {
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
}

.cm-chrono__scorecam-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 0.35rem 0.65rem;
  align-items: baseline;
  font-size: 0.7rem;
}

.cm-chrono__scorecam-meta strong {
  font-size: 0.74rem;
}

.cm-chrono__scorecam-meta span {
  color: var(--cm-muted);
}

.cm-chrono__scorecam-video {
  width: 100%;
  max-height: 12rem;
  border-radius: 8px;
  background: #000;
  object-fit: contain;
}

.cm-chrono__score-ai {
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  margin: 0.35rem 0.65rem 0;
  padding: 0.55rem 0.6rem;
  border: 1px solid var(--cm-border);
  border-radius: 10px;
  background: color-mix(in srgb, var(--cm-slate) 88%, var(--cm-primary) 12%);
}

.cm-chrono__score-ai-hint {
  margin: 0;
  font-size: 0.7rem;
  line-height: 1.35;
  color: var(--cm-muted);
}

.cm-chrono__score-ai-marks,
.cm-chrono__score-ai-actions,
.cm-chrono__score-ai-dock-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 0.35rem;
  align-items: center;
}

.cm-chrono__score-ai-t {
  margin-left: 0.25rem;
  font-variant-numeric: tabular-nums;
  font-weight: 800;
  color: var(--cm-primary);
}

.cm-chrono__score-ai-meta,
.cm-chrono__score-ai-dock-meta {
  margin: 0;
  font-size: 0.68rem;
  color: var(--cm-muted);
}

.cm-chrono__score-ai-err {
  margin: 0;
  font-size: 0.72rem;
  font-weight: 650;
  color: #b42318;
}

.cm-chrono__score-ai-review {
  position: absolute;
  inset: 0;
  z-index: 35;
  pointer-events: none;
}

.cm-chrono__roi-box--review {
  border-color: #f5c542;
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.35);
}

.cm-chrono__score-ai-dock {
  position: absolute;
  left: 0.55rem;
  right: 0.55rem;
  bottom: 0.55rem;
  pointer-events: auto;
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
  padding: 0.55rem 0.65rem;
  border-radius: 12px;
  border: 1px solid var(--cm-border);
  background: color-mix(in srgb, var(--cm-slate) 94%, transparent);
  color: var(--cm-text);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  box-shadow: 0 10px 28px rgba(15, 23, 42, 0.18);
}

.cm-chrono__score-ai-dock-title {
  margin: 0;
  font-size: 0.78rem;
  font-weight: 800;
  color: var(--cm-text);
}

.cm-chrono__score-ai-dock-score {
  margin: 0;
  font-size: 0.9rem;
  font-weight: 800;
  color: var(--cm-primary);
}

.cm-chrono__score-ai-dock .cm-btn {
  color: inherit;
}

.cm-chrono__score-ai-progress {
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
}

.cm-chrono__score-ai-progress-track,
.cm-chrono__scan-progress-track {
  width: 100%;
  height: 0.45rem;
  border-radius: 999px;
  background: color-mix(in srgb, var(--cm-muted) 22%, transparent);
  overflow: hidden;
}

.cm-chrono__score-ai-progress-fill,
.cm-chrono__scan-progress-fill {
  display: block;
  height: 100%;
  border-radius: inherit;
  background: linear-gradient(
    90deg,
    color-mix(in srgb, var(--cm-primary) 75%, #38bdf8),
    var(--cm-primary)
  );
  transition: width 0.18s linear;
}

.cm-chrono__scan-progress {
  position: absolute;
  left: 0.7rem;
  right: 0.7rem;
  bottom: 0.85rem;
  z-index: 40;
  pointer-events: none;
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  padding: 0.65rem 0.75rem;
  border-radius: 12px;
  border: 1px solid var(--cm-border);
  background: color-mix(in srgb, var(--cm-slate) 92%, transparent);
  color: var(--cm-text);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  box-shadow: 0 12px 30px rgba(15, 23, 42, 0.2);
}

.cm-chrono__scan-progress-title {
  margin: 0;
  font-size: 0.8rem;
  font-weight: 800;
  color: var(--cm-text);
}

.cm-chrono__scan-progress-meta {
  margin: 0;
  font-size: 0.7rem;
  font-weight: 650;
  color: var(--cm-muted);
  font-variant-numeric: tabular-nums;
}

.cm-chrono__score-ai-dock .cm-btn {
  font-size: 0.72rem;
  min-height: 2rem;
}

.cm-chrono__emoji-layer {
  position: absolute;
  inset: 0;
  z-index: 24;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  gap: 0.35rem;
  padding-top: 14%;
  pointer-events: none;
}

.cm-chrono__emoji-pop {
  font-size: clamp(2rem, 9cqi, 3.5rem);
  line-height: 1;
  filter: drop-shadow(0 8px 12px rgba(0, 0, 0, 0.5));
  animation: cm-emoji-pop 0.9s ease;
}

@keyframes cm-emoji-pop {
  from {
    transform: translateY(10px) scale(0.7);
    opacity: 0;
  }
  to {
    transform: none;
    opacity: 1;
  }
}

.cm-chrono__probe {
  position: absolute;
  left: 0.55rem;
  right: 0.55rem;
  top: 0.55rem;
  z-index: 26;
  margin: 0;
  padding: 0.4rem 0.45rem 0.4rem 0.6rem;
  border-radius: 10px;
  background: rgba(8, 12, 20, 0.82);
  color: #fff;
  font-size: 0.78rem;
  font-weight: 750;
  display: flex;
  align-items: center;
  gap: 0.4rem;
}

.cm-chrono__probe-dismiss {
  margin-left: auto;
  flex: 0 0 auto;
  width: 1.6rem;
  height: 1.6rem;
  border: 0;
  border-radius: 999px;
  background: transparent;
  color: #fff;
  cursor: pointer;
}

.cm-chrono__roi {
  position: absolute;
  inset: 0;
  z-index: 40;
  pointer-events: none;
  background: rgba(0, 0, 0, 0.18);
}

.cm-video-roi-svg {
  position: absolute;
  left: 0;
  top: 0;
  z-index: 5;
  overflow: visible;
  pointer-events: none;
}

.cm-video-roi-svg.is-draw {
  z-index: 30;
  pointer-events: auto;
  cursor: crosshair;
  touch-action: none;
}

.cm-video-roi-rect {
  fill: rgba(245, 215, 110, 0.18);
  stroke: #f5d76e;
  stroke-width: 2px;
  vector-effect: non-scaling-stroke;
  pointer-events: none;
}

.cm-video-roi-rect.is-reading {
  stroke: #38bdf8;
  fill: rgba(56, 189, 248, 0.16);
}

.cm-video-roi-rect.is-motion,
.cm-video-roi-rect.is-occlusion {
  stroke: #fb7185;
  fill: rgba(251, 113, 133, 0.14);
}

.cm-video-roi-rect.is-hit,
.cm-video-roi-rect.is-confirm {
  stroke: #4ade80;
  fill: rgba(74, 222, 128, 0.16);
}

.cm-chrono__roi-hint {
  position: absolute;
  left: 0.6rem;
  right: 4.5rem;
  top: 0.55rem;
  margin: 0;
  color: #fff;
  font-size: 0.78rem;
  font-weight: 750;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.6);
}

.cm-chrono__roi-cancel {
  position: absolute;
  top: 0.45rem;
  right: 0.45rem;
  pointer-events: auto;
  border: 0;
  border-radius: 999px;
  padding: 0.3rem 0.65rem;
  background: #fff;
  color: #111;
  font: inherit;
  font-size: 0.72rem;
  font-weight: 800;
  cursor: pointer;
}

.cm-chrono__roi-box {
  position: absolute;
  border: 2px solid #f5d76e;
  background: rgba(245, 215, 110, 0.18);
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.35);
  pointer-events: none;
}

.cm-chrono__tagger-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 0.32rem;
}

.cm-chrono__tagger-chips--extra {
  margin-top: 0.35rem;
  padding-top: 0.35rem;
  border-top: 1px dashed color-mix(in srgb, var(--cm-border) 80%, transparent);
}

.cm-chrono__tagger .cm-tagchip {
  font-size: 0.68rem;
  padding: 0.28rem 0.45rem;
}

.cm-chrono__empty {
  margin: 0.85rem 0.35rem;
  color: var(--cm-muted);
  font-size: 0.86rem;
  text-align: center;
}

.cm-chrono__orphan-list {
  list-style: none;
  margin: 0;
  padding: 0.35rem 0.55rem 0.65rem;
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
}

.cm-chrono__orphan-item {
  display: flex;
  align-items: center;
  gap: 0.45rem;
  font-size: 0.8rem;
}

.cm-chrono__orphan-item img {
  max-width: 7rem;
  border-radius: 8px;
}

.cm-chrono__orphan-item audio {
  width: 100%;
}

.cm-chrono__orphans {
  border-top: 1px solid var(--cm-border);
  margin: 0;
  border-radius: 0;
}

/* Mobile: one video, point strip, sticky label dock */
@media (max-width: 860px) {
  .cm-chrono {
    height: auto;
    min-height: 0;
    max-height: 100%;
  }

  .cm-chrono.has-tagger {
    padding-bottom: 0;
  }

  .cm-chrono__layout {
    grid-template-columns: 1fr;
    grid-template-rows: auto auto;
  }

  .cm-chrono__stage {
    padding: 0;
    background: color-mix(in srgb, var(--cm-slate) 70%, #070b12);
  }

  .cm-chrono__player-shell {
    flex: 1 1;
    flex-shrink: 1;
    width: 100%;
    max-width: 100%;
    min-height: 0;
    height: auto;
    aspect-ratio: auto;
    border-radius: 0;
  }

  .cm-chrono__player-shell.is-expanded,
  .cm-chrono__player-shell.is-expanding {
    aspect-ratio: auto;
    width: 100vw;
    max-width: 100vw;
    height: 100dvh;
    border-radius: 0;
  }

  .cm-chrono.is-score-ai .cm-chrono__player-shell,
  .cm-review .cm-chrono__player-shell {
    width: 100%;
    max-width: 100%;
    margin: 0;
    border-radius: 0;
    flex: 1 1 auto;
    min-height: 0;
    aspect-ratio: auto;
    height: auto;
  }

  .cm-chrono.is-score-ai .cm-chrono__player-shell.is-expanded,
  .cm-chrono.is-score-ai .cm-chrono__player-shell.is-expanding,
  .cm-review .cm-chrono__player-shell.is-expanded,
  .cm-review .cm-chrono__player-shell.is-expanding {
    aspect-ratio: auto;
    width: 100vw;
    max-width: 100vw;
    height: 100dvh;
  }

  .cm-chrono.is-score-ai .cm-chrono__stage,
  .cm-review .cm-chrono__stage {
    padding: 0;
  }

  .cm-chrono.is-score-ai .cm-film {
    padding-inline: 0;
  }

  .cm-chrono.is-score-ai .cm-film__sets,
  .cm-chrono.is-score-ai .cm-film__labels {
    padding-inline: 0.55rem;
  }

  .cm-chrono.is-score-ai .cm-chrono__tagger-slot--dock {
    display: none;
  }

  .cm-chrono__point-strip {
    display: none;
  }

  .cm-film {
    display: flex;
  }

  .cm-chrono__sets,
  .cm-chrono__set-label,
  .cm-chrono__rail {
    display: none;
  }

  .cm-chrono__side {
    border-left: 0;
    border-top: 0;
    max-height: none;
    background: transparent;
  }

  .cm-chrono__side:not(:has(.cm-chrono__mod)) {
    display: none;
  }

  .cm-review {
    padding: 0;
    background: var(--cm-bg);
    color: var(--cm-text);
  }

  .cm-review__head {
    margin: 0;
    padding:
      calc(0.4rem + env(safe-area-inset-top, 0px))
      calc(0.7rem + env(safe-area-inset-right, 0px))
      0.35rem
      calc(0.7rem + env(safe-area-inset-left, 0px));
    background: var(--cm-slate);
    color: var(--cm-text);
  }

  .cm-review__sub {
    display: none;
  }

  .cm-review__body {
    border: 0;
    border-radius: 0;
    background: transparent;
  }

  .cm-review .cm-chrono {
    height: 100%;
    min-height: 0;
    border: 0;
    border-radius: 0;
    display: flex;
    flex-direction: column;
  }

  .cm-review .cm-chrono__layout {
    flex: 1 1 auto;
    min-height: 0;
    display: flex;
    flex-direction: column;
  }

  .cm-review .cm-chrono__stage {
    flex: 1 1 auto;
    min-height: 0;
    padding: 0;
    gap: 0;
  }

  .cm-review .cm-chrono__player-shell {
    flex: 1 1 auto;
    aspect-ratio: auto;
    min-height: 0;
    border-radius: 0;
  }

  .cm-chrono__rail {
    max-height: none;
  }

  .cm-chrono__tagger-slot--side {
    display: none;
  }

  .cm-chrono__tagger-slot--dock {
    display: block;
    position: sticky;
    bottom: 0;
    z-index: 8;
    flex: 0 0 auto;
    padding-bottom: env(safe-area-inset-bottom, 0px);
    background: var(--cm-deck);
    box-shadow: 0 -10px 28px rgba(0, 0, 0, 0.22);
  }
}

/* Wide review dialog: video + point strip on the left, tag deck as a right
   column. The timeline tab itself lives in the 430px page column. */
@media (min-width: 1024px) {
  .cm-review .cm-chrono.has-deck:not(.is-review-fs) {
    display: grid;
    grid-template-columns: minmax(0, 1fr) clamp(19rem, 27vw, 23rem);
    grid-template-rows: auto minmax(0, 1fr) auto auto;
    grid-template-areas:
      "head   head"
      "player deck"
      "film   deck"
      "side   deck";
  }

  .cm-review .cm-chrono.has-deck:not(.is-review-fs) > .cm-chrono__rubber {
    grid-area: head;
  }

  .cm-review .cm-chrono.has-deck:not(.is-review-fs) .cm-chrono__player-shell,
  .cm-review .cm-chrono.has-deck:not(.is-review-fs) .cm-chrono__player,
  .cm-review .cm-chrono.has-deck:not(.is-review-fs) .cm-chrono__empty-stage {
    grid-area: player;
    min-height: 0;
    max-height: none;
  }

  .cm-review .cm-chrono.has-deck:not(.is-review-fs) .cm-film {
    grid-area: film;
  }

  .cm-review .cm-chrono.has-deck:not(.is-review-fs) .cm-chrono__side {
    grid-area: side;
    max-height: 12rem;
  }

  .cm-review .cm-chrono.has-deck:not(.is-review-fs) > .cm-chrono__tagger-slot--dock {
    grid-area: deck;
    max-height: none;
    min-height: 0;
    overflow: auto;
    background: var(--cm-deck);
    border-left: 1px solid var(--cm-hair);
  }

  .cm-review .cm-chrono.has-deck:not(.is-review-fs) .cm-deck {
    border-top: 0;
    padding: 0.85rem 0.9rem 1rem;
    gap: 0.75rem;
  }
}

@media (prefers-reduced-motion: reduce) {
  .cm-chrono__cue,
  .cm-chrono__hud {
    transition: none;
  }
}

.cm-replay {
  list-style: none;
  margin: 0.35rem 0 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 0.7rem;
}

.cm-replay__rubber {
  display: flex;
  flex-direction: column;
  gap: 0.55rem;
}

.cm-replay__rubber-head {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 0.5rem;
  padding: 0 0.15rem;
}

.cm-replay__rubber-head strong {
  font-size: 0.82rem;
  font-weight: 800;
}

.cm-replay__rubber-head span {
  color: var(--cm-muted);
  font-size: 0.72rem;
  font-weight: 650;
  text-align: right;
}

.cm-replay__set {
  border: 1px solid var(--cm-border);
  border-radius: 16px;
  background: var(--cm-glass);
  padding: 0.55rem 0.6rem 0.65rem;
}

.cm-replay__set-head {
  font-size: 0.72rem;
  font-weight: 800;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--cm-muted);
}

.cm-replay__player {
  position: relative;
  margin-top: 0.45rem;
}

.cm-replay__eval-player,
.cm-review__eval-player {
  width: 100%;
  min-height: 220px;
  border-radius: 12px;
  overflow: hidden;
}

.cm-review__media .review-video-player {
  flex: 1 1 auto;
  min-height: 0;
}

.cm-replay__board {
  position: absolute;
  left: 0.55rem;
  top: 0.55rem;
  z-index: 2;
  padding: 0.22rem 0.45rem;
  border-radius: 8px;
  background: color-mix(in srgb, #0a0a0a 72%, transparent);
  color: #f4f1ea;
  font-size: 0.62rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
}

.cm-replay__board strong {
  font-size: 0.82rem;
  letter-spacing: -0.03em;
  text-transform: none;
  font-variant-numeric: tabular-nums;
}

.cm-head__board {
  display: block;
  margin-top: 0.18rem;
  color: var(--cm-muted);
  font-size: 0.58rem;
  font-weight: 700;
  letter-spacing: 0.07em;
  text-transform: uppercase;
}

.cm-head__board strong {
  font-size: 0.78rem;
  letter-spacing: -0.03em;
  text-transform: none;
  font-variant-numeric: tabular-nums;
  color: var(--cm-text);
}

.cm-head__board--live {
  color: var(--cm-rec, #c43c3c);
}

.cm-head__board-hint {
  display: block;
  margin-top: 0.12rem;
  color: var(--cm-muted);
  font-size: 0.58rem;
  font-weight: 650;
  line-height: 1.25;
  text-transform: none;
  letter-spacing: 0.01em;
}

.cm-replay__player video,
.cm-replay__orphan video,
.cm-replay video {
  display: block;
  width: 100%;
  min-height: 140px;
  max-height: 42vh;
  margin: 0;
  border-radius: 12px;
  background: #000;
  object-fit: contain;
}

.cm-replay__empty,
.cm-replay__error {
  margin: 0.45rem 0 0;
  color: var(--cm-muted);
  font-size: 0.74rem;
  font-weight: 650;
}

.cm-replay__error {
  color: #fb7185;
}

.cm-replay__points {
  list-style: none;
  margin: 0.4rem 0 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 0.45rem;
}

.cm-replay__point {
  padding-top: 0.2rem;
  border-top: 1px solid var(--cm-border);
}

.cm-replay__point:first-child {
  border-top: 0;
  padding-top: 0;
}

.cm-replay__cue {
  display: flex;
  align-items: baseline;
  gap: 0.45rem;
  width: 100%;
  padding: 0.28rem 0;
  border: 0;
  background: transparent;
  color: inherit;
  text-align: left;
  cursor: pointer;
}

.cm-replay__cue:disabled {
  cursor: default;
  opacity: 0.8;
}

.cm-replay__clock {
  color: var(--cm-muted);
  font-size: 0.72rem;
  font-variant-numeric: tabular-nums;
  font-weight: 700;
}

.cm-replay__meta {
  margin: 0.1rem 0 0;
  color: var(--cm-muted);
  font-size: 0.78rem;
}

.cm-replay__comment {
  color: var(--cm-text);
  font-weight: 650;
}

.cm-replay__gallery {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.35rem;
  margin-top: 0.35rem;
}

.cm-replay__gallery img,
.cm-replay__orphan img,
.cm-replay img {
  display: block;
  width: 100%;
  min-height: 72px;
  max-height: 180px;
  object-fit: cover;
  border-radius: 10px;
  background: #111827;
}

.cm-replay__voices,
.cm-replay__orphan {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  margin-top: 0.35rem;
}

.cm-replay__voices audio,
.cm-replay__orphan audio {
  width: 100%;
}

.cm-replay li {
  border: 0;
  border-radius: 0;
  background: transparent;
  padding: 0;
}

.cm-replay strong {
  font-variant-numeric: tabular-nums;
}

.cm-replay p {
  margin: 0.1rem 0 0;
  color: var(--cm-muted);
  font-size: 0.78rem;
}

.cm-tabs {
  flex: 0 0 auto;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 0.28rem;
  margin-top: 0.45rem;
  padding: 0.28rem;
  border-radius: 16px;
  border: 1px solid var(--cm-border);
  background: rgba(255, 255, 255, 0.04);
}

.cm-page--light .cm-tabs {
  background: rgba(15, 23, 42, 0.04);
}

.cm-tabs button {
  min-height: 40px;
  border: 0;
  border-radius: 12px;
  background: transparent;
  color: var(--cm-muted);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.08rem;
  font-size: 0.62rem;
  font-weight: 700;
  cursor: pointer;
}

.cm-tabs button.is-on {
  background: var(--cm-primary);
  color: #fff;
  box-shadow: 0 8px 18px color-mix(in srgb, var(--cm-primary) 35%, transparent);
}

.cm-tabs button:active {
  transform: scale(0.98);
}

@media (orientation: landscape) and (max-height: 520px) {
  .cm-page {
    max-width: none;
    margin: 0;
    border: 0;
    padding-left: calc(0.4rem + env(safe-area-inset-left, 0px));
    padding-right: calc(0.4rem + env(safe-area-inset-right, 0px));
  }

  .cm-head {
    min-height: 34px;
  }

  .cm-cam-status {
    max-height: 4.4rem;
  }

  .cm-scoredeck {
    max-height: none;
    padding: 0.3rem 0.35rem 0.35rem;
  }

  .cm-scoredeck__pts {
    font-size: clamp(1.7rem, 12vh, 2.8rem);
  }

  .cm-scoredeck__btns {
    --cm-score-btn: 2.35rem;
  }

  .cm-tabs {
    margin-top: 0.2rem;
  }

  .cm-tabs button {
    min-height: 34px;
    flex-direction: row;
    gap: 0.28rem;
    font-size: 0.68rem;
  }
}

@media (min-width: 720px) {
  .cm-page {
    max-width: 430px;
    margin: 0 auto;
    border-left: 1px solid var(--cm-border);
    border-right: 1px solid var(--cm-border);
  }

  .cm-page--cam-landscape {
    max-width: none;
    margin: 0;
    border: 0;
  }
}

@media (min-width: 720px) and (orientation: landscape) and (max-height: 520px) {
  .cm-page {
    max-width: none;
    margin: 0;
    border: 0;
  }
}

/* Full-bleed camera once this phone is the live camera (portrait or landscape) */
.cm-page--cam-armed,
.cm-page--cam-landscape {
  padding: 0;
  background: #000;
}

.cm-page--cam-armed .cm-head,
.cm-page--cam-armed .cm-tables,
.cm-page--cam-armed .cm-match-status,
.cm-page--cam-armed .cm-banner,
.cm-page--cam-armed .cm-stamps,
.cm-page--cam-armed .cm-tagdock,
.cm-page--cam-landscape .cm-head,
.cm-page--cam-landscape .cm-tables,
.cm-page--cam-landscape .cm-match-status,
.cm-page--cam-landscape .cm-banner,
.cm-page--cam-landscape .cm-stamps,
.cm-page--cam-landscape .cm-tagdock,
.cm-page--cam-armed:not(.cm-page--cam-landscape) .cm-tabs {
  display: none !important;
}

/* Landscape keeps the tab bar on screen so the camera does not cover it. */
.cm-page--cam-landscape .cm-tabs,
.cm-page--cam-armed.cm-page--cam-landscape .cm-tabs {
  display: grid !important;
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 90;
  margin: 0;
  border-radius: 0;
  border-left: 0;
  border-right: 0;
  border-bottom: 0;
  padding: 0.2rem 0.35rem calc(0.2rem + env(safe-area-inset-bottom, 0px));
  background: rgba(11, 15, 25, 0.96);
}

.cm-page--cam-armed .cm-body,
.cm-page--cam-landscape .cm-body {
  margin: 0;
  flex: 1 1;
  min-height: 100%;
}

.cm-cam-tags {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  width: min(100%, 28rem);
  pointer-events: auto;
}

.cm-page--cam-armed .cm-cam-tags,
.cm-page--cam-landscape .cm-cam-tags {
  position: absolute;
  left: 0.4rem;
  right: 0.4rem;
  width: auto;
  bottom: calc(4.35rem + env(safe-area-inset-bottom, 0px));
  z-index: 4;
  max-height: min(28dvh, 10.5rem);
  overflow: auto;
  -webkit-overflow-scrolling: touch;
}

.cm-dock-dim .cm-cam-tags {
  position: static;
  left: auto;
  right: auto;
  bottom: auto;
  width: min(100%, 22rem);
  max-height: none;
  margin: 0.15rem 0;
  z-index: auto;
}

.cm-dock-dim .cm-cam-tags__label {
  color: #94a3b8;
}

.cm-dock-dim__score {
  flex: 0 0 auto;
}

.cm-cam-tags__label {
  margin: 0;
  color: #e2e8f0;
  font-size: 0.68rem;
  font-weight: 750;
  letter-spacing: 0.02em;
  text-align: center;
}

.cm-cam-tags .cm-outcome--on-cam {
  padding: 0.28rem;
  border-radius: 14px;
  background: rgba(2, 6, 23, 0.78);
  backdrop-filter: blur(10px);
}

.cm-cam-tags .cm-outcome__btn {
  min-height: 2.2rem;
  color: #f8fafc;
}

.cm-cam-tags .cm-outcome__text {
  color: #f8fafc;
  font-size: 0.62rem;
}

@media (max-height: 640px) {
  .cm-cam-tags .cm-outcome__text {
    display: none;
  }

  .cm-cam-tags .cm-outcome__btn {
    min-height: 2rem;
  }

  .cm-dock-dim__score strong {
    font-size: clamp(2.4rem, 14vw, 4rem);
  }
}

.cm-cam-tags__emojis {
  display: flex;
  justify-content: center;
  gap: 0.3rem;
}

.cm-cam-tags__emoji {
  width: 2.35rem;
  height: 2.35rem;
  border: 0;
  border-radius: 999px;
  background: rgba(2, 6, 23, 0.78);
  font-size: 1.15rem;
  cursor: pointer;
}

.cm-cam-tags__emoji:active {
  transform: scale(0.94);
}

.cm-dock-dim .cm-cam-tags {
  margin: 0.35rem 0 0.15rem;
}

.cm-dock-dim .cm-cam-tags__label,
.cm-dock-dim .cm-cam-tags .cm-outcome__text,
.cm-dock-dim .cm-cam-tags .cm-outcome__btn {
  color: #f8fafc;
}

@media (orientation: landscape) and (max-height: 640px) {
  .cm-page--cam-armed .cm-cam-tags,
  .cm-page--cam-landscape .cm-cam-tags {
    left: auto;
    right: calc(0.4rem + env(safe-area-inset-right, 0px));
    width: min(22rem, 46vw);
    bottom: calc(3.6rem + env(safe-area-inset-bottom, 0px));
  }

  .cm-cam-tags .cm-outcome__btn {
    min-height: 1.85rem;
    padding: 0.12rem 0.1rem;
  }

  .cm-cam-tags__emoji {
    width: 2rem;
    height: 2rem;
    font-size: 1rem;
  }
}

.cm-page--cam-armed .cm-cam,
.cm-page--cam-landscape .cm-cam {
  position: fixed;
  inset: 0;
  z-index: 80;
  gap: 0;
  background: #000;
}

.cm-page--cam-landscape .cm-cam {
  inset: auto;
  top: env(safe-area-inset-top, 0px);
  right: 0;
  bottom: calc(3.15rem + env(safe-area-inset-bottom, 0px));
  left: 0;
}

.cm-cam__armed-info {
  position: absolute;
  left: calc(0.75rem + env(safe-area-inset-left, 0px));
  right: auto;
  width: max-content;
  max-width: calc(
    100% - 5.75rem - env(safe-area-inset-left, 0px) -
      env(safe-area-inset-right, 0px)
  );
  top: calc(0.65rem + env(safe-area-inset-top, 0px));
  z-index: 4;
  display: inline-flex;
  align-items: flex-start;
  gap: 0.4rem;
  margin: 0;
  padding: 0.45rem 0.7rem;
  border-radius: 999px;
  border: 1px solid rgba(255, 255, 255, 0.28);
  background: rgba(2, 6, 23, 0.55);
  color: #f8fafc;
  font-size: 0.78rem;
  font-weight: 700;
  line-height: 1.25;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  pointer-events: none;
}

.cm-cam__armed-info span {
  min-width: 0;
  overflow-wrap: anywhere;
}

.cm-cam__armed-info svg {
  flex: 0 0 auto;
  margin-top: 0.12rem;
}

.cm-page--cam-armed .cm-cam__preview,
.cm-page--cam-landscape .cm-cam__preview {
  position: absolute;
  inset: 0;
  border-radius: 0;
  border: 0;
  min-height: 100%;
  z-index: 0;
  touch-action: none;
}

.cm-page--cam-armed .cm-cam__preview video,
.cm-page--cam-landscape .cm-cam__preview video {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transform-origin: center center;
  pointer-events: none;
}

.cm-page--cam-armed .cm-cam__badge,
.cm-page--cam-landscape .cm-cam__badge {
  z-index: 3;
}

.cm-page--cam-armed .cm-cam__badge.cm-rec,
.cm-page--cam-landscape .cm-cam__badge.cm-rec {
  top: calc(0.55rem + env(safe-area-inset-top, 0px));
  left: auto;
  right: calc(0.55rem + env(safe-area-inset-right, 0px));
  width: max-content;
}

.cm-page--cam-armed .cm-cam__badge.cm-rec + .cm-cam__badge--zoom,
.cm-page--cam-landscape .cm-cam__badge.cm-rec + .cm-cam__badge--zoom {
  top: calc(2.45rem + env(safe-area-inset-top, 0px));
}

.cm-page--cam-armed .cm-cam__badge--zoom,
.cm-page--cam-landscape .cm-cam__badge--zoom {
  top: calc(0.55rem + env(safe-area-inset-top, 0px));
  left: auto;
  right: calc(0.55rem + env(safe-area-inset-right, 0px));
}

/* Hide edge action chrome while picking a lens so only transparent camera buttons show */
.cm-page--cam-armed.cm-page--cam-settings .cm-actions,
.cm-page--cam-landscape.cm-page--cam-settings .cm-actions {
  opacity: 0;
  pointer-events: none;
}

.cm-page--cam-armed .cm-actions,
.cm-page--cam-armed .cm-actions--edge,
.cm-page--cam-landscape .cm-actions,
.cm-page--cam-landscape .cm-actions--edge {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 2;
  margin: 0;
  padding: 0.45rem
    calc(0.45rem + env(safe-area-inset-right, 0px))
    calc(0.45rem + env(safe-area-inset-bottom, 0px))
    calc(0.45rem + env(safe-area-inset-left, 0px));
  display: flex;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: center;
  gap: 0.4rem;
  background: transparent;
  backdrop-filter: none;
  -webkit-backdrop-filter: none;
  pointer-events: none;
}

.cm-page--cam-armed .cm-actions > *,
.cm-page--cam-landscape .cm-actions > * {
  pointer-events: auto;
}

.cm-page--cam-armed .cm-actions .cm-btn,
.cm-page--cam-armed .cm-actions .cm-btn--icon,
.cm-page--cam-landscape .cm-actions .cm-btn,
.cm-page--cam-landscape .cm-actions .cm-btn--icon {
  flex: 0 0 auto;
  width: 46px;
  height: 46px;
  min-width: 46px;
  min-height: 46px;
  padding: 0;
  border-radius: 999px;
  border: 1px solid rgba(255, 255, 255, 0.38);
  background: rgba(0, 0, 0, 0.28);
  color: #fff;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.28);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0;
}

.cm-page--cam-armed .cm-actions .cm-btn--ghost,
.cm-page--cam-landscape .cm-actions .cm-btn--ghost {
  background: rgba(0, 0, 0, 0.28);
  border-color: rgba(255, 255, 255, 0.38);
  color: #fff;
}

.cm-page--cam-armed .cm-actions .cm-btn--dock,
.cm-page--cam-landscape .cm-actions .cm-btn--dock {
  background: rgba(8, 119, 188, 0.42);
  border-color: rgba(125, 211, 252, 0.55);
}

.cm-page--cam-armed .cm-actions .cm-btn--danger,
.cm-page--cam-landscape .cm-actions .cm-btn--danger,
.cm-page--cam-armed .cm-actions .cm-btn--rec,
.cm-page--cam-landscape .cm-actions .cm-btn--rec {
  background: rgba(225, 29, 72, 0.88);
  border: 1px solid rgba(251, 113, 133, 0.85);
  color: #fff;
}

.cm-page--cam-armed .cm-actions .cm-btn--exit-preview,
.cm-page--cam-landscape .cm-actions .cm-btn--exit-preview {
  background: rgba(127, 29, 29, 0.82);
  border-color: #f87171;
  color: #fecaca;
  box-shadow: 0 0 0 2px rgba(248, 113, 113, 0.35), 0 4px 14px rgba(0, 0, 0, 0.35);
}

.cm-cam-hidden {
  position: fixed;
  right: 8px;
  bottom: 8px;
  width: 48px;
  height: 27px;
  opacity: 0.04;
  pointer-events: none;
  z-index: 1;
  object-fit: cover;
}

.cm-page--cam-armed .cm-actions .cm-btn:active,
.cm-page--cam-landscape .cm-actions .cm-btn:active {
  transform: scale(0.94);
}

.cm-page--cam-landscape .cm-status-chip {
  display: none;
}

.cm-rubber-card__review {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-top: 0.15rem;
}

.cm-rubber-card__review-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.35rem;
  min-height: 34px;
  border: 1px solid color-mix(in srgb, var(--cm-primary) 45%, var(--cm-border));
  border-radius: 999px;
  background: color-mix(in srgb, var(--cm-primary) 18%, transparent);
  color: var(--cm-text);
  font: inherit;
  font-size: 0.72rem;
  font-weight: 750;
  padding: 0.28rem 0.75rem;
  cursor: pointer;
}

.cm-rubber-card__review-btn.is-icon {
  width: 2.1rem;
  height: 2.1rem;
  min-height: 0;
  padding: 0;
}

.cm-rubber-card__review-btn:active {
  transform: scale(0.97);
}

.cm-rubber-card__review-wait {
  font-size: 0.68rem;
  font-weight: 650;
  color: var(--cm-muted);
}

.cm-review {
  position: fixed;
  inset: 0;
  z-index: 110;
  display: flex;
  flex-direction: column;
  background: var(--cm-bg);
  color: var(--cm-text);
  padding:
    calc(0.65rem + env(safe-area-inset-top, 0px))
    calc(0.7rem + env(safe-area-inset-right, 0px))
    calc(0.65rem + env(safe-area-inset-bottom, 0px))
    calc(0.7rem + env(safe-area-inset-left, 0px));
}

.cm-review__head {
  flex: 0 0 auto;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.75rem;
  margin-bottom: 0.55rem;
}

.cm-review__kicker {
  margin: 0 0 0.15rem;
  font-size: 0.68rem;
  font-weight: 750;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--cm-muted);
}

.cm-review__head strong {
  font-size: 0.95rem;
  font-weight: 800;
  letter-spacing: -0.02em;
}

.cm-review__body {
  flex: 1 1 auto;
  min-height: 0;
  overflow: hidden;
  border-radius: 16px;
  border: 1px solid var(--cm-border);
  background: var(--cm-glass);
  padding: 0;
  display: flex;
  flex-direction: column;
}

.cm-review__body .cm-chrono {
  margin: 0;
  height: 100%;
  min-height: 0;
  flex: 1 1 auto;
  border: 0;
  border-radius: 16px;
}

.cm-review__sub {
  margin: 0.28rem 0 0;
  font-size: 0.74rem;
  font-weight: 550;
  color: var(--cm-muted);
  line-height: 1.35;
  max-width: 36rem;
}

.cm-review__close {
  width: 2.35rem;
  height: 2.35rem;
  border-radius: 999px;
  border: 1px solid var(--cm-border);
  background: color-mix(in srgb, var(--cm-muted) 12%, var(--cm-slate));
  color: var(--cm-text);
  display: grid;
  place-items: center;
  cursor: pointer;
  flex: 0 0 auto;
}

.cm-review__stage {
  flex: 1 1 auto;
  min-height: 0;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: center;
  border-radius: 18px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  background:
    radial-gradient(80% 60% at 50% 0%, rgba(8, 119, 188, 0.22), transparent 60%),
    rgba(15, 23, 42, 0.72);
  overflow: hidden;
  padding: 0.85rem;
}

.cm-review__kind {
  display: inline-flex;
  align-self: flex-start;
  margin-bottom: 0.55rem;
  padding: 0.18rem 0.5rem;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.08);
  color: #cbd5e1;
  font-size: 0.62rem;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.cm-review__point {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  gap: 0.35rem;
  min-height: 12rem;
}

.cm-review__score {
  margin: 0;
  font-size: clamp(3rem, 16vw, 4.5rem);
  font-weight: 800;
  letter-spacing: -0.06em;
  line-height: 0.95;
  font-variant-numeric: tabular-nums;
}

.cm-review__score--sm {
  font-size: 1.6rem;
  margin-top: 0.5rem;
}

.cm-review__clock {
  margin: 0;
  color: #94a3b8;
  font-size: 0.85rem;
  font-weight: 700;
}

.cm-review__tags {
  margin: 0.25rem 0 0;
  color: #e2e8f0;
  font-size: 0.88rem;
  font-weight: 700;
}

.cm-review__comment {
  margin: 0.35rem 0 0;
  max-width: 22rem;
  color: #f8fafc;
  font-size: 1rem;
  font-weight: 650;
  line-height: 1.35;
}

.cm-review__media {
  flex: 1 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  gap: 0.45rem;
}

.cm-review__media video,
.cm-review__media img {
  width: 100%;
  flex: 1 1;
  min-height: 0;
  max-height: 100%;
  object-fit: contain;
  border-radius: 12px;
  background: #000;
}

.cm-review__media--voice {
  align-items: center;
  justify-content: center;
}

.cm-review__media audio {
  width: min(100%, 22rem);
}

.cm-review__empty {
  display: grid;
  place-items: center;
  gap: 0.65rem;
  text-align: center;
  color: #94a3b8;
}

.cm-review__bar {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  margin-top: 0.65rem;
}

.cm-review__progress {
  font-size: 0.78rem;
  font-weight: 750;
  color: #94a3b8;
  min-width: 4.5rem;
}

.cm-review__acts {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
}

.cm-review__btn {
  width: 2.55rem;
  height: 2.55rem;
  border-radius: 999px;
  border: 1px solid rgba(255, 255, 255, 0.14);
  background: rgba(255, 255, 255, 0.06);
  color: #fff;
  display: grid;
  place-items: center;
  cursor: pointer;
}

.cm-review__btn:disabled {
  opacity: 0.35;
  cursor: not-allowed;
}

.cm-review__btn--main {
  width: 3.1rem;
  height: 3.1rem;
  background: color-mix(in srgb, var(--cm-primary, #0877bc) 78%, #0b0f19);
  border-color: transparent;
}

/* iOS Camera-style calibrate overlay (full-bleed preview + lens chips).
   Pinned to the visual viewport so browser chrome cannot push the buttons off-screen. */
.cm-cam-settings--ios {
  --cm-cam-settings-top: 78px;
  position: fixed;
  top: var(--lt-vvt, 0px);
  left: var(--lt-vvl, 0px);
  right: auto;
  bottom: auto;
  width: var(--lt-vvw, 100%);
  height: var(--lt-vvh, 100svh);
  max-height: var(--lt-vvh, 100svh);
  z-index: 120;
  display: block;
  box-sizing: border-box;
  padding: 0;
  overflow: hidden;
  background: #0b1220;
  color: #f8fafc;
  pointer-events: auto;
}

.cm-cam-settings__stage-full {
  position: absolute;
  inset: 0;
  background: #020617;
  overflow: hidden;
  touch-action: none;
  user-select: none;
  -webkit-user-select: none;
}

.cm-cam-settings__preview-full {
  width: 100%;
  height: 100%;
  object-fit: cover;
  background: #020617;
  transform-origin: center center;
  pointer-events: none;
}

.cm-cam-settings__ios-top {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: calc(10px + env(safe-area-inset-top, 0px)) 16px 12px;
  background: linear-gradient(
    180deg,
    rgba(2, 6, 23, 0.82) 0%,
    rgba(2, 6, 23, 0.05) 100%
  );
  color: #f8fafc;
}

.cm-cam-settings__title-row {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
  color: #e2e8f0;
}

.cm-cam-settings__ios-top strong {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 15px;
  font-weight: 700;
  letter-spacing: 0.01em;
}

.cm-cam-settings__icon-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border: 1px solid rgba(255, 255, 255, 0.16);
  border-radius: 14px;
  background: rgba(15, 23, 42, 0.62);
  color: #f8fafc;
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
  cursor: pointer;
  transition: transform 0.3s cubic-bezier(0.16, 1, 0.3, 1),
    background 0.3s cubic-bezier(0.16, 1, 0.3, 1);
}

.cm-cam-settings__icon-btn:hover {
  transform: scale(1.04);
  background: rgba(15, 23, 42, 0.82);
}

.cm-cam-settings__icon-btn:active {
  transform: scale(0.96);
}

.cm-cam-settings__icon-btn:focus-visible {
  outline: 2px solid #38bdf8;
  outline-offset: 2px;
}

.cm-cam-settings--ios .cm-cam-settings__zoom-pill {
  position: absolute;
  top: calc(64px + env(safe-area-inset-top, 0px));
  right: 16px;
  left: auto;
  z-index: 3;
  padding: 6px 12px;
  border-radius: 999px;
  background: rgba(15, 23, 42, 0.72);
  border: 1px solid rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
  font-size: 12px;
  font-weight: 800;
  letter-spacing: 0.06em;
  color: #e2e8f0;
}

.cm-cam-settings__ios-hint {
  position: static;
  margin: 0;
  font-size: 13px;
  line-height: 1.4;
  color: rgba(248, 250, 252, 0.86);
  text-shadow: 0 1px 8px rgba(0, 0, 0, 0.55);
  pointer-events: none;
}

.cm-cam-settings__ios-bar {
  position: absolute;
  left: calc(14px + env(safe-area-inset-left, 0px));
  right: calc(14px + env(safe-area-inset-right, 0px));
  bottom: calc(8px + env(safe-area-inset-bottom, 0px));
  z-index: 2;
  display: flex;
  flex-direction: column;
  gap: 8px;
  box-sizing: border-box;
  width: min(420px, calc(100% - 28px - env(safe-area-inset-left, 0px) - env(safe-area-inset-right, 0px)));
  max-width: calc(100% - 28px - env(safe-area-inset-left, 0px) - env(safe-area-inset-right, 0px));
  max-height: calc(
    100% - var(--cm-cam-settings-top) - 8px - env(safe-area-inset-top, 0px) -
      env(safe-area-inset-bottom, 0px)
  );
  margin: 0 auto;
  overflow-x: hidden;
  overflow-y: auto;
  overscroll-behavior: contain;
  -webkit-overflow-scrolling: touch;
}

.cm-cam-settings__lenses {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  margin: 0 auto;
  padding: 8px 14px;
  width: fit-content;
  max-width: 100%;
  box-sizing: border-box;
  border-radius: 999px;
  background: rgba(15, 23, 42, 0.62);
  border: 1px solid rgba(255, 255, 255, 0.16);
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
  box-shadow: 0 10px 28px rgba(0, 0, 0, 0.28);
}

.cm-cam-settings__lens {
  min-width: 0;
  height: 44px;
  flex: 1 1 auto;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 0 12px 0 6px;
  border: 1px solid rgba(255, 255, 255, 0.22);
  border-radius: 999px;
  background: rgba(15, 23, 42, 0.55);
  color: rgba(248, 250, 252, 0.88);
  font-size: 12px;
  font-weight: 800;
  letter-spacing: 0.02em;
  cursor: pointer;
  transition: transform 0.3s cubic-bezier(0.16, 1, 0.3, 1),
    background 0.3s cubic-bezier(0.16, 1, 0.3, 1),
    color 0.3s cubic-bezier(0.16, 1, 0.3, 1),
    box-shadow 0.3s cubic-bezier(0.16, 1, 0.3, 1);
}

.cm-cam-settings__lens-mark {
  width: 30px;
  height: 30px;
  flex: 0 0 auto;
  display: grid;
  place-items: center;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.1);
  font-size: 11px;
  line-height: 1;
}

.cm-cam-settings__lens-name {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 11px;
  font-weight: 750;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  line-height: 1;
}

.cm-cam-settings__lens.is-on {
  color: #facc15;
  border-color: #facc15;
  background: rgba(15, 23, 42, 0.88);
  box-shadow: 0 0 0 2px rgba(250, 204, 21, 0.4);
}

.cm-cam-settings__lens.is-on .cm-cam-settings__lens-mark {
  background: rgba(250, 204, 21, 0.16);
}

.cm-cam-settings__lens:hover:not(:disabled) {
  transform: scale(1.06);
}

.cm-cam-settings__lens:active:not(:disabled) {
  transform: scale(0.94);
}

.cm-cam-settings__lens:focus-visible {
  outline: 2px solid #38bdf8;
  outline-offset: 2px;
}

.cm-cam-settings__lens:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.cm-cam-settings__field {
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
}

.cm-cam-settings__seg-label {
  padding: 0 6px;
  color: rgba(248, 250, 252, 0.78);
  font-size: 0.62rem;
  font-weight: 750;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.cm-cam-settings__note {
  margin: 0;
  padding: 0 6px;
  color: rgba(248, 250, 252, 0.72);
  font-size: 0.75rem;
  line-height: 1.35;
}

.cm-cam-settings__queue {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.cm-cam-settings__encode {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
}

a.cm-cam-settings__seg-btn {
  text-decoration: none;
  box-sizing: border-box;
}

.cm-cam-settings__seg-btn svg {
  flex: 0 0 auto;
}

.cm-cam-settings__seg {
  display: flex;
  gap: 4px;
  padding: 4px;
  border-radius: 14px;
  background: rgba(15, 23, 42, 0.62);
  border: 1px solid rgba(255, 255, 255, 0.16);
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
  box-shadow: 0 10px 28px rgba(0, 0, 0, 0.28);
}

.cm-cam-settings__seg--encode {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(3.4rem, 1fr));
}

.cm-cam-settings__seg-btn {
  flex: 1 1;
  min-height: 38px;
  min-width: 44px;
  padding: 6px 10px;
  border: 0;
  border-radius: 10px;
  background: transparent;
  color: #f8fafc;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.04em;
  cursor: pointer;
  transition: transform 0.3s cubic-bezier(0.16, 1, 0.3, 1),
    background 0.3s cubic-bezier(0.16, 1, 0.3, 1);
}

.cm-cam-settings__seg-btn--icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  min-width: 0;
}

.cm-cam-settings__seg--positions .cm-cam-settings__seg-btn--icon {
  flex-direction: column;
  gap: 2px;
  padding: 6px 4px;
  overflow: hidden;
  font-size: 10px;
  letter-spacing: 0.02em;
  line-height: 1.15;
}

.cm-cam-settings__seg--positions .cm-cam-settings__seg-btn--icon span {
  min-width: 0;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.cm-cam-settings__seg--encode .cm-cam-settings__seg-btn {
  width: 100%;
  min-width: 0;
}

.cm-cam-settings__seg-btn:hover:not(:disabled) {
  transform: scale(1.02);
  background: rgba(255, 255, 255, 0.08);
}

.cm-cam-settings__seg-btn:active:not(:disabled) {
  transform: scale(0.97);
}

.cm-cam-settings__seg-btn:focus-visible {
  outline: 2px solid #38bdf8;
  outline-offset: 2px;
}

.cm-cam-settings__seg-btn.is-on {
  background: color-mix(in srgb, var(--cm-primary, #0877bc) 78%, #0f172a);
  box-shadow: 0 0 0 1px rgba(56, 189, 248, 0.28);
}

.cm-cam-settings__seg-btn:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

/* Landscape is short: use the width so every control stays on screen. */
@media (orientation: landscape) {
  .cm-cam-settings--ios {
    --cm-cam-settings-top: 56px;
  }

  .cm-cam-settings__ios-top {
    padding: calc(4px + env(safe-area-inset-top, 0px))
      calc(12px + env(safe-area-inset-right, 0px)) 4px
      calc(12px + env(safe-area-inset-left, 0px));
  }

  .cm-cam-settings__icon-btn {
    width: 40px;
    height: 40px;
  }

  .cm-cam-settings--ios .cm-cam-settings__zoom-pill {
    top: calc(48px + env(safe-area-inset-top, 0px));
  }

  .cm-cam-settings__ios-bar {
    left: calc(10px + env(safe-area-inset-left, 0px));
    right: calc(10px + env(safe-area-inset-right, 0px));
    width: auto;
    max-width: none;
    margin: 0;
    gap: 6px;
    display: grid;
    grid-template-columns: minmax(0, 1.15fr) minmax(0, 1fr);
    grid-template-areas:
      "hint hint"
      "positions lenses"
      "encode encode"
      "wait upload";
    align-items: stretch;
    align-content: end;
  }

  .cm-cam-settings__ios-hint {
    grid-area: hint;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    overflow: hidden;
    font-size: 12px;
    line-height: 1.3;
  }

  .cm-cam-settings__seg--positions {
    grid-area: positions;
    min-width: 0;
  }

  .cm-cam-settings__lenses {
    grid-area: lenses;
    width: 100%;
    max-width: 100%;
    margin: 0;
    box-sizing: border-box;
    justify-content: stretch;
    padding: 4px;
    overflow-x: auto;
  }

  .cm-cam-settings__lens {
    min-width: 0;
    flex: 1 1;
    height: 40px;
    padding: 0 8px 0 4px;
  }

  .cm-cam-settings__lens-name {
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .cm-cam-settings__encode {
    grid-area: encode;
  }

  .cm-cam-settings__note--encode {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .cm-cam-settings__field--wait {
    grid-area: wait;
    min-width: 0;
  }

  .cm-cam-settings__field--upload {
    grid-area: upload;
    min-width: 0;
    display: grid;
    grid-template-columns: minmax(0, auto) minmax(0, 1fr);
    grid-template-areas:
      "label label"
      "control note";
    align-items: center;
    column-gap: 8px;
    row-gap: 4px;
  }

  .cm-cam-settings__field--upload .cm-cam-settings__seg-label {
    grid-area: label;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .cm-cam-settings__field--upload > .cm-cam-settings__seg {
    grid-area: control;
    width: max-content;
    max-width: 100%;
  }

  .cm-cam-settings__field--upload > .cm-cam-settings__note {
    grid-area: note;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
  }

  .cm-cam-settings__field--upload .cm-cam-settings__queue {
    grid-column: 1 / -1;
  }

  .cm-cam-settings__seg-label {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .cm-cam-settings__seg--positions .cm-cam-settings__seg-btn--icon {
    flex-direction: row;
    gap: 4px;
    min-height: 40px;
    padding: 4px 6px;
    font-size: 11px;
  }

  .cm-cam-settings__seg-btn {
    min-width: 0;
    min-height: 40px;
    padding: 4px 6px;
  }
}

@media (orientation: landscape) and (min-width: 980px) {
  .cm-cam-settings__ios-bar {
    left: 50%;
    right: auto;
    width: min(
      920px,
      calc(
        100% - 24px - env(safe-area-inset-left, 0px) -
          env(safe-area-inset-right, 0px)
      )
    );
    transform: translateX(-50%);
  }
}

@media (orientation: landscape) and (max-height: 340px) {
  .cm-cam-settings--ios {
    --cm-cam-settings-top: 50px;
  }

  .cm-cam-settings__ios-hint {
    display: none;
  }

  .cm-cam-settings__ios-bar {
    gap: 4px;
  }

  .cm-cam-settings__field--upload > .cm-cam-settings__note {
    -webkit-line-clamp: 1;
  }

  .cm-cam-settings__seg-btn,
  .cm-cam-settings__lens {
    min-height: 36px;
    height: auto;
  }

  .cm-cam-settings__lens {
    height: 36px;
  }
}

@media (orientation: portrait) and (max-height: 700px) {
  .cm-cam-settings--ios {
    --cm-cam-settings-top: 70px;
  }

  .cm-cam-settings__ios-bar {
    gap: 6px;
  }

  .cm-cam-settings__ios-hint {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
  }
}

@media (prefers-reduced-motion: reduce) {
  .cm-cam-settings__icon-btn,
  .cm-cam-settings__lens,
  .cm-cam-settings__seg-btn {
    transition: none;
  }
}

/* Match Control Room — staff multi-table camera desk (own tab) */
.cm-panel--control {
  padding: 0 0 12px;
}
.cm-panel--control .cm-control-room {
  margin: 0;
}
.cm-control-room {
  margin: 12px 0 20px;
  padding: 14px 14px 10px;
  border: 1px solid rgba(148, 163, 184, 0.28);
  border-radius: 12px;
  background: linear-gradient(
    165deg,
    rgba(15, 23, 42, 0.55),
    rgba(15, 23, 42, 0.28)
  );
}
.cm-control-room__head {
  display: flex;
  flex-wrap: wrap;
  gap: 10px 14px;
  align-items: flex-start;
  margin-bottom: 12px;
}
.cm-control-room__title {
  margin: 0;
  font-size: 1.05rem;
  font-weight: 650;
}
.cm-control-room__hint {
  margin: 0;
  flex: 1 1 220px;
  font-size: 0.85rem;
  opacity: 0.78;
}
.cm-control-room__scorewatch {
  display: block;
  margin: 4px 0 0;
  padding: 4px 8px;
  border-radius: 8px;
  background: rgba(56, 189, 248, 0.12);
  font-size: 0.82rem;
}
.cm-control-room__tables {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.cm-control-room__row {
  padding: 10px 12px;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(148, 163, 184, 0.18);
}
.cm-control-room__row-main {
  display: flex;
  flex-wrap: wrap;
  gap: 8px 12px;
  align-items: center;
  margin-bottom: 8px;
}
.cm-control-room__badge {
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  padding: 2px 8px;
  border-radius: 999px;
  background: rgba(148, 163, 184, 0.2);
}
.cm-control-room__badge.is-rec {
  background: rgba(239, 68, 68, 0.28);
  color: #fecaca;
}
.cm-control-room__badge.is-starting {
  background: rgba(251, 191, 36, 0.28);
  color: #fde68a;
}
.cm-control-room__matchup {
  font-size: 0.85rem;
  opacity: 0.8;
}
.cm-control-room__cams {
  list-style: none;
  margin: 0 0 8px;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.cm-control-room__cam {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.85rem;
}
.cm-control-room__cam.is-offline {
  opacity: 0.55;
}
.cm-control-room__cam.is-empty {
  opacity: 0.65;
  font-style: italic;
}
.cm-control-room__actions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.cm-match-status__scorewatch {
  font-size: 0.85rem;
  opacity: 0.9;
}

/* Match review dialog: the tape is a full-bleed frame. Height follows the
   recording's aspect ratio so a landscape trip cannot collapse it to 0. */
.cm-review {
  padding: 0;
}

.cm-review__head {
  margin: 0;
  padding:
    calc(0.45rem + env(safe-area-inset-top, 0px))
    calc(0.7rem + env(safe-area-inset-right, 0px))
    0.4rem
    calc(0.7rem + env(safe-area-inset-left, 0px));
}

.cm-review__body {
  overflow: auto;
  border: 0;
  border-radius: 0;
  background: transparent;
}

.cm-review .cm-chrono.is-review-layout,
.cm-review .cm-chrono.has-deck:not(.is-review-fs) {
  display: flex;
  flex-direction: column;
  height: auto;
  max-height: none;
  overflow: visible;
  border: 0;
  border-radius: 0;
  background: transparent;
  grid-template-columns: none;
  grid-template-rows: none;
  grid-template-areas: none;
}

.cm-review .cm-chrono__layout,
.cm-review .cm-chrono__stage {
  display: contents;
}

.cm-review .cm-chrono__player-shell {
  order: 1;
  position: relative;
  inset: auto;
  flex: 0 0 auto;
  width: 100%;
  max-width: 100%;
  height: auto;
  min-height: 0;
  max-height: none;
  margin: 0;
  aspect-ratio: var(--cm-frame, 1.7777778);
  border-radius: 0;
  align-self: stretch;
  /* Size containment collapses an aspect-ratio box back to 0 height. */
  container-type: inline-size;
}

.cm-review .cm-chrono.is-stage-landscape .cm-stagectl {
  opacity: 1;
}

/* Review fullscreen: video covers the dialog; hide chrome around it. */
.cm-review:has(.cm-chrono.is-stage-fs) .cm-review__head,
.cm-review:has(.cm-chrono.is-stage-fs) .cm-review__board-dock,
.cm-review:has(.cm-chrono.is-stage-fs) .cm-reviewbar,
.cm-review:has(.cm-chrono.is-stage-fs) .cm-review__sheet,
.cm-review:has(.cm-chrono.is-stage-fs) .cm-chrono__rubber,
.cm-review:has(.cm-chrono.is-stage-fs) .cm-chrono__reassign,
.cm-review:has(.cm-chrono.is-stage-fs) .cm-chrono__side,
.cm-review:has(.cm-chrono.is-stage-fs) .cm-chrono__tagger-slot {
  display: none !important;
}

.cm-review:has(.cm-chrono.is-stage-fs) {
  padding: 0;
  overflow: hidden;
}

.cm-review:has(.cm-chrono.is-stage-fs) .cm-review__body,
.cm-review:has(.cm-chrono.is-stage-fs) .cm-chrono.is-stage-fs {
  flex: 1 1 auto;
  min-height: 0;
  height: 100%;
  max-height: none;
  overflow: hidden;
  border: 0;
  border-radius: 0;
  background: #05070c;
}

.cm-review .cm-chrono.is-stage-landscape .cm-chrono__player-shell,
.cm-review .cm-chrono.is-stage-fs .cm-chrono__player-shell {
  position: fixed;
  inset: 0;
  z-index: 140;
  flex: none;
  width: 100%;
  max-width: none;
  height: 100%;
  max-height: none;
  aspect-ratio: auto;
  margin: 0;
  align-self: stretch;
  transform: none;
  border-radius: 0;
  background: #05070c;
}

.cm-review .cm-chrono.is-stage-fs,
.cm-review .cm-chrono.is-stage-fs.is-portrait-stage {
  position: relative;
  inset: auto;
  width: 100%;
  height: 100%;
  max-height: none;
  transform: none;
}

.cm-review .cm-chrono__player-shell .review-video-player__chrome {
  background: transparent;
  backdrop-filter: none;
  -webkit-backdrop-filter: none;
}

.cm-review .cm-chrono__player-shell .review-video-player__btn,
.cm-review .cm-chrono__player-shell .review-video-player__btn--play,
.cm-review .cm-chrono__player-shell .review-video-player__btn--active {
  background: transparent;
  box-shadow: none;
}

.cm-review .cm-chrono__player-shell .review-video-player__btn svg,
.cm-review .cm-chrono__player-shell .review-video-player__chrome-toggle svg {
  filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.9));
}

.cm-review .cm-chrono.is-stage-landscape .cm-chrono__player-shell .review-video-player__chrome {
  z-index: 24;
}

.cm-review .cm-chrono.is-stage-landscape .cm-chrono__player-shell .review-video-player__chrome--bottom {
  padding-left: max(
    0.75rem,
    calc(min(42cqw, 20rem) + 0.7rem + env(safe-area-inset-left, 0px))
  );
}

.cm-review .cm-league {
  align-items: stretch;
}

.cm-review .cm-league__club {
  display: none;
}

/* Logo column follows the plate height; the round badge stays centered. */
.cm-review .cm-league__brand {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  align-self: stretch;
  width: 3.15rem;
  min-width: 3.15rem;
  height: auto;
  padding: 0.28rem 0.18rem;
  gap: 0.12rem;
  overflow: hidden;
  background: var(--cm-league-brand-bg);
}

.cm-review .cm-league__logo,
.cm-review .cm-league__mark {
  position: relative;
  inset: auto;
  width: 2.35rem;
  height: 2.35rem;
  max-width: none;
  max-height: none;
  margin: 0;
  aspect-ratio: 1;
  object-fit: contain;
  box-sizing: border-box;
}

.cm-review .cm-league__mark {
  display: grid;
  place-items: center;
}

.cm-review .cm-chrono.is-stage-landscape .cm-league {
  z-index: 22;
  left: max(0.45rem, env(safe-area-inset-left, 0px));
  bottom: max(0.45rem, env(safe-area-inset-bottom, 0px));
  width: min(42cqw, 20rem);
  max-width: calc(100% - 0.9rem);
}

.cm-review__board-dock {
  order: 2;
  flex: 0 0 auto;
  width: 100%;
  box-sizing: border-box;
  padding: 0.4rem 0.45rem 0.5rem;
  background: color-mix(in srgb, var(--cm-rail, #070b12) 92%, #000);
}

.cm-page--light .cm-review__board-dock {
  background: color-mix(in srgb, var(--cm-rail, #eef1f6) 88%, #fff);
}

.cm-review__board-dock .cm-league {
  position: relative;
  left: auto;
  right: auto;
  top: auto;
  bottom: auto;
  max-width: none;
  width: 100%;
}

.cm-reviewbar {
  order: 3;
  position: sticky;
  top: 0;
  z-index: 8;
  display: flex;
  align-items: center;
  gap: 0.4rem;
  flex: 0 0 auto;
  padding: 0.45rem 0.55rem;
  padding-left: calc(0.55rem + env(safe-area-inset-left, 0px));
  padding-right: calc(0.55rem + env(safe-area-inset-right, 0px));
  background: color-mix(in srgb, var(--cm-rail) 92%, #000);
  border-top: 1px solid var(--cm-hair);
  border-bottom: 1px solid var(--cm-hair);
}

.cm-reviewbar__btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.35rem;
  min-height: 2.75rem;
  padding: 0 0.8rem;
  border-radius: 999px;
  border: 1px solid var(--cm-hair);
  background: var(--cm-chip);
  color: var(--cm-text);
  font: inherit;
  font-size: 0.75rem;
  font-weight: 750;
  letter-spacing: 0.01em;
  cursor: pointer;
}

.cm-reviewbar__btn.is-on {
  background: color-mix(in srgb, var(--cm-primary, #0877bc) 78%, #0b1018);
  border-color: transparent;
  color: #fff;
}

.cm-reviewbar__btn:focus-visible {
  outline: 2px solid var(--cm-primary, #0877bc);
  outline-offset: 2px;
}

.cm-reviewbar__btn--menu {
  width: 2.75rem;
  margin-left: 0;
  padding: 0;
}

.cm-reviewbar__btn--fs {
  margin-left: auto;
}

.cm-reviewbar__count {
  min-width: 1.15rem;
  padding: 0 0.28rem;
  border-radius: 999px;
  background: color-mix(in srgb, currentColor 16%, transparent);
  font-variant-numeric: tabular-nums;
  font-size: 0.68rem;
  line-height: 1.35;
}

.cm-review__sheet {
  order: 4;
  flex: 0 0 auto;
  display: flex;
  flex-direction: column;
  min-height: 0;
  max-height: min(46dvh, 24rem);
  overflow: auto;
  background: var(--cm-rail);
  border-bottom: 1px solid var(--cm-hair);
}

.cm-review__sheet-sets {
  display: flex;
  gap: 0.3rem;
  overflow-x: auto;
  padding: 0.45rem 0.55rem 0;
  position: sticky;
  top: 0;
  background: var(--cm-rail);
}

.cm-review__sheet-sets button {
  flex: 0 0 auto;
  min-height: 2rem;
  border: 0;
  border-radius: 999px;
  padding: 0.25rem 0.7rem;
  background: transparent;
  color: var(--cm-muted);
  font: inherit;
  font-size: 0.68rem;
  font-weight: 800;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  cursor: pointer;
}

.cm-review__sheet-sets button.is-on {
  background: var(--cm-chip-on);
  color: var(--cm-text);
}

.cm-review__points {
  list-style: none;
  margin: 0;
  padding: 0.35rem 0 0.45rem;
}

.cm-review__pt {
  width: 100%;
  display: grid;
  grid-template-columns: 1.7rem 4.4rem minmax(0, 1fr);
  align-items: center;
  column-gap: 0.65rem;
  min-height: 2.75rem;
  padding: 0.2rem 0.7rem;
  border: 0;
  border-left: 3px solid transparent;
  background: transparent;
  color: var(--cm-text);
  font: inherit;
  text-align: left;
  cursor: pointer;
}

.cm-review__pt:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.cm-review__pt.is-selected {
  background: color-mix(in srgb, var(--cm-primary, #0877bc) 12%, transparent);
}

.cm-review__pt.is-active {
  border-left-color: var(--cm-primary, #0877bc);
  background: color-mix(in srgb, var(--cm-primary, #0877bc) 18%, transparent);
}

.cm-review__pt-n {
  width: 1.7rem;
  height: 1.7rem;
  display: grid;
  place-items: center;
  border: 1px solid var(--cm-hair);
  background: var(--cm-chip);
  font-size: 0.72rem;
  font-weight: 800;
  font-variant-numeric: tabular-nums;
}

.cm-review__pt-score {
  display: inline-flex;
  flex-direction: column;
  align-items: flex-start;
  font-family: "Barlow Condensed", "Arial Narrow", Impact, sans-serif;
  font-size: 1.35rem;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
  letter-spacing: 0.02em;
  line-height: 1;
}

.cm-review__pt-sets,
.cm-deck__sets {
  font-size: 0.62rem;
  font-weight: 750;
  letter-spacing: 0.04em;
  line-height: 1;
  color: var(--cm-muted);
}

.cm-deck__sets {
  margin: 0 0 0.2rem;
  text-align: center;
  font-size: 0.85rem;
}

.cm-chrono__score-ai-accept {
  display: flex;
  align-items: flex-start;
  gap: 0.45rem;
  margin: 0;
  font-size: 0.72rem;
  font-weight: 650;
  line-height: 1.35;
}

.cm-chrono__score-ai-accept input {
  margin-top: 0.12rem;
  flex: 0 0 auto;
}

.cm-chrono__score-ai-live {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
}

.cm-chrono__score-ai-log {
  max-height: 14rem;
  overflow: auto;
}

.cm-review__pt-meta {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: var(--cm-muted);
  font-size: 0.72rem;
  font-weight: 650;
}

.cm-review__sheet-empty {
  margin: 0;
  padding: 0.8rem 0.7rem 1rem;
  color: var(--cm-muted);
  font-size: 0.8rem;
}

.cm-review .cm-chrono__tagger-slot--dock {
  order: 6;
  position: static;
  max-height: none;
  box-shadow: none;
  background: transparent;
}

.cm-review .cm-chrono__tagger-slot--dock:not(:has(.cm-deck)) {
  display: none;
}

.cm-review .cm-chrono__side:has(.cm-chrono__mod),
.cm-review .cm-chrono__side:has(.cm-chrono__score-ai) {
  display: flex;
  order: 7;
  max-height: none;
  overflow: visible;
  border: 0;
  background: transparent;
}

.cm-review .cm-chrono__rail,
.cm-review .cm-chrono__sets,
.cm-review .cm-chrono__set-label,
.cm-review .cm-chrono__tagger-slot--side,
.cm-review .cm-film {
  display: none;
}

.cm-review__tools-kicker {
  flex: 0 0 auto;
  width: 100%;
  margin: 0 0 0.15rem;
  font-size: 0.66rem;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--cm-muted);
}

.cm-review .cm-chrono__mod {
  flex-direction: column;
  align-items: stretch;
  gap: 0.4rem;
  padding: 0.55rem 0.65rem 0.75rem;
  padding-left: calc(0.65rem + env(safe-area-inset-left, 0px));
  padding-right: calc(0.65rem + env(safe-area-inset-right, 0px));
  background: var(--cm-deck);
  border-top: 1px solid var(--cm-hair);
}

.cm-review .cm-chrono__mod .cm-btn,
.cm-review .cm-chrono__mod .cm-chrono__reassign {
  width: 100%;
  justify-content: flex-start;
}

.cm-review .cm-chrono__score-ai {
  margin: 0 0.65rem 0.75rem;
}

/* Desktop match review: tape on the left, point labeler and score
   detection on the right. The player must not cover that column. */
@media (min-width: 1024px) {
  .cm-review__body {
    overflow: hidden;
  }

  .cm-review .cm-chrono.is-review-layout.is-staff-desktop {
    flex: 1 1 auto;
    min-height: 0;
    height: auto;
    max-height: none;
    overflow: hidden;
    display: grid;
    grid-template-columns: minmax(0, 1fr);
    grid-template-rows: auto minmax(12rem, 1fr) auto auto auto;
  }

  .cm-review .cm-chrono.is-review-layout.is-staff-desktop:has(.cm-chrono__side .cm-deck),
  .cm-review .cm-chrono.is-review-layout.is-staff-desktop:has(.cm-chrono__side .cm-chrono__mod),
  .cm-review .cm-chrono.is-review-layout.is-staff-desktop:has(.cm-chrono__side .cm-chrono__score-ai) {
    grid-template-columns: minmax(0, 1fr) minmax(22rem, 32rem);
  }

  .cm-review .cm-chrono.is-review-layout.is-staff-desktop .cm-chrono__reassign {
    grid-column: 1 / -1;
    grid-row: 1;
  }

  .cm-review .cm-chrono.is-review-layout.is-staff-desktop .cm-chrono__player-shell {
    grid-column: 1;
    grid-row: 2;
    position: relative;
    inset: auto;
    z-index: 1;
    width: 100%;
    max-width: none;
    height: 100%;
    max-height: none;
    min-height: 0;
    aspect-ratio: auto;
    flex: none;
    align-self: stretch;
    margin: 0;
    transform: none;
  }

  /* Full screen still covers the desktop two-column review chrome. */
  .cm-review .cm-chrono.is-review-layout.is-staff-desktop.is-stage-fs .cm-chrono__player-shell,
  .cm-review .cm-chrono.is-review-layout.is-staff-desktop.is-stage-landscape .cm-chrono__player-shell {
    position: fixed;
    inset: 0;
    z-index: 140;
    grid-column: auto;
    grid-row: auto;
    width: 100%;
    max-width: none;
    height: 100%;
    max-height: none;
    min-height: 0;
    aspect-ratio: auto;
    margin: 0;
    transform: none;
    border-radius: 0;
    background: #05070c;
  }

  .cm-review .cm-chrono.is-review-layout.is-staff-desktop .cm-review__board-dock {
    grid-column: 1;
    grid-row: 3;
  }

  .cm-review .cm-chrono.is-review-layout.is-staff-desktop .cm-reviewbar {
    grid-column: 1;
    grid-row: 4;
    position: static;
  }

  .cm-review .cm-chrono.is-review-layout.is-staff-desktop .cm-reviewbar__btn--menu {
    margin-left: 0;
  }

  .cm-review .cm-chrono.is-review-layout.is-staff-desktop .cm-review__sheet {
    grid-column: 1;
    grid-row: 5;
    max-height: 28vh;
    min-height: 0;
  }

  .cm-review .cm-chrono.is-review-layout.is-staff-desktop .cm-chrono__tagger-slot--dock {
    display: none;
  }

  .cm-review .cm-chrono.is-review-layout.is-staff-desktop .cm-chrono__tagger-slot--review {
    display: block;
    flex: 0 0 auto;
    min-height: 0;
    max-height: none;
    overflow: visible;
  }

  .cm-review .cm-chrono.is-review-layout.is-staff-desktop .cm-chrono__side:has(.cm-deck),
  .cm-review .cm-chrono.is-review-layout.is-staff-desktop .cm-chrono__side:has(.cm-chrono__mod),
  .cm-review .cm-chrono.is-review-layout.is-staff-desktop .cm-chrono__side:has(.cm-chrono__score-ai) {
    display: flex;
    flex-direction: column;
    grid-column: 2;
    grid-row: 1 / -1;
    align-self: stretch;
    width: auto;
    max-width: none;
    height: auto;
    max-height: none;
    min-height: 0;
    overflow: auto;
    order: unset;
    border-top: 0;
    border-left: 1px solid var(--cm-hair);
    background: var(--cm-deck);
  }

  .cm-review .cm-chrono.is-review-layout.is-staff-desktop .cm-chrono__mod,
  .cm-review .cm-chrono.is-review-layout.is-staff-desktop .cm-chrono__score-ai {
    flex: 0 0 auto;
  }
}

@media (prefers-reduced-motion: reduce) {
  .cm-review__pt,
  .cm-reviewbar__btn {
    transition: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/championship/ChampionshipMatchPage.css"],"names":[],"mappings":"AAEA;;EAEE,eAAe;EACf,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;;;EAGE,6BAA6B;EAC7B,iCAAiC;AACnC;;AAEA;EACE,eAAe;EACf,kDAAkD;EAClD,SAAS;EACT,YAAY;EACZ,2BAA2B;EAC3B,SAAS;EACT,oBAAoB;EACpB,qBAAqB;EACrB,mCAAmC;EACnC,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,2CAA2C;EAC3C,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,sCAAsC;EACtC,kCAAkC;EAClC,2CAA2C;EAC3C,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,wCAAwC;EACxC,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;EACX,cAAc;EACd,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB;oDACkD;EAClD;;;gBAGc;EACd,qBAAqB;EACrB,yDAAyD;AAC3D;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,mCAAmC;EACnC,qCAAqC;EACrC,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;;EAGE,aAAa;AACf;;AAEA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,aAAa;EACb,oCAAoC;EACpC,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,kCAAkC;EAClC,mBAAmB;EACnB,2BAA2B;EAC3B,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;EACvB,gBAAgB;EAChB,kCAAkC;EAClC,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,8BAA8B;EAC9B,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,mBAAmB;EACnB,kCAAkC;EAClC,2BAA2B;EAC3B,aAAa;EACb,+BAA+B;EAC/B,6BAA6B;EAC7B,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,+DAA+D;AACjE;;AAEA;EACE,yEAAyE;EACzE,4EAA4E;AAC9E;;AAEA;EACE,yEAAyE;EACzE,4EAA4E;EAC5E,sEAAsE;AACxE;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,wBAAwB;EACxB,oBAAoB;EACpB,mEAAmE;EACnE,4DAA4D;EAC5D,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,SAAS;EACT,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,mCAAmC;EACnC,2BAA2B;EAC3B,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,+DAA+D;EAC/D,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,SAAS;EACT,uBAAuB;EACvB,sBAAsB;EACtB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,6BAA6B;EAC7B,eAAe;EACf,aAAa;AACf;;AAEA;EACE,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,oCAAoC;EACpC,YAAY;EACZ,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,0BAA0B;EAC1B,SAAS;EACT,mBAAmB;EACnB,uBAAuB;EACvB,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA,2EAA2E;AAC3E;EACE,cAAc;EACd,aAAa;EACb,6BAA6B;EAC7B,aAAa;EACb,yDAAyD;EACzD,mBAAmB;EACnB,oBAAoB;EACpB,+BAA+B;EAC/B,mBAAmB;EACnB,kCAAkC;EAClC;;;;;;mBAMiB;EACjB,mDAAmD;AACrD;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,aAAa;EACb,4CAA4C;EAC5C,oBAAoB;EACpB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,iCAAiC;EACjC,4BAA4B;EAC5B,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,SAAS;EACT,qBAAqB;EACrB,yCAAyC;EACzC,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,sBAAsB;EACtB,yCAAyC;EACzC,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,kBAAkB;EAClB,uCAAuC;EACvC,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,0CAA0C;AAC5C;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,2BAA2B;EAC3B,+BAA+B;EAC/B,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,UAAU;EACV,0CAA0C;EAC1C,wEAAwE;EACxE,wCAAwC;EACxC,0BAA0B;EAC1B,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,sCAAsC;EACtC,qBAAqB;EACrB,6EAA6E;AAC/E;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,sCAAsC;EACtC,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,uBAAuB;EACvB,mBAAmB;EACnB,kCAAkC;EAClC,+BAA+B;AACjC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kEAAkE;AACpE;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE;;0DAEwD;AAC1D;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,4DAA4D;EAC5D,mEAAmE;AACrE;;AAEA;EACE,sEAAsE;EACtE,yEAAyE;AAC3E;;AAEA;EACE,mEAAmE;EACnE,sEAAsE;AACxE;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,kCAAkC;EAClC,oBAAoB;EACpB,2BAA2B;EAC3B,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,6BAA6B;EAC7B,+BAA+B;EAC/B,WAAW;AACb;;AAEA;EACE,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,gDAAgD;AAClD;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,gDAAgD;AAClD;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,wBAAwB;EACxB,mBAAmB;EACnB,yEAAyE;EACzE,kEAAkE;EAClE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,eAAe;EACf,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,6BAA6B;EAC7B,gBAAgB;EAChB,SAAS;EACT,mBAAmB;EACnB,6BAA6B;EAC7B,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,qBAAqB;EACrB,kCAAkC;AACpC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,cAAc;EACd,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,4BAA4B;EAC5B,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,gEAAgE;AAClE;;AAEA;EACE,cAAc;EACd,aAAa;EACb,aAAa;EACb,gDAAgD;EAChD,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,sEAAsE;EACtE,cAAc;EACd,aAAa;EACb,0BAA0B;EAC1B,2BAA2B;EAC3B,oBAAoB;EACpB,YAAY;EACZ,gEAAgE;EAChE,kBAAkB;EAClB,gBAAgB;EAChB,iCAAiC;EACjC,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kCAAkC;EAClC,mBAAmB;EACnB,2BAA2B;EAC3B,qBAAqB;EACrB,uBAAuB;EACvB,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kCAAkC;EAClC,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,6BAA6B;EAC7B,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,oEAAoE;EACpE,sEAAsE;AACxE;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,kCAAkC;EAClC,mBAAmB;EACnB,2BAA2B;EAC3B,qBAAqB;EACrB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,wCAAwC;EACxC,kBAAkB;EAClB,iEAAiE;EACjE,iBAAiB;EACjB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,+BAA+B;EAC/B;;;;;;mBAMiB;AACnB;;AAEA;EACE,SAAS;EACT,uBAAuB;EACvB,8EAA8E;EAC9E,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,qBAAqB;EACrB,YAAY;EACZ,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,kCAAkC;EAClC,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,wBAAwB;EACxB,oBAAoB;EACpB,kEAAkE;EAClE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,gDAAgD;AAClD;;AAEA;EACE,wDAAwD;EACxD,cAAc;AAChB;;AAEA;EACE,+DAA+D;EAC/D,mDAAmD;AACrD;;AAEA;EACE,qCAAqC;AACvC;;AAEA;;EAEE,aAAa;EACb,yDAAyD;EACzD,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,cAAc;AAChB;;AAEA;;EAEE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,uBAAuB;EACvB,mBAAmB;EACnB,6BAA6B;EAC7B,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;;EAEE,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,+DAA+D;EAC/D,iEAAiE;AACnE;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,UAAU;EACV,8DAA8D;EAC9D,gEAAgE;AAClE;;AAEA;EACE,UAAU;EACV,+BAA+B;AACjC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,SAAS;EACT,yBAAyB;EACzB,iDAAiD;EACjD,2BAA2B;EAC3B,2BAA2B;EAC3B,uBAAuB;EACvB,uBAAuB;EACvB,sBAAsB;EACtB,mBAAmB;EACnB,qBAAqB;EACrB,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,SAAS;EACT,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;EACd,yCAAyC;EACzC,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,qBAAqB;EACrB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,oBAAoB;EACpB,oBAAoB;AACtB;;AAEA;EACE,oEAAoE;EACpE,sEAAsE;AACxE;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,sEAAsE;EACtE;;;;;;mBAMiB;EACjB,wCAAwC;AAC1C;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE;;;;;;mBAMiB;EACjB,yCAAyC;AAC3C;;AAEA;EACE,SAAO;EACP,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,iCAAiC;EACjC,4BAA4B;EAC5B,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;EACX,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mCAAmC;EACnC,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,6EAA6E;EAC7E,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,gCAAgC;EAChC,oBAAoB;EACpB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,kCAAkC;EAClC,qDAAqD;AACvD;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,kEAAkE;AACpE;;AAEA;EACE,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gCAAgC;EAChC,8BAA8B;EAC9B,mBAAmB;EACnB,gEAAgE;EAChE,kDAAkD;AACpD;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,kCAAkC;EAClC,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;EACnB,kCAAkC;EAClC,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,wBAAwB;EACxB,oBAAoB;EACpB,6EAA6E;EAC7E,sEAAsE;EACtE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,kCAAkC;EAClC,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,aAAa;EACb,eAAe;EACf,oBAAoB;EACpB,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,mEAAmE;EACnE,4DAA4D;EAC5D,qBAAqB;EACrB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,+DAA+D;EAC/D,4DAA4D;AAC9D;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,SAAS;EACT,wBAAwB;EACxB,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,qBAAqB;EACrB,4DAA4D;EAC5D,mEAAmE;AACrE;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,sEAAsE;EACtE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,6EAA6E;EAC7E,mBAAmB;EACnB,2BAA2B;EAC3B,qBAAqB;EACrB,wCAAwC;EACxC,eAAe;EACf,sBAAsB;EACtB,YAAiC;EAAjC,cAAiC;EAAjC,mCAAiC;EACjC;gDAC8C;AAChD;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,kEAAkE;EAClE,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,yCAAyC;EACzC,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,+BAA+B;EAC/B,YAAiC;EAAjC,cAAiC;EAAjC,mCAAiC;EACjC,oBAAoB;AACtB;;AAEA;EACE,sEAAsE;EACtE,oEAAoE;EACpE,kFAAkF;AACpF;;AAEA;EACE,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,6BAA6B;EAC7B,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,mBAAmB;EACnB,gCAAgC;EAChC,mBAAmB;EACnB,kCAAkC;EAClC,2BAA2B;EAC3B,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kCAAkC;EAClC,oBAAoB;EACpB,uBAAuB;EACvB,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,iCAAiC;EACjC,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;AACd;;AAEA;EACE,YAA6B;EAA7B,cAA6B;EAA7B,+BAA6B;EAC7B,8BAA8B;AAChC;;AAEA,mDAAmD;AACnD;EACE,YAAY;EACZ,mBAAmB;EACnB,kCAAkC;EAClC,mBAAmB;EACnB,2BAA2B;EAC3B,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,sEAAsE;EACtE,oEAAoE;AACtE;;AAEA;EACE,8DAA8D;EAC9D,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,qEAAqE;AACvE;;AAEA;EACE,kBAAkB;EAClB,SAAO;EACP,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,SAAS;EACT,wBAAwB;EACxB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,gBAAgB;EAChB,gEAAgE;EAChE,gCAAgC;AAClC;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,kCAAkC;EAClC,2BAA2B;EAC3B,gBAAgB;EAChB,2CAA2C;EAC3C,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,+BAA+B;EAC/B,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,UAAU;EACV,uBAAuB;EACvB,oBAAoB;EACpB,gCAAgC;EAChC,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,SAAS;EACT,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,kCAAkC;EAClC,mBAAmB;EACnB,2BAA2B;EAC3B,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,6BAA6B;EAC7B,+BAA+B;EAC/B,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,UAAU;EACV,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;;;EAGE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,kDAAkD;EAClD,sDAAsD;EACtD,UAAU;EACV,gBAAgB;EAChB,uBAAuB;EACvB,oBAAoB;EACpB,2CAA2C;EAC3C,+BAA+B;EAC/B,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,kDAAkD;EAClD,oDAAoD;EACpD,UAAU;EACV,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,SAAS;EACT,UAAU;EACV,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,WAAW;EACX;;;kDAGgD;EAChD,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,oBAAoB;EACpB,2CAA2C;EAC3C,+BAA+B;EAC/B,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,kCAAkC;EAClC,0CAA0C;AAC5C;;AAEA;EACE,mCAAmC;EACnC,uCAAuC;EACvC,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,4BAA4B;EAC5B,mBAAmB;EACnB,2CAA2C;EAC3C,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,cAAc;EACd,wBAAwB;EACxB,iBAAiB;EACjB,kCAAkC;EAClC,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,WAAW;EACX,SAAS;EACT,eAAe;EACf,SAAS;EACT,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,+BAA+B;EAC/B,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,gDAAgD;AAClD;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,sCAAsC;EACtC,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,wDAAwD;AAC1D;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,mBAAmB;EACnB,6CAA6C;EAC7C,gDAAgD;AAClD;;AAEA;EACE,mBAAmB;EACnB,6CAA6C;EAC7C,2CAA2C;AAC7C;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,UAAU;EACV,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;;IAEE,aAAa;EACf;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,mBAAmB;IACnB,qBAAqB;EACvB;AACF;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;;EAGE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,kCAAkC;EAClC,mBAAmB;EACnB,2BAA2B;EAC3B,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,kCAAkC;EAClC,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,YAAY;EACZ,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,4CAA4C;EAC5C,YAAY;EACZ,cAAc;EACd,aAAa;EACb,YAAY;EACZ,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,eAAe;EACf,SAAS;EACT,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,kCAAkC;EAClC,mBAAmB;EACnB,2BAA2B;EAC3B,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,iCAAiC;EACjC,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,uBAAuB;EACvB,2BAA2B;EAC3B,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,wBAAwB;EACxB,mBAAmB;EACnB,iFAAiF;EACjF,2EAA2E;EAC3E,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,iDAAiD;EACjD,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,uBAAuB;EACvB,kEAAkE;EAClE,0EAA0E;EAC1E,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,uBAAuB;EACvB,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,UAAU;EACV,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,uCAAuC;EACvC,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,SAAS;EACT,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,wBAAwB;EACxB,mBAAmB;EACnB,kCAAkC;EAClC,2BAA2B;AAC7B;;AAEA;EACE,+BAA+B;EAC/B,6CAA6C;EAC7C,sEAAsE;AACxE;;AAEA;EACE,yEAAyE;EACzE,sEAAsE;AACxE;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,cAAc;EACd,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,kCAAkC;EAClC,wBAAwB;EACxB,kEAAkE;EAClE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,+BAA+B;EAC/B,WAAW;AACb;;AAEA;EACE,aAAa;EACb,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,kCAAkC;EAClC,kEAAkE;EAClE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,kCAAkC;EAClC,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,wEAAwE;EACxE,8BAA8B;AAChC;;AAEA;EACE,uEAAuE;EACvE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;;EAEE,2DAA2D;EAC3D,wBAAwB;AAC1B;;AAEA;EACE,6BAA6B;EAC7B,WAAW;AACb;;AAEA;EACE,0DAA0D;AAC5D;;AAEA;EACE,SAAS;EACT,uBAAuB;EACvB,wBAAwB;EACxB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,SAAS;EACT,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE;IACE,8BAA8B;IAC9B,YAAY;EACd;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,cAAc;IACd,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE,SAAO;EACP,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,SAAO;EACP,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,+BAA+B;EAC/B,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,0CAA0C;EAC1C,4CAA4C;EAC5C,oBAAoB;EACpB,UAAU;EACV,wDAAwD;AAC1D;;AAEA;EACE,qBAAqB;EACrB,iFAAiF;EACjF,wDAAwD;AAC1D;;AAEA;;EAEE,qBAAqB;EACrB,kFAAkF;AACpF;;AAEA;EACE,qBAAqB;EACrB,gFAAgF;AAClF;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,kCAAkC;EAClC,cAAc;EACd,2CAA2C;AAC7C;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;;EAGE,6CAA6C;AAC/C;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE;;IAEE,UAAU;EACZ;EACA;IACE,aAAa;EACf;AACF;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,UAAU;EACV,sCAAsC;EACtC,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,wBAAwB;EACxB,oBAAoB;EACpB,gCAAgC;EAChC,2CAA2C;EAC3C,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,sCAAsC;EACtC,cAAc;AAChB;;AAEA;;EAEE,uCAAuC;EACvC,cAAc;AAChB;;AAEA;EACE,sCAAsC;EACtC,cAAc;AAChB;;AAEA;;EAEE,sCAAsC;EACtC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,sBAAsB;EACtB,mBAAmB;EACnB,gCAAgC;EAChC,2CAA2C;EAC3C,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,sBAAsB;EACtB,mBAAmB;EACnB,gCAAgC;EAChC,0CAA0C;EAC1C,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB;;WAES;AACX;;AAEA;EACE,UAAU;EACV,2BAA2B;EAC3B,0DAA0D;EAC1D,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,oBAAoB;EACpB,oCAAoC;EACpC,0CAA0C;EAC1C,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iDAAiD;EACjD,0DAA0D;EAC1D,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,iCAAiC;EACjC,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,wBAAwB;EACxB,mBAAmB;EACnB,6EAA6E;EAC7E,kEAAkE;EAClE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,sEAAsE;EACtE,+DAA+D;AACjE;;AAEA;EACE,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,qCAAqC;EACrC,uCAAuC;EACvC,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,oBAAoB;EACpB,kCAAkC;EAClC,uBAAuB;EACvB,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,2DAA2D;EAC3D,yEAAyE;AAC3E;;AAEA;;;;;;;EAOE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,oBAAoB;EACpB,+BAA+B;AACjC;;AAEA;EACE,UAAU;EACV,cAAc;EACd,YAAY;EACZ,mCAAmC;AACrC;;AAEA;EACE,UAAU;EACV,cAAc;EACd,YAAY;EACZ,gCAAgC;EAChC,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,SAAS;EACT,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,kCAAkC;EAClC,2BAA2B;EAC3B,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,6BAA6B;EAC7B,+BAA+B;EAC/B,WAAW;AACb;;AAEA;EACE,cAAc;EACd,aAAa;EACb,YAAY;EACZ,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,wBAAwB;EACxB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,yBAAyB;EACzB;;;;GAIC;AACH;;AAEA;EACE,cAAc;EACd,aAAa;AACf;;AAEA;EACE;IACE,6BAA6B;EAC/B;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;IACnB,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,oCAAoC;EACtC;AACF;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,+DAA+D;AAC/D;EACE,gBAAgB;EAChB,mBAAmB;EACnB,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,8BAA8B;EAC9B,iCAAiC;AACnC;;AAEA;EACE,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;EACZ,kCAAkC;EAClC,gEAAgE;EAChE,qBAAqB;EACrB,mBAAmB;EACnB,wBAAwB;EACxB,aAAa;EACb,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,yEAAyE;EACzE,sEAAsE;EACtE,kFAAkF;AACpF;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;EACrB,oCAAoC;EACpC,oCAAoC;EACpC,2CAA2C;EAC3C,aAAa;EACb,sBAAsB;EACtB,cAAc;EACd,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,kCAAkC;EAClC,mBAAmB;EACnB,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;EACrB,iCAAiC;EACjC,iCAAiC;EACjC,uCAAuC;AACzC;;AAEA,wEAAwE;AACxE;EACE,kBAAkB;EAClB,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,WAAW;EACX,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;;;EAGE,QAAQ;AACV;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,SAAY;EACZ,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,2EAA2E;EAC3E,oBAAoB;EACpB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;AACd;;AAEA;;EAEE,eAAe;EACf,cAAc;EACd,SAAS;EACT,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,OAAO;EACP,QAAQ;EACR,aAAa;EACb,sBAAsB;AACxB;;AAEA;;;;EAIE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,aAAa;EACb,gBAAgB;AAClB;;AAEA;;;;EAIE,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,cAAc;AAChB;;AAEA;;;;EAIE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;EACpB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,gBAAgB;AAClB;;AAEA;;EAEE,YAAY;EACZ,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;AACd;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,2DAA2D;AAC3D;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,oBAAoB;EACpB,UAAU;EACV,6BAA6B;AAC/B;;AAEA;;EAEE,UAAU;AACZ;;AAEA;+CAC+C;AAC/C;EACE,iDAAiD;EACjD,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,oBAAoB;EACpB,+BAA+B;EAC/B,0CAA0C;EAC1C,0CAA0C;EAC1C,kDAAkD;EAClD,aAAa;EACb,6BAA6B;AAC/B;;AAEA;;;;EAIE,UAAU;AACZ;;AAEA;EACE,6BAA6B;EAC7B,8BAA8B;EAC9B,SAAS;EACT,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,UAAU;EACV,eAAe;EACf,gCAAgC;EAChC,uBAAuB;EACvB,wCAAwC;EACxC,uDAAuD;AACzD;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,qCAAqC;AACvC;;AAEA;EACE,yBAAyB;EACzB,+CAA+C;EAC/C,mDAAmD;AACrD;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,UAAU;EACV,8CAA8C;EAC9C,oBAAoB;EACpB,iCAAiC;EACjC,cAAc;EACd,2CAA2C;EAC3C,yCAAyC;EACzC,gBAAgB;EAChB,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA;EACE,+CAA+C;EAC/C,iDAAiD;AACnD;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,UAAU;EACV,SAAS;EACT,wBAAwB;EACxB,oBAAoB;EACpB,gCAAgC;EAChC,cAAc;EACd,yCAAyC;EACzC,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,kDAAkD;EAClD,UAAU;EACV,SAAS;EACT,0BAA0B;EAC1B,wBAAwB;EACxB,oBAAoB;EACpB,iCAAiC;EACjC,cAAc;EACd,0CAA0C;EAC1C,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,SAAS;EACT,uBAAuB;EACvB,mBAAmB;EACnB,mCAAmC;EACnC,WAAW;EACX,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,gFAAgF;EAChF,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,gEAAgE;AAClE;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,0EAA0E;AAC1E;EACE,sCAAsC;EACtC,yCAAyC;EACzC,uCAAuC;EACvC,8CAA8C;EAC9C,+CAA+C;EAC/C,yCAAyC;EACzC,gDAAgD;EAChD,0CAA0C;EAC1C,8CAA8C;EAC9C,qBAAqB;AACvB;;AAEA;EACE,mEAAmE;EACnE,gCAAgC;AAClC;;AAEA;EACE,6CAA6C;EAC7C,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,yEAAyE;AAC3E;;AAEA;;;;;;;;EAQE,qBAAqB;AACvB;;AAEA;;;EAGE,uBAAuB;EACvB,wBAAwB;EACxB,YAAY;EACZ,aAAa;EACb,kCAAkC;EAClC,kCAAkC;EAClC,SAAW;AACb;;AAEA;;EAEE,wBAAwB;EACxB,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,YAAc;EACd,8CAA8C;AAChD;;AAEA;;EAEE,wBAAwB;EACxB,yBAAyB;AAC3B;;AAEA;;;EAGE,6BAA6B;AAC/B;;AAEA;;EAEE,YAAY;EACZ,WAAW;EACX,yCAAyC;EACzC,4CAA4C;EAC5C,oBAAoB;AACtB;;AAEA;EACE,4CAA4C;EAC5C,8BAA8B;AAChC;;AAEA;EACE,SAAS;EACT,uBAAuB;EACvB,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EAEE,gBAAgB;EAChB,WAAW;EACX,cAAc;EACd,SAAS;EACT,uBAAuB;EACvB,kBAAkB;EAClB,YAAY;EACZ,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,qCAAqC;EACrC,oBAAoB;AACtB;;AAEA;EAEE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,yCAAyC;EACzC,YAAY;AACd;;AAEA;EACE,WAAW;EACX,qCAAqC;EACrC,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,yCAAyC;EACzC,YAAY;AACd;;AAEA,4EAA4E;AAC5E;EACE,qBAAqB;EACrB,qEAAqE;EACrE,+BAA+B;AACjC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mEAAmE;EACnE,qCAAqC;EACrC,2BAA2B;EAC3B,4BAA4B;EAC5B,uBAAuB;EACvB,wBAAwB;EACxB,kCAAkC;AACpC;;AAEA;EACE,qFAAqF;EACrF,8BAA8B;AAChC;;AAEA;EACE,qCAAqC;EACrC,sCAAsC;AACxC;;AAEA;EACE,kCAAkC;EAClC,mCAAmC;AACrC;;AAEA;EACE,8CAA8C;EAC9C,iDAAiD;EACjD,6DAA6D;EAC7D,uCAAuC;EACvC,4CAA4C;AAC9C;;AAEA;EACE,2CAA2C;AAC7C;;AAEA,kEAAkE;AAClE;EACE;;;;IAIE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,MAAM;EACR;AACF;;AAEA;EACE;;IAEE,aAAa;EACf;;EAEA;IACE,QAAQ;IACR,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,cAAc;EACd,YAAY;EACZ,yBAAyB;EACzB,0BAA0B;EAC1B,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,oBAAoB;EACpB,0BAA0B;EAC1B,iCAAiC;EACjC,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,SAAS;EACT,uBAAuB;EACvB,sBAAsB;EACtB,oBAAoB;EACpB,sBAAsB;EACtB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,eAAe;EACf,mDAAmD;AACrD;;AAEA;EACE,6BAA6B;EAC7B,qBAAqB;EACrB,kFAAkF;AACpF;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,kCAAkC;EAClC,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAChB,6BAA6B;EAC7B,6BAA6B;EAC7B,8BAA8B;EAC9B,iCAAiC;EACjC,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,cAAc;EACd,wBAAwB;EACxB,oBAAoB;EACpB,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,gCAAgC;EAChC,0BAA0B;EAC1B,qBAAqB;EACrB,mBAAmB;EACnB,+BAA+B;EAC/B,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,0DAA0D;AAC5D;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,eAAe;EACf,WAAW;EACX,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA,yCAAyC,aAAa,EAAE;AACxD,iDAAiD,aAAa,EAAE;AAChE,+CAA+C,aAAa,EAAE;AAC9D,wCAAwC,aAAa,EAAE;AACvD,wCAAwC,aAAa,EAAE;;AAEvD;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,qDAAqD;EACrD,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kCAAkC;EAClC,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,oEAAoE;EACpE,qEAAqE;AACvE;;AAEA;EACE,+BAA+B;EAC/B,4EAA4E;AAC9E;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,gCAAgC;EAChC,iCAAiC;AACnC;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,wBAAwB;EACxB,oEAAoE;EACpE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;;;EAGE,wBAAwB;EACxB,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;;;EAGE,aAAa;AACf;;AAEA;;;;;;;;;EASE,aAAa;AACf;;AAEA;;;EAGE,cAAc;EACd,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA;;;EAGE,cAAc;EACd,aAAa;EACb,UAAU;EACV,MAAM;AACR;;AAEA;;;EAGE,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,gBAAgB;AAClB;;AAEA;;;EAGE,aAAa;AACf;;AAEA;EACE,UAAU;AACZ;;AAEA;;EAEE,cAAc;EACd,aAAa;EACb,YAAY;EACZ,SAAS;EACT,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;gEACgE;AAChE;EACE,eAAe;EACf,QAAQ;EACR,cAAc;EACd,aAAa;EACb,cAAc;EACd,gBAAgB;EAChB,SAAS;EACT,SAAS;EACT,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,aAAa;EACb,cAAc;EACd,0CAA0C;EAC1C,0BAA0B;AAC5B;;AAEA;;;;EAIE,cAAc;EACd,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,UAAU;EACV,MAAM;EACN,mBAAmB;AACrB;;AAEA;;EAEE,SAAY;EACZ,aAAa;EACb,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;;;;;;;EAQE,aAAa;AACf;;AAEA;;EAEE,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,8DAA8D;EAC9D,4CAA4C;EAC5C,8CAA8C;AAChD;;AAEA;EACE,8DAA8D;AAChE;;AAEA;kEACkE;AAClE;EACE;;WAES;AACX;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,uBAAuB;AACzB;;AAEA;;EAEE,uCAAuC;EACvC,eAAe;AACjB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,+CAA+C;EAC/C,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE;;IAEE,WAAW;EACb;AACF;;AAEA;0EAC0E;AAC1E;;EAEE,kBAAkB;EAClB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,UAAU;AACZ;;AAEA;;;;EAIE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,OAAO;EACP,WAAW;EACX,UAAU;EACV,YAAY;EACZ,uBAAuB;EACvB,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,aAAa;AACf;;AAEA;;;EAGE,aAAa;AACf;;AAEA;EACE;;;;gDAI8C;EAC9C,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,gCAAgC;EAChC,2CAA2C;EAC3C,2BAA2B;EAC3B,mCAAmC;AACrC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,qCAAqC;EACrC,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,oBAAoB;EACpB,gCAAgC;EAChC,gCAAgC;EAChC,0CAA0C;AAC5C;;AAEA;EACE;;;;gDAI8C;EAC9C,oBAAoB;AACtB;;AAEA;EACE,wEAAwE;AAC1E;;AAEA;EACE;;;GAGC;AACH;;AAEA;EACE,6CAA6C;EAC7C,wBAAwB;EACxB,4CAA4C;EAC5C,wCAAwC;EACxC,2FAA2F;EAC3F,+FAA+F;EAC/F,8BAA8B;EAC9B,2EAA2E;EAC3E,yBAAyB;EACzB,6EAA6E;EAC7E,4BAA4B;EAC5B,6FAA6F;EAC7F,6BAA6B;EAC7B,yFAAyF;EACzF,yFAAyF;EACzF,+DAA+D;EAC/D,kBAAkB;EAClB,WAAW;EACX,iDAAiD;EACjD,qDAAqD;EACrD,aAAa;EACb,oBAAoB;EACpB,YAAY;EACZ,0CAA0C;EAC1C,oBAAoB;EACpB,2BAA2B;EAC3B,+BAA+B;AACjC;;AAEA,gEAAgE;AAChE;EACE,wBAAwB;EACxB,0BAA0B;EAC1B,4CAA4C;EAC5C,wFAAwF;EACxF,6EAA6E;EAC7E,8BAA8B;EAC9B,2EAA2E;EAC3E,yBAAyB;EACzB,6EAA6E;EAC7E,4BAA4B;EAC5B,6FAA6F;EAC7F,6BAA6B;EAC7B,yFAAyF;EACzF,yEAAyE;EACzE,kEAAkE;AACpE;;AAEA,+EAA+E;AAC/E;;;EAGE,wBAAwB;EACxB,4CAA4C;EAC5C,wCAAwC;EACxC,2FAA2F;EAC3F,+FAA+F;EAC/F,8BAA8B;EAC9B,2EAA2E;EAC3E,yBAAyB;EACzB,6EAA6E;EAC7E,4BAA4B;EAC5B,6FAA6F;EAC7F,6BAA6B;EAC7B,yEAAyE;EACzE,yEAAyE;EACzE,+DAA+D;AACjE;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,cAAc;EACd,uBAAuB;EACvB,qCAAqC;AACvC;;AAEA;;EAEE,cAAc;EACd,eAAe;EACf,cAAc;EACd,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,oCAAoC;EACpC,8CAA8C;EAC9C;;6CAE2C;AAC7C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,kCAAkC;EAClC,uCAAuC;EACvC,gDAAgD;AAClD;;AAEA;EACE,aAAa;EACb,8DAA8D;EAC9D,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,qCAAqC;EACrC,iCAAiC;EACjC,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,+CAA+C;AACjD;;AAEA;EACE,uBAAuB;EACvB,mCAAmC;EACnC,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mEAAmE;EACnE,kBAAkB;EAClB,gBAAgB;EAChB,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,gFAAgF;AAClF;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,iDAAiD;EACjD,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,uCAAuC;AACzC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,iCAAiC;EACjC,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,mEAAmE;EACnE,kBAAkB;EAClB,gBAAgB;EAChB,kCAAkC;EAClC,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,gDAAgD;EAChD,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,kDAAkD;EAClD,sDAAsD;EACtD,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,wCAAwC;EACxC,kBAAkB;EAClB,gCAAgC;EAChC,2CAA2C;EAC3C,2CAA2C;EAC3C,0BAA0B;EAC1B,kCAAkC;EAClC,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8CAA8C;EAC9C,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,UAAU;EACV,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,mEAAmE;EACnE,iBAAiB;EACjB,gBAAgB;EAChB,kCAAkC;EAClC,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,WAAW;EACX,mBAAmB;EACnB,oBAAoB;EACpB,+CAA+C;EAC/C,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,2DAA2D;EAC3D,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,WAAW;AACb;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,gCAAgC;EAChC,iCAAiC;EACjC,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,2CAA2C;EAC3C,qCAAqC;EACrC,cAAc;EACd,oBAAoB;EACpB,wCAAwC;EACxC,aAAa;EACb,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,cAAc;EACd,oBAAoB;EACpB,sCAAsC;AACxC;;AAEA;;EAEE,oEAAoE;EACpE,2EAA2E;AAC7E;;AAEA;EACE,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,YAAY;EACZ,cAAc;EACd,eAAe;EACf,cAAc;EACd,cAAc;EACd,sCAAsC;EACtC,mEAAmE;AACrE;;AAEA;EACE,aAAa;AACf;;AAEA;;;EAGE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,+BAA+B;EAC/B,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kCAAkC;EAClC,uBAAuB;EACvB,qBAAqB;EACrB,oBAAoB;EACpB,uBAAuB;EACvB,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,kEAAkE;EAClE,yEAAyE;EACzE,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,cAAc;EACd,gCAAgC;EAChC,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,qBAAqB;EACrB,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,0BAA0B;EAC1B;;;;GAIC;AACH;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,wBAAwB;EACxB,oBAAoB;EACpB,kEAAkE;EAClE,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,6BAA6B;EAC7B,iEAAiE;EACjE;;;yBAGuB;AACzB;;AAEA;EACE,yEAAyE;EACzE,qEAAqE;AACvE;;AAEA;EACE,yEAAyE;EACzE,sEAAsE;EACtE;;oEAEkE;AACpE;;AAEA;EACE,WAAW;EACX,aAAa;EACb,8CAA8C;EAC9C;;;+BAG6B;EAC7B,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;EAChB,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,kCAAkC;EAClC,sBAAsB;EACtB,gEAAgE;EAChE,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,kCAAkC;EAClC,sBAAsB;EACtB,qEAAqE;AACvE;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,kEAAkE;EAClE,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,aAAa;EACb,eAAe;EACf,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,2DAA2D;EAC3D,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,6EAA6E;EAC7E,kEAAkE;EAClE,gEAAgE;EAChE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,YAAY;EACZ,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,kCAAkC;EAClC,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;EACd,cAAc;EACd,aAAa;EACb,eAAe;EACf,cAAc;EACd,4BAA4B;AAC9B;;AAEA;;EAEE,aAAa;AACf;;AAEA,yEAAyE;AACzE;EACE,2BAA2B;EAC3B,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,8BAA8B;EAC9B,0BAA0B;EAC1B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,+CAA+C;EAC/C,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,UAAU;EACV,gCAAgC;EAChC,oBAAoB;EACpB,0BAA0B;EAC1B,qBAAqB;EACrB,eAAe;EACf,uDAAuD;AACzD;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,qEAAqE;EACrE,kBAAkB;EAClB,kCAAkC;EAClC,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8DAA8D;EAC9D,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8DAA8D;EAC9D,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,wEAAwE;AAC1E;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,qDAAqD;EACrD,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA,iDAAiD;AACjD;EACE,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,aAAa;EACb,cAAc;EACd,oBAAoB;EACpB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,UAAU;EACV,SAAS;EACT,oBAAoB;EACpB,0BAA0B;EAC1B,qBAAqB;EACrB,eAAe;EACf,wCAAwC;EACxC,uDAAuD;AACzD;;AAEA;EACE,4DAA4D;AAC9D;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,UAAU;EACV,SAAS;EACT,kBAAkB;EAClB,kBAAkB;EAClB,qDAAqD;EACrD,kBAAkB;EAClB,gBAAgB;EAChB,kCAAkC;EAClC,cAAc;EACd,cAAc;EACd,wBAAwB;EACxB;;;;;;;;4DAQ0D;EAC1D;;;iCAG+B;AACjC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,gCAAgC;EAChC,oBAAoB;EACpB,0BAA0B;EAC1B,sBAAsB;EACtB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,0EAA0E;AAC5E;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,WAAW;EACX,6EAA6E;AAC/E;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;;;;EAIE,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,UAAU;IACV,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,gBAAgB;IAChB,sBAAsB;IACtB,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,aAAa;IACb,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,4DAA4D;EAC5D,4DAA4D;EAC5D,gFAAgF;AAClF;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;EACvB,6DAA6D;EAC7D,gGAAgG;AAClG;;AAEA;EACE,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,qBAAqB;EACrB,iCAAiC;EACjC,oCAAoC;EACpC,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,UAAU;EACV,SAAS;EACT,oBAAoB;EACpB,0BAA0B;EAC1B,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,uDAAuD;AACzD;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;;;;IAIE,2BAA2B;EAC7B;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,yCAAyC;EACzC,kBAAkB;EAClB,wBAAwB;EACxB,gBAAgB;EAChB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,+BAA+B;EAC/B,wBAAwB;AAC1B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,oBAAoB;EACpB,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,yBAAyB;EACzB,uBAAuB;EACvB,wEAAwE;EACxE,mBAAmB;EACnB,+DAA+D;AACjE;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,eAAe;EACf,oBAAoB;EACpB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,yBAAyB;EACzB,uBAAuB;EACvB,kCAAkC;EAClC,mBAAmB;EACnB,0EAA0E;AAC5E;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;;;EAGE,aAAa;EACb,eAAe;EACf,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,kCAAkC;EAClC,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;;EAEE,SAAS;EACT,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,wBAAwB;EACxB,mBAAmB;EACnB,kCAAkC;EAClC,gEAAgE;EAChE,qBAAqB;EACrB,0BAA0B;EAC1B,kCAAkC;EAClC,8CAA8C;AAChD;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;;EAEE,WAAW;EACX,eAAe;EACf,oBAAoB;EACpB,gEAAgE;EAChE,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;EACd,YAAY;EACZ,sBAAsB;EACtB;;;;GAIC;EACD,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,eAAe;EACf,WAAW;EACX,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,wBAAwB;EACxB,mBAAmB;EACnB,kCAAkC;EAClC,gEAAgE;EAChE,qBAAqB;EACrB,0BAA0B;EAC1B,kCAAkC;EAClC,6CAA6C;AAC/C;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,kDAAkD;EAClD,iCAAiC;AACnC;;AAEA;EACE;IACE,sCAAsC;IACtC,UAAU;EACZ;EACA;IACE,eAAe;IACf,UAAU;EACZ;AACF;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,YAAY;EACZ,WAAW;EACX,SAAS;EACT,qCAAqC;EACrC,mBAAmB;EACnB,iCAAiC;EACjC,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,cAAc;EACd,SAAS;EACT,oBAAoB;EACpB,uBAAuB;EACvB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,oBAAoB;EACpB,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,UAAU;EACV,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,eAAe;EACf,iBAAiB;EACjB,iCAAiC;EACjC,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,8BAA8B;AAChC;;AAEA;;EAEE,eAAe;EACf,+BAA+B;AACjC;;AAEA;;EAEE,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,SAAS;EACT,oBAAoB;EACpB,uBAAuB;EACvB,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,qCAAqC;EACrC,yCAAyC;EACzC,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,4EAA4E;AAC9E;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,gCAAgC;EAChC,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,sCAAsC;EACtC,SAAS;EACT,gBAAgB;AAClB;;AAEA,sDAAsD;AACtD;EACE;IACE,YAAY;IACZ,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,0BAA0B;IAC1B,6BAA6B;EAC/B;;EAEA;IACE,UAAU;IACV,4DAA4D;EAC9D;;EAEA;IACE,SAAY;IACZ,cAAc;IACd,WAAW;IACX,eAAe;IACf,aAAa;IACb,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;;IAEE,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;IAChB,cAAc;IACd,gBAAgB;EAClB;;EAEA;;IAEE,WAAW;IACX,eAAe;IACf,SAAS;IACT,gBAAgB;IAChB,cAAc;IACd,aAAa;IACb,kBAAkB;IAClB,YAAY;EACd;;EAEA;;;;IAIE,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;IAChB,cAAc;EAChB;;EAEA;;IAEE,UAAU;EACZ;;EAEA;IACE,iBAAiB;EACnB;;EAEA;;IAEE,uBAAuB;EACzB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;;;IAGE,aAAa;EACf;;EAEA;IACE,cAAc;IACd,aAAa;IACb,gBAAgB;IAChB,uBAAuB;EACzB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,UAAU;IACV,wBAAwB;IACxB,qBAAqB;EACvB;;EAEA;IACE,SAAS;IACT;;;;mDAI+C;IAC/C,2BAA2B;IAC3B,qBAAqB;EACvB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,SAAS;IACT,gBAAgB;IAChB,uBAAuB;EACzB;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,SAAS;IACT,gBAAgB;IAChB,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,cAAc;IACd,aAAa;IACb,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,cAAc;IACd,aAAa;IACb,UAAU;IACV,MAAM;EACR;;EAEA;IACE,cAAc;IACd,kBAAkB;IAClB,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;IACd,gBAAgB;IAChB,SAAS;IACT,UAAU;IACV,cAAc;IACd,gDAAgD;IAChD,0BAA0B;IAC1B,4CAA4C;EAC9C;AACF;;AAEA;oEACoE;AACpE;EACE;IACE,aAAa;IACb,+DAA+D;IAC/D,iDAAiD;IACjD;;;;mBAIe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;;;IAGE,iBAAiB;IACjB,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,cAAc;IACd,0BAA0B;IAC1B,qCAAqC;EACvC;;EAEA;IACE,aAAa;IACb,4BAA4B;IAC5B,YAAY;EACd;AACF;;AAEA;EACE;;IAEE,gBAAgB;EAClB;AACF;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kCAAkC;EAClC,mBAAmB;EACnB,2BAA2B;EAC3B,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;;EAEE,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,UAAU;EACV,wBAAwB;EACxB,kBAAkB;EAClB,wDAAwD;EACxD,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,oBAAoB;EACpB,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,oBAAoB;EACpB,kCAAkC;EAClC,qBAAqB;AACvB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;;;EAGE,cAAc;EACd,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;EAEE,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,YAAY;EACZ,mBAAmB;AACrB;;AAEA;;;EAGE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,uBAAuB;EACvB,UAAU;AACZ;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,qCAAqC;EACrC,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,kCAAkC;EAClC,qCAAqC;AACvC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,6BAA6B;EAC7B,WAAW;EACX,6EAA6E;AAC/E;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE;IACE,eAAe;IACf,SAAS;IACT,SAAS;IACT,2DAA2D;IAC3D,6DAA6D;EAC/D;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,+BAA+B;EACjC;;EAEA;IACE,sCAAsC;EACxC;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,cAAc;IACd,uCAAuC;IACvC,wCAAwC;EAC1C;;EAEA;IACE,eAAe;IACf,SAAS;IACT,SAAS;EACX;AACF;;AAEA;EACE;IACE,eAAe;IACf,SAAS;IACT,SAAS;EACX;AACF;;AAEA,iFAAiF;AACjF;;EAEE,UAAU;EACV,gBAAgB;AAClB;;AAEA;;;;;;;;;;;;;EAaE,wBAAwB;AAC1B;;AAEA,2EAA2E;AAC3E;;EAEE,wBAAwB;EACxB,eAAe;EACf,OAAO;EACP,QAAQ;EACR,SAAS;EACT,WAAW;EACX,SAAS;EACT,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,uEAAuE;EACvE,kCAAkC;AACpC;;AAEA;;EAEE,SAAS;EACT,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;;EAEE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,WAAW;EACX,wDAAwD;EACxD,UAAU;EACV,+BAA+B;EAC/B,cAAc;EACd,iCAAiC;AACnC;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,gCAAgC;EAChC,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,oCAAoC;EACtC;AACF;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,eAAe;EACf,SAAS;EACT,oBAAoB;EACpB,gCAAgC;EAChC,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;EACE;;IAEE,UAAU;IACV,qDAAqD;IACrD,uBAAuB;IACvB,uDAAuD;EACzD;;EAEA;IACE,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;AACF;;AAEA;;EAEE,eAAe;EACf,QAAQ;EACR,WAAW;EACX,MAAM;EACN,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kCAAkC;EAClC,QAAQ;EACR,wDAAwD;EACxD,OAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,oDAAoD;EACpD,WAAW;EACX,kBAAkB;EAClB;;;GAGC;EACD,kDAAkD;EAClD,UAAU;EACV,oBAAoB;EACpB,uBAAuB;EACvB,WAAW;EACX,SAAS;EACT,uBAAuB;EACvB,oBAAoB;EACpB,2CAA2C;EAC3C,gCAAgC;EAChC,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,2BAA2B;EAC3B,mCAAmC;EACnC,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;;EAEE,kBAAkB;EAClB,QAAQ;EACR,gBAAgB;EAChB,SAAS;EACT,gBAAgB;EAChB,UAAU;EACV,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,+BAA+B;EAC/B,oBAAoB;AACtB;;AAEA;;EAEE,UAAU;AACZ;;AAEA;;EAEE,kDAAkD;EAClD,UAAU;EACV,sDAAsD;EACtD,kBAAkB;AACpB;;AAEA;;EAEE,kDAAkD;AACpD;;AAEA;;EAEE,kDAAkD;EAClD,UAAU;EACV,sDAAsD;AACxD;;AAEA,yFAAyF;AACzF;;EAEE,UAAU;EACV,oBAAoB;AACtB;;AAEA;;;;EAIE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,SAAS;EACT,UAAU;EACV,SAAS;EACT;;;kDAGgD;EAChD,aAAa;EACb,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,uBAAuB;EACvB,qBAAqB;EACrB,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA;;EAEE,oBAAoB;AACtB;;AAEA;;;;EAIE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,oBAAoB;EACpB,2CAA2C;EAC3C,+BAA+B;EAC/B,WAAW;EACX,0CAA0C;EAC1C,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,MAAM;AACR;;AAEA;;EAEE,+BAA+B;EAC/B,uCAAuC;EACvC,WAAW;AACb;;AAEA;;EAEE,mCAAmC;EACnC,uCAAuC;AACzC;;AAEA;;;;EAIE,mCAAmC;EACnC,2CAA2C;EAC3C,WAAW;AACb;;AAEA;;EAEE,mCAAmC;EACnC,qBAAqB;EACrB,cAAc;EACd,+EAA+E;AACjF;;AAEA;EACE,eAAe;EACf,UAAU;EACV,WAAW;EACX,WAAW;EACX,YAAY;EACZ,aAAa;EACb,oBAAoB;EACpB,UAAU;EACV,iBAAiB;AACnB;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,6EAA6E;EAC7E,oBAAoB;EACpB,kEAAkE;EAClE,qBAAqB;EACrB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,aAAa;EACb,UAAU;AACZ;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,wBAAwB;EACxB,qBAAqB;EACrB;;;;iDAI+C;AACjD;;AAEA;EACE,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,kCAAkC;EAClC,2BAA2B;EAC3B,UAAU;EACV,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,YAAY;EACZ,aAAa;EACb,cAAc;EACd,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,kCAAkC;EAClC,oEAAoE;EACpE,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,uBAAuB;EACvB,mBAAmB;EACnB,2CAA2C;EAC3C;;0BAEwB;EACxB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,sBAAsB;EACtB,sBAAsB;EACtB,uBAAuB;EACvB,oBAAoB;EACpB,qCAAqC;EACrC,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,oCAAoC;EACpC,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;EACjB,kCAAkC;AACpC;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;;EAEE,WAAW;EACX,SAAO;EACP,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,2CAA2C;EAC3C,qCAAqC;EACrC,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,uEAAuE;EACvE,yBAAyB;AAC3B;;AAEA;wFACwF;AACxF;EACE,2BAA2B;EAC3B,eAAe;EACf,uBAAuB;EACvB,wBAAwB;EACxB,WAAW;EACX,YAAY;EACZ,0BAA0B;EAC1B,6BAA6B;EAC7B,iCAAiC;EACjC,YAAY;EACZ,cAAc;EACd,sBAAsB;EACtB,UAAU;EACV,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,+BAA+B;EAC/B,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,6DAA6D;EAC7D;;;;GAIC;EACD,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,2CAA2C;EAC3C,mBAAmB;EACnB,kCAAkC;EAClC,cAAc;EACd,2BAA2B;EAC3B,mCAAmC;EACnC,eAAe;EACf;iDAC+C;AACjD;;AAEA;EACE,sBAAsB;EACtB,kCAAkC;AACpC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,+CAA+C;EAC/C,WAAW;EACX,UAAU;EACV,UAAU;EACV,iBAAiB;EACjB,oBAAoB;EACpB,kCAAkC;EAClC,0CAA0C;EAC1C,2BAA2B;EAC3B,mCAAmC;EACnC,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,0CAA0C;EAC1C,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,iDAAiD;EACjD,mDAAmD;EACnD,oDAAoD;EACpD,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,sBAAsB;EACtB,uGAAuG;EACvG,+FAA+F;EAC/F;;;GAGC;EACD,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;EAC5B,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,sBAAsB;EACtB,oBAAoB;EACpB,kCAAkC;EAClC,2CAA2C;EAC3C,2BAA2B;EAC3B,mCAAmC;EACnC,2CAA2C;AAC7C;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,qBAAqB;EACrB,2CAA2C;EAC3C,oBAAoB;EACpB,kCAAkC;EAClC,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf;;;iDAG+C;AACjD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,oCAAoC;EACpC,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,kCAAkC;EAClC,6CAA6C;AAC/C;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,cAAc;EACd,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,cAAc;EACd,gCAAgC;EAChC,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,YAAY;EACZ,mBAAmB;EACnB,kCAAkC;EAClC,2CAA2C;EAC3C,2BAA2B;EAC3B,mCAAmC;EACnC,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,4DAA4D;AAC9D;;AAEA;EACE,SAAW;EACX,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,SAAS;EACT,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf;iDAC+C;AACjD;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,qCAAqC;AACvC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,uEAAuE;EACvE,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA,wEAAwE;AACxE;EACE;IACE,2BAA2B;EAC7B;;EAEA;IACE;;iDAE6C;EAC/C;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,+CAA+C;EACjD;;EAEA;IACE,iDAAiD;IACjD,mDAAmD;IACnD,WAAW;IACX,eAAe;IACf,SAAS;IACT,QAAQ;IACR,aAAa;IACb,uDAAuD;IACvD;;;;mBAIe;IACf,oBAAoB;IACpB,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,oBAAoB;IACpB,4BAA4B;IAC5B,qBAAqB;IACrB,gBAAgB;IAChB,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,oBAAoB;IACpB,YAAY;EACd;;EAEA;IACE,iBAAiB;IACjB,WAAW;IACX,eAAe;IACf,SAAS;IACT,sBAAsB;IACtB,wBAAwB;IACxB,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,SAAW;IACX,YAAY;IACZ,oBAAoB;EACtB;;EAEA;IACE,YAAY;IACZ,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;EACzB;;EAEA;IACE,eAAe;IACf,YAAY;EACd;;EAEA;IACE,iBAAiB;IACjB,YAAY;IACZ,aAAa;IACb,qDAAqD;IACrD;;oBAEgB;IAChB,mBAAmB;IACnB,eAAe;IACf,YAAY;EACd;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,oBAAoB;IACpB,4BAA4B;IAC5B,qBAAqB;IACrB,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,SAAS;IACT,WAAW;IACX;;;;;;KAMC;IACD,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,2BAA2B;EAC7B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,qBAAqB;EACvB;;EAEA;;IAEE,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,2BAA2B;EAC7B;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,oBAAoB;IACpB,4BAA4B;IAC5B,qBAAqB;IACrB,gBAAgB;EAClB;AACF;;AAEA;EACE;;;IAGE,gBAAgB;EAClB;AACF;;AAEA,iEAAiE;AACjE;EACE,iBAAiB;AACnB;AACA;EACE,SAAS;AACX;AACA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,2CAA2C;EAC3C,mBAAmB;EACnB;;;;GAIC;AACH;AACA;EACE,aAAa;EACb,eAAe;EACf,cAAc;EACd,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,SAAS;EACT,eAAe;EACf,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,oCAAoC;EACpC,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,qCAAqC;EACrC,2CAA2C;AAC7C;AACA;EACE,aAAa;EACb,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;EAChB,oBAAoB;EACpB,oCAAoC;AACtC;AACA;EACE,mCAAmC;EACnC,cAAc;AAChB;AACA;EACE,oCAAoC;EACpC,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;0EAC0E;AAC1E;EACE,UAAU;AACZ;;AAEA;EACE,SAAS;EACT;;;;iDAI+C;AACjD;;AAEA;EACE,cAAc;EACd,SAAS;EACT,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,SAAS;EACT,gBAAgB;EAChB,uBAAuB;EACvB,2BAA2B;EAC3B,wBAAwB;EACxB,yBAAyB;AAC3B;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;EACE,QAAQ;EACR,kBAAkB;EAClB,WAAW;EACX,cAAc;EACd,WAAW;EACX,eAAe;EACf,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,SAAS;EACT,wCAAwC;EACxC,gBAAgB;EAChB,mBAAmB;EACnB,qEAAqE;EACrE,2BAA2B;AAC7B;;AAEA;EACE,UAAU;AACZ;;AAEA,uEAAuE;AACvE;;;;;;;;EAQE,wBAAwB;AAC1B;;AAEA;EACE,UAAU;EACV,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;EACd,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,SAAS;EACT,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;EAEE,eAAe;EACf,QAAQ;EACR,YAAY;EACZ,UAAU;EACV,WAAW;EACX,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,SAAS;EACT,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;EAEE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;;;EAGE,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;;EAEE,iDAAiD;AACnD;;AAEA;EACE,WAAW;AACb;;AAEA;EACE;;;GAGC;AACH;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;AACf;;AAEA,0EAA0E;AAC1E;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,YAAY;EACZ,wBAAwB;EACxB,YAAY;EACZ,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;;EAEE,kBAAkB;EAClB,WAAW;EACX,cAAc;EACd,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,eAAe;EACf,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kDAAkD;EAClD,sDAAsD;EACtD,wBAAwB;EACxB,8BAA8B;AAChC;;AAEA;EACE,QAAQ;EACR,cAAc;EACd,WAAW;EACX,sBAAsB;EACtB,8BAA8B;EAC9B,iEAAiE;AACnE;;AAEA;EACE,iEAAiE;AACnE;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,SAAS;EACT,YAAY;EACZ,eAAe;EACf,WAAW;AACb;;AAEA;EACE,QAAQ;EACR,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,cAAc;EACd,wBAAwB;EACxB,4DAA4D;EAC5D,8DAA8D;EAC9D,wDAAwD;EACxD,oCAAoC;EACpC,uCAAuC;AACzC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,gCAAgC;EAChC,0BAA0B;EAC1B,qBAAqB;EACrB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,uEAAuE;EACvE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,6CAA6C;EAC7C,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;EACpB,6DAA6D;EAC7D,kCAAkC;EAClC,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,QAAQ;EACR,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,6BAA6B;EAC7B,cAAc;EACd,0BAA0B;EAC1B,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,0BAA0B;EAC1B,gBAAgB;EAChB,MAAM;EACN,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,SAAS;EACT,oBAAoB;EACpB,uBAAuB;EACvB,uBAAuB;EACvB,sBAAsB;EACtB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mDAAmD;EACnD,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,sBAAsB;EACtB,SAAS;EACT,kCAAkC;EAClC,uBAAuB;EACvB,qBAAqB;EACrB,aAAa;EACb,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,2EAA2E;AAC7E;;AAEA;EACE,6CAA6C;EAC7C,2EAA2E;AAC7E;;AAEA;EACE,aAAa;EACb,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,gCAAgC;EAChC,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,oBAAoB;EACpB,sBAAsB;EACtB,uBAAuB;EACvB,mEAAmE;EACnE,kBAAkB;EAClB,gBAAgB;EAChB,kCAAkC;EAClC,sBAAsB;EACtB,cAAc;AAChB;;AAEA;;EAEE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,2BAA2B;EAC3B,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,QAAQ;EACR,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,aAAa;EACb,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;EACjB,SAAS;EACT,uBAAuB;AACzB;;AAEA;;;;;EAKE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,WAAW;EACX,gCAAgC;EAChC,4DAA4D;EAC5D,8DAA8D;EAC9D,0BAA0B;EAC1B,oCAAoC;AACtC;;AAEA;;EAEE,WAAW;EACX,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;mEACmE;AACnE;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,cAAc;IACd,aAAa;IACb,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;IACb,qCAAqC;IACrC,0DAA0D;EAC5D;;EAEA;;;IAGE,0DAA0D;EAC5D;;EAEA;IACE,mBAAmB;IACnB,WAAW;EACb;;EAEA;IACE,cAAc;IACd,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,WAAW;IACX,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb,kBAAkB;IAClB,UAAU;IACV,mBAAmB;IACnB,SAAS;IACT,eAAe;EACjB;;EAEA,mEAAmE;EACnE;;IAEE,eAAe;IACf,QAAQ;IACR,YAAY;IACZ,iBAAiB;IACjB,cAAc;IACd,WAAW;IACX,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb,kBAAkB;IAClB,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,WAAW;EACb;;EAEA;IACE,cAAc;IACd,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;IACd,WAAW;IACX,gBAAgB;IAChB,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;IACd,cAAc;IACd,aAAa;IACb,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;;;IAGE,aAAa;IACb,sBAAsB;IACtB,cAAc;IACd,gBAAgB;IAChB,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb,cAAc;IACd,YAAY;IACZ,aAAa;IACb,qCAAqC;IACrC,0BAA0B;EAC5B;;EAEA;;IAEE,cAAc;EAChB;AACF;;AAEA;EACE;;IAEE,gBAAgB;EAClB;AACF","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Outfit:wght@400;500;600;700;800&family=Barlow+Condensed:wght@600;700&display=swap\");\n\nhtml.cm-immersive,\nhtml.cm-immersive body {\n  position: fixed;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  height: var(--lt-vvh, 100dvh);\n  overflow: hidden;\n  overscroll-behavior: none;\n}\n\nhtml.cm-immersive .cm-page,\nhtml:fullscreen .cm-page,\nhtml:-webkit-full-screen .cm-page {\n  height: var(--lt-vvh, 100dvh);\n  max-height: var(--lt-vvh, 100dvh);\n}\n\n.cm-fs-gate {\n  position: fixed;\n  top: calc(0.55rem + env(safe-area-inset-top, 0px));\n  left: 50%;\n  z-index: 120;\n  transform: translateX(-50%);\n  border: 0;\n  border-radius: 999px;\n  padding: 0.55rem 1rem;\n  background: rgba(8, 119, 188, 0.92);\n  color: #fff;\n  font-size: 0.78rem;\n  font-weight: 750;\n  box-shadow: 0 10px 28px rgba(0, 0, 0, 0.35);\n  cursor: pointer;\n}\n\n.cm-fs-gate__label {\n  white-space: nowrap;\n}\n\n.cm-sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border: 0;\n}\n\n.cm-page {\n  --cm-bg: #0b0f19;\n  --cm-slate: #121826;\n  --cm-text: #f8fafc;\n  --cm-muted: #94a3b8;\n  --cm-border: rgba(255, 255, 255, 0.08);\n  --cm-glass: rgba(15, 23, 42, 0.72);\n  --cm-primary: var(--brand-primary, #0877bc);\n  --cm-home: #34d399;\n  --cm-away: #fbbf24;\n  --cm-rec: #fb7185;\n  --cm-ease: cubic-bezier(0.16, 1, 0.3, 1);\n  box-sizing: border-box;\n  position: relative;\n  width: 100%;\n  height: 100dvh;\n  height: 100svh;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  padding: env(safe-area-inset-top, 0px) 0.7rem\n    calc(0.45rem + env(safe-area-inset-bottom, 0px));\n  background:\n    radial-gradient(1100px 520px at 8% -18%, color-mix(in srgb, var(--cm-primary) 32%, transparent), transparent 58%),\n    radial-gradient(720px 380px at 108% 4%, rgba(251, 191, 36, 0.1), transparent 52%),\n    var(--cm-bg);\n  color: var(--cm-text);\n  font-family: Outfit, Inter, var(--brand-font, sans-serif);\n}\n\n.cm-page--light {\n  --cm-bg: #f3f5f8;\n  --cm-slate: #ffffff;\n  --cm-text: #0f172a;\n  --cm-muted: #475569;\n  --cm-border: rgba(15, 23, 42, 0.08);\n  --cm-glass: rgba(255, 255, 255, 0.86);\n  --cm-home: #047857;\n  --cm-away: #b45309;\n  --cm-rec: #e11d48;\n}\n\n.cm-page * {\n  box-sizing: border-box;\n}\n\n.cm-page [hidden] {\n  display: none !important;\n}\n\n.cm-page button,\n.cm-page input,\n.cm-page textarea {\n  font: inherit;\n}\n\n.cm-status {\n  flex: 1;\n  display: grid;\n  place-items: center;\n  text-align: center;\n  color: var(--cm-muted);\n  padding: 1.5rem;\n}\n\n.cm-status a,\n.cm-status button {\n  color: var(--cm-primary);\n}\n\n.cm-head {\n  flex: 0 0 auto;\n  display: grid;\n  grid-template-columns: 36px 1fr auto;\n  gap: 0.45rem;\n  align-items: center;\n  min-height: 44px;\n}\n\n.cm-head__back,\n.cm-icon-btn {\n  width: 36px;\n  height: 36px;\n  border: 1px solid var(--cm-border);\n  border-radius: 12px;\n  background: var(--cm-glass);\n  color: var(--cm-text);\n  display: grid;\n  place-items: center;\n  cursor: pointer;\n  padding: 0;\n}\n\n.cm-head__vs {\n  min-width: 0;\n}\n\n.cm-head__prep {\n  display: inline-block;\n  margin-top: 4px;\n  font-size: 0.72rem;\n  font-weight: 700;\n  color: #7dd3fc;\n  text-decoration: none;\n}\n\n.cm-head__kicker {\n  margin: 0;\n  color: var(--cm-muted);\n  font-size: 0.62rem;\n  font-weight: 700;\n  letter-spacing: 0.12em;\n  text-transform: uppercase;\n}\n\n.cm-head h1 {\n  margin: 0;\n  font-size: 0.92rem;\n  font-weight: 800;\n  letter-spacing: -0.03em;\n  line-height: 1.15;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.cm-head__score {\n  text-align: right;\n  font-weight: 800;\n  font-size: 1.55rem;\n  letter-spacing: -0.04em;\n  line-height: 0.9;\n  font-variant-numeric: tabular-nums;\n  color: var(--cm-text);\n}\n\n.cm-head__score span {\n  display: block;\n  margin-top: 0.12rem;\n  color: var(--cm-muted);\n  font-size: 0.62rem;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n}\n\n.cm-banner {\n  flex: 0 0 auto;\n  margin: 0.3rem 0 0;\n  color: var(--cm-rec);\n  font-size: 0.75rem;\n  font-weight: 650;\n}\n\n.cm-tables {\n  flex: 0 0 auto;\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 0.3rem;\n  margin-top: 0.32rem;\n}\n\n.cm-table {\n  min-height: 44px;\n  padding: 0.28rem 0.55rem;\n  border-radius: 14px;\n  border: 1px solid var(--cm-border);\n  background: var(--cm-glass);\n  display: grid;\n  grid-template-columns: auto 1fr;\n  grid-template-rows: auto auto;\n  gap: 0.1rem 0.4rem;\n  align-items: center;\n}\n\n.cm-table strong {\n  font-size: 0.72rem;\n  font-weight: 800;\n  grid-column: 1;\n}\n\n.cm-table__meta {\n  grid-column: 2;\n  justify-self: end;\n  color: var(--cm-muted);\n  font-size: 0.66rem;\n  font-weight: 600;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 100%;\n}\n\n.cm-table__scorewatch {\n  grid-column: 1 / -1;\n  color: #7dd3fc;\n  font-size: 0.62rem;\n  font-weight: 700;\n}\n\n.cm-table__cams {\n  grid-column: 1 / -1;\n  display: inline-flex;\n  align-items: center;\n  gap: 0.28rem;\n  margin-top: 0.08rem;\n  color: var(--cm-muted);\n  font-size: 0.62rem;\n  font-weight: 700;\n}\n\n.cm-table__cams.is-on {\n  color: #7dd3fc;\n}\n\n.cm-table.has-cam {\n  border-color: color-mix(in srgb, #7dd3fc 45%, var(--cm-border));\n}\n\n.cm-table.is-live {\n  border-color: color-mix(in srgb, var(--cm-primary) 55%, var(--cm-border));\n  box-shadow: 0 0 0 1px color-mix(in srgb, var(--cm-primary) 35%, transparent);\n}\n\n.cm-table.is-selected {\n  border-color: color-mix(in srgb, var(--cm-primary) 70%, var(--cm-border));\n  box-shadow: 0 0 0 2px color-mix(in srgb, var(--cm-primary) 40%, transparent);\n  background: color-mix(in srgb, var(--cm-primary) 14%, var(--cm-glass));\n}\n\nbutton.cm-table {\n  width: 100%;\n  text-align: left;\n  color: inherit;\n  font: inherit;\n  cursor: pointer;\n}\n\nbutton.cm-table:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n\n.cm-tables--pick .cm-table.is-selected strong {\n  color: var(--cm-primary);\n}\n\n.cm-cam-strip {\n  flex: 0 0 auto;\n  display: flex;\n  align-items: center;\n  gap: 0.4rem;\n  margin: 0.35rem 0 0;\n  padding: 0.35rem 0.55rem;\n  border-radius: 999px;\n  border: 1px solid color-mix(in srgb, #7dd3fc 35%, var(--cm-border));\n  background: color-mix(in srgb, #7dd3fc 12%, var(--cm-glass));\n  color: #7dd3fc;\n  font-size: 0.72rem;\n  font-weight: 700;\n}\n\n.cm-cam-strip .cm-rec {\n  margin-left: auto;\n}\n\n.cm-status-chip {\n  flex: 1 1 100%;\n  margin: 0;\n  min-height: 34px;\n  display: grid;\n  place-items: center;\n  padding: 0 0.7rem;\n  border-radius: 12px;\n  border: 1px dashed var(--cm-border);\n  background: var(--cm-glass);\n  color: var(--cm-muted);\n  font-size: 0.74rem;\n  font-weight: 650;\n  text-align: center;\n}\n\n.cm-status-chip--ok {\n  border-style: solid;\n  border-color: color-mix(in srgb, #7dd3fc 40%, var(--cm-border));\n  color: #7dd3fc;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.35rem;\n}\n\n.cm-btn--block {\n  width: 100%;\n  flex: none;\n  min-height: 44px;\n}\n\n.cm-score-cta {\n  display: flex;\n  flex-direction: column;\n  gap: 0.45rem;\n  margin-top: 0.35rem;\n}\n\n.cm-status-chip--block {\n  width: 100%;\n  justify-content: center;\n  margin: 0;\n  box-sizing: border-box;\n}\n\n.cm-reset-discrete {\n  display: block;\n  width: 100%;\n  margin: 0.85rem 0 0;\n  padding: 0.35rem;\n  border: 0;\n  background: transparent;\n  color: var(--cm-muted);\n  font: inherit;\n  font-size: 0.72rem;\n  font-weight: 650;\n  text-decoration: underline;\n  text-underline-offset: 0.15em;\n  cursor: pointer;\n  opacity: 0.75;\n}\n\n.cm-reset-discrete:hover:not(:disabled) {\n  opacity: 1;\n  color: #fb7185;\n}\n\n.cm-reset-discrete:disabled {\n  opacity: 0.4;\n  cursor: default;\n}\n\n.cm-sheet-label {\n  margin: 0 0 0.35rem;\n  color: var(--cm-muted);\n  font-size: 0.72rem;\n  font-weight: 650;\n  flex: 0 0 auto;\n}\n\n.cm-focus-bar {\n  display: grid;\n  grid-template-columns: auto 1fr auto;\n  gap: 0.35rem;\n  align-items: center;\n  flex: 0 0 auto;\n}\n\n.cm-focus-bar__back {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.1rem;\n  min-height: 36px;\n  padding: 0 0.5rem 0 0.2rem;\n  border: 0;\n  border-radius: 10px;\n  background: transparent;\n  color: var(--cm-primary);\n  font-size: 0.72rem;\n  font-weight: 750;\n  cursor: pointer;\n}\n\n.cm-focus-bar__meta {\n  min-width: 0;\n  text-align: center;\n}\n\n.cm-focus-bar__meta em {\n  display: block;\n  font-style: normal;\n  font-size: 0.9rem;\n  font-weight: 800;\n  letter-spacing: -0.02em;\n}\n\n.cm-focus-bar__meta span {\n  display: block;\n  color: var(--cm-muted);\n  font-size: 0.68rem;\n  font-weight: 650;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.cm-icon-btn--ghost {\n  border-color: transparent;\n  background: transparent;\n  pointer-events: none;\n}\n\n/* Live score console: players + big score + equal −/+ below (no overlap) */\n.cm-scoredeck {\n  flex: 0 1 auto;\n  min-height: 0;\n  max-height: min(52dvh, 24rem);\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) auto minmax(0, 1fr);\n  gap: 0.4rem 0.35rem;\n  align-items: stretch;\n  padding: 0.65rem 0.45rem 0.7rem;\n  border-radius: 22px;\n  border: 1px solid var(--cm-border);\n  background:\n    radial-gradient(\n      120% 80% at 50% -20%,\n      color-mix(in srgb, var(--cm-primary) 22%, transparent),\n      transparent 55%\n    ),\n    var(--cm-glass);\n  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.04);\n}\n\n.cm-scoredeck__lane {\n  min-width: 0;\n  min-height: 0;\n  display: grid;\n  grid-template-rows: minmax(0, 1fr) auto auto;\n  align-content: start;\n  gap: 0.35rem;\n  overflow: hidden;\n}\n\n.cm-scoredeck__players {\n  display: flex;\n  flex-direction: column;\n  gap: 0.28rem;\n  min-height: 0;\n  max-height: 8.5rem;\n  overflow-x: hidden;\n  overflow-y: auto;\n  -webkit-overflow-scrolling: touch;\n  overscroll-behavior: contain;\n  padding-right: 0.1rem;\n}\n\n.cm-scoredeck__players--right {\n  align-items: flex-end;\n  text-align: right;\n}\n\n.cm-scoredeck__player {\n  min-width: 0;\n  max-width: 100%;\n}\n\n.cm-scoredeck__fullname {\n  display: block;\n  margin: 0;\n  color: var(--cm-text);\n  font-size: clamp(0.78rem, 3.6vw, 0.95rem);\n  font-weight: 800;\n  line-height: 1.2;\n  letter-spacing: -0.02em;\n  overflow-wrap: anywhere;\n  word-break: break-word;\n}\n\n.cm-scoredeck__meta {\n  display: block;\n  margin-top: 0.12rem;\n  color: var(--cm-muted);\n  font-size: clamp(0.62rem, 2.8vw, 0.72rem);\n  font-weight: 700;\n  line-height: 1.2;\n}\n\n.cm-scoredeck__pts {\n  margin: 0;\n  padding: 0.15rem 0;\n  text-align: center;\n  font-size: clamp(2.6rem, 14vw, 4.25rem);\n  font-weight: 800;\n  letter-spacing: -0.07em;\n  line-height: 1;\n  font-variant-numeric: tabular-nums;\n}\n\n.cm-scoredeck__btns {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 0.4rem;\n  position: relative;\n  z-index: 2;\n  --cm-score-btn: clamp(3rem, 14vw, 3.55rem);\n}\n\n.cm-scoredeck--score-edit .cm-scoredeck__pts {\n  display: none;\n}\n\n.cm-scoredeck--score-edit .cm-scoredeck__lane {\n  grid-template-rows: minmax(0, 1fr);\n}\n\n.cm-scoredeck__btn {\n  width: 100%;\n  height: var(--cm-score-btn);\n  min-height: var(--cm-score-btn);\n  border: 2px solid #f8fafc;\n  border-radius: 16px;\n  background: #0f172a;\n  color: #fff;\n  font-size: 1.65rem;\n  font-weight: 700;\n  line-height: 1;\n  display: grid;\n  place-items: center;\n  cursor: pointer;\n  padding: 0;\n  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.35);\n  transition: transform 0.12s var(--cm-ease), opacity 0.12s var(--cm-ease);\n  -webkit-tap-highlight-color: transparent;\n  touch-action: manipulation;\n  user-select: none;\n}\n\n.cm-scoredeck__btn:active:not(:disabled) {\n  transform: scale(0.94);\n}\n\n.cm-scoredeck__btn:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n  pointer-events: none;\n  filter: grayscale(0.2);\n}\n\n.cm-scoredeck__btn--plus {\n  color: #fff;\n}\n\n.cm-scoredeck__btn--home {\n  background: var(--cm-primary, #0877bc);\n  border-color: #f8fafc;\n  box-shadow: 0 8px 18px color-mix(in srgb, var(--cm-primary) 42%, transparent);\n}\n\n.cm-scoredeck__btn--away {\n  background: #d97706;\n  border-color: #f8fafc;\n  box-shadow: 0 8px 18px rgba(217, 119, 6, 0.42);\n}\n\n.cm-page--light .cm-scoredeck__btn {\n  background: #0f172a;\n  color: #fff;\n  border-color: #0f172a;\n}\n\n.cm-page--light .cm-scoredeck__btn--home {\n  background: var(--cm-primary, #0877bc);\n  border-color: #0f172a;\n  color: #fff;\n}\n\n.cm-page--light .cm-scoredeck__btn--away {\n  background: #b45309;\n  border-color: #0f172a;\n  color: #fff;\n}\n\n.cm-scoredeck__sets {\n  align-self: center;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 0.15rem;\n  min-width: 3rem;\n  padding: 0.55rem 0.3rem;\n  border-radius: 14px;\n  border: 1px solid var(--cm-border);\n  background: rgba(0, 0, 0, 0.22);\n}\n\n.cm-page--light .cm-scoredeck__sets {\n  background: rgba(15, 23, 42, 0.04);\n}\n\n.cm-scoredeck__sets strong {\n  font-size: 1.15rem;\n  font-weight: 800;\n  letter-spacing: -0.03em;\n  font-variant-numeric: tabular-nums;\n  line-height: 1;\n}\n\n.cm-scoredeck__lane.is-winner .cm-scoredeck__pts {\n  color: #f5d76e;\n  text-shadow: 0 0 18px color-mix(in srgb, #f5d76e 45%, transparent);\n}\n\n.cm-scoredeck__lane.is-winner .cm-scoredeck__fullname {\n  color: #f5d76e;\n}\n\n.cm-page--light .cm-scoredeck__lane.is-winner .cm-scoredeck__pts,\n.cm-page--light .cm-scoredeck__lane.is-winner .cm-scoredeck__fullname {\n  color: #b45309;\n}\n\n.cm-scoredeck.is-set-over {\n  box-shadow:\n    inset 0 1px 0 rgba(255, 255, 255, 0.06),\n    0 0 0 1px color-mix(in srgb, #f5d76e 35%, transparent);\n}\n\n.cm-set-banner {\n  margin: 0.15rem 0 0;\n  padding: 0.45rem 0.7rem;\n  border-radius: 14px;\n  text-align: center;\n  font-size: 0.92rem;\n  font-weight: 800;\n  letter-spacing: -0.02em;\n  background: color-mix(in srgb, #f5d76e 18%, var(--cm-glass));\n  border: 1px solid color-mix(in srgb, #f5d76e 40%, var(--cm-border));\n}\n\n.cm-set-banner.is-home {\n  background: color-mix(in srgb, var(--cm-primary) 22%, var(--cm-glass));\n  border-color: color-mix(in srgb, var(--cm-primary) 45%, var(--cm-border));\n}\n\n.cm-set-banner.is-away {\n  background: color-mix(in srgb, var(--cm-away) 22%, var(--cm-glass));\n  border-color: color-mix(in srgb, var(--cm-away) 45%, var(--cm-border));\n}\n\n.cm-btn--start-set {\n  margin-top: 0.15rem;\n  min-height: 48px;\n  font-weight: 800;\n}\n\n.cm-scoredeck__sets span {\n  color: var(--cm-muted);\n  font-size: 0.58rem;\n  font-weight: 750;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n}\n\n.cm-score-modes {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 0.28rem;\n  flex: 0 0 auto;\n}\n\n.cm-score-modes button {\n  min-height: 34px;\n  border: 1px solid var(--cm-border);\n  border-radius: 999px;\n  background: var(--cm-glass);\n  color: var(--cm-muted);\n  font-size: 0.68rem;\n  font-weight: 700;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.28rem;\n  cursor: pointer;\n}\n\n.cm-score-modes button.is-on {\n  background: var(--cm-primary);\n  border-color: var(--cm-primary);\n  color: #fff;\n}\n\n.cm-follow--compact {\n  flex: 0 0 auto;\n  min-height: 0;\n  padding: 0.55rem;\n  font-size: 0.78rem;\n}\n\n.cm-rec {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.28rem;\n  color: var(--cm-rec);\n  font-size: 0.62rem;\n  font-weight: 800;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n}\n\n.cm-rec i {\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  background: var(--cm-rec);\n  animation: cm-pulse 1.1s var(--cm-ease) infinite;\n}\n\n.cm-head__rec {\n  display: inline-flex;\n  margin-top: 0.28rem;\n  justify-content: flex-end;\n}\n\n.cm-table__rec {\n  margin-left: 0.28rem;\n  vertical-align: middle;\n}\n\n.cm-preview-badge {\n  color: #e2e8f0;\n  font-size: 0.62rem;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n}\n\n.cm-tabs__icon {\n  position: relative;\n  display: inline-flex;\n}\n\n.cm-tabs__rec {\n  position: absolute;\n  top: -2px;\n  right: -6px;\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  background: var(--cm-rec);\n  animation: cm-pulse 1.1s var(--cm-ease) infinite;\n}\n\n@keyframes cm-pulse {\n  50% {\n    opacity: 0.35;\n  }\n}\n\n.cm-cam-perm {\n  flex: 0 0 auto;\n  margin-top: 0.45rem;\n  padding: 0.65rem 0.75rem;\n  border-radius: 14px;\n  border: 1px solid color-mix(in srgb, var(--cm-rec) 42%, var(--cm-border));\n  background: color-mix(in srgb, var(--cm-rec) 14%, var(--cm-glass));\n  color: var(--cm-text);\n  font-size: 0.78rem;\n  line-height: 1.4;\n  font-weight: 600;\n}\n\n.cm-actions {\n  flex: 0 0 auto;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.35rem;\n  margin-top: 0.4rem;\n}\n\n.cm-btn {\n  flex: 1 1 auto;\n  min-width: calc(50% - 0.2rem);\n  min-height: 34px;\n  border: 0;\n  border-radius: 12px;\n  background: var(--cm-primary);\n  color: #fff;\n  font-size: 0.78rem;\n  font-weight: 700;\n  cursor: pointer;\n  padding: 0 0.6rem;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.3rem;\n}\n\n.cm-btn:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n.cm-btn--ghost {\n  background: transparent;\n  color: var(--cm-text);\n  border: 1px solid var(--cm-border);\n}\n\n.cm-btn--danger {\n  background: var(--cm-rec);\n}\n\n.cm-btn--rec {\n  background: var(--cm-rec);\n  color: #fff;\n}\n\n.cm-body {\n  flex: 1 1 auto;\n  min-height: 0;\n  margin-top: 0.45rem;\n  display: flex;\n  flex-direction: column;\n  position: relative;\n}\n\n.cm-panel {\n  flex: 1;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.cm-scroll {\n  flex: 1;\n  min-height: 0;\n  overflow: auto;\n  -webkit-overflow-scrolling: touch;\n}\n\n.cm-scroll--sheet {\n  display: flex;\n  flex-direction: column;\n  overscroll-behavior: contain;\n  touch-action: pan-y;\n  padding-bottom: 0.25rem;\n}\n\n.cm-scroll--sheet .cm-rubbers--sheet {\n  flex: 0 0 auto;\n  min-height: auto;\n  overflow: visible;\n  padding-bottom: calc(0.75rem + env(safe-area-inset-bottom, 0px));\n}\n\n.cm-rubbers {\n  flex: 1 1 auto;\n  min-height: 0;\n  display: grid;\n  grid-template-columns: repeat(5, minmax(0, 1fr));\n  gap: 0.28rem;\n  overflow: auto;\n}\n\n.cm-rubbers--sheet {\n  /* Scroll the list; size rows to content so names are never clipped. */\n  flex: 1 1 auto;\n  min-height: 0;\n  grid-template-columns: 1fr;\n  grid-auto-rows: min-content;\n  align-content: start;\n  gap: 0.45rem;\n  padding-bottom: calc(0.75rem + env(safe-area-inset-bottom, 0px));\n  overflow-x: hidden;\n  overflow-y: auto;\n  -webkit-overflow-scrolling: touch;\n  overscroll-behavior: contain;\n  touch-action: pan-y;\n}\n\n.cm-rubber {\n  min-height: 38px;\n  border: 1px solid var(--cm-border);\n  border-radius: 12px;\n  background: var(--cm-glass);\n  color: var(--cm-text);\n  padding: 0.2rem 0.15rem;\n  cursor: pointer;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 0.05rem;\n}\n\n.cm-rubber em {\n  font-style: normal;\n  font-size: 0.62rem;\n  font-weight: 800;\n}\n\n.cm-rubber span {\n  font-size: 0.58rem;\n  font-weight: 700;\n  font-variant-numeric: tabular-nums;\n  color: var(--cm-muted);\n}\n\n.cm-rubber__names {\n  max-width: 100%;\n  padding: 0 0.1rem;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  font-size: 0.52rem !important;\n  font-weight: 650 !important;\n  line-height: 1.1;\n}\n\n.cm-rubber.is-live {\n  border-color: color-mix(in srgb, var(--cm-primary) 60%, transparent);\n  background: color-mix(in srgb, var(--cm-primary) 18%, var(--cm-glass));\n}\n\n.cm-rubber.is-on {\n  box-shadow: inset 0 0 0 1.5px var(--cm-primary);\n}\n\n.cm-rubber.is-done span {\n  color: var(--cm-text);\n}\n\n.cm-rubber-card {\n  width: 100%;\n  border: 1px solid var(--cm-border);\n  border-radius: 18px;\n  background: var(--cm-glass);\n  color: var(--cm-text);\n  padding: 0.75rem 0.8rem;\n  cursor: pointer;\n  text-align: left;\n  display: flex;\n  flex-direction: column;\n  gap: 0.55rem;\n  -webkit-tap-highlight-color: transparent;\n  position: relative;\n  /* overflow:hidden + grid compression was clipping player names */\n  overflow: visible;\n  min-height: min-content;\n  flex-shrink: 0;\n}\n\n.cm-rubber-card.is-readonly {\n  cursor: default;\n  gap: 0.55rem;\n  padding: 0.75rem 0.8rem 0.85rem;\n  background:\n    linear-gradient(\n      180deg,\n      color-mix(in srgb, var(--cm-primary) 10%, transparent),\n      transparent 38%\n    ),\n    var(--cm-glass);\n}\n\n.cm-rubber-card.is-readonly .cm-rubber-card__top {\n  order: -1;\n  padding-bottom: 0.15rem;\n  border-bottom: 1px solid color-mix(in srgb, var(--cm-border) 70%, transparent);\n  margin-bottom: 0.05rem;\n}\n\n.cm-rubber-card.is-readonly .cm-rubber-card__scoreline {\n  margin-left: auto;\n}\n\n.cm-rubber-card.is-readonly .cm-rubber-card__setn {\n  font-size: 1.35rem;\n}\n\n.cm-rubber-card.is-readonly .cm-rubber-card__setn.is-win {\n  font-size: 1.48rem;\n}\n\n.cm-rubber-card.is-readonly .cm-rubber-card__review {\n  order: 3;\n}\n\n.cm-rubber-card__top {\n  display: flex;\n  align-items: center;\n  gap: 0.4rem;\n  flex-wrap: wrap;\n}\n\n.cm-rubber-card__top em {\n  font-style: normal;\n  font-size: 0.85rem;\n  font-weight: 800;\n  letter-spacing: -0.02em;\n}\n\n.cm-rubber-card__table {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.22rem;\n  color: var(--cm-muted);\n  font-size: 0.7rem;\n  font-weight: 700;\n}\n\n.cm-rubber-card__table.has-cam {\n  color: var(--cm-text);\n}\n\n.cm-rubber-card__scoreline {\n  margin-left: auto;\n  display: inline-flex;\n  align-items: baseline;\n  gap: 0.18rem;\n  font-variant-numeric: tabular-nums;\n}\n\n.cm-rubber-card__points {\n  flex-basis: 100%;\n  margin: 0.05rem 0 0;\n  font-size: 0.72rem;\n  font-weight: 700;\n  letter-spacing: 0.01em;\n  font-variant-numeric: tabular-nums;\n  color: var(--cm-muted);\n}\n\n.cm-rubber-card__setn {\n  font-size: 1.15rem;\n  font-weight: 800;\n  letter-spacing: -0.03em;\n  color: var(--cm-muted);\n  min-width: 0.9em;\n  text-align: center;\n}\n\n.cm-rubber-card__setn.is-win {\n  color: var(--cm-home);\n  font-size: 1.28rem;\n}\n\n.cm-rubber-card__setn.is-lose {\n  color: var(--cm-muted);\n  opacity: 0.72;\n}\n\n.cm-rubber-card__score-sep {\n  color: var(--cm-muted);\n  font-size: 0.95rem;\n  font-weight: 700;\n}\n\n.cm-rubber-card__badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.22rem;\n  padding: 0.14rem 0.45rem;\n  border-radius: 999px;\n  background: color-mix(in srgb, var(--cm-primary) 28%, transparent);\n  color: var(--cm-text);\n  font-size: 0.58rem;\n  font-weight: 800;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n}\n\n.cm-rubber-card__badge--live i {\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background: #fb7185;\n  animation: cm-pulse 1.1s var(--cm-ease) infinite;\n}\n\n.cm-rubber-card__badge--live {\n  background: color-mix(in srgb, #fb7185 28%, transparent);\n  color: #fecdd3;\n}\n\n.cm-rubber-card__badge--final {\n  background: color-mix(in srgb, var(--cm-home) 22%, transparent);\n  color: color-mix(in srgb, var(--cm-home) 70%, #fff);\n}\n\n.cm-rubber-card__badge--done {\n  background: rgba(148, 163, 184, 0.22);\n}\n\n.cm-rubber-card__vs,\n.cm-rubber-card__matchup {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) auto minmax(0, 1fr);\n  gap: 0.45rem;\n  align-items: start;\n  width: 100%;\n  flex: 0 0 auto;\n}\n\n.cm-rubber-card__side,\n.cm-rubber-card__fighter {\n  position: relative;\n  z-index: 1;\n  min-width: 0;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 0.2rem;\n  padding: 0.45rem 0.5rem;\n  border-radius: 12px;\n  border: 1px solid transparent;\n  background: rgba(255, 255, 255, 0.06);\n  isolation: isolate;\n}\n\n.cm-page--light .cm-rubber-card__fighter {\n  background: rgba(15, 23, 42, 0.05);\n}\n\n.cm-rubber-card__side--away,\n.cm-rubber-card__fighter--away {\n  text-align: right;\n  align-items: flex-end;\n}\n\n.cm-rubber-card__fighter.is-winner {\n  background: color-mix(in srgb, var(--cm-home) 16%, transparent);\n  border-color: color-mix(in srgb, var(--cm-home) 42%, transparent);\n}\n\n.cm-rubber-card__fighter.is-winner .cm-rubber-card__names-line {\n  color: var(--cm-home) !important;\n}\n\n.cm-rubber-card__fighter.is-loser {\n  opacity: 1;\n  background: color-mix(in srgb, var(--cm-rec) 16%, transparent);\n  border-color: color-mix(in srgb, var(--cm-rec) 42%, transparent);\n}\n\n.cm-rubber-card__fighter.is-loser .cm-rubber-card__names-line {\n  opacity: 1;\n  color: var(--cm-rec) !important;\n}\n\n.cm-page--light .cm-rubber-card__fighter.is-winner .cm-rubber-card__names-line {\n  color: var(--cm-home) !important;\n}\n\n.cm-page--light .cm-rubber-card__fighter.is-loser .cm-rubber-card__names-line {\n  color: var(--cm-rec) !important;\n}\n\n.cm-rubber-card__result {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.22rem;\n  font-size: 0.62rem;\n  font-weight: 800;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n}\n\n.cm-rubber-card__result--win {\n  color: var(--cm-home);\n}\n\n.cm-rubber-card__result--lose {\n  color: var(--cm-rec);\n}\n\n.cm-rubber-card__fighter--away .cm-rubber-card__result {\n  flex-direction: row-reverse;\n}\n\n.cm-rubber-card__names-line {\n  display: block;\n  margin: 0;\n  color: #f8fafc !important;\n  font-size: clamp(1rem, 4.4vw, 1.18rem) !important;\n  font-weight: 800 !important;\n  line-height: 1.3 !important;\n  letter-spacing: -0.02em;\n  overflow-wrap: anywhere;\n  word-break: break-word;\n  white-space: normal;\n  opacity: 1 !important;\n  visibility: visible !important;\n  min-height: 1.3em;\n}\n\n.cm-page--light .cm-rubber-card__names-line {\n  color: #0f172a !important;\n}\n\n.cm-rubber-card__meta-line {\n  display: block;\n  margin: 0;\n  color: var(--cm-muted);\n  font-size: 0.68rem;\n  font-weight: 700;\n  line-height: 1.2;\n}\n\n.cm-rubber-card__names {\n  display: flex;\n  flex-direction: column;\n  gap: 0.28rem;\n  width: 100%;\n  min-width: 0;\n}\n\n.cm-rubber-card__player {\n  min-width: 0;\n}\n\n.cm-rubber-card__player strong {\n  display: block;\n  font-size: clamp(0.88rem, 3.8vw, 1.02rem);\n  font-weight: 800;\n  line-height: 1.25;\n  letter-spacing: -0.02em;\n  color: var(--cm-text);\n  overflow-wrap: anywhere;\n  word-break: break-word;\n}\n\n.cm-rubber-card__side.is-winner .cm-rubber-card__player strong {\n  font-weight: 800;\n}\n\n.cm-rubber-card__player span {\n  display: block;\n  margin-top: 0.08rem;\n  color: var(--cm-muted);\n  font-size: 0.68rem;\n  font-weight: 700;\n}\n\n.cm-rubber-card__sep {\n  align-self: center;\n  color: var(--cm-muted);\n  font-size: 0.78rem;\n  font-weight: 800;\n  letter-spacing: 0.04em;\n  text-transform: none;\n  padding-top: 0.15rem;\n}\n\n.cm-rubber-card.is-live {\n  border-color: color-mix(in srgb, var(--cm-primary) 55%, transparent);\n  background: color-mix(in srgb, var(--cm-primary) 14%, var(--cm-glass));\n}\n\n.cm-rubber-card.is-on {\n  box-shadow: inset 0 0 0 1.5px var(--cm-primary);\n}\n\n.cm-rubber-card.is-done {\n  border-color: color-mix(in srgb, var(--cm-home) 28%, var(--cm-border));\n  background:\n    linear-gradient(\n      90deg,\n      color-mix(in srgb, var(--cm-home) 18%, transparent),\n      transparent 42%\n    ),\n    var(--cm-glass);\n  box-shadow: inset 3px 0 0 var(--cm-home);\n}\n\n.cm-rubber-card.is-readonly:active {\n  transform: none;\n}\n\n.cm-rubber-card.is-done.is-winner-away {\n  background:\n    linear-gradient(\n      270deg,\n      color-mix(in srgb, var(--cm-home) 18%, transparent),\n      transparent 42%\n    ),\n    var(--cm-glass);\n  box-shadow: inset -3px 0 0 var(--cm-home);\n}\n\n.cm-live {\n  flex: 1;\n  min-height: 0;\n  margin-top: 0.4rem;\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n  overflow-x: hidden;\n  overflow-y: auto;\n  -webkit-overflow-scrolling: touch;\n  overscroll-behavior: contain;\n  padding-bottom: 0.35rem;\n}\n\n.cm-live__meta {\n  display: flex;\n  justify-content: space-between;\n  gap: 0.4rem;\n  align-items: baseline;\n  min-height: 1.1rem;\n}\n\n.cm-live__meta strong {\n  font-size: 0.82rem;\n  font-weight: 750;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.cm-live__meta span {\n  color: var(--cm-muted);\n  font-size: 0.68rem;\n  font-weight: 650;\n  flex-shrink: 0;\n}\n\n.cm-edit-score {\n  flex: 0 0 auto;\n  display: grid;\n  grid-template-columns: 1fr auto 1fr;\n  gap: 0.45rem;\n  align-items: end;\n  padding: 0.2rem 0 0.35rem;\n  position: relative;\n  z-index: 3;\n}\n\n.cm-edit-score label {\n  display: flex;\n  flex-direction: column;\n  gap: 0.28rem;\n  min-width: 0;\n  font-size: 0.72rem;\n  font-weight: 700;\n  color: var(--cm-muted);\n  line-height: 1.2;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.cm-edit-score label input {\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.cm-edit-score input {\n  min-height: 64px;\n  border: 2px solid color-mix(in srgb, var(--cm-primary) 45%, var(--cm-border));\n  border-radius: 14px;\n  background: #0b1220;\n  color: #f8fafc;\n  -webkit-text-fill-color: #f8fafc;\n  caret-color: #38bdf8;\n  color-scheme: dark;\n  font-size: 1.85rem;\n  font-weight: 800;\n  text-align: center;\n  font-variant-numeric: tabular-nums;\n  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.06);\n}\n\n.cm-edit-score input:focus {\n  outline: none;\n  border-color: #38bdf8;\n  box-shadow: 0 0 0 3px color-mix(in srgb, #38bdf8 28%, transparent);\n}\n\n.cm-edit-score input::placeholder {\n  color: #64748b;\n  -webkit-text-fill-color: #64748b;\n}\n\n.cm-page--light .cm-edit-score input {\n  background: #ffffff;\n  color: #0f172a;\n  -webkit-text-fill-color: #0f172a;\n  caret-color: var(--cm-primary);\n  color-scheme: light;\n  border-color: color-mix(in srgb, var(--cm-primary) 35%, #cbd5e1);\n  box-shadow: inset 0 0 0 1px rgba(15, 23, 42, 0.04);\n}\n\n.cm-edit-score > span {\n  font-size: 1.4rem;\n  font-weight: 800;\n  padding-bottom: 0.85rem;\n  color: var(--cm-text);\n}\n\n.cm-edit-score .cm-btn {\n  grid-column: 1 / -1;\n}\n\n.cm-head__live-score {\n  display: block;\n  font-size: 1.85rem;\n  font-weight: 800;\n  letter-spacing: -0.05em;\n  font-variant-numeric: tabular-nums;\n  line-height: 0.95;\n}\n\n.cm-head__match-hint {\n  margin: 0.18rem 0 0;\n  color: var(--cm-muted);\n  font-size: 0.66rem;\n  font-weight: 650;\n}\n\n.cm-match-status {\n  flex: 0 0 auto;\n  display: flex;\n  align-items: center;\n  gap: 0.55rem;\n  margin-top: 0.35rem;\n  padding: 0.4rem 0.6rem;\n  border-radius: 14px;\n  border: 1px solid var(--cm-border);\n  background: var(--cm-glass);\n  font-size: 0.72rem;\n  font-weight: 700;\n}\n\n.cm-match-status .cm-rec {\n  margin-left: auto;\n}\n\n.cm-cam__context {\n  margin: 0;\n  padding: 0.35rem 0.55rem;\n  border-radius: 999px;\n  border: 1px solid color-mix(in srgb, var(--cm-primary) 40%, var(--cm-border));\n  background: color-mix(in srgb, var(--cm-primary) 14%, var(--cm-glass));\n  color: var(--cm-text);\n  font-size: 0.72rem;\n  font-weight: 700;\n  text-align: center;\n}\n\n.cm-page--in-match .cm-head h1 {\n  font-size: 0.98rem;\n}\n\n.cm-chip:disabled {\n  opacity: 0.35;\n  cursor: not-allowed;\n}\n\n.cm-follow {\n  flex: 1;\n  display: grid;\n  place-items: center;\n  text-align: center;\n  color: var(--cm-muted);\n  font-size: 0.86rem;\n  padding: 0.6rem;\n  border-radius: 16px;\n  border: 1px solid var(--cm-border);\n  background: var(--cm-glass);\n}\n\n.cm-stamps {\n  flex: 0 0 auto;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: stretch;\n  gap: 0.35rem;\n  margin-top: 0.35rem;\n  padding: 0.15rem 0 0.1rem;\n  max-height: none;\n  overflow: visible;\n}\n\n.cm-stamps-wrap {\n  flex: 0 0 auto;\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n  margin-top: 0.35rem;\n}\n\n.cm-timeout-toggle {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.45rem;\n  width: 100%;\n  min-height: 2.6rem;\n  border-radius: 12px;\n  border: 1px solid color-mix(in srgb, #c45c26 45%, var(--cm-border));\n  background: color-mix(in srgb, #c45c26 16%, var(--cm-glass));\n  color: var(--cm-text);\n  font-weight: 750;\n  font-size: 0.9rem;\n  cursor: pointer;\n}\n\n.cm-timeout-toggle.is-on {\n  border-color: color-mix(in srgb, #0a7a3e 50%, var(--cm-border));\n  background: color-mix(in srgb, #0a7a3e 18%, var(--cm-glass));\n}\n\n.cm-timeout-toggle:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n.cm-timeout-toggle__mark {\n  display: inline-flex;\n}\n\n.cm-timeout-banner {\n  margin: 0;\n  padding: 0.45rem 0.65rem;\n  border-radius: 10px;\n  font-size: 0.78rem;\n  line-height: 1.35;\n  color: var(--cm-text);\n  background: color-mix(in srgb, #c45c26 12%, var(--cm-glass));\n  border: 1px solid color-mix(in srgb, #c45c26 28%, var(--cm-border));\n}\n\n.cm-tagchip:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n.cm-tagchip {\n  --tag-accent: var(--cm-primary);\n  --tag-fill: color-mix(in srgb, var(--tag-accent) 14%, var(--cm-glass));\n  display: inline-flex;\n  align-items: center;\n  gap: 0.35rem;\n  min-width: 0;\n  min-height: 2.35rem;\n  max-width: 100%;\n  border: 1px solid color-mix(in srgb, var(--tag-accent) 35%, var(--cm-border));\n  border-radius: 12px;\n  background: var(--tag-fill);\n  color: var(--cm-text);\n  padding: 0.28rem 0.55rem 0.28rem 0.35rem;\n  cursor: pointer;\n  box-sizing: border-box;\n  flex: 1 1 calc(33.333% - 0.35rem);\n  transition: transform 0.12s var(--cm-ease), border-color 0.15s ease,\n    background 0.15s ease, box-shadow 0.15s ease;\n}\n\n.cm-tagchip__mark {\n  flex: 0 0 auto;\n  width: 1.55rem;\n  height: 1.55rem;\n  border-radius: 8px;\n  display: grid;\n  place-items: center;\n  background: color-mix(in srgb, var(--tag-accent) 22%, transparent);\n  color: var(--tag-accent);\n}\n\n.cm-tagchip__text {\n  flex: 1 1 auto;\n  min-width: 0;\n  font-size: clamp(0.62rem, 2.6vw, 0.74rem);\n  font-weight: 750;\n  line-height: 1.15;\n  letter-spacing: -0.01em;\n  text-align: left;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.cm-tagchip--serve {\n  --tag-accent: #38bdf8;\n}\n\n.cm-tagchip--error {\n  --tag-accent: #fb7185;\n}\n\n.cm-tagchip--winner {\n  --tag-accent: #34d399;\n}\n\n.cm-tagchip--moment {\n  --tag-accent: #a78bfa;\n}\n\n.cm-tagchip--schema {\n  --tag-accent: #fbbf24;\n}\n\n.cm-tagchip--more {\n  --tag-accent: var(--cm-primary);\n  flex: 1 1 calc(33.333% - 0.35rem);\n  border-style: dashed;\n}\n\n.cm-tagchip.is-on {\n  background: color-mix(in srgb, var(--tag-accent) 28%, var(--cm-glass));\n  border-color: color-mix(in srgb, var(--tag-accent) 72%, transparent);\n  box-shadow: inset 0 0 0 1px color-mix(in srgb, var(--tag-accent) 35%, transparent);\n}\n\n.cm-tagchip.is-on .cm-tagchip__mark {\n  background: var(--tag-accent);\n  color: #0b0f19;\n}\n\n.cm-page--light .cm-tagchip.is-on .cm-tagchip__mark {\n  color: #fff;\n}\n\n.cm-tagchip:active {\n  transform: scale(0.97);\n}\n\n.cm-tagdock {\n  flex: 0 1 auto;\n  min-height: 0;\n  max-height: min(48dvh, 22rem);\n  display: flex;\n  flex-direction: column;\n  gap: 0.45rem;\n  margin-top: 0.35rem;\n  padding: 0.55rem 0.55rem 0.45rem;\n  border-radius: 16px;\n  border: 1px solid var(--cm-border);\n  background: var(--cm-slate);\n  overflow: hidden;\n  position: relative;\n  z-index: 2;\n}\n\n.cm-tagdock__head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.5rem;\n  flex: 0 0 auto;\n}\n\n.cm-tagdock__head strong {\n  font-size: 0.82rem;\n  font-weight: 800;\n  letter-spacing: -0.01em;\n}\n\n.cm-tagdock__close {\n  width: 2rem;\n  height: 2rem;\n  border: 1px solid var(--cm-border);\n  border-radius: 999px;\n  background: transparent;\n  color: var(--cm-text);\n  display: grid;\n  place-items: center;\n  cursor: pointer;\n  flex: 0 0 auto;\n}\n\n.cm-tagdock__scroll {\n  flex: 1 1 auto;\n  min-height: 0;\n  overflow-x: hidden;\n  overflow-y: auto;\n  -webkit-overflow-scrolling: touch;\n  display: flex;\n  flex-direction: column;\n  gap: 0.65rem;\n  padding-bottom: 0.15rem;\n}\n\n.cm-tagdock__group {\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n  min-width: 0;\n}\n\n.cm-tagdock__label {\n  margin: 0;\n  font-size: 0.66rem;\n  font-weight: 750;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: var(--cm-muted);\n}\n\n.cm-tagdock__chips {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.35rem;\n}\n\n.cm-tagdock__chips .cm-tagchip {\n  flex: 1 1 calc(50% - 0.35rem);\n  max-width: calc(50% - 0.18rem);\n}\n\n/* Legacy stamp used only if referenced elsewhere */\n.cm-stamp {\n  min-width: 0;\n  min-height: 2.35rem;\n  border: 1px solid var(--cm-border);\n  border-radius: 12px;\n  background: var(--cm-glass);\n  color: var(--cm-text);\n  font-size: 0.7rem;\n  font-weight: 700;\n  padding: 0.28rem 0.45rem;\n  cursor: pointer;\n}\n\n.cm-stamp.is-on {\n  background: color-mix(in srgb, var(--cm-primary) 22%, var(--cm-glass));\n  border-color: color-mix(in srgb, var(--cm-primary) 55%, transparent);\n}\n\n.cm-btn--dock {\n  background: color-mix(in srgb, #0f172a 70%, var(--cm-primary));\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.35rem;\n}\n\n.cm-calib {\n  position: fixed;\n  inset: 0;\n  z-index: 90;\n  display: flex;\n  flex-direction: column;\n  background: #000;\n  padding: env(safe-area-inset-top, 0) 0 env(safe-area-inset-bottom, 0);\n}\n\n.cm-calib__stage {\n  position: relative;\n  flex: 1;\n  min-height: 0;\n  background: #000;\n}\n\n.cm-calib__video {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n  background: #000;\n}\n\n.cm-calib__hint {\n  flex: 0 0 auto;\n  margin: 0;\n  padding: 0.55rem 0.85rem;\n  color: #cbd5e1;\n  font-size: 0.75rem;\n  font-weight: 650;\n  text-align: center;\n  background: #0b1220;\n}\n\n.cm-cam-settings {\n  position: fixed;\n  inset: 0;\n  z-index: 92;\n  display: grid;\n  place-items: end center;\n  padding: 0.85rem;\n  padding-bottom: calc(0.85rem + env(safe-area-inset-bottom, 0px));\n  background: rgba(2, 6, 23, 0.55);\n}\n\n.cm-cam-settings__card {\n  width: min(420px, 100%);\n  border-radius: 18px;\n  border: 1px solid var(--cm-border);\n  background: var(--cm-slate);\n  padding: 0.85rem;\n  box-shadow: 0 18px 40px rgba(0, 0, 0, 0.35);\n  display: flex;\n  flex-direction: column;\n  gap: 0.55rem;\n  max-height: min(92dvh, 720px);\n}\n\n.cm-cam-settings__head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.5rem;\n}\n\n.cm-cam-settings__head strong {\n  font-size: 0.95rem;\n  font-weight: 800;\n}\n\n.cm-cam-settings__stage {\n  position: relative;\n  width: 100%;\n  aspect-ratio: 3 / 4;\n  max-height: 48dvh;\n  border-radius: 14px;\n  overflow: hidden;\n  background: #0b1220;\n  touch-action: none;\n  user-select: none;\n  -webkit-user-select: none;\n}\n\n.cm-cam-settings__preview {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n  transform-origin: center center;\n  pointer-events: none;\n}\n\n.cm-cam-settings__zoom-pill {\n  position: absolute;\n  top: 0.55rem;\n  right: 0.55rem;\n  z-index: 2;\n  padding: 0.22rem 0.5rem;\n  border-radius: 999px;\n  background: rgba(2, 6, 23, 0.72);\n  color: #f8fafc;\n  font-size: 0.72rem;\n  font-weight: 800;\n  letter-spacing: 0.02em;\n  pointer-events: none;\n}\n\n.cm-cam-settings__hint {\n  margin: 0;\n  color: var(--cm-muted);\n  font-size: 0.74rem;\n  font-weight: 650;\n}\n\n.cm-cam-settings__cams {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 0.4rem;\n}\n\n.cm-cam-settings__cam {\n  min-height: 44px;\n  border: 1px solid var(--cm-border);\n  border-radius: 12px;\n  background: var(--cm-glass);\n  color: var(--cm-text);\n  font-size: 0.82rem;\n  font-weight: 750;\n  cursor: pointer;\n}\n\n.cm-cam-settings__cam.is-on {\n  background: var(--cm-primary);\n  border-color: var(--cm-primary);\n  color: #fff;\n}\n\n.cm-cam-settings__cam:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n.cm-cam-settings__reset {\n  width: 100%;\n}\n\n.cm-cam-settings__encode {\n  display: flex;\n  flex-direction: column;\n  gap: 0.4rem;\n  margin-top: 0.85rem;\n}\n\n.cm-cam-settings__encode-label {\n  font-size: 0.72rem;\n  letter-spacing: 0.02em;\n  opacity: 0.72;\n}\n\n.cm-cam-settings__encode-row {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.35rem;\n}\n\n.cm-cam-settings--landscape {\n  place-items: stretch;\n  padding: 0;\n  background: #000;\n  pointer-events: none;\n}\n\n.cm-cam-settings--landscape .cm-cam-settings__close,\n.cm-cam-settings--landscape .cm-cam-settings__cams,\n.cm-cam-settings--landscape .cm-cam-settings__zoom-pill {\n  pointer-events: auto;\n}\n\n.cm-cam-settings--landscape .cm-cam-settings__close {\n  position: absolute;\n  top: calc(0.55rem + env(safe-area-inset-top, 0px));\n  right: calc(0.55rem + env(safe-area-inset-right, 0px));\n  z-index: 3;\n  min-height: 40px;\n  padding: 0.4rem 0.85rem;\n  border-radius: 999px;\n  border: 1px solid rgba(255, 255, 255, 0.35);\n  background: rgba(0, 0, 0, 0.28);\n  color: #fff;\n  font-size: 0.78rem;\n  font-weight: 750;\n  backdrop-filter: blur(8px);\n  -webkit-backdrop-filter: blur(8px);\n}\n\n.cm-cam-settings--landscape .cm-cam-settings__zoom-pill {\n  position: absolute;\n  top: calc(0.55rem + env(safe-area-inset-top, 0px));\n  left: calc(0.55rem + env(safe-area-inset-left, 0px));\n  z-index: 3;\n  right: auto;\n}\n\n.cm-cam-settings__cams--overlay {\n  position: absolute;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 3;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  gap: 0.4rem;\n  padding: 0.55rem\n    calc(0.55rem + env(safe-area-inset-right, 0px))\n    calc(0.7rem + env(safe-area-inset-bottom, 0px))\n    calc(0.55rem + env(safe-area-inset-left, 0px));\n  background: transparent;\n}\n\n.cm-cam-settings--landscape .cm-cam-settings__cam {\n  min-height: 42px;\n  padding: 0.4rem 0.85rem;\n  border-radius: 999px;\n  border: 1px solid rgba(255, 255, 255, 0.38);\n  background: rgba(0, 0, 0, 0.28);\n  color: #fff;\n  font-size: 0.78rem;\n  font-weight: 750;\n  backdrop-filter: blur(8px);\n  -webkit-backdrop-filter: blur(8px);\n  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.25);\n}\n\n.cm-cam-settings--landscape .cm-cam-settings__cam.is-on {\n  background: rgba(8, 119, 188, 0.72);\n  border-color: rgba(255, 255, 255, 0.55);\n  color: #fff;\n}\n\n.cm-cam-record-canvas {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  opacity: 0;\n  pointer-events: none;\n  overflow: hidden;\n}\n\n.cm-score-jump {\n  position: fixed;\n  inset: 0;\n  z-index: 160;\n  display: grid;\n  place-items: center;\n  padding: 1.25rem;\n  background: rgba(2, 6, 23, 0.72);\n}\n\n.cm-score-jump__card {\n  width: min(22rem, 100%);\n  border-radius: 18px;\n  padding: 1.1rem 1.15rem 1rem;\n  background: #0f172a;\n  border: 1px solid rgba(255, 255, 255, 0.14);\n  color: #f8fafc;\n  text-align: center;\n}\n\n.cm-score-jump__card p {\n  margin: 0;\n}\n\n.cm-score-jump__card strong {\n  display: block;\n  margin: 0.45rem 0 0.7rem;\n  font-size: 1.7rem;\n  font-variant-numeric: tabular-nums;\n  letter-spacing: 0.02em;\n}\n\n.cm-score-jump__acts {\n  display: flex;\n  gap: 0.5rem;\n  justify-content: center;\n  margin-top: 0.9rem;\n}\n\n.cm-dock-dim {\n  position: fixed;\n  inset: 0;\n  z-index: 95;\n  border: 0;\n  padding: 0 1rem;\n  margin: 0;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 0.55rem;\n  background: rgba(0, 0, 0, 0.94);\n  color: #94a3b8;\n  -webkit-tap-highlight-color: transparent;\n}\n\n.cm-dock-dim__rec {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.35rem;\n  color: #fb7185;\n  font-size: 0.72rem;\n  font-weight: 800;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n}\n\n.cm-dock-dim__rec i {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: #fb7185;\n  animation: cm-pulse 1.1s var(--cm-ease) infinite;\n}\n\n.cm-dock-dim__wait {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.35rem;\n  color: #94a3b8;\n  font-size: 0.72rem;\n  font-weight: 800;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n}\n\n.cm-dock-dim__hint {\n  margin: 0;\n  max-width: 18rem;\n  text-align: center;\n  font-size: 0.72rem;\n  font-weight: 650;\n  opacity: 0.75;\n  line-height: 1.35;\n}\n\n.cm-dock-dim strong {\n  color: #e2e8f0;\n  font-size: 1rem;\n  font-weight: 750;\n}\n\n.cm-dock-dim__score {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.2rem;\n  margin: 0.15rem 0;\n}\n\n.cm-dock-dim__score-kicker {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.4rem;\n  color: #64748b;\n  font-size: 0.68rem;\n  font-weight: 800;\n  letter-spacing: 0.12em;\n  text-transform: uppercase;\n}\n\n.cm-dock-dim__score strong {\n  font-size: clamp(3.4rem, 18vw, 5.6rem);\n  font-weight: 800;\n  line-height: 0.9;\n  letter-spacing: -0.05em;\n  font-variant-numeric: tabular-nums;\n  color: #cbd5e1;\n}\n\n.cm-dock-dim__score-sets {\n  color: #64748b;\n  font-size: 0.78rem;\n  font-weight: 750;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n}\n\n.cm-dock-dim__pulse {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: #475569;\n  flex: 0 0 auto;\n}\n\n.cm-dock-dim__score.is-reading .cm-dock-dim__score-kicker,\n.cm-dock-dim__score.is-reading strong {\n  color: #7dd3fc;\n}\n\n.cm-dock-dim__score.is-reading strong {\n  animation: cm-dock-score-read 0.85s ease-in-out infinite;\n}\n\n.cm-dock-dim__score.is-read strong {\n  animation: cm-dock-score-hit 0.55s ease-out;\n}\n\n.cm-dock-dim__pulse--reading {\n  background: #38bdf8;\n  box-shadow: 0 0 10px rgba(56, 189, 248, 0.85);\n  animation: cm-pulse 0.7s var(--cm-ease) infinite;\n}\n\n.cm-dock-dim__pulse--read {\n  background: #34d399;\n  box-shadow: 0 0 10px rgba(52, 211, 153, 0.75);\n  animation: cm-dock-score-hit 0.55s ease-out;\n}\n\n.cm-dock-dim__score-icon {\n  flex: 0 0 auto;\n  color: #94a3b8;\n}\n\n.cm-dock-dim__score.is-reading .cm-dock-dim__score-icon {\n  color: #38bdf8;\n}\n\n.cm-dock-dim__score.is-motion .cm-dock-dim__score-icon,\n.cm-dock-dim__score.is-occlusion .cm-dock-dim__score-icon {\n  color: #fb7185;\n}\n\n.cm-dock-dim__score.is-hit .cm-dock-dim__score-icon {\n  color: #34d399;\n}\n\n.cm-dock-dim__score-log {\n  list-style: none;\n  margin: 0.35rem 0 0;\n  padding: 0;\n  width: min(18rem, 100%);\n  display: flex;\n  flex-direction: column;\n  gap: 0.15rem;\n  text-align: center;\n}\n\n.cm-dock-dim__score-log li {\n  font-size: 0.62rem;\n  font-weight: 650;\n  color: #64748b;\n  line-height: 1.25;\n}\n\n.cm-dock-dim__score-log .is-ok {\n  color: #86efac;\n}\n\n.cm-dock-dim__score-log .is-warn {\n  color: #fde68a;\n}\n\n.cm-dock-dim__score-log .is-err {\n  color: #fda4af;\n}\n\n@keyframes cm-dock-score-read {\n  0%,\n  100% {\n    opacity: 0.45;\n  }\n  50% {\n    opacity: 1;\n  }\n}\n\n@keyframes cm-dock-score-hit {\n  0% {\n    transform: scale(1.06);\n    filter: brightness(1.6);\n  }\n  100% {\n    transform: scale(1);\n    filter: brightness(1);\n  }\n}\n\n.cm-dock-dim__actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.45rem;\n  justify-content: center;\n  margin-top: 0.55rem;\n  width: min(360px, 100%);\n}\n\n.cm-dock-dim__actions .cm-btn {\n  min-width: 8.5rem;\n}\n\n.cm-page--cam-docked .cm-tabs,\n.cm-page--cam-docked .cm-head,\n.cm-page--cam-docked .cm-body {\n  visibility: hidden;\n}\n\n.cm-comment {\n  flex: 0 0 auto;\n  display: flex;\n  gap: 0.35rem;\n  margin-top: 0.35rem;\n}\n\n.cm-comment input {\n  flex: 1;\n  min-width: 0;\n  min-height: 38px;\n  border: 1px solid var(--cm-border);\n  border-radius: 12px;\n  background: var(--cm-glass);\n  color: var(--cm-text);\n  padding: 0 0.7rem;\n}\n\n.cm-comment button {\n  flex: 0 0 auto;\n}\n\n.cm-sheet {\n  position: relative;\n  z-index: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 0.45rem;\n  padding: 0.7rem;\n  border-radius: 18px;\n  border: 1px solid var(--cm-border);\n  background: var(--cm-slate);\n  overflow: hidden;\n}\n\n.cm-sheet__head {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  font-weight: 800;\n}\n\n.cm-sheet__grid {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 0.32rem;\n  overflow: auto;\n  margin-top: 0.45rem;\n}\n\n.cm-sheet__grid .cm-stamp {\n  width: 100%;\n}\n\n.cm-lineup {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  grid-template-rows: minmax(0, 1fr) auto auto;\n  gap: 0.45rem;\n  flex: 1 1 auto;\n  min-height: 0;\n  height: 100%;\n  align-content: stretch;\n  overflow: hidden;\n}\n\n.cm-lineup.has-sheet-photo {\n  grid-template-rows: auto minmax(0, 1fr) auto auto;\n}\n\n.cm-lineup.has-sheet-photo section {\n  grid-row: 2;\n}\n\n.cm-sheet-photo {\n  grid-column: 1 / -1;\n  grid-row: 1;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 0.35rem 0.5rem;\n}\n\n.cm-sheet-photo .cm-btn {\n  flex: 0 1 auto;\n  min-width: 0;\n}\n\n.cm-sheet-photo__note {\n  flex: 1 1 12rem;\n  margin: 0;\n  color: var(--cm-muted);\n  font-size: 0.68rem;\n  line-height: 1.35;\n}\n\n.cm-lineup section {\n  grid-row: 1;\n  min-height: 0;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  border: 1px solid var(--cm-border);\n  border-radius: 16px;\n  background: var(--cm-glass);\n  padding: 0.45rem;\n  overflow-x: hidden;\n  overflow-y: auto;\n  -webkit-overflow-scrolling: touch;\n  overscroll-behavior: contain;\n}\n\n.cm-lineup h2 {\n  margin: 0 0 0.35rem;\n  flex: 0 0 auto;\n  position: sticky;\n  top: 0;\n  z-index: 1;\n  padding-bottom: 0.15rem;\n  background: var(--cm-glass);\n  font-size: 0.72rem;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: var(--cm-muted);\n}\n\n.cm-lineup__section-label {\n  margin: 0 0 0.3rem;\n  flex: 0 0 auto;\n  font-size: 0.66rem;\n  font-weight: 750;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: var(--cm-primary);\n}\n\n.cm-lineup__locked {\n  margin: 0 0 0.85rem;\n  padding: 0.55rem 0.75rem;\n  border-radius: 12px;\n  border: 1px solid color-mix(in srgb, var(--cm-primary, #0877bc) 35%, transparent);\n  background: color-mix(in srgb, var(--cm-primary, #0877bc) 12%, transparent);\n  font-size: 0.84rem;\n  font-weight: 600;\n}\n\n.cm-lineup.is-locked input {\n  opacity: 0.92;\n  cursor: default;\n}\n\n.cm-lineup ol {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.28rem;\n  flex: 0 0 auto;\n}\n\n.cm-lineup li {\n  display: grid;\n  grid-template-columns: 1.1rem minmax(0, 1fr) auto;\n  gap: 0.28rem;\n  align-items: center;\n  min-height: 42px;\n  min-width: 0;\n}\n\n.cm-lineup li.is-swap-target {\n  cursor: pointer;\n  border-radius: 10px;\n  padding: 0.12rem 0.2rem;\n  background: color-mix(in srgb, var(--cm-primary) 14%, transparent);\n  outline: 1px dashed color-mix(in srgb, var(--cm-primary) 72%, transparent);\n  outline-offset: 1px;\n}\n\n.cm-lineup li.is-swap-target input {\n  pointer-events: none;\n}\n\n.cm-lineup__swap-hint {\n  margin: 0 0 0.35rem;\n  flex: 0 0 auto;\n  font-size: 0.66rem;\n  font-weight: 700;\n  line-height: 1.3;\n  color: var(--cm-primary);\n}\n\n.cm-lineup li > div {\n  min-width: 0;\n  overflow: hidden;\n}\n\n.cm-lineup__acts {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.12rem;\n  flex-shrink: 0;\n}\n\n.cm-lineup .pos {\n  font-weight: 800;\n  color: var(--cm-primary);\n}\n\n.cm-lineup input {\n  width: 100%;\n  min-width: 0;\n  border: 0;\n  background: transparent;\n  color: var(--cm-text);\n  font-size: 0.78rem;\n  font-weight: 650;\n  outline: none;\n  padding: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.cm-lineup small {\n  display: block;\n  color: var(--cm-muted);\n  font-size: 0.58rem;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.cm-opp-pool {\n  margin-top: 0.65rem;\n  padding-top: 0.55rem;\n  border-top: 1px dashed var(--cm-border);\n  flex: 0 0 auto;\n  display: flex;\n  flex-direction: column;\n  gap: 0.55rem;\n}\n\n.cm-opp-pool__group {\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n  min-width: 0;\n}\n\n.cm-opp-pool__label {\n  margin: 0;\n  flex: 0 0 auto;\n  font-size: 0.72rem;\n  font-weight: 750;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: var(--cm-muted);\n}\n\n.cm-opp-pool__hint {\n  margin: 0;\n  font-size: 0.66rem;\n  font-weight: 650;\n  line-height: 1.35;\n  color: var(--cm-primary);\n}\n\n.cm-opp-pool__list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n}\n\n.cm-opp-pool__list li {\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  gap: 0.28rem;\n  min-height: 40px;\n  min-width: 0;\n  padding: 0.35rem 0.45rem;\n  border-radius: 12px;\n  border: 1px solid var(--cm-border);\n  background: var(--cm-glass);\n}\n\n.cm-opp-pool__list li.is-swap-source {\n  border-color: var(--cm-primary);\n  box-shadow: inset 0 0 0 1px var(--cm-primary);\n  background: color-mix(in srgb, var(--cm-primary) 12%, var(--cm-glass));\n}\n\n.cm-opp-pool__list li.is-expected {\n  border-color: color-mix(in srgb, var(--cm-primary) 42%, var(--cm-border));\n  background: color-mix(in srgb, var(--cm-primary) 10%, var(--cm-glass));\n}\n\n.cm-opp-pool__list strong {\n  display: block;\n  font-size: 0.82rem;\n  line-height: 1.25;\n  overflow-wrap: anywhere;\n}\n\n.cm-opp-pool__list small {\n  display: block;\n  color: var(--cm-muted);\n  font-size: 0.66rem;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.cm-opp-pool__list > li > div:first-child {\n  flex: 1 1 auto;\n  min-width: 0;\n  overflow: hidden;\n}\n\n.cm-opp-pool__seats {\n  display: inline-flex;\n  gap: 0.2rem;\n  flex: 0 0 auto;\n  position: relative;\n  z-index: 1;\n}\n\n.cm-opp-pool__acts {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  flex: 0 0 auto;\n  min-width: 0;\n}\n\n.cm-opp-pool__swap {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.28rem;\n  min-height: 1.7rem;\n  border-radius: 999px;\n  border: 1px solid var(--cm-border);\n  padding: 0.16rem 0.55rem;\n  background: color-mix(in srgb, var(--cm-primary) 16%, transparent);\n  color: var(--cm-text);\n  font-size: 0.68rem;\n  font-weight: 750;\n  cursor: pointer;\n  white-space: nowrap;\n}\n\n.cm-opp-pool__swap.is-on {\n  background: var(--cm-primary);\n  border-color: var(--cm-primary);\n  color: #fff;\n}\n\n.cm-opp-pool__seat {\n  width: 1.7rem;\n  height: 1.7rem;\n  flex: 0 0 auto;\n  border-radius: 8px;\n  border: 1px solid var(--cm-border);\n  background: color-mix(in srgb, var(--cm-primary) 16%, transparent);\n  color: var(--cm-text);\n  font-size: 0.72rem;\n  font-weight: 750;\n  cursor: pointer;\n}\n\n.cm-opp-pool__in {\n  flex: 0 0 auto;\n  font-size: 0.66rem;\n  font-weight: 750;\n  color: var(--cm-home, #34d399);\n  white-space: nowrap;\n}\n\n.cm-opp-avail {\n  min-height: 1.7rem;\n  border-radius: 999px;\n  border: 1px solid var(--cm-border);\n  padding: 0.18rem 0.55rem;\n  font-size: 0.68rem;\n  font-weight: 750;\n  cursor: pointer;\n  white-space: nowrap;\n}\n\n.cm-opp-avail--play {\n  background: color-mix(in srgb, var(--cm-home, #34d399) 18%, transparent);\n  color: var(--cm-home, #34d399);\n}\n\n.cm-opp-avail--bench {\n  background: color-mix(in srgb, var(--cm-rec, #fb7185) 16%, transparent);\n  color: var(--cm-rec, #fb7185);\n}\n\n.cm-opp-avail--icon {\n  width: 1.7rem;\n  height: 1.7rem;\n  min-width: 1.7rem;\n  min-height: 1.7rem;\n  padding: 0;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.cm-page--light .cm-opp-pool__seat,\n.cm-page--light .cm-opp-pool__swap {\n  background: color-mix(in srgb, var(--cm-primary) 12%, #fff);\n  color: var(--cm-primary);\n}\n\n.cm-page--light .cm-opp-pool__swap.is-on {\n  background: var(--cm-primary);\n  color: #fff;\n}\n\n.cm-page--light .cm-opp-pool__list li.is-expected {\n  background: color-mix(in srgb, var(--cm-primary) 8%, #fff);\n}\n\n.cm-swap {\n  border: 0;\n  background: transparent;\n  color: var(--cm-primary);\n  font-weight: 800;\n  cursor: pointer;\n  padding: 0 0.15rem;\n  flex-shrink: 0;\n}\n\n.cm-hint {\n  grid-column: 1 / -1;\n  margin: 0;\n  color: var(--cm-muted);\n  font-size: 0.68rem;\n}\n\n@media (max-width: 719px) {\n  .cm-lineup {\n    grid-template-columns: 1fr 1fr;\n    gap: 0.35rem;\n  }\n\n  .cm-lineup section {\n    padding: 0.35rem;\n  }\n\n  .cm-lineup input {\n    font-size: 0.7rem;\n  }\n\n  .cm-lineup li {\n    min-height: 36px;\n  }\n\n  .cm-opp-pool__seat {\n    width: 1.45rem;\n    height: 1.45rem;\n    font-size: 0.66rem;\n  }\n\n  .cm-opp-pool__list strong {\n    font-size: 0.72rem;\n  }\n}\n\n.cm-cam {\n  flex: 1;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.4rem;\n}\n\n.cm-cam__preview {\n  flex: 1;\n  min-height: 0;\n  position: relative;\n  border-radius: 18px;\n  overflow: hidden;\n  background: #000;\n  border: 1px solid var(--cm-border);\n  touch-action: none;\n}\n\n.cm-cam__preview video {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  transform-origin: center center;\n  pointer-events: none;\n}\n\n.cm-cam__score-roi {\n  position: absolute;\n  border: 2px solid rgba(56, 189, 248, 0.95);\n  box-shadow: 0 0 0 1px rgba(15, 23, 42, 0.45);\n  pointer-events: none;\n  z-index: 3;\n  transition: border-color 0.2s ease, box-shadow 0.2s ease;\n}\n\n.cm-cam__score-roi.is-reading {\n  border-color: #38bdf8;\n  box-shadow: 0 0 0 2px rgba(56, 189, 248, 0.55), 0 0 18px rgba(56, 189, 248, 0.55);\n  animation: cm-score-roi-pulse 0.85s ease-in-out infinite;\n}\n\n.cm-cam__score-roi.is-motion,\n.cm-cam__score-roi.is-occlusion {\n  border-color: #fb7185;\n  box-shadow: 0 0 0 2px rgba(251, 113, 133, 0.5), 0 0 16px rgba(251, 113, 133, 0.45);\n}\n\n.cm-cam__score-roi.is-hit {\n  border-color: #34d399;\n  box-shadow: 0 0 0 2px rgba(52, 211, 153, 0.55), 0 0 16px rgba(52, 211, 153, 0.4);\n}\n\n.cm-cam__score-roi.is-confirm {\n  border-color: #fbbf24;\n  box-shadow: 0 0 0 2px rgba(251, 191, 36, 0.5);\n}\n\n.cm-cam__score-roi-icon {\n  position: absolute;\n  top: -10px;\n  right: -10px;\n  width: 22px;\n  height: 22px;\n  border-radius: 999px;\n  display: grid;\n  place-items: center;\n  background: rgba(15, 23, 42, 0.92);\n  color: #e2e8f0;\n  border: 1px solid rgba(255, 255, 255, 0.18);\n}\n\n.cm-cam__score-roi.is-reading .cm-cam__score-roi-icon {\n  color: #7dd3fc;\n}\n\n.cm-cam__score-roi.is-motion .cm-cam__score-roi-icon,\n.cm-cam__score-roi.is-occlusion .cm-cam__score-roi-icon {\n  color: #fda4af;\n}\n\n.cm-cam__score-roi.is-hit .cm-cam__score-roi-icon {\n  color: #6ee7b7;\n}\n\n.cm-cam__score-roi-icon .is-spin,\n.cm-score-ai-hud .is-spin,\n.cm-dock-dim__score-icon.is-spin {\n  animation: cm-score-spin 0.8s linear infinite;\n}\n\n@keyframes cm-score-spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n@keyframes cm-score-roi-pulse {\n  0%,\n  100% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.72;\n  }\n}\n\n.cm-score-ai-hud {\n  position: absolute;\n  left: 0.55rem;\n  bottom: 0.55rem;\n  z-index: 6;\n  width: min(22rem, calc(100% - 1.1rem));\n  pointer-events: none;\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n}\n\n.cm-score-ai-hud__status {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.4rem;\n  max-width: 100%;\n  padding: 0.35rem 0.55rem;\n  border-radius: 999px;\n  background: rgba(2, 6, 23, 0.78);\n  border: 1px solid rgba(148, 163, 184, 0.28);\n  color: #e2e8f0;\n  font-size: 0.68rem;\n  font-weight: 750;\n  letter-spacing: 0.02em;\n}\n\n.cm-score-ai-hud__status span {\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.cm-score-ai-hud__status strong {\n  margin-left: auto;\n  font-variant-numeric: tabular-nums;\n  color: #7dd3fc;\n}\n\n.cm-score-ai-hud.is-reading .cm-score-ai-hud__status {\n  border-color: rgba(56, 189, 248, 0.55);\n  color: #bae6fd;\n}\n\n.cm-score-ai-hud.is-motion .cm-score-ai-hud__status,\n.cm-score-ai-hud.is-occlusion .cm-score-ai-hud__status {\n  border-color: rgba(251, 113, 133, 0.55);\n  color: #fecdd3;\n}\n\n.cm-score-ai-hud.is-hit .cm-score-ai-hud__status {\n  border-color: rgba(52, 211, 153, 0.55);\n  color: #a7f3d0;\n}\n\n.cm-score-ai-hud.is-confirm .cm-score-ai-hud__status,\n.cm-score-ai-hud.is-error .cm-score-ai-hud__status {\n  border-color: rgba(251, 191, 36, 0.55);\n  color: #fde68a;\n}\n\n.cm-score-ai-hud__gate {\n  display: flex;\n  flex-direction: column;\n  gap: 0.1rem;\n  padding: 0.3rem 0.5rem;\n  border-radius: 10px;\n  background: rgba(2, 6, 23, 0.66);\n  border: 1px solid rgba(148, 163, 184, 0.18);\n  color: #94a3b8;\n  font-size: 0.58rem;\n  font-weight: 650;\n  font-variant-numeric: tabular-nums;\n  line-height: 1.3;\n}\n\n.cm-score-ai-hud__gate span {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.cm-score-ai-hud__log {\n  list-style: none;\n  margin: 0;\n  padding: 0.4rem 0.5rem;\n  border-radius: 12px;\n  background: rgba(2, 6, 23, 0.72);\n  border: 1px solid rgba(148, 163, 184, 0.2);\n  max-height: 9.5rem;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  gap: 0.18rem;\n}\n\n.cm-score-ai-hud__log li {\n  display: grid;\n  grid-template-columns: auto 1fr;\n  gap: 0.4rem;\n  font-size: 0.62rem;\n  font-weight: 650;\n  color: #cbd5e1;\n  line-height: 1.25;\n}\n\n.cm-score-ai-hud__log time {\n  color: #64748b;\n  font-variant-numeric: tabular-nums;\n}\n\n.cm-score-ai-hud__log .is-ok {\n  color: #86efac;\n}\n\n.cm-score-ai-hud__log .is-warn {\n  color: #fde68a;\n}\n\n.cm-score-ai-hud__log .is-err {\n  color: #fda4af;\n}\n\n.cm-cam__score-roi-draw {\n  z-index: 4;\n}\n\n.cm-cam__idle {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 0.65rem;\n  padding: 1.25rem;\n  text-align: center;\n  color: var(--cm-muted);\n  background:\n    radial-gradient(circle at 50% 35%, rgba(8, 119, 188, 0.18), transparent 55%),\n    #0a0f18;\n}\n\n.cm-cam__idle--guide {\n  z-index: 5;\n  justify-content: flex-start;\n  padding-top: calc(4.15rem + env(safe-area-inset-top, 0px));\n  background: transparent;\n  pointer-events: none;\n}\n\n.cm-cam__idle--guide > :first-child {\n  display: none;\n}\n\n.cm-cam__idle p {\n  margin: 0;\n  max-width: 16rem;\n  font-size: 0.82rem;\n  font-weight: 600;\n  line-height: 1.35;\n  color: #cbd5e1;\n}\n\n.cm-cam__roster {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.28rem;\n}\n\n.cm-cam__roster li {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.35rem;\n  min-height: 28px;\n  padding: 0.2rem 0.55rem;\n  border-radius: 999px;\n  background: rgba(52, 211, 153, 0.12);\n  border: 1px solid rgba(52, 211, 153, 0.35);\n  color: #6ee7b7;\n  font-size: 0.72rem;\n  font-weight: 700;\n}\n\n.cm-page--light .cm-cam__roster li {\n  background: color-mix(in srgb, #047857 10%, #fff);\n  border-color: color-mix(in srgb, #047857 28%, transparent);\n  color: #047857;\n}\n\n.cm-cam-status {\n  list-style: none;\n  flex: 0 1 auto;\n  min-height: 0;\n  max-height: 7.25rem;\n  margin: 0.35rem 0 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.28rem;\n  overflow-x: hidden;\n  overflow-y: auto;\n  -webkit-overflow-scrolling: touch;\n  overscroll-behavior: contain;\n}\n\n.cm-cam-status__item {\n  display: flex;\n  align-items: center;\n  gap: 0.4rem;\n  min-height: 34px;\n  padding: 0.35rem 0.55rem;\n  border-radius: 12px;\n  border: 1px solid color-mix(in srgb, var(--cm-primary) 35%, var(--cm-border));\n  background: color-mix(in srgb, var(--cm-primary) 12%, transparent);\n  color: var(--cm-text);\n  font-size: 0.74rem;\n  font-weight: 650;\n}\n\n.cm-cam-status__item.is-this {\n  border-color: color-mix(in srgb, var(--cm-home) 45%, var(--cm-border));\n  background: color-mix(in srgb, var(--cm-home) 14%, transparent);\n}\n\n.cm-cam-status__item.is-offline {\n  opacity: 0.72;\n  border-style: dashed;\n}\n\n.cm-cam__roster li.is-offline {\n  background: rgba(148, 163, 184, 0.12);\n  border-color: rgba(148, 163, 184, 0.35);\n  border-style: dashed;\n  color: #94a3b8;\n}\n\n.cm-cam__roster li.is-this {\n  box-shadow: inset 0 0 0 1px rgba(52, 211, 153, 0.45);\n}\n\n.cm-cam__idle-phones {\n  margin: 0 0 0.35rem;\n  color: var(--cm-muted);\n  font-size: 0.78rem;\n  font-weight: 600;\n}\n\n.cm-cam-status__item span {\n  flex: 1;\n  min-width: 0;\n  overflow: visible;\n  line-height: 1.35;\n  overflow-wrap: anywhere;\n}\n\n.cm-cam-status__remove {\n  flex: 0 0 auto;\n  min-height: 28px;\n  padding: 0.2rem 0.55rem;\n  border-radius: 999px;\n  border: 1px solid var(--cm-border);\n  background: transparent;\n  color: var(--cm-text);\n  font-size: 0.7rem;\n  font-weight: 750;\n  cursor: pointer;\n}\n\n.cm-page--light .cm-cam-status__item {\n  background: color-mix(in srgb, var(--cm-primary) 10%, #fff);\n  border-color: color-mix(in srgb, var(--cm-primary) 28%, var(--cm-border));\n}\n\n.cm-page--cam-armed .cm-cam__roster,\n.cm-page--cam-armed .cm-picks,\n.cm-page--cam-armed .cm-cam__idle-phones,\n.cm-page--cam-armed .cm-hint,\n.cm-page--cam-landscape .cm-cam-status,\n.cm-page--cam-landscape .cm-cam__roster,\n.cm-page--cam-landscape .cm-cam__idle-phones {\n  display: none;\n}\n\n.cm-cam__badge {\n  position: absolute;\n  top: 0.55rem;\n  left: 0.55rem;\n  padding: 0.22rem 0.5rem;\n  border-radius: 999px;\n  background: rgba(0, 0, 0, 0.55);\n}\n\n.cm-cam__badge--roster {\n  left: auto;\n  right: 0.55rem;\n  top: 0.55rem;\n  background: rgba(8, 119, 188, 0.72);\n}\n\n.cm-cam__badge--zoom {\n  left: auto;\n  right: 0.55rem;\n  top: 0.55rem;\n  background: rgba(2, 6, 23, 0.72);\n  font-variant-numeric: tabular-nums;\n}\n\n.cm-picks {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.3rem;\n}\n\n.cm-scorecam-mode {\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n}\n\n.cm-scorecam-mode__note {\n  margin: 0;\n  color: var(--cm-muted);\n  font-size: 0.75rem;\n  line-height: 1.35;\n}\n\n.cm-chip {\n  min-height: 34px;\n  padding: 0 0.7rem;\n  border-radius: 999px;\n  border: 1px solid var(--cm-border);\n  background: var(--cm-glass);\n  color: var(--cm-text);\n  font-size: 0.72rem;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.cm-chip.is-on {\n  background: var(--cm-primary);\n  border-color: var(--cm-primary);\n  color: #fff;\n}\n\n.cm-replay__filters {\n  flex: 0 0 auto;\n  display: flex;\n  gap: 0.28rem;\n  overflow: auto;\n  padding-bottom: 0.2rem;\n}\n\n.cm-replay__filters .cm-tagchip {\n  flex: 0 0 auto;\n  max-width: none;\n  min-width: 5.2rem;\n}\n\n.cm-replay__filters .cm-outcome__btn {\n  flex: 0 0 auto;\n  flex-direction: row;\n  gap: 0.28rem;\n  min-height: 2.15rem;\n  min-width: 4.6rem;\n  padding: 0.2rem 0.55rem;\n}\n\n.cm-outcome--score {\n  flex: 0 0 auto;\n  margin: 0.25rem 0 0.1rem;\n  min-width: 0;\n}\n\n.cm-live > .cm-outcome--score {\n  position: relative;\n  z-index: 2;\n  padding: 0.2rem 0 0.15rem;\n  background: linear-gradient(\n    180deg,\n    transparent,\n    color-mix(in srgb, var(--cm-glass, #0b1220) 92%, transparent) 35%\n  );\n}\n\n.cm-live > .cm-scoredeck {\n  flex: 1 1 auto;\n  min-height: 0;\n}\n\n@media (max-height: 720px) {\n  .cm-live > .cm-scoredeck {\n    max-height: min(38dvh, 16rem);\n  }\n\n  .cm-live > .cm-outcome--score .cm-outcome__text {\n    font-size: 0.58rem;\n  }\n\n  .cm-live > .cm-outcome--score .cm-outcome__btn {\n    min-height: 2.25rem;\n    padding: 0.18rem 0.1rem;\n  }\n}\n\n@media (max-height: 580px) {\n  .cm-live > .cm-outcome--score .cm-outcome__text {\n    display: none;\n  }\n\n  .cm-live > .cm-scoredeck {\n    max-height: min(32dvh, 12.5rem);\n  }\n\n  .cm-scoredeck__pts {\n    font-size: clamp(1.9rem, 10vw, 3rem);\n  }\n}\n\n.cm-film__outcome {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.25rem;\n  font-size: 0.75rem;\n  font-weight: 750;\n}\n\n.cm-film__outcome--winner {\n  color: #22c55e;\n}\n\n.cm-film__outcome--unforced_error {\n  color: #ef4444;\n}\n\n.cm-film__outcome--forced_error {\n  color: #eab308;\n}\n\n.cm-film__outcome--lucky {\n  color: #94a3b8;\n}\n\n.cm-film__outcome--rally {\n  color: #0ea5e9;\n}\n\n/* ── Match video replay (cinema desk + mobile label dock) ── */\n.cm-chrono-shell {\n  list-style: none;\n  margin: 0.25rem 0 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n  min-height: 0;\n  flex: 1 1 auto;\n  overflow: hidden;\n}\n\n.cm-chrono__rubber-tabs {\n  display: flex;\n  gap: 0.4rem;\n  overflow-x: auto;\n  padding: 0.1rem 0.1rem 0.15rem;\n  -webkit-overflow-scrolling: touch;\n}\n\n.cm-chrono__rubber-tab {\n  flex: 0 0 auto;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 0.12rem;\n  border: 1px solid var(--cm-border);\n  background: color-mix(in srgb, var(--cm-slate) 80%, transparent);\n  color: var(--cm-text);\n  border-radius: 12px;\n  padding: 0.45rem 0.75rem;\n  font: inherit;\n  cursor: pointer;\n  min-width: 5.5rem;\n}\n\n.cm-chrono__rubber-tab strong {\n  font-size: 0.78rem;\n  font-weight: 800;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n}\n\n.cm-chrono__rubber-tab span {\n  font-size: 0.66rem;\n  font-weight: 650;\n  color: var(--cm-muted);\n}\n\n.cm-chrono__rubber-tab.is-on {\n  border-color: color-mix(in srgb, var(--cm-primary) 55%, var(--cm-border));\n  background: color-mix(in srgb, var(--cm-primary) 14%, var(--cm-slate));\n  box-shadow: inset 0 0 0 1px color-mix(in srgb, var(--cm-primary) 25%, transparent);\n}\n\n.cm-chrono {\n  --cm-chrono-chrome: 1;\n  --cm-rail: #0a0f18;\n  --cm-deck: #0f1520;\n  --cm-chip: #121a27;\n  --cm-chip-on: #1d2636;\n  --cm-hair: rgba(255, 255, 255, 0.07);\n  --cm-fill: rgba(255, 255, 255, 0.05);\n  --cm-fill-strong: rgba(255, 255, 255, 0.12);\n  display: flex;\n  flex-direction: column;\n  flex: 1 1 auto;\n  height: auto;\n  min-height: 0;\n  max-height: 100%;\n  border: 1px solid var(--cm-border);\n  border-radius: 16px;\n  background: var(--cm-glass);\n  overflow: hidden;\n}\n\n.cm-page--light .cm-chrono:not(.is-stage-fs) {\n  --cm-rail: #eef1f6;\n  --cm-deck: #ffffff;\n  --cm-chip: #f4f6fa;\n  --cm-chip-on: #ffffff;\n  --cm-hair: rgba(15, 23, 42, 0.09);\n  --cm-fill: rgba(15, 23, 42, 0.05);\n  --cm-fill-strong: rgba(15, 23, 42, 0.1);\n}\n\n/* Full-screen stage is always a dark cinema, whatever the page theme. */\n.cm-chrono.is-stage-fs {\n  --cm-text: #f8fafc;\n  --cm-muted: #94a3b8;\n  --cm-border: rgba(255, 255, 255, 0.08);\n}\n\n.cm-chrono__rubber {\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  gap: 0.5rem;\n  padding: 0.5rem 0.75rem 0.3rem;\n  flex: 0 0 auto;\n}\n\n.cm-chrono__rubber strong {\n  font-size: 0.8rem;\n  font-weight: 800;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n}\n\n.cm-chrono__rubber span {\n  color: var(--cm-muted);\n  font-size: 0.72rem;\n  font-weight: 650;\n  text-align: right;\n}\n\n.cm-chrono__layout,\n.cm-chrono__stage {\n  display: contents;\n}\n\n.cm-chrono__player-shell,\n.cm-chrono__player,\n.cm-chrono__empty-stage {\n  order: 1;\n}\n\n.cm-chrono__tape-scrub {\n  order: 2;\n}\n\n.cm-film {\n  order: 3;\n}\n\n.cm-chrono__tagger-slot--dock {\n  order: 4;\n}\n\n.cm-chrono__side {\n  order: 5;\n}\n\n.cm-chrono__player-spacer {\n  width: 100%;\n  pointer-events: none;\n}\n\n.cm-chrono__player-shell {\n  position: relative;\n  flex: 1 1 0%;\n  min-height: 0;\n  width: 100%;\n  border-radius: 0;\n  overflow: hidden;\n  background: #05070c;\n  isolation: isolate;\n  /* Width + height so chrome can scale with the video frame, not the page. */\n  container-type: size;\n  container-name: cm-player;\n}\n\n.cm-chrono__player-shell > .review-video-player {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n}\n\n.cm-chrono__player-shell.is-expanding,\n.cm-chrono__player-shell.is-expanded {\n  position: fixed;\n  z-index: 11000;\n  margin: 0;\n  overflow: hidden;\n  background: #000;\n  box-shadow: none;\n  border-radius: 0;\n}\n\n.cm-chrono__player-shell.is-expanded:not(.is-expanding) {\n  inset: 0;\n  width: 100vw;\n  width: 100dvw;\n  height: 100%;\n  height: 100dvh;\n  max-width: 100vw;\n  left: 0;\n  right: 0;\n  display: flex;\n  flex-direction: column;\n}\n\n.cm-chrono__player-shell.is-expanded .cm-chrono__eval-player,\n.cm-chrono__player-shell.is-expanding .cm-chrono__eval-player,\n.cm-chrono__player-shell.is-expanded .review-video-player,\n.cm-chrono__player-shell.is-expanding .review-video-player {\n  flex: 1 1 auto;\n  width: 100%;\n  height: 100%;\n  min-height: 0;\n  border-radius: 0;\n}\n\n.cm-chrono__player-shell.is-expanded .review-video-player__viewport,\n.cm-chrono__player-shell.is-expanding .review-video-player__viewport,\n.cm-chrono__player-shell.is-expanded .review-video-player--embedded .review-video-player__viewport,\n.cm-chrono__player-shell.is-expanding .review-video-player--embedded .review-video-player__viewport {\n  aspect-ratio: auto;\n  max-height: none;\n  height: 100%;\n  width: 100%;\n  flex: 1 1 auto;\n}\n\n.cm-chrono__player-shell.is-expanded .review-video-player__transform,\n.cm-chrono__player-shell.is-expanding .review-video-player__transform,\n.cm-chrono__player-shell.is-expanded .review-video-player__video,\n.cm-chrono__player-shell.is-expanding .review-video-player__video {\n  width: 100%;\n  height: 100%;\n  max-width: none;\n  max-height: none;\n  object-fit: contain;\n}\n\n.cm-chrono__player {\n  position: relative;\n  border-radius: 12px;\n  overflow: hidden;\n  background: #05070c;\n  aspect-ratio: 16 / 9;\n  max-height: min(46vh, 26rem);\n}\n\n.cm-chrono__player--photo {\n  display: grid;\n  place-items: center;\n  flex: 1 1 auto;\n  max-height: none;\n}\n\n.cm-chrono__player--photo img {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n}\n\n.cm-chrono__eval-player {\n  width: 100%;\n  height: 100%;\n  min-height: 0;\n  border-radius: 0;\n}\n\n.cm-chrono__player-shell .cm-chrono__eval-player.review-video-player--embedded,\n.cm-chrono__player-shell .review-video-player--embedded {\n  height: 100%;\n  min-height: 0;\n  border-radius: 0;\n}\n\n.cm-chrono__player-shell .review-video-player--embedded .review-video-player__viewport {\n  aspect-ratio: auto;\n  max-height: none;\n  height: 100%;\n}\n\n.cm-chrono__eval-player video,\n.cm-chrono__player video {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n  background: #000;\n}\n\n/* HUD overlays: hide with player chrome after inactivity */\n.cm-chrono__hud {\n  position: absolute;\n  inset: 0;\n  z-index: 22;\n  pointer-events: none;\n  opacity: 0;\n  transition: opacity 0.2s ease;\n}\n\n.cm-chrono__player-shell:has(.review-video-player--controls-visible) .cm-chrono__hud,\n.cm-chrono__player-shell:not(:has(.review-video-player)) .cm-chrono__hud {\n  opacity: 1;\n}\n\n/* View-mode pill: portrait / landscape full screen, exit. Stays tappable but\n   recedes while the player chrome is hidden. */\n.cm-stagectl {\n  --cm-stagectl-btn: clamp(1.75rem, 7cqmin, 2.3rem);\n  position: absolute;\n  top: 0.5rem;\n  right: 0.5rem;\n  z-index: 30;\n  display: flex;\n  align-items: center;\n  gap: 1px;\n  padding: 2px;\n  border-radius: 999px;\n  background: rgba(6, 9, 15, 0.5);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  backdrop-filter: blur(10px) saturate(140%);\n  -webkit-backdrop-filter: blur(10px) saturate(140%);\n  opacity: 0.62;\n  transition: opacity 0.2s ease;\n}\n\n.cm-chrono__player-shell:has(.review-video-player--controls-visible) .cm-stagectl,\n.cm-chrono__player-shell:not(:has(.review-video-player)) .cm-stagectl,\n.cm-stagectl:hover,\n.cm-stagectl:focus-within {\n  opacity: 1;\n}\n\n.cm-stagectl__btn {\n  width: var(--cm-stagectl-btn);\n  height: var(--cm-stagectl-btn);\n  border: 0;\n  border-radius: 999px;\n  display: grid;\n  place-items: center;\n  padding: 0;\n  cursor: pointer;\n  color: rgba(248, 250, 252, 0.92);\n  background: transparent;\n  -webkit-tap-highlight-color: transparent;\n  transition: background 0.15s ease, transform 0.12s ease;\n}\n\n.cm-stagectl__btn:hover {\n  background: rgba(255, 255, 255, 0.12);\n}\n\n.cm-stagectl__btn:active {\n  transform: scale(0.92);\n}\n\n.cm-stagectl__btn:focus-visible {\n  outline: 2px solid var(--cm-primary);\n  outline-offset: 1px;\n}\n\n.cm-stagectl__btn--exit {\n  color: #fff;\n  background: rgba(255, 255, 255, 0.14);\n}\n\n.cm-chrono.is-stage-fs .cm-stagectl {\n  --cm-stagectl-btn: 2.5rem;\n  top: max(0.6rem, env(safe-area-inset-top, 0px));\n  right: max(0.6rem, env(safe-area-inset-right, 0px));\n}\n\n.cm-chrono__board {\n  position: absolute;\n  left: 0.5rem;\n  top: 0.5rem;\n  z-index: 1;\n  padding: 0.22rem clamp(0.4rem, 2.2cqi, 0.6rem);\n  border-radius: 999px;\n  background: rgba(8, 12, 20, 0.55);\n  color: #f8fafc;\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  font-size: clamp(0.66rem, 3.2cqi, 0.8rem);\n  font-weight: 750;\n  letter-spacing: 0.02em;\n  backdrop-filter: blur(8px);\n}\n\n.cm-chrono__player-shell.is-expanded .cm-chrono__board {\n  top: max(0.7rem, env(safe-area-inset-top, 0px));\n  left: max(0.7rem, env(safe-area-inset-left, 0px));\n}\n\n.cm-chrono__parts {\n  position: absolute;\n  left: 0.5rem;\n  bottom: 0.5rem;\n  z-index: 1;\n  margin: 0;\n  padding: 0.18rem 0.45rem;\n  border-radius: 999px;\n  background: rgba(8, 12, 20, 0.5);\n  color: #f8fafc;\n  font-size: clamp(0.58rem, 2.8cqi, 0.7rem);\n  font-weight: 700;\n  letter-spacing: 0.04em;\n}\n\n.cm-chrono__tape-id {\n  position: absolute;\n  left: 0.5rem;\n  top: calc(0.5rem + clamp(1.5rem, 6cqmin, 1.95rem));\n  z-index: 1;\n  margin: 0;\n  max-width: min(70%, 22rem);\n  padding: 0.18rem 0.45rem;\n  border-radius: 999px;\n  background: rgba(8, 12, 20, 0.55);\n  color: #f8fafc;\n  font-size: clamp(0.55rem, 2.5cqi, 0.68rem);\n  font-weight: 600;\n  letter-spacing: 0.02em;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.cm-chrono__error {\n  position: absolute;\n  inset: auto 0.55rem 0.55rem;\n  margin: 0;\n  padding: 0.4rem 0.55rem;\n  border-radius: 10px;\n  background: rgba(127, 29, 29, 0.88);\n  color: #fff;\n  font-size: 0.75rem;\n  z-index: 24;\n}\n\n.cm-chrono__empty-stage {\n  display: grid;\n  place-items: center;\n  gap: 0.35rem;\n  flex: 1 1 auto;\n  min-height: 0;\n  width: 100%;\n  border-radius: 0;\n  border: 1.5px dashed color-mix(in srgb, var(--cm-primary) 40%, var(--cm-border));\n  color: var(--cm-muted);\n  text-align: center;\n  padding: 1rem;\n  background: color-mix(in srgb, var(--cm-slate) 70%, transparent);\n}\n\n.cm-chrono__empty-stage p {\n  margin: 0;\n  font-size: 0.84rem;\n  max-width: 16rem;\n}\n\n/* Compact ReviewVideoPlayer chrome: scale with the video frame (cqmin). */\n.cm-chrono__player-shell .review-video-player__chrome {\n  --cm-rv-gap: clamp(2px, 1.1cqmin, 8px);\n  --cm-rv-pad-y: clamp(4px, 1.5cqmin, 10px);\n  --cm-rv-pad-x: clamp(6px, 2cqmin, 12px);\n  --cm-rv-btn: clamp(1.35rem, 5.8cqmin, 2.35rem);\n  --cm-rv-play: clamp(1.65rem, 7.2cqmin, 2.85rem);\n  --cm-rv-icon: clamp(12px, 3.8cqmin, 18px);\n  --cm-rv-label: clamp(0.55rem, 2.2cqmin, 0.78rem);\n  --cm-rv-radius: clamp(8px, 1.8cqmin, 14px);\n  padding: var(--cm-rv-pad-y) var(--cm-rv-pad-x);\n  gap: var(--cm-rv-gap);\n}\n\n.cm-chrono__player-shell .review-video-player__chrome--top {\n  padding-top: max(var(--cm-rv-pad-y), env(safe-area-inset-top, 0px));\n  padding-left: var(--cm-rv-pad-x);\n}\n\n.cm-chrono__player-shell .review-video-player--embedded .review-video-player__chrome--top {\n  padding-right: clamp(4.4rem, 18cqmin, 6.5rem);\n  padding-left: var(--cm-rv-pad-x);\n  border-radius: 0;\n}\n\n.cm-chrono__player-shell .review-video-player__chrome--bottom {\n  padding-bottom: max(var(--cm-rv-pad-y), env(safe-area-inset-bottom, 0px));\n}\n\n.cm-chrono__player-shell .review-video-player__orient,\n.cm-chrono__player-shell .review-video-player__pose-tools,\n.cm-chrono__player-shell .review-video-player__joint-overlay,\n.cm-chrono__player-shell .review-video-player__speeds,\n.cm-chrono__player-shell .review-video-player__transport,\n.cm-chrono__player-shell .review-video-player__transport-main,\n.cm-chrono__player-shell .review-video-player__transport-extra,\n.cm-chrono__player-shell .review-video-player__game-points {\n  gap: var(--cm-rv-gap);\n}\n\n.cm-chrono__player-shell .review-video-player__btn,\n.cm-chrono__player-shell .review-video-player__transport-main > .review-video-player__btn,\n.cm-chrono__player-shell .review-video-player__game-points .review-video-player__btn {\n  width: var(--cm-rv-btn);\n  height: var(--cm-rv-btn);\n  min-width: 0;\n  min-height: 0;\n  padding: clamp(2px, 0.7cqmin, 6px);\n  border-radius: var(--cm-rv-radius);\n  flex: 1 1 0;\n}\n\n.cm-chrono__player-shell .review-video-player__btn--play,\n.cm-chrono__player-shell .review-video-player__transport-main > .review-video-player__btn--play {\n  width: var(--cm-rv-play);\n  height: var(--cm-rv-play);\n  min-width: 0;\n  min-height: 0;\n  flex: 1.15 1 0;\n  border-radius: calc(var(--cm-rv-radius) + 2px);\n}\n\n.cm-chrono__player-shell .review-video-player__btn svg,\n.cm-chrono__player-shell .review-video-player__chrome-toggle svg {\n  width: var(--cm-rv-icon);\n  height: var(--cm-rv-icon);\n}\n\n.cm-chrono__player-shell .review-video-player__btn span,\n.cm-chrono__player-shell .review-video-player__speed-btn,\n.cm-chrono__player-shell .review-video-player__joint-overlay-btn {\n  font-size: var(--cm-rv-label);\n}\n\n.cm-chrono__player-shell .review-video-player__speed-btn,\n.cm-chrono__player-shell .review-video-player__joint-overlay-btn {\n  min-width: 0;\n  width: auto;\n  height: clamp(1.15rem, 4.6cqmin, 1.85rem);\n  padding: 0 clamp(0.35rem, 1.6cqmin, 0.65rem);\n  border-radius: 999px;\n}\n\n.cm-chrono__player-shell .review-video-player__time {\n  font-size: clamp(0.58rem, 2.4cqmin, 0.75rem);\n  gap: clamp(2px, 0.8cqmin, 4px);\n}\n\n.cm-chrono__player-shell .review-video-player__scrubber-wrap {\n  margin: 0;\n  padding: 0.45rem 0.1rem;\n  pointer-events: auto !important;\n  touch-action: none;\n}\n\n.cm-chrono__player-shell .review-video-player__scrubber {\n  -webkit-appearance: none;\n  appearance: none;\n  width: 100%;\n  height: 1.4rem;\n  margin: 0;\n  background: transparent;\n  accent-color: #fff;\n  cursor: grab;\n  pointer-events: auto !important;\n  touch-action: none;\n}\n\n.cm-chrono__player-shell .review-video-player__scrubber::-webkit-slider-runnable-track {\n  height: 4px;\n  background: rgba(255, 255, 255, 0.38);\n  border-radius: 999px;\n}\n\n.cm-chrono__player-shell .review-video-player__scrubber::-webkit-slider-thumb {\n  -webkit-appearance: none;\n  appearance: none;\n  width: 0.95rem;\n  height: 0.95rem;\n  margin-top: -0.36rem;\n  border: 0;\n  border-radius: 50%;\n  background: #fff;\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.55);\n  cursor: grab;\n}\n\n.cm-chrono__player-shell .review-video-player__scrubber::-moz-range-track {\n  height: 4px;\n  background: rgba(255, 255, 255, 0.38);\n  border-radius: 999px;\n}\n\n.cm-chrono__player-shell .review-video-player__scrubber::-moz-range-thumb {\n  width: 0.95rem;\n  height: 0.95rem;\n  border: 0;\n  border-radius: 50%;\n  background: #fff;\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.55);\n  cursor: grab;\n}\n\n/* The frame ball stays on the picture after the rest of the chrome hides. */\n.cm-chrono__player-shell .review-video-player:not(.review-video-player--controls-visible) .review-video-player__chrome--bottom {\n  opacity: 1 !important;\n  background: linear-gradient(to top, rgba(0, 0, 0, 0.55), transparent);\n  pointer-events: none !important;\n}\n\n.cm-chrono__player-shell .review-video-player:not(.review-video-player--controls-visible) .review-video-player__chrome--bottom > :not(.review-video-player__scrubber-wrap) {\n  display: none;\n}\n\n.cm-chrono__player-shell .review-video-player__chrome-toggle {\n  top: max(clamp(4px, 1.4cqmin, 10px), env(safe-area-inset-top, 0px));\n  right: clamp(2.4rem, 11cqmin, 3.5rem);\n  min-width: var(--cm-rv-btn);\n  min-height: var(--cm-rv-btn);\n  width: var(--cm-rv-btn);\n  height: var(--cm-rv-btn);\n  border-radius: var(--cm-rv-radius);\n}\n\n.cm-chrono__player-shell .review-video-player__analysis-hud {\n  top: calc(max(0.5rem, env(safe-area-inset-top, 0px)) + clamp(2.2rem, 8cqmin, 2.9rem));\n  gap: clamp(4px, 1.2cqmin, 8px);\n}\n\n.cm-chrono__player-shell .review-video-player__analysis-info-btn {\n  width: clamp(1.55rem, 7cqmin, 2.4rem);\n  height: clamp(1.55rem, 7cqmin, 2.4rem);\n}\n\n.cm-chrono__player-shell .review-video-player__analysis-info-btn svg {\n  width: clamp(12px, 3.6cqmin, 18px);\n  height: clamp(12px, 3.6cqmin, 18px);\n}\n\n.cm-chrono__player-shell .review-video-player__feedback-panel {\n  width: min(86%, clamp(9rem, 42cqmin, 13.5rem));\n  max-height: min(38%, clamp(6.5rem, 36cqh, 14rem));\n  padding: clamp(4px, 1.4cqmin, 8px) clamp(6px, 1.8cqmin, 10px);\n  border-radius: clamp(8px, 2cqmin, 12px);\n  font-size: clamp(0.58rem, 2.2cqmin, 0.72rem);\n}\n\n.cm-chrono__player-shell .cm-chrono__board {\n  font-size: clamp(0.62rem, 2.6cqmin, 0.9rem);\n}\n\n/* Short / narrow frames: keep transport, drop secondary chrome. */\n@container cm-player (max-width: 480px), (max-height: 320px) {\n  .review-video-player__chrome--top .review-video-player__orient,\n  .review-video-player__chrome--top .review-video-player__pose-tools,\n  .review-video-player__transport-extra,\n  .review-video-player__joint-overlay {\n    display: none;\n  }\n\n  .review-video-player__btn span {\n    display: none;\n  }\n\n  .review-video-player__btn {\n    gap: 0;\n  }\n}\n\n@container cm-player (max-height: 260px) {\n  .review-video-player__speeds,\n  .review-video-player__chrome--top .review-video-player__orient-status {\n    display: none;\n  }\n\n  .review-video-player__chrome--bottom {\n    gap: 2px;\n    padding-top: 2px;\n  }\n}\n\n@container cm-player (max-height: 200px) {\n  .review-video-player__chrome--top {\n    display: none;\n  }\n\n  .review-video-player__time {\n    display: none;\n  }\n}\n\n.cm-film {\n  display: flex;\n  flex-direction: column;\n  gap: 0.4rem;\n  flex: 0 0 auto;\n  min-width: 0;\n  padding: 0.5rem 0 0.45rem;\n  background: var(--cm-rail);\n  color: var(--cm-text);\n}\n\n.cm-film__head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.5rem;\n  padding: 0 0.6rem;\n  min-width: 0;\n}\n\n.cm-film__sets {\n  display: inline-flex;\n  align-items: center;\n  gap: 2px;\n  min-width: 0;\n  overflow-x: auto;\n  padding: 2px;\n  border-radius: 999px;\n  background: var(--cm-fill);\n  -webkit-overflow-scrolling: touch;\n  scrollbar-width: none;\n}\n\n.cm-film .cm-film__set {\n  flex: 0 0 auto;\n  border: 0;\n  background: transparent;\n  color: var(--cm-muted);\n  border-radius: 999px;\n  padding: 0.3rem 0.7rem;\n  font: inherit;\n  font-size: 0.68rem;\n  font-weight: 750;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  cursor: pointer;\n  transition: background 0.15s ease, color 0.15s ease;\n}\n\n.cm-film .cm-film__set.is-on {\n  background: var(--cm-chip-on);\n  color: var(--cm-text);\n  box-shadow: 0 1px 0 rgba(255, 255, 255, 0.06) inset, 0 2px 6px rgba(0, 0, 0, 0.35);\n}\n\n.cm-film__progress {\n  flex: 0 0 auto;\n  font-size: 0.66rem;\n  font-weight: 700;\n  font-variant-numeric: tabular-nums;\n  color: var(--cm-muted);\n  white-space: nowrap;\n}\n\n.cm-film__progress.is-done {\n  color: var(--cm-home);\n}\n\n.cm-film__points {\n  display: flex;\n  flex-wrap: nowrap;\n  gap: 0.3rem;\n  overflow-x: auto;\n  scroll-snap-type: x proximity;\n  scroll-padding-inline: 0.6rem;\n  padding: 0.1rem 0.6rem 0.15rem;\n  -webkit-overflow-scrolling: touch;\n  scrollbar-width: none;\n}\n\n.cm-film__point {\n  --oc: var(--cm-fill-strong);\n  position: relative;\n  flex: 0 0 auto;\n  scroll-snap-align: start;\n  display: inline-flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 0.05rem;\n  min-width: 2.7rem;\n  min-height: 2.6rem;\n  border: 1px solid var(--cm-hair);\n  background: var(--cm-chip);\n  color: var(--cm-text);\n  border-radius: 10px;\n  padding: 0.2rem 0.45rem 0.32rem;\n  overflow: hidden;\n  font: inherit;\n  cursor: pointer;\n  transition: border-color 0.15s ease, background 0.15s ease;\n}\n\n.cm-film__point::after {\n  content: \"\";\n  position: absolute;\n  left: 0.4rem;\n  right: 0.4rem;\n  bottom: 0.18rem;\n  height: 3px;\n  border-radius: 999px;\n  background: var(--oc);\n}\n\n.cm-film__point[data-outcome=\"winner\"] { --oc: #22c55e; }\n.cm-film__point[data-outcome=\"unforced_error\"] { --oc: #ef4444; }\n.cm-film__point[data-outcome=\"forced_error\"] { --oc: #eab308; }\n.cm-film__point[data-outcome=\"lucky\"] { --oc: #94a3b8; }\n.cm-film__point[data-outcome=\"rally\"] { --oc: #0ea5e9; }\n\n.cm-film__point:disabled {\n  opacity: 0.45;\n  cursor: default;\n}\n\n.cm-film__point:focus-visible {\n  outline: 2px solid var(--cm-primary);\n  outline-offset: 1px;\n}\n\n.cm-film__point-n {\n  font-family: \"Barlow Condensed\", \"Outfit\", sans-serif;\n  font-size: 0.66rem;\n  font-weight: 600;\n  letter-spacing: 0.04em;\n  color: var(--cm-muted);\n  line-height: 1;\n}\n\n.cm-film__point-score {\n  font-size: 0.8rem;\n  font-weight: 800;\n  font-variant-numeric: tabular-nums;\n  letter-spacing: -0.02em;\n  line-height: 1.1;\n}\n\n.cm-film__point-score.is-empty {\n  color: var(--cm-muted);\n  font-weight: 650;\n}\n\n.cm-film__point.is-selected {\n  border-color: color-mix(in srgb, var(--cm-primary) 70%, transparent);\n  background: color-mix(in srgb, var(--cm-primary) 24%, var(--cm-chip));\n}\n\n.cm-film__point.is-active {\n  border-color: var(--cm-primary);\n  box-shadow: 0 0 0 2px color-mix(in srgb, var(--cm-primary) 35%, transparent);\n}\n\n.cm-film__point.is-active .cm-film__point-n,\n.cm-film__point.is-selected .cm-film__point-n {\n  color: var(--cm-text);\n}\n\n.cm-film__labels {\n  display: flex;\n  gap: 0.7rem;\n  overflow-x: auto;\n  padding: 0.05rem 0.55rem 0.35rem;\n  -webkit-overflow-scrolling: touch;\n}\n\n.cm-film__label-group {\n  flex: 0 0 auto;\n  display: inline-flex;\n  align-items: center;\n  gap: 0.28rem;\n}\n\n.cm-film__label-kicker {\n  font-size: 0.62rem;\n  font-weight: 800;\n  letter-spacing: 0.07em;\n  text-transform: uppercase;\n  color: var(--cm-muted);\n  margin-right: 0.1rem;\n}\n\n.cm-film__label {\n  border-radius: 999px;\n  padding: 0.16rem 0.45rem;\n  background: color-mix(in srgb, var(--cm-muted) 14%, var(--cm-slate));\n  color: var(--cm-text);\n  font-size: 0.68rem;\n  font-weight: 700;\n}\n\n.cm-film__labels-empty {\n  font-size: 0.72rem;\n  color: var(--cm-muted);\n}\n\n.cm-chrono:fullscreen,\n.cm-chrono.is-review-fs,\n.cm-review:fullscreen {\n  background: var(--cm-bg);\n  color: var(--cm-text);\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n\n.cm-chrono:fullscreen .cm-film,\n.cm-chrono.is-review-fs .cm-film,\n.cm-review:fullscreen .cm-film {\n  display: flex;\n}\n\n.cm-chrono:fullscreen .cm-chrono__sets,\n.cm-chrono:fullscreen .cm-chrono__set-label,\n.cm-chrono:fullscreen .cm-chrono__rail,\n.cm-chrono.is-review-fs .cm-chrono__sets,\n.cm-chrono.is-review-fs .cm-chrono__set-label,\n.cm-chrono.is-review-fs .cm-chrono__rail,\n.cm-review:fullscreen .cm-chrono__sets,\n.cm-review:fullscreen .cm-chrono__set-label,\n.cm-review:fullscreen .cm-chrono__rail {\n  display: none;\n}\n\n.cm-chrono:fullscreen .cm-chrono__layout,\n.cm-chrono.is-review-fs .cm-chrono__layout,\n.cm-review:fullscreen .cm-chrono__layout {\n  flex: 1 1 auto;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n  grid-template-columns: 1fr;\n}\n\n.cm-chrono:fullscreen .cm-chrono__stage,\n.cm-chrono.is-review-fs .cm-chrono__stage,\n.cm-review:fullscreen .cm-chrono__stage {\n  flex: 1 1 auto;\n  min-height: 0;\n  padding: 0;\n  gap: 0;\n}\n\n.cm-chrono:fullscreen .cm-chrono__player-shell,\n.cm-chrono.is-review-fs .cm-chrono__player-shell,\n.cm-review:fullscreen .cm-chrono__player-shell {\n  flex: 1 1 auto;\n  aspect-ratio: auto;\n  min-height: 0;\n  border-radius: 0;\n}\n\n.cm-chrono:fullscreen .cm-chrono__side:not(:has(.cm-chrono__mod)),\n.cm-chrono.is-review-fs .cm-chrono__side:not(:has(.cm-chrono__mod)),\n.cm-review:fullscreen .cm-chrono__side:not(:has(.cm-chrono__mod)) {\n  display: none;\n}\n\n.cm-review:fullscreen {\n  padding: 0;\n}\n\n.cm-review:fullscreen .cm-review__body,\n.cm-review:fullscreen .cm-chrono {\n  flex: 1 1 auto;\n  min-height: 0;\n  height: auto;\n  border: 0;\n  border-radius: 0;\n  background: transparent;\n}\n\n/* Timeline fullscreen: video on top, one set + point strip along the bottom.\n   Portrait phones rotate this stage so playback is landscape. */\n.cm-chrono.is-stage-fs {\n  position: fixed;\n  inset: 0;\n  z-index: 11000;\n  width: 100dvw;\n  height: 100dvh;\n  max-height: none;\n  margin: 0;\n  border: 0;\n  border-radius: 0;\n  background: #05070c;\n  display: flex;\n  flex-direction: column;\n}\n\n.cm-chrono.is-stage-fs.is-portrait-stage {\n  inset: auto;\n  top: 0;\n  left: 0;\n  right: auto;\n  bottom: auto;\n  width: 100dvh;\n  height: 100dvw;\n  transform: rotate(90deg) translateY(-100%);\n  transform-origin: top left;\n}\n\n.cm-chrono.is-stage-fs .cm-chrono__layout,\n.cm-chrono.is-stage-fs .cm-chrono__stage,\n.cm-chrono:fullscreen .cm-chrono__layout,\n.cm-chrono:fullscreen .cm-chrono__stage {\n  flex: 1 1 auto;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n  padding: 0;\n  gap: 0;\n  background: #05070c;\n}\n\n.cm-chrono.is-stage-fs .cm-chrono__player-shell,\n.cm-chrono:fullscreen .cm-chrono__player-shell {\n  flex: 1 1 0%;\n  min-height: 0;\n  width: 100%;\n  height: auto;\n  aspect-ratio: auto;\n  border-radius: 0;\n}\n\n.cm-chrono.is-stage-fs .cm-chrono__rubber,\n.cm-chrono.is-stage-fs .cm-chrono__side,\n.cm-chrono.is-stage-fs .cm-chrono__tagger-slot,\n.cm-chrono.is-stage-fs .cm-chrono__tape-scrub,\n.cm-chrono:fullscreen .cm-chrono__rubber,\n.cm-chrono:fullscreen .cm-chrono__side,\n.cm-chrono:fullscreen .cm-chrono__tagger-slot,\n.cm-chrono:fullscreen .cm-chrono__tape-scrub {\n  display: none;\n}\n\n.cm-chrono.is-stage-fs .cm-film,\n.cm-chrono:fullscreen .cm-film {\n  display: flex;\n  flex: 0 0 auto;\n  background: #0b1018;\n  padding-bottom: max(0.45rem, env(safe-area-inset-bottom, 0px));\n  padding-left: env(safe-area-inset-left, 0px);\n  padding-right: env(safe-area-inset-right, 0px);\n}\n\n.cm-chrono.is-stage-fs .cm-chrono__player-shell .review-video-player__analysis-hud {\n  top: calc(max(0.6rem, env(safe-area-inset-top, 0px)) + 3.2rem);\n}\n\n/* Portrait full screen: upright stage, video centred, point strip under the\n   thumb. On wide screens the stage keeps a phone-shaped column. */\n.cm-chrono.is-stage-portrait {\n  background:\n    radial-gradient(120% 60% at 50% 0%, color-mix(in srgb, var(--cm-primary) 14%, transparent), transparent 70%),\n    #05070c;\n}\n\n.cm-chrono.is-stage-portrait .cm-chrono__layout {\n  background: transparent;\n}\n\n.cm-chrono.is-stage-portrait .cm-chrono__stage {\n  align-items: center;\n  width: 100%;\n  min-width: 0;\n  background: transparent;\n}\n\n.cm-chrono.is-stage-portrait .cm-chrono__player-shell,\n.cm-chrono.is-stage-portrait .cm-film {\n  width: min(100%, calc(100dvh * 9 / 16));\n  max-width: 100%;\n}\n\n.cm-chrono.is-stage-portrait .cm-chrono__player-shell {\n  background: transparent;\n}\n\n.cm-chrono.is-stage-portrait .cm-film {\n  background: transparent;\n  border-top: 1px solid rgba(255, 255, 255, 0.06);\n  padding-top: 0.65rem;\n}\n\n.cm-chrono.is-stage-portrait .cm-film__point {\n  min-width: 3rem;\n  min-height: 2.9rem;\n}\n\n@media (orientation: portrait) {\n  .cm-chrono.is-stage-portrait .cm-chrono__player-shell,\n  .cm-chrono.is-stage-portrait .cm-film {\n    width: 100%;\n  }\n}\n\n/* Landscape stage: the tape fills the screen. Sets, labels, and the live\n   score sit on top of the picture instead of reserving a band under it. */\n.cm-chrono.is-stage-landscape .cm-chrono__layout,\n.cm-chrono.is-stage-landscape .cm-chrono__stage {\n  position: relative;\n  flex: 1 1 auto;\n  min-height: 0;\n}\n\n.cm-chrono.is-stage-landscape .cm-chrono__player-shell {\n  position: absolute;\n  inset: 0;\n  z-index: 1;\n  width: 100%;\n  height: 100%;\n  max-height: none;\n  flex: none;\n}\n\n.cm-chrono.is-stage-landscape .cm-chrono__player-shell .review-video-player,\n.cm-chrono.is-stage-landscape .cm-chrono__player-shell .review-video-player__viewport,\n.cm-chrono.is-stage-landscape .cm-chrono__player-shell .review-video-player__transform,\n.cm-chrono.is-stage-landscape .cm-chrono__player-shell .review-video-player__video {\n  width: 100%;\n  height: 100%;\n  max-width: none;\n  max-height: none;\n  aspect-ratio: auto;\n  object-fit: contain;\n}\n\n.cm-chrono.is-stage-landscape .cm-film {\n  position: absolute;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: 26;\n  flex: none;\n  height: auto;\n  background: transparent;\n  padding: 0;\n  pointer-events: none;\n}\n\n.cm-chrono.is-stage-landscape .cm-film__points {\n  display: none;\n}\n\n.cm-chrono.is-stage-landscape .cm-chrono__board,\n.cm-chrono.is-stage-landscape .cm-chrono__tape-id,\n.cm-chrono.is-stage-landscape .cm-chrono__parts {\n  display: none;\n}\n\n.cm-chrono.is-stage-landscape .cm-film__head {\n  padding:\n    max(0.45rem, env(safe-area-inset-top, 0px))\n    max(6.4rem, calc(env(safe-area-inset-right, 0px) + 5.6rem))\n    0\n    max(0.55rem, env(safe-area-inset-left, 0px));\n  pointer-events: none;\n}\n\n.cm-chrono.is-stage-landscape .cm-film__sets {\n  pointer-events: auto;\n  background: rgba(5, 8, 14, 0.55);\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n}\n\n.cm-chrono.is-stage-landscape .cm-film .cm-film__set {\n  color: rgba(248, 250, 252, 0.72);\n}\n\n.cm-chrono.is-stage-landscape .cm-film .cm-film__set.is-on {\n  background: rgba(255, 255, 255, 0.16);\n  color: #fff;\n  box-shadow: none;\n}\n\n.cm-chrono.is-stage-landscape .cm-film__progress {\n  padding: 0.28rem 0.55rem;\n  border-radius: 999px;\n  background: rgba(5, 8, 14, 0.55);\n  color: rgba(248, 250, 252, 0.82);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.cm-chrono.is-stage-landscape .cm-film__labels {\n  padding:\n    0.35rem\n    max(0.55rem, env(safe-area-inset-right, 0px))\n    0\n    max(0.55rem, env(safe-area-inset-left, 0px));\n  pointer-events: none;\n}\n\n.cm-chrono.is-stage-landscape .cm-chrono__player-shell .review-video-player__chrome--top {\n  padding-top: max(2.75rem, calc(env(safe-area-inset-top, 0px) + 2.35rem));\n}\n\n.cm-chrono.is-stage-landscape .cm-chrono__player-shell .review-video-player__chrome--bottom {\n  padding-left: max(\n    0.75rem,\n    calc(min(22rem, 68vw) + env(safe-area-inset-left, 0px))\n  );\n}\n\n.cm-league {\n  --cm-league-brand: var(--cm-primary, #0877bc);\n  --cm-league-ink: #f8fafc;\n  --cm-league-muted: rgba(248, 250, 252, 0.72);\n  --cm-league-board: rgba(8, 12, 20, 0.88);\n  --cm-league-edge: color-mix(in srgb, var(--cm-league-brand) 45%, rgba(255, 255, 255, 0.14));\n  --cm-league-teams-bg: color-mix(in srgb, var(--cm-league-brand) 16%, rgba(248, 250, 252, 0.96));\n  --cm-league-teams-ink: #0f172a;\n  --cm-league-set-bg: color-mix(in srgb, var(--cm-league-brand) 78%, #0b1220);\n  --cm-league-set-ink: #fff;\n  --cm-league-brand-bg: color-mix(in srgb, var(--cm-league-brand) 82%, #0b1220);\n  --cm-league-logo-bg: #ffffff;\n  --cm-league-logo-ring: color-mix(in srgb, var(--cm-league-brand) 28%, rgba(15, 23, 42, 0.18));\n  --cm-league-logo-ink: #0f172a;\n  --cm-league-home: color-mix(in srgb, var(--cm-league-brand) 72%, var(--cm-home, #34d399));\n  --cm-league-away: color-mix(in srgb, var(--cm-league-brand) 55%, var(--cm-away, #60a5fa));\n  --cm-league-shadow: drop-shadow(0 8px 18px rgba(0, 0, 0, 0.45));\n  position: absolute;\n  z-index: 21;\n  left: max(0.4rem, env(safe-area-inset-left, 0px));\n  bottom: max(0.4rem, env(safe-area-inset-bottom, 0px));\n  display: flex;\n  align-items: stretch;\n  gap: 0.28rem;\n  max-width: min(34rem, calc(100% - 0.8rem));\n  pointer-events: none;\n  color: var(--cm-league-ink);\n  filter: var(--cm-league-shadow);\n}\n\n/* Bright page theme — light plate when docked under the tape. */\n.cm-page--light .cm-league {\n  --cm-league-ink: #0f172a;\n  --cm-league-muted: #475569;\n  --cm-league-board: rgba(255, 255, 255, 0.94);\n  --cm-league-edge: color-mix(in srgb, var(--cm-league-brand) 40%, rgba(15, 23, 42, 0.12));\n  --cm-league-teams-bg: color-mix(in srgb, var(--cm-league-brand) 12%, #ffffff);\n  --cm-league-teams-ink: #0f172a;\n  --cm-league-set-bg: color-mix(in srgb, var(--cm-league-brand) 88%, #0b1220);\n  --cm-league-set-ink: #fff;\n  --cm-league-brand-bg: color-mix(in srgb, var(--cm-league-brand) 22%, #e8eef5);\n  --cm-league-logo-bg: #ffffff;\n  --cm-league-logo-ring: color-mix(in srgb, var(--cm-league-brand) 35%, rgba(15, 23, 42, 0.14));\n  --cm-league-logo-ink: #0f172a;\n  --cm-league-home: color-mix(in srgb, var(--cm-league-brand) 55%, var(--cm-home, #047857));\n  --cm-league-away: color-mix(in srgb, var(--cm-league-brand) 45%, #2563eb);\n  --cm-league-shadow: drop-shadow(0 6px 14px rgba(15, 23, 42, 0.16));\n}\n\n/* Over video (fullscreen / landscape) stay dark for contrast on the picture. */\n.cm-page--light .cm-chrono.is-stage-landscape .cm-league,\n.cm-page--light .cm-chrono.is-stage-fs .cm-league,\n.cm-page--light .cm-chrono__player-shell .cm-league {\n  --cm-league-ink: #f8fafc;\n  --cm-league-muted: rgba(248, 250, 252, 0.72);\n  --cm-league-board: rgba(8, 12, 20, 0.88);\n  --cm-league-edge: color-mix(in srgb, var(--cm-league-brand) 45%, rgba(255, 255, 255, 0.14));\n  --cm-league-teams-bg: color-mix(in srgb, var(--cm-league-brand) 16%, rgba(248, 250, 252, 0.96));\n  --cm-league-teams-ink: #0f172a;\n  --cm-league-set-bg: color-mix(in srgb, var(--cm-league-brand) 78%, #0b1220);\n  --cm-league-set-ink: #fff;\n  --cm-league-brand-bg: color-mix(in srgb, var(--cm-league-brand) 82%, #0b1220);\n  --cm-league-logo-bg: #ffffff;\n  --cm-league-logo-ring: color-mix(in srgb, var(--cm-league-brand) 28%, rgba(15, 23, 42, 0.18));\n  --cm-league-logo-ink: #0f172a;\n  --cm-league-home: color-mix(in srgb, var(--cm-league-brand) 72%, #34d399);\n  --cm-league-away: color-mix(in srgb, var(--cm-league-brand) 55%, #60a5fa);\n  --cm-league-shadow: drop-shadow(0 8px 18px rgba(0, 0, 0, 0.45));\n}\n\n.cm-league__brand {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 0.18rem;\n  width: 3.35rem;\n  flex: 0 0 auto;\n  padding: 0.28rem 0.2rem;\n  background: var(--cm-league-brand-bg);\n}\n\n.cm-league__logo,\n.cm-league__mark {\n  width: 2.35rem;\n  height: 2.35rem;\n  flex: 0 0 auto;\n  box-sizing: border-box;\n  padding: 0.22rem;\n  border-radius: 50%;\n  background: var(--cm-league-logo-bg);\n  border: 1.5px solid var(--cm-league-logo-ring);\n  box-shadow:\n    0 1px 2px rgba(15, 23, 42, 0.12),\n    inset 0 0 0 1px rgba(255, 255, 255, 0.55);\n}\n\n.cm-league__logo {\n  object-fit: contain;\n}\n\n.cm-league__mark {\n  display: grid;\n  place-items: center;\n  color: var(--cm-league-logo-ink);\n  font-size: 0.72rem;\n  font-weight: 800;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n}\n\n.cm-league__club {\n  max-width: 3.3rem;\n  font-size: 0.48rem;\n  font-weight: 800;\n  letter-spacing: 0.04em;\n  line-height: 1.05;\n  text-align: center;\n  text-transform: uppercase;\n  color: var(--cm-league-set-ink);\n}\n\n.cm-league__board {\n  flex: 1 1 auto;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  background: var(--cm-league-board);\n  border: 1px solid var(--cm-league-edge);\n  box-shadow: inset 3px 0 0 var(--cm-league-brand);\n}\n\n.cm-league__teams {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) auto auto minmax(0, 1fr);\n  align-items: center;\n  column-gap: 0.35rem;\n  padding: 0.12rem 0.4rem;\n  background: var(--cm-league-teams-bg);\n  color: var(--cm-league-teams-ink);\n  font-size: 0.68rem;\n  font-weight: 800;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  border-bottom: 2px solid var(--cm-league-brand);\n}\n\n.cm-league__set {\n  padding: 0.08rem 0.4rem;\n  background: var(--cm-league-set-bg);\n  color: var(--cm-league-set-ink);\n  font-size: 0.58rem;\n  font-weight: 800;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n}\n\n.cm-league__team {\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.cm-league__team--away {\n  text-align: right;\n}\n\n.cm-league__team-score {\n  font-family: \"Barlow Condensed\", \"Arial Narrow\", Impact, sans-serif;\n  font-size: 1.15rem;\n  font-weight: 700;\n  font-variant-numeric: tabular-nums;\n  line-height: 1;\n}\n\n.cm-league__teams.has-division {\n  grid-template-columns: minmax(0, 1fr) auto minmax(0, 1.15fr) auto minmax(0, 1fr);\n}\n\n.cm-league__division {\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  text-align: center;\n  font-size: 0.58rem;\n  font-weight: 800;\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n}\n\n.cm-league__player {\n  display: grid;\n  grid-template-columns: 1.2rem minmax(0, 1fr) auto;\n  align-items: center;\n  column-gap: 0.4rem;\n  min-height: 1.45rem;\n  padding: 0.08rem 0.4rem 0.08rem 0.22rem;\n}\n\n.cm-league__player--home {\n  --cm-league-side: var(--cm-league-home);\n}\n\n.cm-league__player--away {\n  --cm-league-side: var(--cm-league-away);\n}\n\n.cm-league__games {\n  width: 1.2rem;\n  height: 1.2rem;\n  display: grid;\n  place-items: center;\n  background: var(--cm-league-side);\n  color: #fff;\n  font-size: 0.75rem;\n  font-weight: 800;\n  font-variant-numeric: tabular-nums;\n}\n\n.cm-league__name {\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  font-size: 0.66rem;\n  font-weight: 750;\n  letter-spacing: 0.02em;\n  text-transform: none;\n}\n\n.cm-league__pts {\n  font-family: \"Barlow Condensed\", \"Arial Narrow\", Impact, sans-serif;\n  font-size: 1.45rem;\n  font-weight: 700;\n  font-variant-numeric: tabular-nums;\n  line-height: 0.9;\n  min-width: 1.2rem;\n  text-align: right;\n}\n\n.cm-chrono__label-wait {\n  top: max(0.55rem, env(safe-area-inset-top, 0px));\n  bottom: auto;\n}\n\n.cm-broadcast {\n  position: absolute;\n  z-index: 21;\n  left: max(0.55rem, env(safe-area-inset-left, 0px));\n  bottom: max(0.55rem, env(safe-area-inset-bottom, 0px));\n  width: min(16.4rem, 48vw);\n  display: flex;\n  flex-direction: column;\n  gap: 0.12rem;\n  padding: 0.38rem 0.55rem 0.32rem 0.42rem;\n  border-radius: 2px;\n  background: rgba(5, 8, 14, 0.78);\n  border: 1px solid rgba(255, 255, 255, 0.16);\n  box-shadow: 0 10px 28px rgba(0, 0, 0, 0.38);\n  backdrop-filter: blur(8px);\n  -webkit-backdrop-filter: blur(8px);\n  pointer-events: none;\n  color: #f8fafc;\n}\n\n.cm-broadcast__row {\n  display: grid;\n  grid-template-columns: 3px minmax(0, 1fr) auto;\n  align-items: center;\n  column-gap: 0.45rem;\n  min-height: 1.45rem;\n}\n\n.cm-broadcast__row--home {\n  --cm-side: var(--cm-home, #34d399);\n}\n\n.cm-broadcast__row--away {\n  --cm-side: var(--cm-away, #fbbf24);\n}\n\n.cm-broadcast__bar {\n  width: 3px;\n  height: 1.05rem;\n  background: var(--cm-side);\n}\n\n.cm-broadcast__name {\n  min-width: 0;\n  font-size: 0.72rem;\n  font-weight: 700;\n  letter-spacing: 0.07em;\n  text-transform: uppercase;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.cm-broadcast__pts {\n  font-family: \"Barlow Condensed\", \"Arial Narrow\", Impact, sans-serif;\n  font-size: 1.7rem;\n  font-weight: 700;\n  font-variant-numeric: tabular-nums;\n  letter-spacing: 0.02em;\n  line-height: 0.85;\n  min-width: 1.35rem;\n  text-align: right;\n}\n\n.cm-broadcast__meta {\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  gap: 0.6rem;\n  margin-top: 0.12rem;\n  padding-top: 0.16rem;\n  border-top: 1px solid rgba(255, 255, 255, 0.14);\n  font-size: 0.62rem;\n  font-weight: 700;\n  letter-spacing: 0.12em;\n  text-transform: uppercase;\n  color: rgba(248, 250, 252, 0.72);\n}\n\n.cm-broadcast__sets {\n  font-family: \"Barlow Condensed\", \"Arial Narrow\", sans-serif;\n  font-size: 0.95rem;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  color: #fff;\n}\n\n.cm-page--timeline .cm-body,\n.cm-page--timeline .cm-panel {\n  min-height: 0;\n}\n\n.cm-page--timeline .cm-cam-status {\n  max-height: 2.6rem;\n  overflow: auto;\n  flex: 0 0 auto;\n}\n\n.cm-chrono__point-strip {\n  display: none;\n  gap: 0.35rem;\n  overflow-x: auto;\n  padding: 0.05rem 0.05rem 0.15rem;\n  -webkit-overflow-scrolling: touch;\n  scroll-snap-type: x proximity;\n}\n\n.cm-chrono__point-pill {\n  flex: 0 0 auto;\n  display: inline-flex;\n  align-items: center;\n  gap: 0.35rem;\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  background: rgba(255, 255, 255, 0.06);\n  color: #f8fafc;\n  border-radius: 999px;\n  padding: 0.38rem 0.65rem 0.38rem 0.38rem;\n  font: inherit;\n  cursor: pointer;\n  scroll-snap-align: start;\n}\n\n.cm-chrono__point-pill:disabled {\n  opacity: 0.45;\n  cursor: default;\n}\n\n.cm-chrono__point-pill-n {\n  width: 1.35rem;\n  height: 1.35rem;\n  border-radius: 999px;\n  display: grid;\n  place-items: center;\n  font-size: 0.65rem;\n  font-weight: 800;\n  background: rgba(255, 255, 255, 0.12);\n}\n\n.cm-chrono__point-pill-score {\n  font-size: 0.82rem;\n  font-weight: 800;\n  font-variant-numeric: tabular-nums;\n}\n\n.cm-chrono__point-pill-dot {\n  width: 0.4rem;\n  height: 0.4rem;\n  border-radius: 999px;\n  background: var(--cm-primary, #38bdf8);\n}\n\n.cm-chrono__point-pill.is-active,\n.cm-chrono__point-pill.is-selected {\n  border-color: color-mix(in srgb, var(--cm-primary) 65%, transparent);\n  background: color-mix(in srgb, var(--cm-primary) 28%, rgba(8, 12, 20, 0.7));\n}\n\n.cm-chrono__point-pill.is-active .cm-chrono__point-pill-n {\n  background: var(--cm-primary);\n  color: #041018;\n}\n\n.cm-chrono__tape-scrub {\n  display: flex;\n  align-items: center;\n  gap: 0.55rem;\n  padding: 0 0.1rem;\n  flex: 0 0 auto;\n}\n\n.cm-chrono__tape-scrub-label {\n  flex: 0 0 auto;\n  font-size: 0.66rem;\n  font-weight: 800;\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n  color: rgba(248, 250, 252, 0.65);\n}\n\n.cm-chrono__tape-scrub input[type=\"range\"] {\n  flex: 1 1 auto;\n  min-width: 0;\n  accent-color: var(--cm-primary);\n}\n\n.cm-chrono__side {\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n  min-width: 0;\n  flex: 0 0 auto;\n  max-height: 28%;\n  overflow: auto;\n  border-left: 0;\n  border-top: 1px solid var(--cm-border);\n  background: color-mix(in srgb, var(--cm-muted) 5%, var(--cm-slate));\n}\n\n.cm-chrono__side:not(:has(.cm-chrono__mod)):not(:has(.cm-chrono__score-ai)) {\n  display: none;\n}\n\n.cm-chrono__sets,\n.cm-chrono__set-label,\n.cm-chrono__rail {\n  display: none;\n}\n\n.cm-chrono__sets {\n  gap: 0.35rem;\n  padding: 0.55rem 0.65rem 0.2rem;\n  overflow-x: auto;\n  flex: 0 0 auto;\n}\n\n.cm-chrono__set {\n  flex: 0 0 auto;\n  border: 1px solid var(--cm-border);\n  background: transparent;\n  color: var(--cm-text);\n  border-radius: 999px;\n  padding: 0.3rem 0.68rem;\n  font: inherit;\n  font-size: 0.7rem;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  cursor: pointer;\n}\n\n.cm-chrono__set.is-on {\n  background: color-mix(in srgb, var(--cm-primary) 18%, transparent);\n  border-color: color-mix(in srgb, var(--cm-primary) 55%, var(--cm-border));\n  color: var(--cm-primary);\n}\n\n.cm-chrono__set-label {\n  margin: 0.45rem 0.75rem 0;\n  font-size: 0.68rem;\n  font-weight: 800;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: var(--cm-muted);\n  flex: 0 0 auto;\n}\n\n.cm-chrono__rail {\n  flex: 1 1 auto;\n  min-height: 0;\n  overflow: auto;\n  padding: 0.45rem 0.55rem 0.55rem;\n  scroll-padding-block: 2.5rem;\n}\n\n.cm-chrono__rail-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.5rem;\n  margin-bottom: 0.4rem;\n  position: sticky;\n  top: 0;\n  z-index: 1;\n  padding: 0.15rem 0 0.35rem;\n  background: linear-gradient(\n    to bottom,\n    color-mix(in srgb, var(--cm-slate) 96%, transparent),\n    color-mix(in srgb, var(--cm-slate) 88%, transparent)\n  );\n}\n\n.cm-chrono__rail-label {\n  margin: 0;\n  font-size: 0.66rem;\n  font-weight: 800;\n  letter-spacing: 0.07em;\n  text-transform: uppercase;\n  color: var(--cm-muted);\n}\n\n.cm-chrono__now-pill {\n  flex: 0 0 auto;\n  padding: 0.16rem 0.48rem;\n  border-radius: 999px;\n  background: color-mix(in srgb, var(--cm-primary) 22%, transparent);\n  color: var(--cm-primary);\n  font-size: 0.62rem;\n  font-weight: 800;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n}\n\n.cm-chrono__cues {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n}\n\n.cm-chrono__cue {\n  border-radius: 12px;\n  border: 1px solid transparent;\n  background: color-mix(in srgb, var(--cm-primary) 4%, transparent);\n  transition:\n    border-color 0.18s ease,\n    background 0.18s ease,\n    box-shadow 0.18s ease;\n}\n\n.cm-chrono__cue.is-selected {\n  border-color: color-mix(in srgb, var(--cm-primary) 32%, var(--cm-border));\n  background: color-mix(in srgb, var(--cm-primary) 8%, var(--cm-slate));\n}\n\n.cm-chrono__cue.is-active {\n  border-color: color-mix(in srgb, var(--cm-primary) 70%, var(--cm-border));\n  background: color-mix(in srgb, var(--cm-primary) 15%, var(--cm-slate));\n  box-shadow:\n    inset 3px 0 0 var(--cm-primary),\n    0 0 0 1px color-mix(in srgb, var(--cm-primary) 22%, transparent);\n}\n\n.cm-chrono__cue-hit {\n  width: 100%;\n  display: grid;\n  grid-template-columns: auto auto auto 1fr auto;\n  grid-template-areas:\n    \"index score clock live media\"\n    \"index tags tags tags tags\"\n    \"index note note note note\";\n  gap: 0.14rem 0.4rem;\n  align-items: baseline;\n  text-align: left;\n  border: 0;\n  background: transparent;\n  color: inherit;\n  font: inherit;\n  padding: 0.5rem 0.6rem;\n  cursor: pointer;\n}\n\n.cm-chrono__cue-hit:disabled {\n  opacity: 0.55;\n  cursor: default;\n}\n\n.cm-chrono__cue-index {\n  grid-area: index;\n  width: 1.45rem;\n  height: 1.45rem;\n  border-radius: 8px;\n  display: grid;\n  place-items: center;\n  font-size: 0.66rem;\n  font-weight: 800;\n  font-variant-numeric: tabular-nums;\n  color: var(--cm-muted);\n  background: color-mix(in srgb, var(--cm-muted) 14%, transparent);\n  align-self: start;\n}\n\n.cm-chrono__cue.is-active .cm-chrono__cue-index {\n  color: #041018;\n  background: var(--cm-primary);\n}\n\n.cm-chrono__cue-score {\n  grid-area: score;\n  font-weight: 800;\n  font-variant-numeric: tabular-nums;\n  font-size: 0.92rem;\n}\n\n.cm-chrono__cue-clock {\n  grid-area: clock;\n  font-size: 0.7rem;\n  font-weight: 700;\n  font-variant-numeric: tabular-nums;\n  color: var(--cm-muted);\n  font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;\n}\n\n.cm-chrono__cue-live {\n  grid-area: live;\n  justify-self: start;\n  padding: 0.1rem 0.35rem;\n  border-radius: 999px;\n  background: color-mix(in srgb, var(--cm-primary) 28%, transparent);\n  color: var(--cm-primary);\n  font-size: 0.6rem;\n  font-weight: 800;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n}\n\n.cm-chrono__cue-tags {\n  grid-area: tags;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.25rem;\n  min-width: 0;\n}\n\n.cm-chrono__cue-tags--empty {\n  font-size: 0.68rem;\n  font-weight: 600;\n  color: color-mix(in srgb, var(--cm-muted) 80%, transparent);\n  font-style: italic;\n}\n\n.cm-chrono__cue-tag {\n  display: inline-flex;\n  align-items: center;\n  padding: 0.1rem 0.38rem;\n  border-radius: 999px;\n  border: 1px solid color-mix(in srgb, var(--cm-primary) 28%, var(--cm-border));\n  background: color-mix(in srgb, var(--cm-primary) 12%, transparent);\n  color: color-mix(in srgb, var(--cm-primary) 75%, var(--cm-text));\n  font-size: 0.64rem;\n  font-weight: 700;\n  letter-spacing: 0.02em;\n  white-space: nowrap;\n}\n\n.cm-chrono__cue-note {\n  grid-area: note;\n  font-size: 0.74rem;\n  color: var(--cm-muted);\n}\n\n.cm-chrono__cue-media {\n  grid-area: media;\n  display: inline-flex;\n  gap: 0.25rem;\n  color: var(--cm-muted);\n  justify-self: end;\n}\n\n.cm-chrono__cue-gallery {\n  display: flex;\n  gap: 0.35rem;\n  padding: 0 0.65rem 0.55rem;\n  overflow-x: auto;\n}\n\n.cm-chrono__thumb {\n  width: 3rem;\n  height: 3rem;\n  padding: 0;\n  border: 1px solid var(--cm-border);\n  border-radius: 8px;\n  overflow: hidden;\n  background: #0b1220;\n  cursor: pointer;\n}\n\n.cm-chrono__thumb img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n}\n\n.cm-chrono__cue-voices {\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n  padding: 0 0.65rem 0.55rem;\n}\n\n.cm-chrono__cue-voices audio {\n  width: 100%;\n}\n\n.cm-chrono__tagger-slot--dock {\n  display: block;\n  flex: 0 1 auto;\n  min-height: 0;\n  max-height: 52%;\n  overflow: auto;\n  overscroll-behavior: contain;\n}\n\n.cm-chrono__tagger-slot--side,\n.cm-chrono__tagger-slot--review {\n  display: none;\n}\n\n/* ── Tag deck (embedded): point nav, flip score, outcome, reactions ── */\n.cm-deck {\n  container-type: inline-size;\n  container-name: cm-deck;\n  display: flex;\n  flex-direction: column;\n  gap: 0.6rem;\n  padding: 0.6rem 0.7rem 0.75rem;\n  background: var(--cm-deck);\n  border-top: 1px solid var(--cm-hair);\n  color: var(--cm-text);\n}\n\n.cm-deck__head {\n  display: grid;\n  grid-template-columns: auto minmax(0, 1fr) auto;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.cm-deck__nav {\n  width: 2.15rem;\n  height: 2.15rem;\n  display: grid;\n  place-items: center;\n  padding: 0;\n  border: 1px solid var(--cm-hair);\n  border-radius: 999px;\n  background: var(--cm-fill);\n  color: var(--cm-text);\n  cursor: pointer;\n  transition: background 0.15s ease, transform 0.12s ease;\n}\n\n.cm-deck__nav:hover:not(:disabled) {\n  background: var(--cm-fill-strong);\n}\n\n.cm-deck__nav:active:not(:disabled) {\n  transform: scale(0.94);\n}\n\n.cm-deck__nav:disabled {\n  opacity: 0.3;\n  cursor: default;\n}\n\n.cm-deck__title {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  min-width: 0;\n  line-height: 1.15;\n}\n\n.cm-deck__title strong {\n  font-size: 0.82rem;\n  font-weight: 750;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 100%;\n}\n\n.cm-deck__clock {\n  font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;\n  font-size: 0.66rem;\n  font-variant-numeric: tabular-nums;\n  color: var(--cm-muted);\n}\n\n.cm-deck__score {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) auto minmax(0, 1fr) auto;\n  align-items: end;\n  gap: 0.35rem;\n}\n\n.cm-deck__sets-edit {\n  display: grid;\n  grid-template-columns: auto minmax(0, 1fr) auto minmax(0, 1fr);\n  align-items: end;\n  gap: 0.3rem 0.35rem;\n  margin: 0 0 0.35rem;\n  padding: 0.35rem 0.4rem;\n  border-radius: 10px;\n  background: color-mix(in srgb, var(--cm-fill, #1e293b) 70%, transparent);\n}\n\n.cm-deck__sets-label {\n  grid-column: 1;\n  align-self: center;\n  font-size: 0.68rem;\n  font-weight: 800;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: var(--cm-muted);\n}\n\n.cm-deck__colon {\n  font-family: \"Barlow Condensed\", \"Outfit\", sans-serif;\n  font-size: 1.7rem;\n  font-weight: 700;\n  line-height: 1;\n  color: var(--cm-muted);\n  opacity: 0.6;\n  padding-bottom: 0.6rem;\n}\n\n.cm-deck__colon--sets {\n  font-size: 1.1rem;\n  padding-bottom: 0.35rem;\n}\n\n.cm-flip--compact .cm-flip__name {\n  font-size: 0.58rem;\n}\n\n.cm-flip--compact .cm-flip__card {\n  min-width: 2.1rem;\n  height: 2.1rem;\n  font-size: 1.05rem;\n}\n\n.cm-flip--compact .cm-flip__step {\n  width: 1.55rem;\n  height: 1.55rem;\n}\n\n/* Flip score card: the umpire's table counter. */\n.cm-flip {\n  --side: var(--cm-home);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.25rem;\n  min-width: 0;\n}\n\n.cm-flip--away {\n  --side: var(--cm-away);\n}\n\n.cm-flip__name {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.3rem;\n  max-width: 100%;\n  font-size: 0.66rem;\n  font-weight: 700;\n  color: var(--cm-muted);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.cm-flip__name::before {\n  content: \"\";\n  flex: 0 0 auto;\n  width: 0.4rem;\n  height: 0.4rem;\n  border-radius: 999px;\n  background: var(--side);\n}\n\n.cm-flip__row {\n  display: flex;\n  align-items: center;\n  gap: 0.25rem;\n}\n\n.cm-flip__step {\n  flex: 0 0 auto;\n  width: 1.95rem;\n  height: 1.95rem;\n  display: grid;\n  place-items: center;\n  padding: 0;\n  border: 0;\n  border-radius: 999px;\n  background: var(--cm-fill);\n  color: var(--cm-text);\n  cursor: pointer;\n  -webkit-tap-highlight-color: transparent;\n  transition: background 0.15s ease, transform 0.12s ease;\n}\n\n.cm-flip__step:hover:not(:disabled) {\n  background: color-mix(in srgb, var(--side) 22%, transparent);\n}\n\n.cm-flip__step:active:not(:disabled) {\n  transform: scale(0.9);\n}\n\n.cm-flip__step:disabled {\n  opacity: 0.3;\n  cursor: default;\n}\n\n.cm-flip .cm-flip__card {\n  width: 2.75rem;\n  height: 3.15rem;\n  padding: 0;\n  border: 0;\n  border-radius: 8px;\n  text-align: center;\n  font-family: \"Barlow Condensed\", \"Outfit\", sans-serif;\n  font-size: 2.05rem;\n  font-weight: 700;\n  font-variant-numeric: tabular-nums;\n  line-height: 1;\n  color: #f8fafc;\n  caret-color: var(--side);\n  background:\n    linear-gradient(\n      180deg,\n      transparent calc(50% - 0.5px),\n      rgba(0, 0, 0, 0.6) calc(50% - 0.5px),\n      rgba(0, 0, 0, 0.6) calc(50% + 0.5px),\n      transparent calc(50% + 0.5px)\n    ),\n    linear-gradient(180deg, #1f2838 0 50%, #171e2b 50% 100%);\n  box-shadow:\n    inset 0 -3px 0 var(--side),\n    inset 0 1px 0 rgba(255, 255, 255, 0.06),\n    0 4px 12px rgba(0, 0, 0, 0.4);\n}\n\n.cm-flip__card::placeholder {\n  color: rgba(248, 250, 252, 0.25);\n}\n\n.cm-flip__card:focus-visible {\n  outline: 2px solid var(--side);\n  outline-offset: 2px;\n}\n\n.cm-deck .cm-deck__save {\n  align-self: end;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.35rem;\n  height: 2.45rem;\n  min-width: 2.45rem;\n  margin-bottom: 0.35rem;\n  padding: 0 0.85rem;\n  border: 1px solid var(--cm-hair);\n  border-radius: 999px;\n  background: var(--cm-fill);\n  color: var(--cm-muted);\n  font: inherit;\n  font-size: 0.72rem;\n  font-weight: 750;\n  white-space: nowrap;\n  cursor: pointer;\n  transition: background 0.18s ease, color 0.18s ease, box-shadow 0.18s ease;\n}\n\n.cm-deck__save.is-ready {\n  border-color: transparent;\n  background: var(--cm-primary);\n  color: #fff;\n  box-shadow: 0 6px 18px color-mix(in srgb, var(--cm-primary) 40%, transparent);\n}\n\n.cm-deck__save:disabled {\n  cursor: default;\n}\n\n.cm-deck__save:disabled:not(.is-ready) {\n  opacity: 0.55;\n}\n\n.cm-deck__save:focus-visible,\n.cm-deck__emoji:focus-visible,\n.cm-deck__nav:focus-visible,\n.cm-flip__step:focus-visible {\n  outline: 2px solid var(--cm-primary);\n  outline-offset: 2px;\n}\n\n.cm-deck__spin {\n  animation: cm-deck-spin 0.9s linear infinite;\n}\n\n@keyframes cm-deck-spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n@container cm-deck (max-width: 26rem) {\n  .cm-deck .cm-deck__save {\n    padding: 0;\n    width: 2.45rem;\n  }\n\n  .cm-deck .cm-deck__save span {\n    position: absolute;\n    width: 1px;\n    height: 1px;\n    overflow: hidden;\n    clip: rect(0, 0, 0, 0);\n    white-space: nowrap;\n  }\n}\n\n@container cm-deck (max-width: 19rem) {\n  .cm-flip__step {\n    width: 1.6rem;\n    height: 1.6rem;\n  }\n\n  .cm-flip .cm-flip__card {\n    width: 2.35rem;\n  }\n}\n\n.cm-deck__label {\n  margin: 0;\n  font-size: 0.62rem;\n  font-weight: 750;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: var(--cm-muted);\n  margin-bottom: -0.3rem;\n}\n\n.cm-outcome--deck {\n  gap: 0.3rem;\n}\n\n.cm-outcome--deck .cm-outcome__btn {\n  min-height: 2.6rem;\n  border-radius: 10px;\n  border-color: color-mix(in srgb, var(--oc) 28%, transparent);\n  background: color-mix(in srgb, var(--oc) 7%, var(--cm-chip));\n  transition: background 0.15s ease, border-color 0.15s ease, transform 0.12s ease;\n}\n\n.cm-outcome--deck .cm-outcome__btn:hover:not(:disabled) {\n  background: color-mix(in srgb, var(--oc) 16%, var(--cm-chip));\n}\n\n.cm-outcome--deck .cm-outcome__btn:active:not(:disabled) {\n  transform: scale(0.96);\n}\n\n.cm-outcome--deck .cm-outcome__btn.is-on {\n  border-color: var(--oc);\n  background: color-mix(in srgb, var(--oc) 26%, var(--cm-chip));\n  box-shadow: 0 0 0 1px var(--oc) inset, 0 4px 14px color-mix(in srgb, var(--oc) 25%, transparent);\n}\n\n.cm-outcome--deck .cm-outcome__btn:focus-visible {\n  outline: 2px solid var(--oc);\n  outline-offset: 2px;\n}\n\n.cm-outcome--deck .cm-outcome__mark {\n  font-size: 0.82rem;\n}\n\n.cm-deck__react {\n  display: flex;\n  gap: 0.3rem;\n  overflow-x: auto;\n  scrollbar-width: none;\n  -webkit-overflow-scrolling: touch;\n  border-top: 1px solid var(--cm-hair);\n  padding-top: 0.55rem;\n}\n\n.cm-deck .cm-deck__emoji {\n  flex: 0 0 auto;\n  width: 2.05rem;\n  height: 2.05rem;\n  display: grid;\n  place-items: center;\n  padding: 0;\n  border: 0;\n  border-radius: 999px;\n  background: var(--cm-fill);\n  font-size: 1.05rem;\n  line-height: 1;\n  cursor: pointer;\n  transition: transform 0.12s ease, background 0.15s ease;\n}\n\n.cm-deck__emoji:hover {\n  background: var(--cm-fill-strong);\n}\n\n.cm-deck__emoji:active {\n  transform: scale(1.18);\n}\n\n.cm-deck__note {\n  margin: -0.2rem 0 0;\n  font-size: 0.72rem;\n  color: var(--cm-muted);\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .cm-deck__spin {\n    animation: none;\n  }\n\n  .cm-deck *,\n  .cm-stagectl,\n  .cm-stagectl__btn,\n  .cm-film__point {\n    transition: none !important;\n  }\n}\n\n.cm-chrono__reassign {\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n  margin-top: 0.35rem;\n  font-size: 0.78rem;\n  color: var(--cm-muted, #6b7280);\n}\n\n.cm-chrono__reassign-select {\n  width: 100%;\n  border: 1px solid var(--cm-line, #d1d5db);\n  border-radius: 8px;\n  padding: 0.45rem 0.55rem;\n  background: #fff;\n  font: inherit;\n  color: inherit;\n}\n\n.cm-chrono__mod {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.35rem;\n  padding: 0.55rem 0.65rem 0;\n}\n\n.cm-chrono__mod .cm-btn {\n  font-size: 0.72rem;\n  min-height: 2rem;\n  padding: 0.28rem 0.55rem;\n}\n\n.cm-chrono__mod .cm-btn.is-on {\n  border-color: var(--cm-primary);\n  color: var(--cm-primary);\n}\n\n.cm-chrono__scorecam-count {\n  display: inline-grid;\n  place-items: center;\n  min-width: 1.15rem;\n  height: 1.15rem;\n  padding: 0 0.28rem;\n  border-radius: 999px;\n  background: rgba(255, 255, 255, 0.12);\n  font-size: 0.65rem;\n  font-weight: 800;\n  font-variant-numeric: tabular-nums;\n}\n\n.cm-chrono__scorecam-debug {\n  display: flex;\n  flex-direction: column;\n  gap: 0.45rem;\n  margin: 0.35rem 0.65rem 0;\n  padding: 0.55rem 0.6rem;\n  border: 1px dashed color-mix(in srgb, var(--cm-border) 70%, #f59e0b 30%);\n  border-radius: 10px;\n  background: color-mix(in srgb, var(--cm-slate) 92%, #f59e0b 8%);\n}\n\n.cm-chrono__scorecam-hint {\n  margin: 0;\n  font-size: 0.7rem;\n  line-height: 1.35;\n  color: var(--cm-muted);\n}\n\n.cm-chrono__scorecam-list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.55rem;\n}\n\n.cm-chrono__scorecam-item {\n  display: flex;\n  flex-direction: column;\n  gap: 0.3rem;\n}\n\n.cm-chrono__scorecam-meta {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.35rem 0.65rem;\n  align-items: baseline;\n  font-size: 0.7rem;\n}\n\n.cm-chrono__scorecam-meta strong {\n  font-size: 0.74rem;\n}\n\n.cm-chrono__scorecam-meta span {\n  color: var(--cm-muted);\n}\n\n.cm-chrono__scorecam-video {\n  width: 100%;\n  max-height: 12rem;\n  border-radius: 8px;\n  background: #000;\n  object-fit: contain;\n}\n\n.cm-chrono__score-ai {\n  display: flex;\n  flex-direction: column;\n  gap: 0.4rem;\n  margin: 0.35rem 0.65rem 0;\n  padding: 0.55rem 0.6rem;\n  border: 1px solid var(--cm-border);\n  border-radius: 10px;\n  background: color-mix(in srgb, var(--cm-slate) 88%, var(--cm-primary) 12%);\n}\n\n.cm-chrono__score-ai-hint {\n  margin: 0;\n  font-size: 0.7rem;\n  line-height: 1.35;\n  color: var(--cm-muted);\n}\n\n.cm-chrono__score-ai-marks,\n.cm-chrono__score-ai-actions,\n.cm-chrono__score-ai-dock-actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.35rem;\n  align-items: center;\n}\n\n.cm-chrono__score-ai-t {\n  margin-left: 0.25rem;\n  font-variant-numeric: tabular-nums;\n  font-weight: 800;\n  color: var(--cm-primary);\n}\n\n.cm-chrono__score-ai-meta,\n.cm-chrono__score-ai-dock-meta {\n  margin: 0;\n  font-size: 0.68rem;\n  color: var(--cm-muted);\n}\n\n.cm-chrono__score-ai-err {\n  margin: 0;\n  font-size: 0.72rem;\n  font-weight: 650;\n  color: #b42318;\n}\n\n.cm-chrono__score-ai-review {\n  position: absolute;\n  inset: 0;\n  z-index: 35;\n  pointer-events: none;\n}\n\n.cm-chrono__roi-box--review {\n  border-color: #f5c542;\n  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.35);\n}\n\n.cm-chrono__score-ai-dock {\n  position: absolute;\n  left: 0.55rem;\n  right: 0.55rem;\n  bottom: 0.55rem;\n  pointer-events: auto;\n  display: flex;\n  flex-direction: column;\n  gap: 0.3rem;\n  padding: 0.55rem 0.65rem;\n  border-radius: 12px;\n  border: 1px solid var(--cm-border);\n  background: color-mix(in srgb, var(--cm-slate) 94%, transparent);\n  color: var(--cm-text);\n  backdrop-filter: blur(8px);\n  -webkit-backdrop-filter: blur(8px);\n  box-shadow: 0 10px 28px rgba(15, 23, 42, 0.18);\n}\n\n.cm-chrono__score-ai-dock-title {\n  margin: 0;\n  font-size: 0.78rem;\n  font-weight: 800;\n  color: var(--cm-text);\n}\n\n.cm-chrono__score-ai-dock-score {\n  margin: 0;\n  font-size: 0.9rem;\n  font-weight: 800;\n  color: var(--cm-primary);\n}\n\n.cm-chrono__score-ai-dock .cm-btn {\n  color: inherit;\n}\n\n.cm-chrono__score-ai-progress {\n  display: flex;\n  flex-direction: column;\n  gap: 0.3rem;\n}\n\n.cm-chrono__score-ai-progress-track,\n.cm-chrono__scan-progress-track {\n  width: 100%;\n  height: 0.45rem;\n  border-radius: 999px;\n  background: color-mix(in srgb, var(--cm-muted) 22%, transparent);\n  overflow: hidden;\n}\n\n.cm-chrono__score-ai-progress-fill,\n.cm-chrono__scan-progress-fill {\n  display: block;\n  height: 100%;\n  border-radius: inherit;\n  background: linear-gradient(\n    90deg,\n    color-mix(in srgb, var(--cm-primary) 75%, #38bdf8),\n    var(--cm-primary)\n  );\n  transition: width 0.18s linear;\n}\n\n.cm-chrono__scan-progress {\n  position: absolute;\n  left: 0.7rem;\n  right: 0.7rem;\n  bottom: 0.85rem;\n  z-index: 40;\n  pointer-events: none;\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n  padding: 0.65rem 0.75rem;\n  border-radius: 12px;\n  border: 1px solid var(--cm-border);\n  background: color-mix(in srgb, var(--cm-slate) 92%, transparent);\n  color: var(--cm-text);\n  backdrop-filter: blur(8px);\n  -webkit-backdrop-filter: blur(8px);\n  box-shadow: 0 12px 30px rgba(15, 23, 42, 0.2);\n}\n\n.cm-chrono__scan-progress-title {\n  margin: 0;\n  font-size: 0.8rem;\n  font-weight: 800;\n  color: var(--cm-text);\n}\n\n.cm-chrono__scan-progress-meta {\n  margin: 0;\n  font-size: 0.7rem;\n  font-weight: 650;\n  color: var(--cm-muted);\n  font-variant-numeric: tabular-nums;\n}\n\n.cm-chrono__score-ai-dock .cm-btn {\n  font-size: 0.72rem;\n  min-height: 2rem;\n}\n\n.cm-chrono__emoji-layer {\n  position: absolute;\n  inset: 0;\n  z-index: 24;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n  gap: 0.35rem;\n  padding-top: 14%;\n  pointer-events: none;\n}\n\n.cm-chrono__emoji-pop {\n  font-size: clamp(2rem, 9cqi, 3.5rem);\n  line-height: 1;\n  filter: drop-shadow(0 8px 12px rgba(0, 0, 0, 0.5));\n  animation: cm-emoji-pop 0.9s ease;\n}\n\n@keyframes cm-emoji-pop {\n  from {\n    transform: translateY(10px) scale(0.7);\n    opacity: 0;\n  }\n  to {\n    transform: none;\n    opacity: 1;\n  }\n}\n\n.cm-chrono__probe {\n  position: absolute;\n  left: 0.55rem;\n  right: 0.55rem;\n  top: 0.55rem;\n  z-index: 26;\n  margin: 0;\n  padding: 0.4rem 0.45rem 0.4rem 0.6rem;\n  border-radius: 10px;\n  background: rgba(8, 12, 20, 0.82);\n  color: #fff;\n  font-size: 0.78rem;\n  font-weight: 750;\n  display: flex;\n  align-items: center;\n  gap: 0.4rem;\n}\n\n.cm-chrono__probe-dismiss {\n  margin-left: auto;\n  flex: 0 0 auto;\n  width: 1.6rem;\n  height: 1.6rem;\n  border: 0;\n  border-radius: 999px;\n  background: transparent;\n  color: #fff;\n  cursor: pointer;\n}\n\n.cm-chrono__roi {\n  position: absolute;\n  inset: 0;\n  z-index: 40;\n  pointer-events: none;\n  background: rgba(0, 0, 0, 0.18);\n}\n\n.cm-video-roi-svg {\n  position: absolute;\n  left: 0;\n  top: 0;\n  z-index: 5;\n  overflow: visible;\n  pointer-events: none;\n}\n\n.cm-video-roi-svg.is-draw {\n  z-index: 30;\n  pointer-events: auto;\n  cursor: crosshair;\n  touch-action: none;\n}\n\n.cm-video-roi-rect {\n  fill: rgba(245, 215, 110, 0.18);\n  stroke: #f5d76e;\n  stroke-width: 2px;\n  vector-effect: non-scaling-stroke;\n  pointer-events: none;\n}\n\n.cm-video-roi-rect.is-reading {\n  stroke: #38bdf8;\n  fill: rgba(56, 189, 248, 0.16);\n}\n\n.cm-video-roi-rect.is-motion,\n.cm-video-roi-rect.is-occlusion {\n  stroke: #fb7185;\n  fill: rgba(251, 113, 133, 0.14);\n}\n\n.cm-video-roi-rect.is-hit,\n.cm-video-roi-rect.is-confirm {\n  stroke: #4ade80;\n  fill: rgba(74, 222, 128, 0.16);\n}\n\n.cm-chrono__roi-hint {\n  position: absolute;\n  left: 0.6rem;\n  right: 4.5rem;\n  top: 0.55rem;\n  margin: 0;\n  color: #fff;\n  font-size: 0.78rem;\n  font-weight: 750;\n  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.6);\n}\n\n.cm-chrono__roi-cancel {\n  position: absolute;\n  top: 0.45rem;\n  right: 0.45rem;\n  pointer-events: auto;\n  border: 0;\n  border-radius: 999px;\n  padding: 0.3rem 0.65rem;\n  background: #fff;\n  color: #111;\n  font: inherit;\n  font-size: 0.72rem;\n  font-weight: 800;\n  cursor: pointer;\n}\n\n.cm-chrono__roi-box {\n  position: absolute;\n  border: 2px solid #f5d76e;\n  background: rgba(245, 215, 110, 0.18);\n  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.35);\n  pointer-events: none;\n}\n\n.cm-chrono__tagger-chips {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.32rem;\n}\n\n.cm-chrono__tagger-chips--extra {\n  margin-top: 0.35rem;\n  padding-top: 0.35rem;\n  border-top: 1px dashed color-mix(in srgb, var(--cm-border) 80%, transparent);\n}\n\n.cm-chrono__tagger .cm-tagchip {\n  font-size: 0.68rem;\n  padding: 0.28rem 0.45rem;\n}\n\n.cm-chrono__empty {\n  margin: 0.85rem 0.35rem;\n  color: var(--cm-muted);\n  font-size: 0.86rem;\n  text-align: center;\n}\n\n.cm-chrono__orphan-list {\n  list-style: none;\n  margin: 0;\n  padding: 0.35rem 0.55rem 0.65rem;\n  display: flex;\n  flex-direction: column;\n  gap: 0.4rem;\n}\n\n.cm-chrono__orphan-item {\n  display: flex;\n  align-items: center;\n  gap: 0.45rem;\n  font-size: 0.8rem;\n}\n\n.cm-chrono__orphan-item img {\n  max-width: 7rem;\n  border-radius: 8px;\n}\n\n.cm-chrono__orphan-item audio {\n  width: 100%;\n}\n\n.cm-chrono__orphans {\n  border-top: 1px solid var(--cm-border);\n  margin: 0;\n  border-radius: 0;\n}\n\n/* Mobile: one video, point strip, sticky label dock */\n@media (max-width: 860px) {\n  .cm-chrono {\n    height: auto;\n    min-height: 0;\n    max-height: 100%;\n  }\n\n  .cm-chrono.has-tagger {\n    padding-bottom: 0;\n  }\n\n  .cm-chrono__layout {\n    grid-template-columns: 1fr;\n    grid-template-rows: auto auto;\n  }\n\n  .cm-chrono__stage {\n    padding: 0;\n    background: color-mix(in srgb, var(--cm-slate) 70%, #070b12);\n  }\n\n  .cm-chrono__player-shell {\n    flex: 1 1 0%;\n    flex-shrink: 1;\n    width: 100%;\n    max-width: 100%;\n    min-height: 0;\n    height: auto;\n    aspect-ratio: auto;\n    border-radius: 0;\n  }\n\n  .cm-chrono__player-shell.is-expanded,\n  .cm-chrono__player-shell.is-expanding {\n    aspect-ratio: auto;\n    width: 100vw;\n    max-width: 100vw;\n    height: 100dvh;\n    border-radius: 0;\n  }\n\n  .cm-chrono.is-score-ai .cm-chrono__player-shell,\n  .cm-review .cm-chrono__player-shell {\n    width: 100%;\n    max-width: 100%;\n    margin: 0;\n    border-radius: 0;\n    flex: 1 1 auto;\n    min-height: 0;\n    aspect-ratio: auto;\n    height: auto;\n  }\n\n  .cm-chrono.is-score-ai .cm-chrono__player-shell.is-expanded,\n  .cm-chrono.is-score-ai .cm-chrono__player-shell.is-expanding,\n  .cm-review .cm-chrono__player-shell.is-expanded,\n  .cm-review .cm-chrono__player-shell.is-expanding {\n    aspect-ratio: auto;\n    width: 100vw;\n    max-width: 100vw;\n    height: 100dvh;\n  }\n\n  .cm-chrono.is-score-ai .cm-chrono__stage,\n  .cm-review .cm-chrono__stage {\n    padding: 0;\n  }\n\n  .cm-chrono.is-score-ai .cm-film {\n    padding-inline: 0;\n  }\n\n  .cm-chrono.is-score-ai .cm-film__sets,\n  .cm-chrono.is-score-ai .cm-film__labels {\n    padding-inline: 0.55rem;\n  }\n\n  .cm-chrono.is-score-ai .cm-chrono__tagger-slot--dock {\n    display: none;\n  }\n\n  .cm-chrono__point-strip {\n    display: none;\n  }\n\n  .cm-film {\n    display: flex;\n  }\n\n  .cm-chrono__sets,\n  .cm-chrono__set-label,\n  .cm-chrono__rail {\n    display: none;\n  }\n\n  .cm-chrono__side {\n    border-left: 0;\n    border-top: 0;\n    max-height: none;\n    background: transparent;\n  }\n\n  .cm-chrono__side:not(:has(.cm-chrono__mod)) {\n    display: none;\n  }\n\n  .cm-review {\n    padding: 0;\n    background: var(--cm-bg);\n    color: var(--cm-text);\n  }\n\n  .cm-review__head {\n    margin: 0;\n    padding:\n      calc(0.4rem + env(safe-area-inset-top, 0px))\n      calc(0.7rem + env(safe-area-inset-right, 0px))\n      0.35rem\n      calc(0.7rem + env(safe-area-inset-left, 0px));\n    background: var(--cm-slate);\n    color: var(--cm-text);\n  }\n\n  .cm-review__sub {\n    display: none;\n  }\n\n  .cm-review__body {\n    border: 0;\n    border-radius: 0;\n    background: transparent;\n  }\n\n  .cm-review .cm-chrono {\n    height: 100%;\n    min-height: 0;\n    border: 0;\n    border-radius: 0;\n    display: flex;\n    flex-direction: column;\n  }\n\n  .cm-review .cm-chrono__layout {\n    flex: 1 1 auto;\n    min-height: 0;\n    display: flex;\n    flex-direction: column;\n  }\n\n  .cm-review .cm-chrono__stage {\n    flex: 1 1 auto;\n    min-height: 0;\n    padding: 0;\n    gap: 0;\n  }\n\n  .cm-review .cm-chrono__player-shell {\n    flex: 1 1 auto;\n    aspect-ratio: auto;\n    min-height: 0;\n    border-radius: 0;\n  }\n\n  .cm-chrono__rail {\n    max-height: none;\n  }\n\n  .cm-chrono__tagger-slot--side {\n    display: none;\n  }\n\n  .cm-chrono__tagger-slot--dock {\n    display: block;\n    position: sticky;\n    bottom: 0;\n    z-index: 8;\n    flex: 0 0 auto;\n    padding-bottom: env(safe-area-inset-bottom, 0px);\n    background: var(--cm-deck);\n    box-shadow: 0 -10px 28px rgba(0, 0, 0, 0.22);\n  }\n}\n\n/* Wide review dialog: video + point strip on the left, tag deck as a right\n   column. The timeline tab itself lives in the 430px page column. */\n@media (min-width: 1024px) {\n  .cm-review .cm-chrono.has-deck:not(.is-review-fs) {\n    display: grid;\n    grid-template-columns: minmax(0, 1fr) clamp(19rem, 27vw, 23rem);\n    grid-template-rows: auto minmax(0, 1fr) auto auto;\n    grid-template-areas:\n      \"head   head\"\n      \"player deck\"\n      \"film   deck\"\n      \"side   deck\";\n  }\n\n  .cm-review .cm-chrono.has-deck:not(.is-review-fs) > .cm-chrono__rubber {\n    grid-area: head;\n  }\n\n  .cm-review .cm-chrono.has-deck:not(.is-review-fs) .cm-chrono__player-shell,\n  .cm-review .cm-chrono.has-deck:not(.is-review-fs) .cm-chrono__player,\n  .cm-review .cm-chrono.has-deck:not(.is-review-fs) .cm-chrono__empty-stage {\n    grid-area: player;\n    min-height: 0;\n    max-height: none;\n  }\n\n  .cm-review .cm-chrono.has-deck:not(.is-review-fs) .cm-film {\n    grid-area: film;\n  }\n\n  .cm-review .cm-chrono.has-deck:not(.is-review-fs) .cm-chrono__side {\n    grid-area: side;\n    max-height: 12rem;\n  }\n\n  .cm-review .cm-chrono.has-deck:not(.is-review-fs) > .cm-chrono__tagger-slot--dock {\n    grid-area: deck;\n    max-height: none;\n    min-height: 0;\n    overflow: auto;\n    background: var(--cm-deck);\n    border-left: 1px solid var(--cm-hair);\n  }\n\n  .cm-review .cm-chrono.has-deck:not(.is-review-fs) .cm-deck {\n    border-top: 0;\n    padding: 0.85rem 0.9rem 1rem;\n    gap: 0.75rem;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .cm-chrono__cue,\n  .cm-chrono__hud {\n    transition: none;\n  }\n}\n\n.cm-replay {\n  list-style: none;\n  margin: 0.35rem 0 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.7rem;\n}\n\n.cm-replay__rubber {\n  display: flex;\n  flex-direction: column;\n  gap: 0.55rem;\n}\n\n.cm-replay__rubber-head {\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  gap: 0.5rem;\n  padding: 0 0.15rem;\n}\n\n.cm-replay__rubber-head strong {\n  font-size: 0.82rem;\n  font-weight: 800;\n}\n\n.cm-replay__rubber-head span {\n  color: var(--cm-muted);\n  font-size: 0.72rem;\n  font-weight: 650;\n  text-align: right;\n}\n\n.cm-replay__set {\n  border: 1px solid var(--cm-border);\n  border-radius: 16px;\n  background: var(--cm-glass);\n  padding: 0.55rem 0.6rem 0.65rem;\n}\n\n.cm-replay__set-head {\n  font-size: 0.72rem;\n  font-weight: 800;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: var(--cm-muted);\n}\n\n.cm-replay__player {\n  position: relative;\n  margin-top: 0.45rem;\n}\n\n.cm-replay__eval-player,\n.cm-review__eval-player {\n  width: 100%;\n  min-height: 220px;\n  border-radius: 12px;\n  overflow: hidden;\n}\n\n.cm-review__media .review-video-player {\n  flex: 1 1 auto;\n  min-height: 0;\n}\n\n.cm-replay__board {\n  position: absolute;\n  left: 0.55rem;\n  top: 0.55rem;\n  z-index: 2;\n  padding: 0.22rem 0.45rem;\n  border-radius: 8px;\n  background: color-mix(in srgb, #0a0a0a 72%, transparent);\n  color: #f4f1ea;\n  font-size: 0.62rem;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n}\n\n.cm-replay__board strong {\n  font-size: 0.82rem;\n  letter-spacing: -0.03em;\n  text-transform: none;\n  font-variant-numeric: tabular-nums;\n}\n\n.cm-head__board {\n  display: block;\n  margin-top: 0.18rem;\n  color: var(--cm-muted);\n  font-size: 0.58rem;\n  font-weight: 700;\n  letter-spacing: 0.07em;\n  text-transform: uppercase;\n}\n\n.cm-head__board strong {\n  font-size: 0.78rem;\n  letter-spacing: -0.03em;\n  text-transform: none;\n  font-variant-numeric: tabular-nums;\n  color: var(--cm-text);\n}\n\n.cm-head__board--live {\n  color: var(--cm-rec, #c43c3c);\n}\n\n.cm-head__board-hint {\n  display: block;\n  margin-top: 0.12rem;\n  color: var(--cm-muted);\n  font-size: 0.58rem;\n  font-weight: 650;\n  line-height: 1.25;\n  text-transform: none;\n  letter-spacing: 0.01em;\n}\n\n.cm-replay__player video,\n.cm-replay__orphan video,\n.cm-replay video {\n  display: block;\n  width: 100%;\n  min-height: 140px;\n  max-height: 42vh;\n  margin: 0;\n  border-radius: 12px;\n  background: #000;\n  object-fit: contain;\n}\n\n.cm-replay__empty,\n.cm-replay__error {\n  margin: 0.45rem 0 0;\n  color: var(--cm-muted);\n  font-size: 0.74rem;\n  font-weight: 650;\n}\n\n.cm-replay__error {\n  color: #fb7185;\n}\n\n.cm-replay__points {\n  list-style: none;\n  margin: 0.4rem 0 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.45rem;\n}\n\n.cm-replay__point {\n  padding-top: 0.2rem;\n  border-top: 1px solid var(--cm-border);\n}\n\n.cm-replay__point:first-child {\n  border-top: 0;\n  padding-top: 0;\n}\n\n.cm-replay__cue {\n  display: flex;\n  align-items: baseline;\n  gap: 0.45rem;\n  width: 100%;\n  padding: 0.28rem 0;\n  border: 0;\n  background: transparent;\n  color: inherit;\n  text-align: left;\n  cursor: pointer;\n}\n\n.cm-replay__cue:disabled {\n  cursor: default;\n  opacity: 0.8;\n}\n\n.cm-replay__clock {\n  color: var(--cm-muted);\n  font-size: 0.72rem;\n  font-variant-numeric: tabular-nums;\n  font-weight: 700;\n}\n\n.cm-replay__meta {\n  margin: 0.1rem 0 0;\n  color: var(--cm-muted);\n  font-size: 0.78rem;\n}\n\n.cm-replay__comment {\n  color: var(--cm-text);\n  font-weight: 650;\n}\n\n.cm-replay__gallery {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 0.35rem;\n  margin-top: 0.35rem;\n}\n\n.cm-replay__gallery img,\n.cm-replay__orphan img,\n.cm-replay img {\n  display: block;\n  width: 100%;\n  min-height: 72px;\n  max-height: 180px;\n  object-fit: cover;\n  border-radius: 10px;\n  background: #111827;\n}\n\n.cm-replay__voices,\n.cm-replay__orphan {\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n  margin-top: 0.35rem;\n}\n\n.cm-replay__voices audio,\n.cm-replay__orphan audio {\n  width: 100%;\n}\n\n.cm-replay li {\n  border: 0;\n  border-radius: 0;\n  background: transparent;\n  padding: 0;\n}\n\n.cm-replay strong {\n  font-variant-numeric: tabular-nums;\n}\n\n.cm-replay p {\n  margin: 0.1rem 0 0;\n  color: var(--cm-muted);\n  font-size: 0.78rem;\n}\n\n.cm-tabs {\n  flex: 0 0 auto;\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 0.28rem;\n  margin-top: 0.45rem;\n  padding: 0.28rem;\n  border-radius: 16px;\n  border: 1px solid var(--cm-border);\n  background: rgba(255, 255, 255, 0.04);\n}\n\n.cm-page--light .cm-tabs {\n  background: rgba(15, 23, 42, 0.04);\n}\n\n.cm-tabs button {\n  min-height: 40px;\n  border: 0;\n  border-radius: 12px;\n  background: transparent;\n  color: var(--cm-muted);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 0.08rem;\n  font-size: 0.62rem;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.cm-tabs button.is-on {\n  background: var(--cm-primary);\n  color: #fff;\n  box-shadow: 0 8px 18px color-mix(in srgb, var(--cm-primary) 35%, transparent);\n}\n\n.cm-tabs button:active {\n  transform: scale(0.98);\n}\n\n@media (orientation: landscape) and (max-height: 520px) {\n  .cm-page {\n    max-width: none;\n    margin: 0;\n    border: 0;\n    padding-left: calc(0.4rem + env(safe-area-inset-left, 0px));\n    padding-right: calc(0.4rem + env(safe-area-inset-right, 0px));\n  }\n\n  .cm-head {\n    min-height: 34px;\n  }\n\n  .cm-cam-status {\n    max-height: 4.4rem;\n  }\n\n  .cm-scoredeck {\n    max-height: none;\n    padding: 0.3rem 0.35rem 0.35rem;\n  }\n\n  .cm-scoredeck__pts {\n    font-size: clamp(1.7rem, 12vh, 2.8rem);\n  }\n\n  .cm-scoredeck__btns {\n    --cm-score-btn: 2.35rem;\n  }\n\n  .cm-tabs {\n    margin-top: 0.2rem;\n  }\n\n  .cm-tabs button {\n    min-height: 34px;\n    flex-direction: row;\n    gap: 0.28rem;\n    font-size: 0.68rem;\n  }\n}\n\n@media (min-width: 720px) {\n  .cm-page {\n    max-width: 430px;\n    margin: 0 auto;\n    border-left: 1px solid var(--cm-border);\n    border-right: 1px solid var(--cm-border);\n  }\n\n  .cm-page--cam-landscape {\n    max-width: none;\n    margin: 0;\n    border: 0;\n  }\n}\n\n@media (min-width: 720px) and (orientation: landscape) and (max-height: 520px) {\n  .cm-page {\n    max-width: none;\n    margin: 0;\n    border: 0;\n  }\n}\n\n/* Full-bleed camera once this phone is the live camera (portrait or landscape) */\n.cm-page--cam-armed,\n.cm-page--cam-landscape {\n  padding: 0;\n  background: #000;\n}\n\n.cm-page--cam-armed .cm-head,\n.cm-page--cam-armed .cm-tables,\n.cm-page--cam-armed .cm-match-status,\n.cm-page--cam-armed .cm-banner,\n.cm-page--cam-armed .cm-stamps,\n.cm-page--cam-armed .cm-tagdock,\n.cm-page--cam-landscape .cm-head,\n.cm-page--cam-landscape .cm-tables,\n.cm-page--cam-landscape .cm-match-status,\n.cm-page--cam-landscape .cm-banner,\n.cm-page--cam-landscape .cm-stamps,\n.cm-page--cam-landscape .cm-tagdock,\n.cm-page--cam-armed:not(.cm-page--cam-landscape) .cm-tabs {\n  display: none !important;\n}\n\n/* Landscape keeps the tab bar on screen so the camera does not cover it. */\n.cm-page--cam-landscape .cm-tabs,\n.cm-page--cam-armed.cm-page--cam-landscape .cm-tabs {\n  display: grid !important;\n  position: fixed;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 90;\n  margin: 0;\n  border-radius: 0;\n  border-left: 0;\n  border-right: 0;\n  border-bottom: 0;\n  padding: 0.2rem 0.35rem calc(0.2rem + env(safe-area-inset-bottom, 0px));\n  background: rgba(11, 15, 25, 0.96);\n}\n\n.cm-page--cam-armed .cm-body,\n.cm-page--cam-landscape .cm-body {\n  margin: 0;\n  flex: 1;\n  min-height: 100%;\n}\n\n.cm-cam-tags {\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n  width: min(100%, 28rem);\n  pointer-events: auto;\n}\n\n.cm-page--cam-armed .cm-cam-tags,\n.cm-page--cam-landscape .cm-cam-tags {\n  position: absolute;\n  left: 0.4rem;\n  right: 0.4rem;\n  width: auto;\n  bottom: calc(4.35rem + env(safe-area-inset-bottom, 0px));\n  z-index: 4;\n  max-height: min(28dvh, 10.5rem);\n  overflow: auto;\n  -webkit-overflow-scrolling: touch;\n}\n\n.cm-dock-dim .cm-cam-tags {\n  position: static;\n  left: auto;\n  right: auto;\n  bottom: auto;\n  width: min(100%, 22rem);\n  max-height: none;\n  margin: 0.15rem 0;\n  z-index: auto;\n}\n\n.cm-dock-dim .cm-cam-tags__label {\n  color: #94a3b8;\n}\n\n.cm-dock-dim__score {\n  flex: 0 0 auto;\n}\n\n.cm-cam-tags__label {\n  margin: 0;\n  color: #e2e8f0;\n  font-size: 0.68rem;\n  font-weight: 750;\n  letter-spacing: 0.02em;\n  text-align: center;\n}\n\n.cm-cam-tags .cm-outcome--on-cam {\n  padding: 0.28rem;\n  border-radius: 14px;\n  background: rgba(2, 6, 23, 0.78);\n  backdrop-filter: blur(10px);\n}\n\n.cm-cam-tags .cm-outcome__btn {\n  min-height: 2.2rem;\n  color: #f8fafc;\n}\n\n.cm-cam-tags .cm-outcome__text {\n  color: #f8fafc;\n  font-size: 0.62rem;\n}\n\n@media (max-height: 640px) {\n  .cm-cam-tags .cm-outcome__text {\n    display: none;\n  }\n\n  .cm-cam-tags .cm-outcome__btn {\n    min-height: 2rem;\n  }\n\n  .cm-dock-dim__score strong {\n    font-size: clamp(2.4rem, 14vw, 4rem);\n  }\n}\n\n.cm-cam-tags__emojis {\n  display: flex;\n  justify-content: center;\n  gap: 0.3rem;\n}\n\n.cm-cam-tags__emoji {\n  width: 2.35rem;\n  height: 2.35rem;\n  border: 0;\n  border-radius: 999px;\n  background: rgba(2, 6, 23, 0.78);\n  font-size: 1.15rem;\n  cursor: pointer;\n}\n\n.cm-cam-tags__emoji:active {\n  transform: scale(0.94);\n}\n\n.cm-dock-dim .cm-cam-tags {\n  margin: 0.35rem 0 0.15rem;\n}\n\n.cm-dock-dim .cm-cam-tags__label,\n.cm-dock-dim .cm-cam-tags .cm-outcome__text,\n.cm-dock-dim .cm-cam-tags .cm-outcome__btn {\n  color: #f8fafc;\n}\n\n@media (orientation: landscape) and (max-height: 640px) {\n  .cm-page--cam-armed .cm-cam-tags,\n  .cm-page--cam-landscape .cm-cam-tags {\n    left: auto;\n    right: calc(0.4rem + env(safe-area-inset-right, 0px));\n    width: min(22rem, 46vw);\n    bottom: calc(3.6rem + env(safe-area-inset-bottom, 0px));\n  }\n\n  .cm-cam-tags .cm-outcome__btn {\n    min-height: 1.85rem;\n    padding: 0.12rem 0.1rem;\n  }\n\n  .cm-cam-tags__emoji {\n    width: 2rem;\n    height: 2rem;\n    font-size: 1rem;\n  }\n}\n\n.cm-page--cam-armed .cm-cam,\n.cm-page--cam-landscape .cm-cam {\n  position: fixed;\n  inset: 0;\n  z-index: 80;\n  gap: 0;\n  background: #000;\n}\n\n.cm-page--cam-landscape .cm-cam {\n  inset: auto;\n  top: env(safe-area-inset-top, 0px);\n  right: 0;\n  bottom: calc(3.15rem + env(safe-area-inset-bottom, 0px));\n  left: 0;\n}\n\n.cm-cam__armed-info {\n  position: absolute;\n  left: calc(0.75rem + env(safe-area-inset-left, 0px));\n  right: auto;\n  width: max-content;\n  max-width: calc(\n    100% - 5.75rem - env(safe-area-inset-left, 0px) -\n      env(safe-area-inset-right, 0px)\n  );\n  top: calc(0.65rem + env(safe-area-inset-top, 0px));\n  z-index: 4;\n  display: inline-flex;\n  align-items: flex-start;\n  gap: 0.4rem;\n  margin: 0;\n  padding: 0.45rem 0.7rem;\n  border-radius: 999px;\n  border: 1px solid rgba(255, 255, 255, 0.28);\n  background: rgba(2, 6, 23, 0.55);\n  color: #f8fafc;\n  font-size: 0.78rem;\n  font-weight: 700;\n  line-height: 1.25;\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n  pointer-events: none;\n}\n\n.cm-cam__armed-info span {\n  min-width: 0;\n  overflow-wrap: anywhere;\n}\n\n.cm-cam__armed-info svg {\n  flex: 0 0 auto;\n  margin-top: 0.12rem;\n}\n\n.cm-page--cam-armed .cm-cam__preview,\n.cm-page--cam-landscape .cm-cam__preview {\n  position: absolute;\n  inset: 0;\n  border-radius: 0;\n  border: 0;\n  min-height: 100%;\n  z-index: 0;\n  touch-action: none;\n}\n\n.cm-page--cam-armed .cm-cam__preview video,\n.cm-page--cam-landscape .cm-cam__preview video {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  transform-origin: center center;\n  pointer-events: none;\n}\n\n.cm-page--cam-armed .cm-cam__badge,\n.cm-page--cam-landscape .cm-cam__badge {\n  z-index: 3;\n}\n\n.cm-page--cam-armed .cm-cam__badge.cm-rec,\n.cm-page--cam-landscape .cm-cam__badge.cm-rec {\n  top: calc(0.55rem + env(safe-area-inset-top, 0px));\n  left: auto;\n  right: calc(0.55rem + env(safe-area-inset-right, 0px));\n  width: max-content;\n}\n\n.cm-page--cam-armed .cm-cam__badge.cm-rec + .cm-cam__badge--zoom,\n.cm-page--cam-landscape .cm-cam__badge.cm-rec + .cm-cam__badge--zoom {\n  top: calc(2.45rem + env(safe-area-inset-top, 0px));\n}\n\n.cm-page--cam-armed .cm-cam__badge--zoom,\n.cm-page--cam-landscape .cm-cam__badge--zoom {\n  top: calc(0.55rem + env(safe-area-inset-top, 0px));\n  left: auto;\n  right: calc(0.55rem + env(safe-area-inset-right, 0px));\n}\n\n/* Hide edge action chrome while picking a lens so only transparent camera buttons show */\n.cm-page--cam-armed.cm-page--cam-settings .cm-actions,\n.cm-page--cam-landscape.cm-page--cam-settings .cm-actions {\n  opacity: 0;\n  pointer-events: none;\n}\n\n.cm-page--cam-armed .cm-actions,\n.cm-page--cam-armed .cm-actions--edge,\n.cm-page--cam-landscape .cm-actions,\n.cm-page--cam-landscape .cm-actions--edge {\n  position: absolute;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 2;\n  margin: 0;\n  padding: 0.45rem\n    calc(0.45rem + env(safe-area-inset-right, 0px))\n    calc(0.45rem + env(safe-area-inset-bottom, 0px))\n    calc(0.45rem + env(safe-area-inset-left, 0px));\n  display: flex;\n  flex-wrap: nowrap;\n  justify-content: center;\n  align-items: center;\n  gap: 0.4rem;\n  background: transparent;\n  backdrop-filter: none;\n  -webkit-backdrop-filter: none;\n  pointer-events: none;\n}\n\n.cm-page--cam-armed .cm-actions > *,\n.cm-page--cam-landscape .cm-actions > * {\n  pointer-events: auto;\n}\n\n.cm-page--cam-armed .cm-actions .cm-btn,\n.cm-page--cam-armed .cm-actions .cm-btn--icon,\n.cm-page--cam-landscape .cm-actions .cm-btn,\n.cm-page--cam-landscape .cm-actions .cm-btn--icon {\n  flex: 0 0 auto;\n  width: 46px;\n  height: 46px;\n  min-width: 46px;\n  min-height: 46px;\n  padding: 0;\n  border-radius: 999px;\n  border: 1px solid rgba(255, 255, 255, 0.38);\n  background: rgba(0, 0, 0, 0.28);\n  color: #fff;\n  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.28);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0;\n}\n\n.cm-page--cam-armed .cm-actions .cm-btn--ghost,\n.cm-page--cam-landscape .cm-actions .cm-btn--ghost {\n  background: rgba(0, 0, 0, 0.28);\n  border-color: rgba(255, 255, 255, 0.38);\n  color: #fff;\n}\n\n.cm-page--cam-armed .cm-actions .cm-btn--dock,\n.cm-page--cam-landscape .cm-actions .cm-btn--dock {\n  background: rgba(8, 119, 188, 0.42);\n  border-color: rgba(125, 211, 252, 0.55);\n}\n\n.cm-page--cam-armed .cm-actions .cm-btn--danger,\n.cm-page--cam-landscape .cm-actions .cm-btn--danger,\n.cm-page--cam-armed .cm-actions .cm-btn--rec,\n.cm-page--cam-landscape .cm-actions .cm-btn--rec {\n  background: rgba(225, 29, 72, 0.88);\n  border: 1px solid rgba(251, 113, 133, 0.85);\n  color: #fff;\n}\n\n.cm-page--cam-armed .cm-actions .cm-btn--exit-preview,\n.cm-page--cam-landscape .cm-actions .cm-btn--exit-preview {\n  background: rgba(127, 29, 29, 0.82);\n  border-color: #f87171;\n  color: #fecaca;\n  box-shadow: 0 0 0 2px rgba(248, 113, 113, 0.35), 0 4px 14px rgba(0, 0, 0, 0.35);\n}\n\n.cm-cam-hidden {\n  position: fixed;\n  right: 8px;\n  bottom: 8px;\n  width: 48px;\n  height: 27px;\n  opacity: 0.04;\n  pointer-events: none;\n  z-index: 1;\n  object-fit: cover;\n}\n\n.cm-page--cam-armed .cm-actions .cm-btn:active,\n.cm-page--cam-landscape .cm-actions .cm-btn:active {\n  transform: scale(0.94);\n}\n\n.cm-page--cam-landscape .cm-status-chip {\n  display: none;\n}\n\n.cm-rubber-card__review {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  margin-top: 0.15rem;\n}\n\n.cm-rubber-card__review-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.35rem;\n  min-height: 34px;\n  border: 1px solid color-mix(in srgb, var(--cm-primary) 45%, var(--cm-border));\n  border-radius: 999px;\n  background: color-mix(in srgb, var(--cm-primary) 18%, transparent);\n  color: var(--cm-text);\n  font: inherit;\n  font-size: 0.72rem;\n  font-weight: 750;\n  padding: 0.28rem 0.75rem;\n  cursor: pointer;\n}\n\n.cm-rubber-card__review-btn.is-icon {\n  width: 2.1rem;\n  height: 2.1rem;\n  min-height: 0;\n  padding: 0;\n}\n\n.cm-rubber-card__review-btn:active {\n  transform: scale(0.97);\n}\n\n.cm-rubber-card__review-wait {\n  font-size: 0.68rem;\n  font-weight: 650;\n  color: var(--cm-muted);\n}\n\n.cm-review {\n  position: fixed;\n  inset: 0;\n  z-index: 110;\n  display: flex;\n  flex-direction: column;\n  background: var(--cm-bg);\n  color: var(--cm-text);\n  padding:\n    calc(0.65rem + env(safe-area-inset-top, 0px))\n    calc(0.7rem + env(safe-area-inset-right, 0px))\n    calc(0.65rem + env(safe-area-inset-bottom, 0px))\n    calc(0.7rem + env(safe-area-inset-left, 0px));\n}\n\n.cm-review__head {\n  flex: 0 0 auto;\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 0.75rem;\n  margin-bottom: 0.55rem;\n}\n\n.cm-review__kicker {\n  margin: 0 0 0.15rem;\n  font-size: 0.68rem;\n  font-weight: 750;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: var(--cm-muted);\n}\n\n.cm-review__head strong {\n  font-size: 0.95rem;\n  font-weight: 800;\n  letter-spacing: -0.02em;\n}\n\n.cm-review__body {\n  flex: 1 1 auto;\n  min-height: 0;\n  overflow: hidden;\n  border-radius: 16px;\n  border: 1px solid var(--cm-border);\n  background: var(--cm-glass);\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n}\n\n.cm-review__body .cm-chrono {\n  margin: 0;\n  height: 100%;\n  min-height: 0;\n  flex: 1 1 auto;\n  border: 0;\n  border-radius: 16px;\n}\n\n.cm-review__sub {\n  margin: 0.28rem 0 0;\n  font-size: 0.74rem;\n  font-weight: 550;\n  color: var(--cm-muted);\n  line-height: 1.35;\n  max-width: 36rem;\n}\n\n.cm-review__close {\n  width: 2.35rem;\n  height: 2.35rem;\n  border-radius: 999px;\n  border: 1px solid var(--cm-border);\n  background: color-mix(in srgb, var(--cm-muted) 12%, var(--cm-slate));\n  color: var(--cm-text);\n  display: grid;\n  place-items: center;\n  cursor: pointer;\n  flex: 0 0 auto;\n}\n\n.cm-review__stage {\n  flex: 1 1 auto;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  justify-content: center;\n  border-radius: 18px;\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  background:\n    radial-gradient(80% 60% at 50% 0%, rgba(8, 119, 188, 0.22), transparent 60%),\n    rgba(15, 23, 42, 0.72);\n  overflow: hidden;\n  padding: 0.85rem;\n}\n\n.cm-review__kind {\n  display: inline-flex;\n  align-self: flex-start;\n  margin-bottom: 0.55rem;\n  padding: 0.18rem 0.5rem;\n  border-radius: 999px;\n  background: rgba(255, 255, 255, 0.08);\n  color: #cbd5e1;\n  font-size: 0.62rem;\n  font-weight: 800;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n}\n\n.cm-review__point {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  gap: 0.35rem;\n  min-height: 12rem;\n}\n\n.cm-review__score {\n  margin: 0;\n  font-size: clamp(3rem, 16vw, 4.5rem);\n  font-weight: 800;\n  letter-spacing: -0.06em;\n  line-height: 0.95;\n  font-variant-numeric: tabular-nums;\n}\n\n.cm-review__score--sm {\n  font-size: 1.6rem;\n  margin-top: 0.5rem;\n}\n\n.cm-review__clock {\n  margin: 0;\n  color: #94a3b8;\n  font-size: 0.85rem;\n  font-weight: 700;\n}\n\n.cm-review__tags {\n  margin: 0.25rem 0 0;\n  color: #e2e8f0;\n  font-size: 0.88rem;\n  font-weight: 700;\n}\n\n.cm-review__comment {\n  margin: 0.35rem 0 0;\n  max-width: 22rem;\n  color: #f8fafc;\n  font-size: 1rem;\n  font-weight: 650;\n  line-height: 1.35;\n}\n\n.cm-review__media {\n  flex: 1;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.45rem;\n}\n\n.cm-review__media video,\n.cm-review__media img {\n  width: 100%;\n  flex: 1;\n  min-height: 0;\n  max-height: 100%;\n  object-fit: contain;\n  border-radius: 12px;\n  background: #000;\n}\n\n.cm-review__media--voice {\n  align-items: center;\n  justify-content: center;\n}\n\n.cm-review__media audio {\n  width: min(100%, 22rem);\n}\n\n.cm-review__empty {\n  display: grid;\n  place-items: center;\n  gap: 0.65rem;\n  text-align: center;\n  color: #94a3b8;\n}\n\n.cm-review__bar {\n  flex: 0 0 auto;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.75rem;\n  margin-top: 0.65rem;\n}\n\n.cm-review__progress {\n  font-size: 0.78rem;\n  font-weight: 750;\n  color: #94a3b8;\n  min-width: 4.5rem;\n}\n\n.cm-review__acts {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.4rem;\n}\n\n.cm-review__btn {\n  width: 2.55rem;\n  height: 2.55rem;\n  border-radius: 999px;\n  border: 1px solid rgba(255, 255, 255, 0.14);\n  background: rgba(255, 255, 255, 0.06);\n  color: #fff;\n  display: grid;\n  place-items: center;\n  cursor: pointer;\n}\n\n.cm-review__btn:disabled {\n  opacity: 0.35;\n  cursor: not-allowed;\n}\n\n.cm-review__btn--main {\n  width: 3.1rem;\n  height: 3.1rem;\n  background: color-mix(in srgb, var(--cm-primary, #0877bc) 78%, #0b0f19);\n  border-color: transparent;\n}\n\n/* iOS Camera-style calibrate overlay (full-bleed preview + lens chips).\n   Pinned to the visual viewport so browser chrome cannot push the buttons off-screen. */\n.cm-cam-settings--ios {\n  --cm-cam-settings-top: 78px;\n  position: fixed;\n  top: var(--lt-vvt, 0px);\n  left: var(--lt-vvl, 0px);\n  right: auto;\n  bottom: auto;\n  width: var(--lt-vvw, 100%);\n  height: var(--lt-vvh, 100svh);\n  max-height: var(--lt-vvh, 100svh);\n  z-index: 120;\n  display: block;\n  box-sizing: border-box;\n  padding: 0;\n  overflow: hidden;\n  background: #0b1220;\n  color: #f8fafc;\n  pointer-events: auto;\n}\n\n.cm-cam-settings__stage-full {\n  position: absolute;\n  inset: 0;\n  background: #020617;\n  overflow: hidden;\n  touch-action: none;\n  user-select: none;\n  -webkit-user-select: none;\n}\n\n.cm-cam-settings__preview-full {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  background: #020617;\n  transform-origin: center center;\n  pointer-events: none;\n}\n\n.cm-cam-settings__ios-top {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  z-index: 2;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: calc(10px + env(safe-area-inset-top, 0px)) 16px 12px;\n  background: linear-gradient(\n    180deg,\n    rgba(2, 6, 23, 0.82) 0%,\n    rgba(2, 6, 23, 0.05) 100%\n  );\n  color: #f8fafc;\n}\n\n.cm-cam-settings__title-row {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  min-width: 0;\n  color: #e2e8f0;\n}\n\n.cm-cam-settings__ios-top strong {\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  font-size: 15px;\n  font-weight: 700;\n  letter-spacing: 0.01em;\n}\n\n.cm-cam-settings__icon-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 44px;\n  height: 44px;\n  border: 1px solid rgba(255, 255, 255, 0.16);\n  border-radius: 14px;\n  background: rgba(15, 23, 42, 0.62);\n  color: #f8fafc;\n  backdrop-filter: blur(16px);\n  -webkit-backdrop-filter: blur(16px);\n  cursor: pointer;\n  transition: transform 0.3s cubic-bezier(0.16, 1, 0.3, 1),\n    background 0.3s cubic-bezier(0.16, 1, 0.3, 1);\n}\n\n.cm-cam-settings__icon-btn:hover {\n  transform: scale(1.04);\n  background: rgba(15, 23, 42, 0.82);\n}\n\n.cm-cam-settings__icon-btn:active {\n  transform: scale(0.96);\n}\n\n.cm-cam-settings__icon-btn:focus-visible {\n  outline: 2px solid #38bdf8;\n  outline-offset: 2px;\n}\n\n.cm-cam-settings--ios .cm-cam-settings__zoom-pill {\n  position: absolute;\n  top: calc(64px + env(safe-area-inset-top, 0px));\n  right: 16px;\n  left: auto;\n  z-index: 3;\n  padding: 6px 12px;\n  border-radius: 999px;\n  background: rgba(15, 23, 42, 0.72);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  backdrop-filter: blur(16px);\n  -webkit-backdrop-filter: blur(16px);\n  font-size: 12px;\n  font-weight: 800;\n  letter-spacing: 0.06em;\n  color: #e2e8f0;\n}\n\n.cm-cam-settings__ios-hint {\n  position: static;\n  margin: 0;\n  font-size: 13px;\n  line-height: 1.4;\n  color: rgba(248, 250, 252, 0.86);\n  text-shadow: 0 1px 8px rgba(0, 0, 0, 0.55);\n  pointer-events: none;\n}\n\n.cm-cam-settings__ios-bar {\n  position: absolute;\n  left: calc(14px + env(safe-area-inset-left, 0px));\n  right: calc(14px + env(safe-area-inset-right, 0px));\n  bottom: calc(8px + env(safe-area-inset-bottom, 0px));\n  z-index: 2;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  box-sizing: border-box;\n  width: min(420px, calc(100% - 28px - env(safe-area-inset-left, 0px) - env(safe-area-inset-right, 0px)));\n  max-width: calc(100% - 28px - env(safe-area-inset-left, 0px) - env(safe-area-inset-right, 0px));\n  max-height: calc(\n    100% - var(--cm-cam-settings-top) - 8px - env(safe-area-inset-top, 0px) -\n      env(safe-area-inset-bottom, 0px)\n  );\n  margin: 0 auto;\n  overflow-x: hidden;\n  overflow-y: auto;\n  overscroll-behavior: contain;\n  -webkit-overflow-scrolling: touch;\n}\n\n.cm-cam-settings__lenses {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 10px;\n  margin: 0 auto;\n  padding: 8px 14px;\n  width: fit-content;\n  max-width: 100%;\n  box-sizing: border-box;\n  border-radius: 999px;\n  background: rgba(15, 23, 42, 0.62);\n  border: 1px solid rgba(255, 255, 255, 0.16);\n  backdrop-filter: blur(16px);\n  -webkit-backdrop-filter: blur(16px);\n  box-shadow: 0 10px 28px rgba(0, 0, 0, 0.28);\n}\n\n.cm-cam-settings__lens {\n  min-width: 0;\n  height: 44px;\n  flex: 1 1 auto;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  padding: 0 12px 0 6px;\n  border: 1px solid rgba(255, 255, 255, 0.22);\n  border-radius: 999px;\n  background: rgba(15, 23, 42, 0.55);\n  color: rgba(248, 250, 252, 0.88);\n  font-size: 12px;\n  font-weight: 800;\n  letter-spacing: 0.02em;\n  cursor: pointer;\n  transition: transform 0.3s cubic-bezier(0.16, 1, 0.3, 1),\n    background 0.3s cubic-bezier(0.16, 1, 0.3, 1),\n    color 0.3s cubic-bezier(0.16, 1, 0.3, 1),\n    box-shadow 0.3s cubic-bezier(0.16, 1, 0.3, 1);\n}\n\n.cm-cam-settings__lens-mark {\n  width: 30px;\n  height: 30px;\n  flex: 0 0 auto;\n  display: grid;\n  place-items: center;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.1);\n  font-size: 11px;\n  line-height: 1;\n}\n\n.cm-cam-settings__lens-name {\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  font-size: 11px;\n  font-weight: 750;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  line-height: 1;\n}\n\n.cm-cam-settings__lens.is-on {\n  color: #facc15;\n  border-color: #facc15;\n  background: rgba(15, 23, 42, 0.88);\n  box-shadow: 0 0 0 2px rgba(250, 204, 21, 0.4);\n}\n\n.cm-cam-settings__lens.is-on .cm-cam-settings__lens-mark {\n  background: rgba(250, 204, 21, 0.16);\n}\n\n.cm-cam-settings__lens:hover:not(:disabled) {\n  transform: scale(1.06);\n}\n\n.cm-cam-settings__lens:active:not(:disabled) {\n  transform: scale(0.94);\n}\n\n.cm-cam-settings__lens:focus-visible {\n  outline: 2px solid #38bdf8;\n  outline-offset: 2px;\n}\n\n.cm-cam-settings__lens:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n.cm-cam-settings__field {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  min-width: 0;\n}\n\n.cm-cam-settings__seg-label {\n  padding: 0 6px;\n  color: rgba(248, 250, 252, 0.78);\n  font-size: 0.62rem;\n  font-weight: 750;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n}\n\n.cm-cam-settings__note {\n  margin: 0;\n  padding: 0 6px;\n  color: rgba(248, 250, 252, 0.72);\n  font-size: 0.75rem;\n  line-height: 1.35;\n}\n\n.cm-cam-settings__queue {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.cm-cam-settings__encode {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  min-width: 0;\n}\n\na.cm-cam-settings__seg-btn {\n  text-decoration: none;\n  box-sizing: border-box;\n}\n\n.cm-cam-settings__seg-btn svg {\n  flex: 0 0 auto;\n}\n\n.cm-cam-settings__seg {\n  display: flex;\n  gap: 4px;\n  padding: 4px;\n  border-radius: 14px;\n  background: rgba(15, 23, 42, 0.62);\n  border: 1px solid rgba(255, 255, 255, 0.16);\n  backdrop-filter: blur(16px);\n  -webkit-backdrop-filter: blur(16px);\n  box-shadow: 0 10px 28px rgba(0, 0, 0, 0.28);\n}\n\n.cm-cam-settings__seg--encode {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(3.4rem, 1fr));\n}\n\n.cm-cam-settings__seg-btn {\n  flex: 1 1 0;\n  min-height: 38px;\n  min-width: 44px;\n  padding: 6px 10px;\n  border: 0;\n  border-radius: 10px;\n  background: transparent;\n  color: #f8fafc;\n  font-size: 12px;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  cursor: pointer;\n  transition: transform 0.3s cubic-bezier(0.16, 1, 0.3, 1),\n    background 0.3s cubic-bezier(0.16, 1, 0.3, 1);\n}\n\n.cm-cam-settings__seg-btn--icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  min-width: 0;\n}\n\n.cm-cam-settings__seg--positions .cm-cam-settings__seg-btn--icon {\n  flex-direction: column;\n  gap: 2px;\n  padding: 6px 4px;\n  overflow: hidden;\n  font-size: 10px;\n  letter-spacing: 0.02em;\n  line-height: 1.15;\n}\n\n.cm-cam-settings__seg--positions .cm-cam-settings__seg-btn--icon span {\n  min-width: 0;\n  max-width: 100%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.cm-cam-settings__seg--encode .cm-cam-settings__seg-btn {\n  width: 100%;\n  min-width: 0;\n}\n\n.cm-cam-settings__seg-btn:hover:not(:disabled) {\n  transform: scale(1.02);\n  background: rgba(255, 255, 255, 0.08);\n}\n\n.cm-cam-settings__seg-btn:active:not(:disabled) {\n  transform: scale(0.97);\n}\n\n.cm-cam-settings__seg-btn:focus-visible {\n  outline: 2px solid #38bdf8;\n  outline-offset: 2px;\n}\n\n.cm-cam-settings__seg-btn.is-on {\n  background: color-mix(in srgb, var(--cm-primary, #0877bc) 78%, #0f172a);\n  box-shadow: 0 0 0 1px rgba(56, 189, 248, 0.28);\n}\n\n.cm-cam-settings__seg-btn:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n/* Landscape is short: use the width so every control stays on screen. */\n@media (orientation: landscape) {\n  .cm-cam-settings--ios {\n    --cm-cam-settings-top: 56px;\n  }\n\n  .cm-cam-settings__ios-top {\n    padding: calc(4px + env(safe-area-inset-top, 0px))\n      calc(12px + env(safe-area-inset-right, 0px)) 4px\n      calc(12px + env(safe-area-inset-left, 0px));\n  }\n\n  .cm-cam-settings__icon-btn {\n    width: 40px;\n    height: 40px;\n  }\n\n  .cm-cam-settings--ios .cm-cam-settings__zoom-pill {\n    top: calc(48px + env(safe-area-inset-top, 0px));\n  }\n\n  .cm-cam-settings__ios-bar {\n    left: calc(10px + env(safe-area-inset-left, 0px));\n    right: calc(10px + env(safe-area-inset-right, 0px));\n    width: auto;\n    max-width: none;\n    margin: 0;\n    gap: 6px;\n    display: grid;\n    grid-template-columns: minmax(0, 1.15fr) minmax(0, 1fr);\n    grid-template-areas:\n      \"hint hint\"\n      \"positions lenses\"\n      \"encode encode\"\n      \"wait upload\";\n    align-items: stretch;\n    align-content: end;\n  }\n\n  .cm-cam-settings__ios-hint {\n    grid-area: hint;\n    display: -webkit-box;\n    -webkit-box-orient: vertical;\n    -webkit-line-clamp: 1;\n    overflow: hidden;\n    font-size: 12px;\n    line-height: 1.3;\n  }\n\n  .cm-cam-settings__seg--positions {\n    grid-area: positions;\n    min-width: 0;\n  }\n\n  .cm-cam-settings__lenses {\n    grid-area: lenses;\n    width: 100%;\n    max-width: 100%;\n    margin: 0;\n    box-sizing: border-box;\n    justify-content: stretch;\n    padding: 4px;\n    overflow-x: auto;\n  }\n\n  .cm-cam-settings__lens {\n    min-width: 0;\n    flex: 1 1 0;\n    height: 40px;\n    padding: 0 8px 0 4px;\n  }\n\n  .cm-cam-settings__lens-name {\n    min-width: 0;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  .cm-cam-settings__encode {\n    grid-area: encode;\n  }\n\n  .cm-cam-settings__note--encode {\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n\n  .cm-cam-settings__field--wait {\n    grid-area: wait;\n    min-width: 0;\n  }\n\n  .cm-cam-settings__field--upload {\n    grid-area: upload;\n    min-width: 0;\n    display: grid;\n    grid-template-columns: minmax(0, auto) minmax(0, 1fr);\n    grid-template-areas:\n      \"label label\"\n      \"control note\";\n    align-items: center;\n    column-gap: 8px;\n    row-gap: 4px;\n  }\n\n  .cm-cam-settings__field--upload .cm-cam-settings__seg-label {\n    grid-area: label;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  .cm-cam-settings__field--upload > .cm-cam-settings__seg {\n    grid-area: control;\n    width: max-content;\n    max-width: 100%;\n  }\n\n  .cm-cam-settings__field--upload > .cm-cam-settings__note {\n    grid-area: note;\n    display: -webkit-box;\n    -webkit-box-orient: vertical;\n    -webkit-line-clamp: 2;\n    overflow: hidden;\n  }\n\n  .cm-cam-settings__field--upload .cm-cam-settings__queue {\n    grid-column: 1 / -1;\n  }\n\n  .cm-cam-settings__seg-label {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  .cm-cam-settings__seg--positions .cm-cam-settings__seg-btn--icon {\n    flex-direction: row;\n    gap: 4px;\n    min-height: 40px;\n    padding: 4px 6px;\n    font-size: 11px;\n  }\n\n  .cm-cam-settings__seg-btn {\n    min-width: 0;\n    min-height: 40px;\n    padding: 4px 6px;\n  }\n}\n\n@media (orientation: landscape) and (min-width: 980px) {\n  .cm-cam-settings__ios-bar {\n    left: 50%;\n    right: auto;\n    width: min(\n      920px,\n      calc(\n        100% - 24px - env(safe-area-inset-left, 0px) -\n          env(safe-area-inset-right, 0px)\n      )\n    );\n    transform: translateX(-50%);\n  }\n}\n\n@media (orientation: landscape) and (max-height: 340px) {\n  .cm-cam-settings--ios {\n    --cm-cam-settings-top: 50px;\n  }\n\n  .cm-cam-settings__ios-hint {\n    display: none;\n  }\n\n  .cm-cam-settings__ios-bar {\n    gap: 4px;\n  }\n\n  .cm-cam-settings__field--upload > .cm-cam-settings__note {\n    -webkit-line-clamp: 1;\n  }\n\n  .cm-cam-settings__seg-btn,\n  .cm-cam-settings__lens {\n    min-height: 36px;\n    height: auto;\n  }\n\n  .cm-cam-settings__lens {\n    height: 36px;\n  }\n}\n\n@media (orientation: portrait) and (max-height: 700px) {\n  .cm-cam-settings--ios {\n    --cm-cam-settings-top: 70px;\n  }\n\n  .cm-cam-settings__ios-bar {\n    gap: 6px;\n  }\n\n  .cm-cam-settings__ios-hint {\n    display: -webkit-box;\n    -webkit-box-orient: vertical;\n    -webkit-line-clamp: 2;\n    overflow: hidden;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .cm-cam-settings__icon-btn,\n  .cm-cam-settings__lens,\n  .cm-cam-settings__seg-btn {\n    transition: none;\n  }\n}\n\n/* Match Control Room — staff multi-table camera desk (own tab) */\n.cm-panel--control {\n  padding: 0 0 12px;\n}\n.cm-panel--control .cm-control-room {\n  margin: 0;\n}\n.cm-control-room {\n  margin: 12px 0 20px;\n  padding: 14px 14px 10px;\n  border: 1px solid rgba(148, 163, 184, 0.28);\n  border-radius: 12px;\n  background: linear-gradient(\n    165deg,\n    rgba(15, 23, 42, 0.55),\n    rgba(15, 23, 42, 0.28)\n  );\n}\n.cm-control-room__head {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px 14px;\n  align-items: flex-start;\n  margin-bottom: 12px;\n}\n.cm-control-room__title {\n  margin: 0;\n  font-size: 1.05rem;\n  font-weight: 650;\n}\n.cm-control-room__hint {\n  margin: 0;\n  flex: 1 1 220px;\n  font-size: 0.85rem;\n  opacity: 0.78;\n}\n.cm-control-room__scorewatch {\n  display: block;\n  margin: 4px 0 0;\n  padding: 4px 8px;\n  border-radius: 8px;\n  background: rgba(56, 189, 248, 0.12);\n  font-size: 0.82rem;\n}\n.cm-control-room__tables {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n.cm-control-room__row {\n  padding: 10px 12px;\n  border-radius: 10px;\n  background: rgba(255, 255, 255, 0.04);\n  border: 1px solid rgba(148, 163, 184, 0.18);\n}\n.cm-control-room__row-main {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px 12px;\n  align-items: center;\n  margin-bottom: 8px;\n}\n.cm-control-room__badge {\n  font-size: 0.75rem;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  padding: 2px 8px;\n  border-radius: 999px;\n  background: rgba(148, 163, 184, 0.2);\n}\n.cm-control-room__badge.is-rec {\n  background: rgba(239, 68, 68, 0.28);\n  color: #fecaca;\n}\n.cm-control-room__badge.is-starting {\n  background: rgba(251, 191, 36, 0.28);\n  color: #fde68a;\n}\n.cm-control-room__matchup {\n  font-size: 0.85rem;\n  opacity: 0.8;\n}\n.cm-control-room__cams {\n  list-style: none;\n  margin: 0 0 8px;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n.cm-control-room__cam {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 0.85rem;\n}\n.cm-control-room__cam.is-offline {\n  opacity: 0.55;\n}\n.cm-control-room__cam.is-empty {\n  opacity: 0.65;\n  font-style: italic;\n}\n.cm-control-room__actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.cm-match-status__scorewatch {\n  font-size: 0.85rem;\n  opacity: 0.9;\n}\n\n/* Match review dialog: the tape is a full-bleed frame. Height follows the\n   recording's aspect ratio so a landscape trip cannot collapse it to 0. */\n.cm-review {\n  padding: 0;\n}\n\n.cm-review__head {\n  margin: 0;\n  padding:\n    calc(0.45rem + env(safe-area-inset-top, 0px))\n    calc(0.7rem + env(safe-area-inset-right, 0px))\n    0.4rem\n    calc(0.7rem + env(safe-area-inset-left, 0px));\n}\n\n.cm-review__body {\n  overflow: auto;\n  border: 0;\n  border-radius: 0;\n  background: transparent;\n}\n\n.cm-review .cm-chrono.is-review-layout,\n.cm-review .cm-chrono.has-deck:not(.is-review-fs) {\n  display: flex;\n  flex-direction: column;\n  height: auto;\n  max-height: none;\n  overflow: visible;\n  border: 0;\n  border-radius: 0;\n  background: transparent;\n  grid-template-columns: none;\n  grid-template-rows: none;\n  grid-template-areas: none;\n}\n\n.cm-review .cm-chrono__layout,\n.cm-review .cm-chrono__stage {\n  display: contents;\n}\n\n.cm-review .cm-chrono__player-shell {\n  order: 1;\n  position: relative;\n  inset: auto;\n  flex: 0 0 auto;\n  width: 100%;\n  max-width: 100%;\n  height: auto;\n  min-height: 0;\n  max-height: none;\n  margin: 0;\n  aspect-ratio: var(--cm-frame, 1.7777778);\n  border-radius: 0;\n  align-self: stretch;\n  /* Size containment collapses an aspect-ratio box back to 0 height. */\n  container-type: inline-size;\n}\n\n.cm-review .cm-chrono.is-stage-landscape .cm-stagectl {\n  opacity: 1;\n}\n\n/* Review fullscreen: video covers the dialog; hide chrome around it. */\n.cm-review:has(.cm-chrono.is-stage-fs) .cm-review__head,\n.cm-review:has(.cm-chrono.is-stage-fs) .cm-review__board-dock,\n.cm-review:has(.cm-chrono.is-stage-fs) .cm-reviewbar,\n.cm-review:has(.cm-chrono.is-stage-fs) .cm-review__sheet,\n.cm-review:has(.cm-chrono.is-stage-fs) .cm-chrono__rubber,\n.cm-review:has(.cm-chrono.is-stage-fs) .cm-chrono__reassign,\n.cm-review:has(.cm-chrono.is-stage-fs) .cm-chrono__side,\n.cm-review:has(.cm-chrono.is-stage-fs) .cm-chrono__tagger-slot {\n  display: none !important;\n}\n\n.cm-review:has(.cm-chrono.is-stage-fs) {\n  padding: 0;\n  overflow: hidden;\n}\n\n.cm-review:has(.cm-chrono.is-stage-fs) .cm-review__body,\n.cm-review:has(.cm-chrono.is-stage-fs) .cm-chrono.is-stage-fs {\n  flex: 1 1 auto;\n  min-height: 0;\n  height: 100%;\n  max-height: none;\n  overflow: hidden;\n  border: 0;\n  border-radius: 0;\n  background: #05070c;\n}\n\n.cm-review .cm-chrono.is-stage-landscape .cm-chrono__player-shell,\n.cm-review .cm-chrono.is-stage-fs .cm-chrono__player-shell {\n  position: fixed;\n  inset: 0;\n  z-index: 140;\n  flex: none;\n  width: 100%;\n  max-width: none;\n  height: 100%;\n  max-height: none;\n  aspect-ratio: auto;\n  margin: 0;\n  align-self: stretch;\n  transform: none;\n  border-radius: 0;\n  background: #05070c;\n}\n\n.cm-review .cm-chrono.is-stage-fs,\n.cm-review .cm-chrono.is-stage-fs.is-portrait-stage {\n  position: relative;\n  inset: auto;\n  width: 100%;\n  height: 100%;\n  max-height: none;\n  transform: none;\n}\n\n.cm-review .cm-chrono__player-shell .review-video-player__chrome {\n  background: transparent;\n  backdrop-filter: none;\n  -webkit-backdrop-filter: none;\n}\n\n.cm-review .cm-chrono__player-shell .review-video-player__btn,\n.cm-review .cm-chrono__player-shell .review-video-player__btn--play,\n.cm-review .cm-chrono__player-shell .review-video-player__btn--active {\n  background: transparent;\n  box-shadow: none;\n}\n\n.cm-review .cm-chrono__player-shell .review-video-player__btn svg,\n.cm-review .cm-chrono__player-shell .review-video-player__chrome-toggle svg {\n  filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.9));\n}\n\n.cm-review .cm-chrono.is-stage-landscape .cm-chrono__player-shell .review-video-player__chrome {\n  z-index: 24;\n}\n\n.cm-review .cm-chrono.is-stage-landscape .cm-chrono__player-shell .review-video-player__chrome--bottom {\n  padding-left: max(\n    0.75rem,\n    calc(min(42cqw, 20rem) + 0.7rem + env(safe-area-inset-left, 0px))\n  );\n}\n\n.cm-review .cm-league {\n  align-items: stretch;\n}\n\n.cm-review .cm-league__club {\n  display: none;\n}\n\n/* Logo column follows the plate height; the round badge stays centered. */\n.cm-review .cm-league__brand {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  flex: 0 0 auto;\n  align-self: stretch;\n  width: 3.15rem;\n  min-width: 3.15rem;\n  height: auto;\n  padding: 0.28rem 0.18rem;\n  gap: 0.12rem;\n  overflow: hidden;\n  background: var(--cm-league-brand-bg);\n}\n\n.cm-review .cm-league__logo,\n.cm-review .cm-league__mark {\n  position: relative;\n  inset: auto;\n  width: 2.35rem;\n  height: 2.35rem;\n  max-width: none;\n  max-height: none;\n  margin: 0;\n  aspect-ratio: 1;\n  object-fit: contain;\n  box-sizing: border-box;\n}\n\n.cm-review .cm-league__mark {\n  display: grid;\n  place-items: center;\n}\n\n.cm-review .cm-chrono.is-stage-landscape .cm-league {\n  z-index: 22;\n  left: max(0.45rem, env(safe-area-inset-left, 0px));\n  bottom: max(0.45rem, env(safe-area-inset-bottom, 0px));\n  width: min(42cqw, 20rem);\n  max-width: calc(100% - 0.9rem);\n}\n\n.cm-review__board-dock {\n  order: 2;\n  flex: 0 0 auto;\n  width: 100%;\n  box-sizing: border-box;\n  padding: 0.4rem 0.45rem 0.5rem;\n  background: color-mix(in srgb, var(--cm-rail, #070b12) 92%, #000);\n}\n\n.cm-page--light .cm-review__board-dock {\n  background: color-mix(in srgb, var(--cm-rail, #eef1f6) 88%, #fff);\n}\n\n.cm-review__board-dock .cm-league {\n  position: relative;\n  left: auto;\n  right: auto;\n  top: auto;\n  bottom: auto;\n  max-width: none;\n  width: 100%;\n}\n\n.cm-reviewbar {\n  order: 3;\n  position: sticky;\n  top: 0;\n  z-index: 8;\n  display: flex;\n  align-items: center;\n  gap: 0.4rem;\n  flex: 0 0 auto;\n  padding: 0.45rem 0.55rem;\n  padding-left: calc(0.55rem + env(safe-area-inset-left, 0px));\n  padding-right: calc(0.55rem + env(safe-area-inset-right, 0px));\n  background: color-mix(in srgb, var(--cm-rail) 92%, #000);\n  border-top: 1px solid var(--cm-hair);\n  border-bottom: 1px solid var(--cm-hair);\n}\n\n.cm-reviewbar__btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.35rem;\n  min-height: 2.75rem;\n  padding: 0 0.8rem;\n  border-radius: 999px;\n  border: 1px solid var(--cm-hair);\n  background: var(--cm-chip);\n  color: var(--cm-text);\n  font: inherit;\n  font-size: 0.75rem;\n  font-weight: 750;\n  letter-spacing: 0.01em;\n  cursor: pointer;\n}\n\n.cm-reviewbar__btn.is-on {\n  background: color-mix(in srgb, var(--cm-primary, #0877bc) 78%, #0b1018);\n  border-color: transparent;\n  color: #fff;\n}\n\n.cm-reviewbar__btn:focus-visible {\n  outline: 2px solid var(--cm-primary, #0877bc);\n  outline-offset: 2px;\n}\n\n.cm-reviewbar__btn--menu {\n  width: 2.75rem;\n  margin-left: 0;\n  padding: 0;\n}\n\n.cm-reviewbar__btn--fs {\n  margin-left: auto;\n}\n\n.cm-reviewbar__count {\n  min-width: 1.15rem;\n  padding: 0 0.28rem;\n  border-radius: 999px;\n  background: color-mix(in srgb, currentColor 16%, transparent);\n  font-variant-numeric: tabular-nums;\n  font-size: 0.68rem;\n  line-height: 1.35;\n}\n\n.cm-review__sheet {\n  order: 4;\n  flex: 0 0 auto;\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n  max-height: min(46dvh, 24rem);\n  overflow: auto;\n  background: var(--cm-rail);\n  border-bottom: 1px solid var(--cm-hair);\n}\n\n.cm-review__sheet-sets {\n  display: flex;\n  gap: 0.3rem;\n  overflow-x: auto;\n  padding: 0.45rem 0.55rem 0;\n  position: sticky;\n  top: 0;\n  background: var(--cm-rail);\n}\n\n.cm-review__sheet-sets button {\n  flex: 0 0 auto;\n  min-height: 2rem;\n  border: 0;\n  border-radius: 999px;\n  padding: 0.25rem 0.7rem;\n  background: transparent;\n  color: var(--cm-muted);\n  font: inherit;\n  font-size: 0.68rem;\n  font-weight: 800;\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n  cursor: pointer;\n}\n\n.cm-review__sheet-sets button.is-on {\n  background: var(--cm-chip-on);\n  color: var(--cm-text);\n}\n\n.cm-review__points {\n  list-style: none;\n  margin: 0;\n  padding: 0.35rem 0 0.45rem;\n}\n\n.cm-review__pt {\n  width: 100%;\n  display: grid;\n  grid-template-columns: 1.7rem 4.4rem minmax(0, 1fr);\n  align-items: center;\n  column-gap: 0.65rem;\n  min-height: 2.75rem;\n  padding: 0.2rem 0.7rem;\n  border: 0;\n  border-left: 3px solid transparent;\n  background: transparent;\n  color: var(--cm-text);\n  font: inherit;\n  text-align: left;\n  cursor: pointer;\n}\n\n.cm-review__pt:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n.cm-review__pt.is-selected {\n  background: color-mix(in srgb, var(--cm-primary, #0877bc) 12%, transparent);\n}\n\n.cm-review__pt.is-active {\n  border-left-color: var(--cm-primary, #0877bc);\n  background: color-mix(in srgb, var(--cm-primary, #0877bc) 18%, transparent);\n}\n\n.cm-review__pt-n {\n  width: 1.7rem;\n  height: 1.7rem;\n  display: grid;\n  place-items: center;\n  border: 1px solid var(--cm-hair);\n  background: var(--cm-chip);\n  font-size: 0.72rem;\n  font-weight: 800;\n  font-variant-numeric: tabular-nums;\n}\n\n.cm-review__pt-score {\n  display: inline-flex;\n  flex-direction: column;\n  align-items: flex-start;\n  font-family: \"Barlow Condensed\", \"Arial Narrow\", Impact, sans-serif;\n  font-size: 1.35rem;\n  font-weight: 700;\n  font-variant-numeric: tabular-nums;\n  letter-spacing: 0.02em;\n  line-height: 1;\n}\n\n.cm-review__pt-sets,\n.cm-deck__sets {\n  font-size: 0.62rem;\n  font-weight: 750;\n  letter-spacing: 0.04em;\n  line-height: 1;\n  color: var(--cm-muted);\n}\n\n.cm-deck__sets {\n  margin: 0 0 0.2rem;\n  text-align: center;\n  font-size: 0.85rem;\n}\n\n.cm-chrono__score-ai-accept {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.45rem;\n  margin: 0;\n  font-size: 0.72rem;\n  font-weight: 650;\n  line-height: 1.35;\n}\n\n.cm-chrono__score-ai-accept input {\n  margin-top: 0.12rem;\n  flex: 0 0 auto;\n}\n\n.cm-chrono__score-ai-live {\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n}\n\n.cm-chrono__score-ai-log {\n  max-height: 14rem;\n  overflow: auto;\n}\n\n.cm-review__pt-meta {\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  color: var(--cm-muted);\n  font-size: 0.72rem;\n  font-weight: 650;\n}\n\n.cm-review__sheet-empty {\n  margin: 0;\n  padding: 0.8rem 0.7rem 1rem;\n  color: var(--cm-muted);\n  font-size: 0.8rem;\n}\n\n.cm-review .cm-chrono__tagger-slot--dock {\n  order: 6;\n  position: static;\n  max-height: none;\n  box-shadow: none;\n  background: transparent;\n}\n\n.cm-review .cm-chrono__tagger-slot--dock:not(:has(.cm-deck)) {\n  display: none;\n}\n\n.cm-review .cm-chrono__side:has(.cm-chrono__mod),\n.cm-review .cm-chrono__side:has(.cm-chrono__score-ai) {\n  display: flex;\n  order: 7;\n  max-height: none;\n  overflow: visible;\n  border: 0;\n  background: transparent;\n}\n\n.cm-review .cm-chrono__rail,\n.cm-review .cm-chrono__sets,\n.cm-review .cm-chrono__set-label,\n.cm-review .cm-chrono__tagger-slot--side,\n.cm-review .cm-film {\n  display: none;\n}\n\n.cm-review__tools-kicker {\n  flex: 0 0 auto;\n  width: 100%;\n  margin: 0 0 0.15rem;\n  font-size: 0.66rem;\n  font-weight: 800;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: var(--cm-muted);\n}\n\n.cm-review .cm-chrono__mod {\n  flex-direction: column;\n  align-items: stretch;\n  gap: 0.4rem;\n  padding: 0.55rem 0.65rem 0.75rem;\n  padding-left: calc(0.65rem + env(safe-area-inset-left, 0px));\n  padding-right: calc(0.65rem + env(safe-area-inset-right, 0px));\n  background: var(--cm-deck);\n  border-top: 1px solid var(--cm-hair);\n}\n\n.cm-review .cm-chrono__mod .cm-btn,\n.cm-review .cm-chrono__mod .cm-chrono__reassign {\n  width: 100%;\n  justify-content: flex-start;\n}\n\n.cm-review .cm-chrono__score-ai {\n  margin: 0 0.65rem 0.75rem;\n}\n\n/* Desktop match review: tape on the left, point labeler and score\n   detection on the right. The player must not cover that column. */\n@media (min-width: 1024px) {\n  .cm-review__body {\n    overflow: hidden;\n  }\n\n  .cm-review .cm-chrono.is-review-layout.is-staff-desktop {\n    flex: 1 1 auto;\n    min-height: 0;\n    height: auto;\n    max-height: none;\n    overflow: hidden;\n    display: grid;\n    grid-template-columns: minmax(0, 1fr);\n    grid-template-rows: auto minmax(12rem, 1fr) auto auto auto;\n  }\n\n  .cm-review .cm-chrono.is-review-layout.is-staff-desktop:has(.cm-chrono__side .cm-deck),\n  .cm-review .cm-chrono.is-review-layout.is-staff-desktop:has(.cm-chrono__side .cm-chrono__mod),\n  .cm-review .cm-chrono.is-review-layout.is-staff-desktop:has(.cm-chrono__side .cm-chrono__score-ai) {\n    grid-template-columns: minmax(0, 1fr) minmax(22rem, 32rem);\n  }\n\n  .cm-review .cm-chrono.is-review-layout.is-staff-desktop .cm-chrono__reassign {\n    grid-column: 1 / -1;\n    grid-row: 1;\n  }\n\n  .cm-review .cm-chrono.is-review-layout.is-staff-desktop .cm-chrono__player-shell {\n    grid-column: 1;\n    grid-row: 2;\n    position: relative;\n    inset: auto;\n    z-index: 1;\n    width: 100%;\n    max-width: none;\n    height: 100%;\n    max-height: none;\n    min-height: 0;\n    aspect-ratio: auto;\n    flex: none;\n    align-self: stretch;\n    margin: 0;\n    transform: none;\n  }\n\n  /* Full screen still covers the desktop two-column review chrome. */\n  .cm-review .cm-chrono.is-review-layout.is-staff-desktop.is-stage-fs .cm-chrono__player-shell,\n  .cm-review .cm-chrono.is-review-layout.is-staff-desktop.is-stage-landscape .cm-chrono__player-shell {\n    position: fixed;\n    inset: 0;\n    z-index: 140;\n    grid-column: auto;\n    grid-row: auto;\n    width: 100%;\n    max-width: none;\n    height: 100%;\n    max-height: none;\n    min-height: 0;\n    aspect-ratio: auto;\n    margin: 0;\n    transform: none;\n    border-radius: 0;\n    background: #05070c;\n  }\n\n  .cm-review .cm-chrono.is-review-layout.is-staff-desktop .cm-review__board-dock {\n    grid-column: 1;\n    grid-row: 3;\n  }\n\n  .cm-review .cm-chrono.is-review-layout.is-staff-desktop .cm-reviewbar {\n    grid-column: 1;\n    grid-row: 4;\n    position: static;\n  }\n\n  .cm-review .cm-chrono.is-review-layout.is-staff-desktop .cm-reviewbar__btn--menu {\n    margin-left: 0;\n  }\n\n  .cm-review .cm-chrono.is-review-layout.is-staff-desktop .cm-review__sheet {\n    grid-column: 1;\n    grid-row: 5;\n    max-height: 28vh;\n    min-height: 0;\n  }\n\n  .cm-review .cm-chrono.is-review-layout.is-staff-desktop .cm-chrono__tagger-slot--dock {\n    display: none;\n  }\n\n  .cm-review .cm-chrono.is-review-layout.is-staff-desktop .cm-chrono__tagger-slot--review {\n    display: block;\n    flex: 0 0 auto;\n    min-height: 0;\n    max-height: none;\n    overflow: visible;\n  }\n\n  .cm-review .cm-chrono.is-review-layout.is-staff-desktop .cm-chrono__side:has(.cm-deck),\n  .cm-review .cm-chrono.is-review-layout.is-staff-desktop .cm-chrono__side:has(.cm-chrono__mod),\n  .cm-review .cm-chrono.is-review-layout.is-staff-desktop .cm-chrono__side:has(.cm-chrono__score-ai) {\n    display: flex;\n    flex-direction: column;\n    grid-column: 2;\n    grid-row: 1 / -1;\n    align-self: stretch;\n    width: auto;\n    max-width: none;\n    height: auto;\n    max-height: none;\n    min-height: 0;\n    overflow: auto;\n    order: unset;\n    border-top: 0;\n    border-left: 1px solid var(--cm-hair);\n    background: var(--cm-deck);\n  }\n\n  .cm-review .cm-chrono.is-review-layout.is-staff-desktop .cm-chrono__mod,\n  .cm-review .cm-chrono.is-review-layout.is-staff-desktop .cm-chrono__score-ai {\n    flex: 0 0 auto;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .cm-review__pt,\n  .cm-reviewbar__btn {\n    transition: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
